const city = [
    {
        "id":1,
        "label":"北京市",
        "value":"110000",
        "key":"110000",
        "parent_area_key":"",
        "children":[
            {
                "id":2,
                "label":"市辖区",
                "value":"110100",
                "key":"110100",
                "parent_area_key":"110000",
                "children":[
                    {
                        "id":3,
                        "label":"东城区",
                        "value":"110101",
                        "key":"110101",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":4,
                        "label":"西城区",
                        "value":"110102",
                        "key":"110102",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":5,
                        "label":"朝阳区",
                        "value":"110105",
                        "key":"110105",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":6,
                        "label":"丰台区",
                        "value":"110106",
                        "key":"110106",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":7,
                        "label":"石景山区",
                        "value":"110107",
                        "key":"110107",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":8,
                        "label":"海淀区",
                        "value":"110108",
                        "key":"110108",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":9,
                        "label":"门头沟区",
                        "value":"110109",
                        "key":"110109",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":10,
                        "label":"房山区",
                        "value":"110111",
                        "key":"110111",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":11,
                        "label":"通州区",
                        "value":"110112",
                        "key":"110112",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":12,
                        "label":"顺义区",
                        "value":"110113",
                        "key":"110113",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":13,
                        "label":"昌平区",
                        "value":"110114",
                        "key":"110114",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":14,
                        "label":"大兴区",
                        "value":"110115",
                        "key":"110115",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":15,
                        "label":"怀柔区",
                        "value":"110116",
                        "key":"110116",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":16,
                        "label":"平谷区",
                        "value":"110117",
                        "key":"110117",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":17,
                        "label":"密云区",
                        "value":"110118",
                        "key":"110118",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    },
                    {
                        "id":18,
                        "label":"延庆区",
                        "value":"110119",
                        "key":"110119",
                        "parent_area_key":"110100",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":19,
        "label":"天津市",
        "value":"120000",
        "key":"120000",
        "parent_area_key":"",
        "children":[
            {
                "id":20,
                "label":"市辖区",
                "value":"120100",
                "key":"120100",
                "parent_area_key":"120000",
                "children":[
                    {
                        "id":21,
                        "label":"和平区",
                        "value":"120101",
                        "key":"120101",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":22,
                        "label":"河东区",
                        "value":"120102",
                        "key":"120102",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":23,
                        "label":"河西区",
                        "value":"120103",
                        "key":"120103",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":24,
                        "label":"南开区",
                        "value":"120104",
                        "key":"120104",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":25,
                        "label":"河北区",
                        "value":"120105",
                        "key":"120105",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":26,
                        "label":"红桥区",
                        "value":"120106",
                        "key":"120106",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":27,
                        "label":"东丽区",
                        "value":"120110",
                        "key":"120110",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":28,
                        "label":"西青区",
                        "value":"120111",
                        "key":"120111",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":29,
                        "label":"津南区",
                        "value":"120112",
                        "key":"120112",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":30,
                        "label":"北辰区",
                        "value":"120113",
                        "key":"120113",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":31,
                        "label":"武清区",
                        "value":"120114",
                        "key":"120114",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":32,
                        "label":"宝坻区",
                        "value":"120115",
                        "key":"120115",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":33,
                        "label":"滨海新区",
                        "value":"120116",
                        "key":"120116",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":34,
                        "label":"宁河区",
                        "value":"120117",
                        "key":"120117",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":35,
                        "label":"静海区",
                        "value":"120118",
                        "key":"120118",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    },
                    {
                        "id":36,
                        "label":"蓟州区",
                        "value":"120119",
                        "key":"120119",
                        "parent_area_key":"120100",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":37,
        "label":"河北省",
        "value":"130000",
        "key":"130000",
        "parent_area_key":"",
        "children":[
            {
                "id":38,
                "label":"石家庄市",
                "value":"130100",
                "key":"130100",
                "parent_area_key":"130000",
                "children":[
                    {
                        "id":39,
                        "label":"市辖区",
                        "value":"130101",
                        "key":"130101",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":40,
                        "label":"长安区",
                        "value":"130102",
                        "key":"130102",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":41,
                        "label":"桥西区",
                        "value":"130104",
                        "key":"130104",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":42,
                        "label":"新华区",
                        "value":"130105",
                        "key":"130105",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":43,
                        "label":"井陉矿区",
                        "value":"130107",
                        "key":"130107",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":44,
                        "label":"裕华区",
                        "value":"130108",
                        "key":"130108",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":45,
                        "label":"藁城区",
                        "value":"130109",
                        "key":"130109",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":46,
                        "label":"鹿泉区",
                        "value":"130110",
                        "key":"130110",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":47,
                        "label":"栾城区",
                        "value":"130111",
                        "key":"130111",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":48,
                        "label":"井陉县",
                        "value":"130121",
                        "key":"130121",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":49,
                        "label":"正定县",
                        "value":"130123",
                        "key":"130123",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":50,
                        "label":"行唐县",
                        "value":"130125",
                        "key":"130125",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":51,
                        "label":"灵寿县",
                        "value":"130126",
                        "key":"130126",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":52,
                        "label":"高邑县",
                        "value":"130127",
                        "key":"130127",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":53,
                        "label":"深泽县",
                        "value":"130128",
                        "key":"130128",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":54,
                        "label":"赞皇县",
                        "value":"130129",
                        "key":"130129",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":55,
                        "label":"无极县",
                        "value":"130130",
                        "key":"130130",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":56,
                        "label":"平山县",
                        "value":"130131",
                        "key":"130131",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":57,
                        "label":"元氏县",
                        "value":"130132",
                        "key":"130132",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":58,
                        "label":"赵县",
                        "value":"130133",
                        "key":"130133",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":59,
                        "label":"晋州市",
                        "value":"130183",
                        "key":"130183",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    },
                    {
                        "id":60,
                        "label":"新乐市",
                        "value":"130184",
                        "key":"130184",
                        "parent_area_key":"130100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":61,
                "label":"唐山市",
                "value":"130200",
                "key":"130200",
                "parent_area_key":"130000",
                "children":[
                    {
                        "id":62,
                        "label":"市辖区",
                        "value":"130201",
                        "key":"130201",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":63,
                        "label":"路南区",
                        "value":"130202",
                        "key":"130202",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":64,
                        "label":"路北区",
                        "value":"130203",
                        "key":"130203",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":65,
                        "label":"古冶区",
                        "value":"130204",
                        "key":"130204",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":66,
                        "label":"开平区",
                        "value":"130205",
                        "key":"130205",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":67,
                        "label":"丰南区",
                        "value":"130207",
                        "key":"130207",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":68,
                        "label":"丰润区",
                        "value":"130208",
                        "key":"130208",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":69,
                        "label":"曹妃甸区",
                        "value":"130209",
                        "key":"130209",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":70,
                        "label":"滦县",
                        "value":"130223",
                        "key":"130223",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":71,
                        "label":"滦南县",
                        "value":"130224",
                        "key":"130224",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":72,
                        "label":"乐亭县",
                        "value":"130225",
                        "key":"130225",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":73,
                        "label":"迁西县",
                        "value":"130227",
                        "key":"130227",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":74,
                        "label":"玉田县",
                        "value":"130229",
                        "key":"130229",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":75,
                        "label":"遵化市",
                        "value":"130281",
                        "key":"130281",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    },
                    {
                        "id":76,
                        "label":"迁安市",
                        "value":"130283",
                        "key":"130283",
                        "parent_area_key":"130200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":77,
                "label":"秦皇岛市",
                "value":"130300",
                "key":"130300",
                "parent_area_key":"130000",
                "children":[
                    {
                        "id":78,
                        "label":"市辖区",
                        "value":"130301",
                        "key":"130301",
                        "parent_area_key":"130300",
                        "children":[

                        ]
                    },
                    {
                        "id":79,
                        "label":"海港区",
                        "value":"130302",
                        "key":"130302",
                        "parent_area_key":"130300",
                        "children":[

                        ]
                    },
                    {
                        "id":80,
                        "label":"山海关区",
                        "value":"130303",
                        "key":"130303",
                        "parent_area_key":"130300",
                        "children":[

                        ]
                    },
                    {
                        "id":81,
                        "label":"北戴河区",
                        "value":"130304",
                        "key":"130304",
                        "parent_area_key":"130300",
                        "children":[

                        ]
                    },
                    {
                        "id":82,
                        "label":"抚宁区",
                        "value":"130306",
                        "key":"130306",
                        "parent_area_key":"130300",
                        "children":[

                        ]
                    },
                    {
                        "id":83,
                        "label":"青龙满族自治县",
                        "value":"130321",
                        "key":"130321",
                        "parent_area_key":"130300",
                        "children":[

                        ]
                    },
                    {
                        "id":84,
                        "label":"昌黎县",
                        "value":"130322",
                        "key":"130322",
                        "parent_area_key":"130300",
                        "children":[

                        ]
                    },
                    {
                        "id":85,
                        "label":"卢龙县",
                        "value":"130324",
                        "key":"130324",
                        "parent_area_key":"130300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":86,
                "label":"邯郸市",
                "value":"130400",
                "key":"130400",
                "parent_area_key":"130000",
                "children":[
                    {
                        "id":87,
                        "label":"市辖区",
                        "value":"130401",
                        "key":"130401",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":88,
                        "label":"邯山区",
                        "value":"130402",
                        "key":"130402",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":89,
                        "label":"丛台区",
                        "value":"130403",
                        "key":"130403",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":90,
                        "label":"复兴区",
                        "value":"130404",
                        "key":"130404",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":91,
                        "label":"峰峰矿区",
                        "value":"130406",
                        "key":"130406",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":92,
                        "label":"邯郸县",
                        "value":"130421",
                        "key":"130421",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":93,
                        "label":"临漳县",
                        "value":"130423",
                        "key":"130423",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":94,
                        "label":"成安县",
                        "value":"130424",
                        "key":"130424",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":95,
                        "label":"大名县",
                        "value":"130425",
                        "key":"130425",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":96,
                        "label":"涉县",
                        "value":"130426",
                        "key":"130426",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":97,
                        "label":"磁县",
                        "value":"130427",
                        "key":"130427",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":98,
                        "label":"肥乡县",
                        "value":"130428",
                        "key":"130428",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":99,
                        "label":"永年县",
                        "value":"130429",
                        "key":"130429",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":100,
                        "label":"邱县",
                        "value":"130430",
                        "key":"130430",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":101,
                        "label":"鸡泽县",
                        "value":"130431",
                        "key":"130431",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":102,
                        "label":"广平县",
                        "value":"130432",
                        "key":"130432",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":103,
                        "label":"馆陶县",
                        "value":"130433",
                        "key":"130433",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":104,
                        "label":"魏县",
                        "value":"130434",
                        "key":"130434",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":105,
                        "label":"曲周县",
                        "value":"130435",
                        "key":"130435",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    },
                    {
                        "id":106,
                        "label":"武安市",
                        "value":"130481",
                        "key":"130481",
                        "parent_area_key":"130400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":107,
                "label":"邢台市",
                "value":"130500",
                "key":"130500",
                "parent_area_key":"130000",
                "children":[
                    {
                        "id":108,
                        "label":"市辖区",
                        "value":"130501",
                        "key":"130501",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":109,
                        "label":"桥东区",
                        "value":"130502",
                        "key":"130502",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":110,
                        "label":"桥西区",
                        "value":"130503",
                        "key":"130503",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":111,
                        "label":"邢台县",
                        "value":"130521",
                        "key":"130521",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":112,
                        "label":"临城县",
                        "value":"130522",
                        "key":"130522",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":113,
                        "label":"内丘县",
                        "value":"130523",
                        "key":"130523",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":114,
                        "label":"柏乡县",
                        "value":"130524",
                        "key":"130524",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":115,
                        "label":"隆尧县",
                        "value":"130525",
                        "key":"130525",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":116,
                        "label":"任县",
                        "value":"130526",
                        "key":"130526",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":117,
                        "label":"南和县",
                        "value":"130527",
                        "key":"130527",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":118,
                        "label":"宁晋县",
                        "value":"130528",
                        "key":"130528",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":119,
                        "label":"巨鹿县",
                        "value":"130529",
                        "key":"130529",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":120,
                        "label":"新河县",
                        "value":"130530",
                        "key":"130530",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":121,
                        "label":"广宗县",
                        "value":"130531",
                        "key":"130531",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":122,
                        "label":"平乡县",
                        "value":"130532",
                        "key":"130532",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":123,
                        "label":"威县",
                        "value":"130533",
                        "key":"130533",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":124,
                        "label":"清河县",
                        "value":"130534",
                        "key":"130534",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":125,
                        "label":"临西县",
                        "value":"130535",
                        "key":"130535",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":126,
                        "label":"南宫市",
                        "value":"130581",
                        "key":"130581",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    },
                    {
                        "id":127,
                        "label":"沙河市",
                        "value":"130582",
                        "key":"130582",
                        "parent_area_key":"130500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":128,
                "label":"保定市",
                "value":"130600",
                "key":"130600",
                "parent_area_key":"130000",
                "children":[
                    {
                        "id":129,
                        "label":"市辖区",
                        "value":"130601",
                        "key":"130601",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":130,
                        "label":"竞秀区",
                        "value":"130602",
                        "key":"130602",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":131,
                        "label":"莲池区",
                        "value":"130606",
                        "key":"130606",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":132,
                        "label":"满城区",
                        "value":"130607",
                        "key":"130607",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":133,
                        "label":"清苑区",
                        "value":"130608",
                        "key":"130608",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":134,
                        "label":"徐水区",
                        "value":"130609",
                        "key":"130609",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":135,
                        "label":"涞水县",
                        "value":"130623",
                        "key":"130623",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":136,
                        "label":"阜平县",
                        "value":"130624",
                        "key":"130624",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":137,
                        "label":"定兴县",
                        "value":"130626",
                        "key":"130626",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":138,
                        "label":"唐县",
                        "value":"130627",
                        "key":"130627",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":139,
                        "label":"高阳县",
                        "value":"130628",
                        "key":"130628",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":140,
                        "label":"容城县",
                        "value":"130629",
                        "key":"130629",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":141,
                        "label":"涞源县",
                        "value":"130630",
                        "key":"130630",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":142,
                        "label":"望都县",
                        "value":"130631",
                        "key":"130631",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":143,
                        "label":"安新县",
                        "value":"130632",
                        "key":"130632",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":144,
                        "label":"易县",
                        "value":"130633",
                        "key":"130633",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":145,
                        "label":"曲阳县",
                        "value":"130634",
                        "key":"130634",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":146,
                        "label":"蠡县",
                        "value":"130635",
                        "key":"130635",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":147,
                        "label":"顺平县",
                        "value":"130636",
                        "key":"130636",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":148,
                        "label":"博野县",
                        "value":"130637",
                        "key":"130637",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":149,
                        "label":"雄县",
                        "value":"130638",
                        "key":"130638",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":150,
                        "label":"涿州市",
                        "value":"130681",
                        "key":"130681",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":151,
                        "label":"安国市",
                        "value":"130683",
                        "key":"130683",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    },
                    {
                        "id":152,
                        "label":"高碑店市",
                        "value":"130684",
                        "key":"130684",
                        "parent_area_key":"130600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":153,
                "label":"张家口市",
                "value":"130700",
                "key":"130700",
                "parent_area_key":"130000",
                "children":[
                    {
                        "id":154,
                        "label":"市辖区",
                        "value":"130701",
                        "key":"130701",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":155,
                        "label":"桥东区",
                        "value":"130702",
                        "key":"130702",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":156,
                        "label":"桥西区",
                        "value":"130703",
                        "key":"130703",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":157,
                        "label":"宣化区",
                        "value":"130705",
                        "key":"130705",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":158,
                        "label":"下花园区",
                        "value":"130706",
                        "key":"130706",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":159,
                        "label":"万全区",
                        "value":"130708",
                        "key":"130708",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":160,
                        "label":"崇礼区",
                        "value":"130709",
                        "key":"130709",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":161,
                        "label":"张北县",
                        "value":"130722",
                        "key":"130722",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":162,
                        "label":"康保县",
                        "value":"130723",
                        "key":"130723",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":163,
                        "label":"沽源县",
                        "value":"130724",
                        "key":"130724",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":164,
                        "label":"尚义县",
                        "value":"130725",
                        "key":"130725",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":165,
                        "label":"蔚县",
                        "value":"130726",
                        "key":"130726",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":166,
                        "label":"阳原县",
                        "value":"130727",
                        "key":"130727",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":167,
                        "label":"怀安县",
                        "value":"130728",
                        "key":"130728",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":168,
                        "label":"怀来县",
                        "value":"130730",
                        "key":"130730",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":169,
                        "label":"涿鹿县",
                        "value":"130731",
                        "key":"130731",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    },
                    {
                        "id":170,
                        "label":"赤城县",
                        "value":"130732",
                        "key":"130732",
                        "parent_area_key":"130700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":171,
                "label":"承德市",
                "value":"130800",
                "key":"130800",
                "parent_area_key":"130000",
                "children":[
                    {
                        "id":172,
                        "label":"市辖区",
                        "value":"130801",
                        "key":"130801",
                        "parent_area_key":"130800",
                        "children":[

                        ]
                    },
                    {
                        "id":173,
                        "label":"双桥区",
                        "value":"130802",
                        "key":"130802",
                        "parent_area_key":"130800",
                        "children":[

                        ]
                    },
                    {
                        "id":174,
                        "label":"双滦区",
                        "value":"130803",
                        "key":"130803",
                        "parent_area_key":"130800",
                        "children":[

                        ]
                    },
                    {
                        "id":175,
                        "label":"鹰手营子矿区",
                        "value":"130804",
                        "key":"130804",
                        "parent_area_key":"130800",
                        "children":[

                        ]
                    },
                    {
                        "id":176,
                        "label":"承德县",
                        "value":"130821",
                        "key":"130821",
                        "parent_area_key":"130800",
                        "children":[

                        ]
                    },
                    {
                        "id":177,
                        "label":"兴隆县",
                        "value":"130822",
                        "key":"130822",
                        "parent_area_key":"130800",
                        "children":[

                        ]
                    },
                    {
                        "id":178,
                        "label":"平泉县",
                        "value":"130823",
                        "key":"130823",
                        "parent_area_key":"130800",
                        "children":[

                        ]
                    },
                    {
                        "id":179,
                        "label":"滦平县",
                        "value":"130824",
                        "key":"130824",
                        "parent_area_key":"130800",
                        "children":[

                        ]
                    },
                    {
                        "id":180,
                        "label":"隆化县",
                        "value":"130825",
                        "key":"130825",
                        "parent_area_key":"130800",
                        "children":[

                        ]
                    },
                    {
                        "id":181,
                        "label":"丰宁满族自治县",
                        "value":"130826",
                        "key":"130826",
                        "parent_area_key":"130800",
                        "children":[

                        ]
                    },
                    {
                        "id":182,
                        "label":"宽城满族自治县",
                        "value":"130827",
                        "key":"130827",
                        "parent_area_key":"130800",
                        "children":[

                        ]
                    },
                    {
                        "id":183,
                        "label":"围场满族蒙古族自治县",
                        "value":"130828",
                        "key":"130828",
                        "parent_area_key":"130800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":184,
                "label":"沧州市",
                "value":"130900",
                "key":"130900",
                "parent_area_key":"130000",
                "children":[
                    {
                        "id":185,
                        "label":"市辖区",
                        "value":"130901",
                        "key":"130901",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":186,
                        "label":"新华区",
                        "value":"130902",
                        "key":"130902",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":187,
                        "label":"运河区",
                        "value":"130903",
                        "key":"130903",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":188,
                        "label":"沧县",
                        "value":"130921",
                        "key":"130921",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":189,
                        "label":"青县",
                        "value":"130922",
                        "key":"130922",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":190,
                        "label":"东光县",
                        "value":"130923",
                        "key":"130923",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":191,
                        "label":"海兴县",
                        "value":"130924",
                        "key":"130924",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":192,
                        "label":"盐山县",
                        "value":"130925",
                        "key":"130925",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":193,
                        "label":"肃宁县",
                        "value":"130926",
                        "key":"130926",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":194,
                        "label":"南皮县",
                        "value":"130927",
                        "key":"130927",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":195,
                        "label":"吴桥县",
                        "value":"130928",
                        "key":"130928",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":196,
                        "label":"献县",
                        "value":"130929",
                        "key":"130929",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":197,
                        "label":"孟村回族自治县",
                        "value":"130930",
                        "key":"130930",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":198,
                        "label":"泊头市",
                        "value":"130981",
                        "key":"130981",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":199,
                        "label":"任丘市",
                        "value":"130982",
                        "key":"130982",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":200,
                        "label":"黄骅市",
                        "value":"130983",
                        "key":"130983",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    },
                    {
                        "id":201,
                        "label":"河间市",
                        "value":"130984",
                        "key":"130984",
                        "parent_area_key":"130900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":202,
                "label":"廊坊市",
                "value":"131000",
                "key":"131000",
                "parent_area_key":"130000",
                "children":[
                    {
                        "id":203,
                        "label":"市辖区",
                        "value":"131001",
                        "key":"131001",
                        "parent_area_key":"131000",
                        "children":[

                        ]
                    },
                    {
                        "id":204,
                        "label":"安次区",
                        "value":"131002",
                        "key":"131002",
                        "parent_area_key":"131000",
                        "children":[

                        ]
                    },
                    {
                        "id":205,
                        "label":"广阳区",
                        "value":"131003",
                        "key":"131003",
                        "parent_area_key":"131000",
                        "children":[

                        ]
                    },
                    {
                        "id":206,
                        "label":"固安县",
                        "value":"131022",
                        "key":"131022",
                        "parent_area_key":"131000",
                        "children":[

                        ]
                    },
                    {
                        "id":207,
                        "label":"永清县",
                        "value":"131023",
                        "key":"131023",
                        "parent_area_key":"131000",
                        "children":[

                        ]
                    },
                    {
                        "id":208,
                        "label":"香河县",
                        "value":"131024",
                        "key":"131024",
                        "parent_area_key":"131000",
                        "children":[

                        ]
                    },
                    {
                        "id":209,
                        "label":"大城县",
                        "value":"131025",
                        "key":"131025",
                        "parent_area_key":"131000",
                        "children":[

                        ]
                    },
                    {
                        "id":210,
                        "label":"文安县",
                        "value":"131026",
                        "key":"131026",
                        "parent_area_key":"131000",
                        "children":[

                        ]
                    },
                    {
                        "id":211,
                        "label":"大厂回族自治县",
                        "value":"131028",
                        "key":"131028",
                        "parent_area_key":"131000",
                        "children":[

                        ]
                    },
                    {
                        "id":212,
                        "label":"霸州市",
                        "value":"131081",
                        "key":"131081",
                        "parent_area_key":"131000",
                        "children":[

                        ]
                    },
                    {
                        "id":213,
                        "label":"三河市",
                        "value":"131082",
                        "key":"131082",
                        "parent_area_key":"131000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":214,
                "label":"衡水市",
                "value":"131100",
                "key":"131100",
                "parent_area_key":"130000",
                "children":[
                    {
                        "id":215,
                        "label":"市辖区",
                        "value":"131101",
                        "key":"131101",
                        "parent_area_key":"131100",
                        "children":[

                        ]
                    },
                    {
                        "id":216,
                        "label":"桃城区",
                        "value":"131102",
                        "key":"131102",
                        "parent_area_key":"131100",
                        "children":[

                        ]
                    },
                    {
                        "id":217,
                        "label":"冀州区",
                        "value":"131103",
                        "key":"131103",
                        "parent_area_key":"131100",
                        "children":[

                        ]
                    },
                    {
                        "id":218,
                        "label":"枣强县",
                        "value":"131121",
                        "key":"131121",
                        "parent_area_key":"131100",
                        "children":[

                        ]
                    },
                    {
                        "id":219,
                        "label":"武邑县",
                        "value":"131122",
                        "key":"131122",
                        "parent_area_key":"131100",
                        "children":[

                        ]
                    },
                    {
                        "id":220,
                        "label":"武强县",
                        "value":"131123",
                        "key":"131123",
                        "parent_area_key":"131100",
                        "children":[

                        ]
                    },
                    {
                        "id":221,
                        "label":"饶阳县",
                        "value":"131124",
                        "key":"131124",
                        "parent_area_key":"131100",
                        "children":[

                        ]
                    },
                    {
                        "id":222,
                        "label":"安平县",
                        "value":"131125",
                        "key":"131125",
                        "parent_area_key":"131100",
                        "children":[

                        ]
                    },
                    {
                        "id":223,
                        "label":"故城县",
                        "value":"131126",
                        "key":"131126",
                        "parent_area_key":"131100",
                        "children":[

                        ]
                    },
                    {
                        "id":224,
                        "label":"景县",
                        "value":"131127",
                        "key":"131127",
                        "parent_area_key":"131100",
                        "children":[

                        ]
                    },
                    {
                        "id":225,
                        "label":"阜城县",
                        "value":"131128",
                        "key":"131128",
                        "parent_area_key":"131100",
                        "children":[

                        ]
                    },
                    {
                        "id":226,
                        "label":"深州市",
                        "value":"131182",
                        "key":"131182",
                        "parent_area_key":"131100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":227,
                "label":"省直辖县级行政区划",
                "value":"139000",
                "key":"139000",
                "parent_area_key":"130000",
                "children":[
                    {
                        "id":228,
                        "label":"定州市",
                        "value":"139001",
                        "key":"139001",
                        "parent_area_key":"139000",
                        "children":[

                        ]
                    },
                    {
                        "id":229,
                        "label":"辛集市",
                        "value":"139002",
                        "key":"139002",
                        "parent_area_key":"139000",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":230,
        "label":"山西省",
        "value":"140000",
        "key":"140000",
        "parent_area_key":"",
        "children":[
            {
                "id":231,
                "label":"太原市",
                "value":"140100",
                "key":"140100",
                "parent_area_key":"140000",
                "children":[
                    {
                        "id":232,
                        "label":"市辖区",
                        "value":"140101",
                        "key":"140101",
                        "parent_area_key":"140100",
                        "children":[

                        ]
                    },
                    {
                        "id":233,
                        "label":"小店区",
                        "value":"140105",
                        "key":"140105",
                        "parent_area_key":"140100",
                        "children":[

                        ]
                    },
                    {
                        "id":234,
                        "label":"迎泽区",
                        "value":"140106",
                        "key":"140106",
                        "parent_area_key":"140100",
                        "children":[

                        ]
                    },
                    {
                        "id":235,
                        "label":"杏花岭区",
                        "value":"140107",
                        "key":"140107",
                        "parent_area_key":"140100",
                        "children":[

                        ]
                    },
                    {
                        "id":236,
                        "label":"尖草坪区",
                        "value":"140108",
                        "key":"140108",
                        "parent_area_key":"140100",
                        "children":[

                        ]
                    },
                    {
                        "id":237,
                        "label":"万柏林区",
                        "value":"140109",
                        "key":"140109",
                        "parent_area_key":"140100",
                        "children":[

                        ]
                    },
                    {
                        "id":238,
                        "label":"晋源区",
                        "value":"140110",
                        "key":"140110",
                        "parent_area_key":"140100",
                        "children":[

                        ]
                    },
                    {
                        "id":239,
                        "label":"清徐县",
                        "value":"140121",
                        "key":"140121",
                        "parent_area_key":"140100",
                        "children":[

                        ]
                    },
                    {
                        "id":240,
                        "label":"阳曲县",
                        "value":"140122",
                        "key":"140122",
                        "parent_area_key":"140100",
                        "children":[

                        ]
                    },
                    {
                        "id":241,
                        "label":"娄烦县",
                        "value":"140123",
                        "key":"140123",
                        "parent_area_key":"140100",
                        "children":[

                        ]
                    },
                    {
                        "id":242,
                        "label":"古交市",
                        "value":"140181",
                        "key":"140181",
                        "parent_area_key":"140100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":243,
                "label":"大同市",
                "value":"140200",
                "key":"140200",
                "parent_area_key":"140000",
                "children":[
                    {
                        "id":244,
                        "label":"市辖区",
                        "value":"140201",
                        "key":"140201",
                        "parent_area_key":"140200",
                        "children":[

                        ]
                    },
                    {
                        "id":245,
                        "label":"城区",
                        "value":"140202",
                        "key":"140202",
                        "parent_area_key":"140200",
                        "children":[

                        ]
                    },
                    {
                        "id":246,
                        "label":"矿区",
                        "value":"140203",
                        "key":"140203",
                        "parent_area_key":"140200",
                        "children":[

                        ]
                    },
                    {
                        "id":247,
                        "label":"南郊区",
                        "value":"140211",
                        "key":"140211",
                        "parent_area_key":"140200",
                        "children":[

                        ]
                    },
                    {
                        "id":248,
                        "label":"新荣区",
                        "value":"140212",
                        "key":"140212",
                        "parent_area_key":"140200",
                        "children":[

                        ]
                    },
                    {
                        "id":249,
                        "label":"阳高县",
                        "value":"140221",
                        "key":"140221",
                        "parent_area_key":"140200",
                        "children":[

                        ]
                    },
                    {
                        "id":250,
                        "label":"天镇县",
                        "value":"140222",
                        "key":"140222",
                        "parent_area_key":"140200",
                        "children":[

                        ]
                    },
                    {
                        "id":251,
                        "label":"广灵县",
                        "value":"140223",
                        "key":"140223",
                        "parent_area_key":"140200",
                        "children":[

                        ]
                    },
                    {
                        "id":252,
                        "label":"灵丘县",
                        "value":"140224",
                        "key":"140224",
                        "parent_area_key":"140200",
                        "children":[

                        ]
                    },
                    {
                        "id":253,
                        "label":"浑源县",
                        "value":"140225",
                        "key":"140225",
                        "parent_area_key":"140200",
                        "children":[

                        ]
                    },
                    {
                        "id":254,
                        "label":"左云县",
                        "value":"140226",
                        "key":"140226",
                        "parent_area_key":"140200",
                        "children":[

                        ]
                    },
                    {
                        "id":255,
                        "label":"大同县",
                        "value":"140227",
                        "key":"140227",
                        "parent_area_key":"140200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":256,
                "label":"阳泉市",
                "value":"140300",
                "key":"140300",
                "parent_area_key":"140000",
                "children":[
                    {
                        "id":257,
                        "label":"市辖区",
                        "value":"140301",
                        "key":"140301",
                        "parent_area_key":"140300",
                        "children":[

                        ]
                    },
                    {
                        "id":258,
                        "label":"城区",
                        "value":"140302",
                        "key":"140302",
                        "parent_area_key":"140300",
                        "children":[

                        ]
                    },
                    {
                        "id":259,
                        "label":"矿区",
                        "value":"140303",
                        "key":"140303",
                        "parent_area_key":"140300",
                        "children":[

                        ]
                    },
                    {
                        "id":260,
                        "label":"郊区",
                        "value":"140311",
                        "key":"140311",
                        "parent_area_key":"140300",
                        "children":[

                        ]
                    },
                    {
                        "id":261,
                        "label":"平定县",
                        "value":"140321",
                        "key":"140321",
                        "parent_area_key":"140300",
                        "children":[

                        ]
                    },
                    {
                        "id":262,
                        "label":"盂县",
                        "value":"140322",
                        "key":"140322",
                        "parent_area_key":"140300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":263,
                "label":"长治市",
                "value":"140400",
                "key":"140400",
                "parent_area_key":"140000",
                "children":[
                    {
                        "id":264,
                        "label":"市辖区",
                        "value":"140401",
                        "key":"140401",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    },
                    {
                        "id":265,
                        "label":"城区",
                        "value":"140402",
                        "key":"140402",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    },
                    {
                        "id":266,
                        "label":"郊区",
                        "value":"140411",
                        "key":"140411",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    },
                    {
                        "id":267,
                        "label":"长治县",
                        "value":"140421",
                        "key":"140421",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    },
                    {
                        "id":268,
                        "label":"襄垣县",
                        "value":"140423",
                        "key":"140423",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    },
                    {
                        "id":269,
                        "label":"屯留县",
                        "value":"140424",
                        "key":"140424",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    },
                    {
                        "id":270,
                        "label":"平顺县",
                        "value":"140425",
                        "key":"140425",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    },
                    {
                        "id":271,
                        "label":"黎城县",
                        "value":"140426",
                        "key":"140426",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    },
                    {
                        "id":272,
                        "label":"壶关县",
                        "value":"140427",
                        "key":"140427",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    },
                    {
                        "id":273,
                        "label":"长子县",
                        "value":"140428",
                        "key":"140428",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    },
                    {
                        "id":274,
                        "label":"武乡县",
                        "value":"140429",
                        "key":"140429",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    },
                    {
                        "id":275,
                        "label":"沁县",
                        "value":"140430",
                        "key":"140430",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    },
                    {
                        "id":276,
                        "label":"沁源县",
                        "value":"140431",
                        "key":"140431",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    },
                    {
                        "id":277,
                        "label":"潞城市",
                        "value":"140481",
                        "key":"140481",
                        "parent_area_key":"140400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":278,
                "label":"晋城市",
                "value":"140500",
                "key":"140500",
                "parent_area_key":"140000",
                "children":[
                    {
                        "id":279,
                        "label":"市辖区",
                        "value":"140501",
                        "key":"140501",
                        "parent_area_key":"140500",
                        "children":[

                        ]
                    },
                    {
                        "id":280,
                        "label":"城区",
                        "value":"140502",
                        "key":"140502",
                        "parent_area_key":"140500",
                        "children":[

                        ]
                    },
                    {
                        "id":281,
                        "label":"沁水县",
                        "value":"140521",
                        "key":"140521",
                        "parent_area_key":"140500",
                        "children":[

                        ]
                    },
                    {
                        "id":282,
                        "label":"阳城县",
                        "value":"140522",
                        "key":"140522",
                        "parent_area_key":"140500",
                        "children":[

                        ]
                    },
                    {
                        "id":283,
                        "label":"陵川县",
                        "value":"140524",
                        "key":"140524",
                        "parent_area_key":"140500",
                        "children":[

                        ]
                    },
                    {
                        "id":284,
                        "label":"泽州县",
                        "value":"140525",
                        "key":"140525",
                        "parent_area_key":"140500",
                        "children":[

                        ]
                    },
                    {
                        "id":285,
                        "label":"高平市",
                        "value":"140581",
                        "key":"140581",
                        "parent_area_key":"140500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":286,
                "label":"朔州市",
                "value":"140600",
                "key":"140600",
                "parent_area_key":"140000",
                "children":[
                    {
                        "id":287,
                        "label":"市辖区",
                        "value":"140601",
                        "key":"140601",
                        "parent_area_key":"140600",
                        "children":[

                        ]
                    },
                    {
                        "id":288,
                        "label":"朔城区",
                        "value":"140602",
                        "key":"140602",
                        "parent_area_key":"140600",
                        "children":[

                        ]
                    },
                    {
                        "id":289,
                        "label":"平鲁区",
                        "value":"140603",
                        "key":"140603",
                        "parent_area_key":"140600",
                        "children":[

                        ]
                    },
                    {
                        "id":290,
                        "label":"山阴县",
                        "value":"140621",
                        "key":"140621",
                        "parent_area_key":"140600",
                        "children":[

                        ]
                    },
                    {
                        "id":291,
                        "label":"应县",
                        "value":"140622",
                        "key":"140622",
                        "parent_area_key":"140600",
                        "children":[

                        ]
                    },
                    {
                        "id":292,
                        "label":"右玉县",
                        "value":"140623",
                        "key":"140623",
                        "parent_area_key":"140600",
                        "children":[

                        ]
                    },
                    {
                        "id":293,
                        "label":"怀仁县",
                        "value":"140624",
                        "key":"140624",
                        "parent_area_key":"140600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":294,
                "label":"晋中市",
                "value":"140700",
                "key":"140700",
                "parent_area_key":"140000",
                "children":[
                    {
                        "id":295,
                        "label":"市辖区",
                        "value":"140701",
                        "key":"140701",
                        "parent_area_key":"140700",
                        "children":[

                        ]
                    },
                    {
                        "id":296,
                        "label":"榆次区",
                        "value":"140702",
                        "key":"140702",
                        "parent_area_key":"140700",
                        "children":[

                        ]
                    },
                    {
                        "id":297,
                        "label":"榆社县",
                        "value":"140721",
                        "key":"140721",
                        "parent_area_key":"140700",
                        "children":[

                        ]
                    },
                    {
                        "id":298,
                        "label":"左权县",
                        "value":"140722",
                        "key":"140722",
                        "parent_area_key":"140700",
                        "children":[

                        ]
                    },
                    {
                        "id":299,
                        "label":"和顺县",
                        "value":"140723",
                        "key":"140723",
                        "parent_area_key":"140700",
                        "children":[

                        ]
                    },
                    {
                        "id":300,
                        "label":"昔阳县",
                        "value":"140724",
                        "key":"140724",
                        "parent_area_key":"140700",
                        "children":[

                        ]
                    },
                    {
                        "id":301,
                        "label":"寿阳县",
                        "value":"140725",
                        "key":"140725",
                        "parent_area_key":"140700",
                        "children":[

                        ]
                    },
                    {
                        "id":302,
                        "label":"太谷县",
                        "value":"140726",
                        "key":"140726",
                        "parent_area_key":"140700",
                        "children":[

                        ]
                    },
                    {
                        "id":303,
                        "label":"祁县",
                        "value":"140727",
                        "key":"140727",
                        "parent_area_key":"140700",
                        "children":[

                        ]
                    },
                    {
                        "id":304,
                        "label":"平遥县",
                        "value":"140728",
                        "key":"140728",
                        "parent_area_key":"140700",
                        "children":[

                        ]
                    },
                    {
                        "id":305,
                        "label":"灵石县",
                        "value":"140729",
                        "key":"140729",
                        "parent_area_key":"140700",
                        "children":[

                        ]
                    },
                    {
                        "id":306,
                        "label":"介休市",
                        "value":"140781",
                        "key":"140781",
                        "parent_area_key":"140700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":307,
                "label":"运城市",
                "value":"140800",
                "key":"140800",
                "parent_area_key":"140000",
                "children":[
                    {
                        "id":308,
                        "label":"市辖区",
                        "value":"140801",
                        "key":"140801",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    },
                    {
                        "id":309,
                        "label":"盐湖区",
                        "value":"140802",
                        "key":"140802",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    },
                    {
                        "id":310,
                        "label":"临猗县",
                        "value":"140821",
                        "key":"140821",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    },
                    {
                        "id":311,
                        "label":"万荣县",
                        "value":"140822",
                        "key":"140822",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    },
                    {
                        "id":312,
                        "label":"闻喜县",
                        "value":"140823",
                        "key":"140823",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    },
                    {
                        "id":313,
                        "label":"稷山县",
                        "value":"140824",
                        "key":"140824",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    },
                    {
                        "id":314,
                        "label":"新绛县",
                        "value":"140825",
                        "key":"140825",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    },
                    {
                        "id":315,
                        "label":"绛县",
                        "value":"140826",
                        "key":"140826",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    },
                    {
                        "id":316,
                        "label":"垣曲县",
                        "value":"140827",
                        "key":"140827",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    },
                    {
                        "id":317,
                        "label":"夏县",
                        "value":"140828",
                        "key":"140828",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    },
                    {
                        "id":318,
                        "label":"平陆县",
                        "value":"140829",
                        "key":"140829",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    },
                    {
                        "id":319,
                        "label":"芮城县",
                        "value":"140830",
                        "key":"140830",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    },
                    {
                        "id":320,
                        "label":"永济市",
                        "value":"140881",
                        "key":"140881",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    },
                    {
                        "id":321,
                        "label":"河津市",
                        "value":"140882",
                        "key":"140882",
                        "parent_area_key":"140800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":322,
                "label":"忻州市",
                "value":"140900",
                "key":"140900",
                "parent_area_key":"140000",
                "children":[
                    {
                        "id":323,
                        "label":"市辖区",
                        "value":"140901",
                        "key":"140901",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":324,
                        "label":"忻府区",
                        "value":"140902",
                        "key":"140902",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":325,
                        "label":"定襄县",
                        "value":"140921",
                        "key":"140921",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":326,
                        "label":"五台县",
                        "value":"140922",
                        "key":"140922",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":327,
                        "label":"代县",
                        "value":"140923",
                        "key":"140923",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":328,
                        "label":"繁峙县",
                        "value":"140924",
                        "key":"140924",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":329,
                        "label":"宁武县",
                        "value":"140925",
                        "key":"140925",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":330,
                        "label":"静乐县",
                        "value":"140926",
                        "key":"140926",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":331,
                        "label":"神池县",
                        "value":"140927",
                        "key":"140927",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":332,
                        "label":"五寨县",
                        "value":"140928",
                        "key":"140928",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":333,
                        "label":"岢岚县",
                        "value":"140929",
                        "key":"140929",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":334,
                        "label":"河曲县",
                        "value":"140930",
                        "key":"140930",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":335,
                        "label":"保德县",
                        "value":"140931",
                        "key":"140931",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":336,
                        "label":"偏关县",
                        "value":"140932",
                        "key":"140932",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    },
                    {
                        "id":337,
                        "label":"原平市",
                        "value":"140981",
                        "key":"140981",
                        "parent_area_key":"140900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":338,
                "label":"临汾市",
                "value":"141000",
                "key":"141000",
                "parent_area_key":"140000",
                "children":[
                    {
                        "id":339,
                        "label":"市辖区",
                        "value":"141001",
                        "key":"141001",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":340,
                        "label":"尧都区",
                        "value":"141002",
                        "key":"141002",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":341,
                        "label":"曲沃县",
                        "value":"141021",
                        "key":"141021",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":342,
                        "label":"翼城县",
                        "value":"141022",
                        "key":"141022",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":343,
                        "label":"襄汾县",
                        "value":"141023",
                        "key":"141023",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":344,
                        "label":"洪洞县",
                        "value":"141024",
                        "key":"141024",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":345,
                        "label":"古县",
                        "value":"141025",
                        "key":"141025",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":346,
                        "label":"安泽县",
                        "value":"141026",
                        "key":"141026",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":347,
                        "label":"浮山县",
                        "value":"141027",
                        "key":"141027",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":348,
                        "label":"吉县",
                        "value":"141028",
                        "key":"141028",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":349,
                        "label":"乡宁县",
                        "value":"141029",
                        "key":"141029",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":350,
                        "label":"大宁县",
                        "value":"141030",
                        "key":"141030",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":351,
                        "label":"隰县",
                        "value":"141031",
                        "key":"141031",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":352,
                        "label":"永和县",
                        "value":"141032",
                        "key":"141032",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":353,
                        "label":"蒲县",
                        "value":"141033",
                        "key":"141033",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":354,
                        "label":"汾西县",
                        "value":"141034",
                        "key":"141034",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":355,
                        "label":"侯马市",
                        "value":"141081",
                        "key":"141081",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    },
                    {
                        "id":356,
                        "label":"霍州市",
                        "value":"141082",
                        "key":"141082",
                        "parent_area_key":"141000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":357,
                "label":"吕梁市",
                "value":"141100",
                "key":"141100",
                "parent_area_key":"140000",
                "children":[
                    {
                        "id":358,
                        "label":"市辖区",
                        "value":"141101",
                        "key":"141101",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    },
                    {
                        "id":359,
                        "label":"离石区",
                        "value":"141102",
                        "key":"141102",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    },
                    {
                        "id":360,
                        "label":"文水县",
                        "value":"141121",
                        "key":"141121",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    },
                    {
                        "id":361,
                        "label":"交城县",
                        "value":"141122",
                        "key":"141122",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    },
                    {
                        "id":362,
                        "label":"兴县",
                        "value":"141123",
                        "key":"141123",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    },
                    {
                        "id":363,
                        "label":"临县",
                        "value":"141124",
                        "key":"141124",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    },
                    {
                        "id":364,
                        "label":"柳林县",
                        "value":"141125",
                        "key":"141125",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    },
                    {
                        "id":365,
                        "label":"石楼县",
                        "value":"141126",
                        "key":"141126",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    },
                    {
                        "id":366,
                        "label":"岚县",
                        "value":"141127",
                        "key":"141127",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    },
                    {
                        "id":367,
                        "label":"方山县",
                        "value":"141128",
                        "key":"141128",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    },
                    {
                        "id":368,
                        "label":"中阳县",
                        "value":"141129",
                        "key":"141129",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    },
                    {
                        "id":369,
                        "label":"交口县",
                        "value":"141130",
                        "key":"141130",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    },
                    {
                        "id":370,
                        "label":"孝义市",
                        "value":"141181",
                        "key":"141181",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    },
                    {
                        "id":371,
                        "label":"汾阳市",
                        "value":"141182",
                        "key":"141182",
                        "parent_area_key":"141100",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":372,
        "label":"内蒙古自治区",
        "value":"150000",
        "key":"150000",
        "parent_area_key":"",
        "children":[
            {
                "id":373,
                "label":"呼和浩特市",
                "value":"150100",
                "key":"150100",
                "parent_area_key":"150000",
                "children":[
                    {
                        "id":374,
                        "label":"市辖区",
                        "value":"150101",
                        "key":"150101",
                        "parent_area_key":"150100",
                        "children":[

                        ]
                    },
                    {
                        "id":375,
                        "label":"新城区",
                        "value":"150102",
                        "key":"150102",
                        "parent_area_key":"150100",
                        "children":[

                        ]
                    },
                    {
                        "id":376,
                        "label":"回民区",
                        "value":"150103",
                        "key":"150103",
                        "parent_area_key":"150100",
                        "children":[

                        ]
                    },
                    {
                        "id":377,
                        "label":"玉泉区",
                        "value":"150104",
                        "key":"150104",
                        "parent_area_key":"150100",
                        "children":[

                        ]
                    },
                    {
                        "id":378,
                        "label":"赛罕区",
                        "value":"150105",
                        "key":"150105",
                        "parent_area_key":"150100",
                        "children":[

                        ]
                    },
                    {
                        "id":379,
                        "label":"土默特左旗",
                        "value":"150121",
                        "key":"150121",
                        "parent_area_key":"150100",
                        "children":[

                        ]
                    },
                    {
                        "id":380,
                        "label":"托克托县",
                        "value":"150122",
                        "key":"150122",
                        "parent_area_key":"150100",
                        "children":[

                        ]
                    },
                    {
                        "id":381,
                        "label":"和林格尔县",
                        "value":"150123",
                        "key":"150123",
                        "parent_area_key":"150100",
                        "children":[

                        ]
                    },
                    {
                        "id":382,
                        "label":"清水河县",
                        "value":"150124",
                        "key":"150124",
                        "parent_area_key":"150100",
                        "children":[

                        ]
                    },
                    {
                        "id":383,
                        "label":"武川县",
                        "value":"150125",
                        "key":"150125",
                        "parent_area_key":"150100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":384,
                "label":"包头市",
                "value":"150200",
                "key":"150200",
                "parent_area_key":"150000",
                "children":[
                    {
                        "id":385,
                        "label":"市辖区",
                        "value":"150201",
                        "key":"150201",
                        "parent_area_key":"150200",
                        "children":[

                        ]
                    },
                    {
                        "id":386,
                        "label":"东河区",
                        "value":"150202",
                        "key":"150202",
                        "parent_area_key":"150200",
                        "children":[

                        ]
                    },
                    {
                        "id":387,
                        "label":"昆都仑区",
                        "value":"150203",
                        "key":"150203",
                        "parent_area_key":"150200",
                        "children":[

                        ]
                    },
                    {
                        "id":388,
                        "label":"青山区",
                        "value":"150204",
                        "key":"150204",
                        "parent_area_key":"150200",
                        "children":[

                        ]
                    },
                    {
                        "id":389,
                        "label":"石拐区",
                        "value":"150205",
                        "key":"150205",
                        "parent_area_key":"150200",
                        "children":[

                        ]
                    },
                    {
                        "id":390,
                        "label":"白云鄂博矿区",
                        "value":"150206",
                        "key":"150206",
                        "parent_area_key":"150200",
                        "children":[

                        ]
                    },
                    {
                        "id":391,
                        "label":"九原区",
                        "value":"150207",
                        "key":"150207",
                        "parent_area_key":"150200",
                        "children":[

                        ]
                    },
                    {
                        "id":392,
                        "label":"土默特右旗",
                        "value":"150221",
                        "key":"150221",
                        "parent_area_key":"150200",
                        "children":[

                        ]
                    },
                    {
                        "id":393,
                        "label":"固阳县",
                        "value":"150222",
                        "key":"150222",
                        "parent_area_key":"150200",
                        "children":[

                        ]
                    },
                    {
                        "id":394,
                        "label":"达尔罕茂明安联合旗",
                        "value":"150223",
                        "key":"150223",
                        "parent_area_key":"150200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":395,
                "label":"乌海市",
                "value":"150300",
                "key":"150300",
                "parent_area_key":"150000",
                "children":[
                    {
                        "id":396,
                        "label":"市辖区",
                        "value":"150301",
                        "key":"150301",
                        "parent_area_key":"150300",
                        "children":[

                        ]
                    },
                    {
                        "id":397,
                        "label":"海勃湾区",
                        "value":"150302",
                        "key":"150302",
                        "parent_area_key":"150300",
                        "children":[

                        ]
                    },
                    {
                        "id":398,
                        "label":"海南区",
                        "value":"150303",
                        "key":"150303",
                        "parent_area_key":"150300",
                        "children":[

                        ]
                    },
                    {
                        "id":399,
                        "label":"乌达区",
                        "value":"150304",
                        "key":"150304",
                        "parent_area_key":"150300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":400,
                "label":"赤峰市",
                "value":"150400",
                "key":"150400",
                "parent_area_key":"150000",
                "children":[
                    {
                        "id":401,
                        "label":"市辖区",
                        "value":"150401",
                        "key":"150401",
                        "parent_area_key":"150400",
                        "children":[

                        ]
                    },
                    {
                        "id":402,
                        "label":"红山区",
                        "value":"150402",
                        "key":"150402",
                        "parent_area_key":"150400",
                        "children":[

                        ]
                    },
                    {
                        "id":403,
                        "label":"元宝山区",
                        "value":"150403",
                        "key":"150403",
                        "parent_area_key":"150400",
                        "children":[

                        ]
                    },
                    {
                        "id":404,
                        "label":"松山区",
                        "value":"150404",
                        "key":"150404",
                        "parent_area_key":"150400",
                        "children":[

                        ]
                    },
                    {
                        "id":405,
                        "label":"阿鲁科尔沁旗",
                        "value":"150421",
                        "key":"150421",
                        "parent_area_key":"150400",
                        "children":[

                        ]
                    },
                    {
                        "id":406,
                        "label":"巴林左旗",
                        "value":"150422",
                        "key":"150422",
                        "parent_area_key":"150400",
                        "children":[

                        ]
                    },
                    {
                        "id":407,
                        "label":"巴林右旗",
                        "value":"150423",
                        "key":"150423",
                        "parent_area_key":"150400",
                        "children":[

                        ]
                    },
                    {
                        "id":408,
                        "label":"林西县",
                        "value":"150424",
                        "key":"150424",
                        "parent_area_key":"150400",
                        "children":[

                        ]
                    },
                    {
                        "id":409,
                        "label":"克什克腾旗",
                        "value":"150425",
                        "key":"150425",
                        "parent_area_key":"150400",
                        "children":[

                        ]
                    },
                    {
                        "id":410,
                        "label":"翁牛特旗",
                        "value":"150426",
                        "key":"150426",
                        "parent_area_key":"150400",
                        "children":[

                        ]
                    },
                    {
                        "id":411,
                        "label":"喀喇沁旗",
                        "value":"150428",
                        "key":"150428",
                        "parent_area_key":"150400",
                        "children":[

                        ]
                    },
                    {
                        "id":412,
                        "label":"宁城县",
                        "value":"150429",
                        "key":"150429",
                        "parent_area_key":"150400",
                        "children":[

                        ]
                    },
                    {
                        "id":413,
                        "label":"敖汉旗",
                        "value":"150430",
                        "key":"150430",
                        "parent_area_key":"150400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":414,
                "label":"通辽市",
                "value":"150500",
                "key":"150500",
                "parent_area_key":"150000",
                "children":[
                    {
                        "id":415,
                        "label":"市辖区",
                        "value":"150501",
                        "key":"150501",
                        "parent_area_key":"150500",
                        "children":[

                        ]
                    },
                    {
                        "id":416,
                        "label":"科尔沁区",
                        "value":"150502",
                        "key":"150502",
                        "parent_area_key":"150500",
                        "children":[

                        ]
                    },
                    {
                        "id":417,
                        "label":"科尔沁左翼中旗",
                        "value":"150521",
                        "key":"150521",
                        "parent_area_key":"150500",
                        "children":[

                        ]
                    },
                    {
                        "id":418,
                        "label":"科尔沁左翼后旗",
                        "value":"150522",
                        "key":"150522",
                        "parent_area_key":"150500",
                        "children":[

                        ]
                    },
                    {
                        "id":419,
                        "label":"开鲁县",
                        "value":"150523",
                        "key":"150523",
                        "parent_area_key":"150500",
                        "children":[

                        ]
                    },
                    {
                        "id":420,
                        "label":"库伦旗",
                        "value":"150524",
                        "key":"150524",
                        "parent_area_key":"150500",
                        "children":[

                        ]
                    },
                    {
                        "id":421,
                        "label":"奈曼旗",
                        "value":"150525",
                        "key":"150525",
                        "parent_area_key":"150500",
                        "children":[

                        ]
                    },
                    {
                        "id":422,
                        "label":"扎鲁特旗",
                        "value":"150526",
                        "key":"150526",
                        "parent_area_key":"150500",
                        "children":[

                        ]
                    },
                    {
                        "id":423,
                        "label":"霍林郭勒市",
                        "value":"150581",
                        "key":"150581",
                        "parent_area_key":"150500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":424,
                "label":"鄂尔多斯市",
                "value":"150600",
                "key":"150600",
                "parent_area_key":"150000",
                "children":[
                    {
                        "id":425,
                        "label":"市辖区",
                        "value":"150601",
                        "key":"150601",
                        "parent_area_key":"150600",
                        "children":[

                        ]
                    },
                    {
                        "id":426,
                        "label":"东胜区",
                        "value":"150602",
                        "key":"150602",
                        "parent_area_key":"150600",
                        "children":[

                        ]
                    },
                    {
                        "id":427,
                        "label":"康巴什区",
                        "value":"150603",
                        "key":"150603",
                        "parent_area_key":"150600",
                        "children":[

                        ]
                    },
                    {
                        "id":428,
                        "label":"达拉特旗",
                        "value":"150621",
                        "key":"150621",
                        "parent_area_key":"150600",
                        "children":[

                        ]
                    },
                    {
                        "id":429,
                        "label":"准格尔旗",
                        "value":"150622",
                        "key":"150622",
                        "parent_area_key":"150600",
                        "children":[

                        ]
                    },
                    {
                        "id":430,
                        "label":"鄂托克前旗",
                        "value":"150623",
                        "key":"150623",
                        "parent_area_key":"150600",
                        "children":[

                        ]
                    },
                    {
                        "id":431,
                        "label":"鄂托克旗",
                        "value":"150624",
                        "key":"150624",
                        "parent_area_key":"150600",
                        "children":[

                        ]
                    },
                    {
                        "id":432,
                        "label":"杭锦旗",
                        "value":"150625",
                        "key":"150625",
                        "parent_area_key":"150600",
                        "children":[

                        ]
                    },
                    {
                        "id":433,
                        "label":"乌审旗",
                        "value":"150626",
                        "key":"150626",
                        "parent_area_key":"150600",
                        "children":[

                        ]
                    },
                    {
                        "id":434,
                        "label":"伊金霍洛旗",
                        "value":"150627",
                        "key":"150627",
                        "parent_area_key":"150600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":435,
                "label":"呼伦贝尔市",
                "value":"150700",
                "key":"150700",
                "parent_area_key":"150000",
                "children":[
                    {
                        "id":436,
                        "label":"市辖区",
                        "value":"150701",
                        "key":"150701",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":437,
                        "label":"海拉尔区",
                        "value":"150702",
                        "key":"150702",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":438,
                        "label":"扎赉诺尔区",
                        "value":"150703",
                        "key":"150703",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":439,
                        "label":"阿荣旗",
                        "value":"150721",
                        "key":"150721",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":440,
                        "label":"莫力达瓦达斡尔族自治旗",
                        "value":"150722",
                        "key":"150722",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":441,
                        "label":"鄂伦春自治旗",
                        "value":"150723",
                        "key":"150723",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":442,
                        "label":"鄂温克族自治旗",
                        "value":"150724",
                        "key":"150724",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":443,
                        "label":"陈巴尔虎旗",
                        "value":"150725",
                        "key":"150725",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":444,
                        "label":"新巴尔虎左旗",
                        "value":"150726",
                        "key":"150726",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":445,
                        "label":"新巴尔虎右旗",
                        "value":"150727",
                        "key":"150727",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":446,
                        "label":"满洲里市",
                        "value":"150781",
                        "key":"150781",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":447,
                        "label":"牙克石市",
                        "value":"150782",
                        "key":"150782",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":448,
                        "label":"扎兰屯市",
                        "value":"150783",
                        "key":"150783",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":449,
                        "label":"额尔古纳市",
                        "value":"150784",
                        "key":"150784",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    },
                    {
                        "id":450,
                        "label":"根河市",
                        "value":"150785",
                        "key":"150785",
                        "parent_area_key":"150700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":451,
                "label":"巴彦淖尔市",
                "value":"150800",
                "key":"150800",
                "parent_area_key":"150000",
                "children":[
                    {
                        "id":452,
                        "label":"市辖区",
                        "value":"150801",
                        "key":"150801",
                        "parent_area_key":"150800",
                        "children":[

                        ]
                    },
                    {
                        "id":453,
                        "label":"临河区",
                        "value":"150802",
                        "key":"150802",
                        "parent_area_key":"150800",
                        "children":[

                        ]
                    },
                    {
                        "id":454,
                        "label":"五原县",
                        "value":"150821",
                        "key":"150821",
                        "parent_area_key":"150800",
                        "children":[

                        ]
                    },
                    {
                        "id":455,
                        "label":"磴口县",
                        "value":"150822",
                        "key":"150822",
                        "parent_area_key":"150800",
                        "children":[

                        ]
                    },
                    {
                        "id":456,
                        "label":"乌拉特前旗",
                        "value":"150823",
                        "key":"150823",
                        "parent_area_key":"150800",
                        "children":[

                        ]
                    },
                    {
                        "id":457,
                        "label":"乌拉特中旗",
                        "value":"150824",
                        "key":"150824",
                        "parent_area_key":"150800",
                        "children":[

                        ]
                    },
                    {
                        "id":458,
                        "label":"乌拉特后旗",
                        "value":"150825",
                        "key":"150825",
                        "parent_area_key":"150800",
                        "children":[

                        ]
                    },
                    {
                        "id":459,
                        "label":"杭锦后旗",
                        "value":"150826",
                        "key":"150826",
                        "parent_area_key":"150800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":460,
                "label":"乌兰察布市",
                "value":"150900",
                "key":"150900",
                "parent_area_key":"150000",
                "children":[
                    {
                        "id":461,
                        "label":"市辖区",
                        "value":"150901",
                        "key":"150901",
                        "parent_area_key":"150900",
                        "children":[

                        ]
                    },
                    {
                        "id":462,
                        "label":"集宁区",
                        "value":"150902",
                        "key":"150902",
                        "parent_area_key":"150900",
                        "children":[

                        ]
                    },
                    {
                        "id":463,
                        "label":"卓资县",
                        "value":"150921",
                        "key":"150921",
                        "parent_area_key":"150900",
                        "children":[

                        ]
                    },
                    {
                        "id":464,
                        "label":"化德县",
                        "value":"150922",
                        "key":"150922",
                        "parent_area_key":"150900",
                        "children":[

                        ]
                    },
                    {
                        "id":465,
                        "label":"商都县",
                        "value":"150923",
                        "key":"150923",
                        "parent_area_key":"150900",
                        "children":[

                        ]
                    },
                    {
                        "id":466,
                        "label":"兴和县",
                        "value":"150924",
                        "key":"150924",
                        "parent_area_key":"150900",
                        "children":[

                        ]
                    },
                    {
                        "id":467,
                        "label":"凉城县",
                        "value":"150925",
                        "key":"150925",
                        "parent_area_key":"150900",
                        "children":[

                        ]
                    },
                    {
                        "id":468,
                        "label":"察哈尔右翼前旗",
                        "value":"150926",
                        "key":"150926",
                        "parent_area_key":"150900",
                        "children":[

                        ]
                    },
                    {
                        "id":469,
                        "label":"察哈尔右翼中旗",
                        "value":"150927",
                        "key":"150927",
                        "parent_area_key":"150900",
                        "children":[

                        ]
                    },
                    {
                        "id":470,
                        "label":"察哈尔右翼后旗",
                        "value":"150928",
                        "key":"150928",
                        "parent_area_key":"150900",
                        "children":[

                        ]
                    },
                    {
                        "id":471,
                        "label":"四子王旗",
                        "value":"150929",
                        "key":"150929",
                        "parent_area_key":"150900",
                        "children":[

                        ]
                    },
                    {
                        "id":472,
                        "label":"丰镇市",
                        "value":"150981",
                        "key":"150981",
                        "parent_area_key":"150900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":473,
                "label":"兴安盟",
                "value":"152200",
                "key":"152200",
                "parent_area_key":"150000",
                "children":[
                    {
                        "id":474,
                        "label":"乌兰浩特市",
                        "value":"152201",
                        "key":"152201",
                        "parent_area_key":"152200",
                        "children":[

                        ]
                    },
                    {
                        "id":475,
                        "label":"阿尔山市",
                        "value":"152202",
                        "key":"152202",
                        "parent_area_key":"152200",
                        "children":[

                        ]
                    },
                    {
                        "id":476,
                        "label":"科尔沁右翼前旗",
                        "value":"152221",
                        "key":"152221",
                        "parent_area_key":"152200",
                        "children":[

                        ]
                    },
                    {
                        "id":477,
                        "label":"科尔沁右翼中旗",
                        "value":"152222",
                        "key":"152222",
                        "parent_area_key":"152200",
                        "children":[

                        ]
                    },
                    {
                        "id":478,
                        "label":"扎赉特旗",
                        "value":"152223",
                        "key":"152223",
                        "parent_area_key":"152200",
                        "children":[

                        ]
                    },
                    {
                        "id":479,
                        "label":"突泉县",
                        "value":"152224",
                        "key":"152224",
                        "parent_area_key":"152200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":480,
                "label":"锡林郭勒盟",
                "value":"152500",
                "key":"152500",
                "parent_area_key":"150000",
                "children":[
                    {
                        "id":481,
                        "label":"二连浩特市",
                        "value":"152501",
                        "key":"152501",
                        "parent_area_key":"152500",
                        "children":[

                        ]
                    },
                    {
                        "id":482,
                        "label":"锡林浩特市",
                        "value":"152502",
                        "key":"152502",
                        "parent_area_key":"152500",
                        "children":[

                        ]
                    },
                    {
                        "id":483,
                        "label":"阿巴嘎旗",
                        "value":"152522",
                        "key":"152522",
                        "parent_area_key":"152500",
                        "children":[

                        ]
                    },
                    {
                        "id":484,
                        "label":"苏尼特左旗",
                        "value":"152523",
                        "key":"152523",
                        "parent_area_key":"152500",
                        "children":[

                        ]
                    },
                    {
                        "id":485,
                        "label":"苏尼特右旗",
                        "value":"152524",
                        "key":"152524",
                        "parent_area_key":"152500",
                        "children":[

                        ]
                    },
                    {
                        "id":486,
                        "label":"东乌珠穆沁旗",
                        "value":"152525",
                        "key":"152525",
                        "parent_area_key":"152500",
                        "children":[

                        ]
                    },
                    {
                        "id":487,
                        "label":"西乌珠穆沁旗",
                        "value":"152526",
                        "key":"152526",
                        "parent_area_key":"152500",
                        "children":[

                        ]
                    },
                    {
                        "id":488,
                        "label":"太仆寺旗",
                        "value":"152527",
                        "key":"152527",
                        "parent_area_key":"152500",
                        "children":[

                        ]
                    },
                    {
                        "id":489,
                        "label":"镶黄旗",
                        "value":"152528",
                        "key":"152528",
                        "parent_area_key":"152500",
                        "children":[

                        ]
                    },
                    {
                        "id":490,
                        "label":"正镶白旗",
                        "value":"152529",
                        "key":"152529",
                        "parent_area_key":"152500",
                        "children":[

                        ]
                    },
                    {
                        "id":491,
                        "label":"正蓝旗",
                        "value":"152530",
                        "key":"152530",
                        "parent_area_key":"152500",
                        "children":[

                        ]
                    },
                    {
                        "id":492,
                        "label":"多伦县",
                        "value":"152531",
                        "key":"152531",
                        "parent_area_key":"152500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":493,
                "label":"阿拉善盟",
                "value":"152900",
                "key":"152900",
                "parent_area_key":"150000",
                "children":[
                    {
                        "id":494,
                        "label":"阿拉善左旗",
                        "value":"152921",
                        "key":"152921",
                        "parent_area_key":"152900",
                        "children":[

                        ]
                    },
                    {
                        "id":495,
                        "label":"阿拉善右旗",
                        "value":"152922",
                        "key":"152922",
                        "parent_area_key":"152900",
                        "children":[

                        ]
                    },
                    {
                        "id":496,
                        "label":"额济纳旗",
                        "value":"152923",
                        "key":"152923",
                        "parent_area_key":"152900",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":497,
        "label":"辽宁省",
        "value":"210000",
        "key":"210000",
        "parent_area_key":"",
        "children":[
            {
                "id":498,
                "label":"沈阳市",
                "value":"210100",
                "key":"210100",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":499,
                        "label":"市辖区",
                        "value":"210101",
                        "key":"210101",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    },
                    {
                        "id":500,
                        "label":"和平区",
                        "value":"210102",
                        "key":"210102",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    },
                    {
                        "id":501,
                        "label":"沈河区",
                        "value":"210103",
                        "key":"210103",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    },
                    {
                        "id":502,
                        "label":"大东区",
                        "value":"210104",
                        "key":"210104",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    },
                    {
                        "id":503,
                        "label":"皇姑区",
                        "value":"210105",
                        "key":"210105",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    },
                    {
                        "id":504,
                        "label":"铁西区",
                        "value":"210106",
                        "key":"210106",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    },
                    {
                        "id":505,
                        "label":"苏家屯区",
                        "value":"210111",
                        "key":"210111",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    },
                    {
                        "id":506,
                        "label":"浑南区",
                        "value":"210112",
                        "key":"210112",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    },
                    {
                        "id":507,
                        "label":"沈北新区",
                        "value":"210113",
                        "key":"210113",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    },
                    {
                        "id":508,
                        "label":"于洪区",
                        "value":"210114",
                        "key":"210114",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    },
                    {
                        "id":509,
                        "label":"辽中区",
                        "value":"210115",
                        "key":"210115",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    },
                    {
                        "id":510,
                        "label":"康平县",
                        "value":"210123",
                        "key":"210123",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    },
                    {
                        "id":511,
                        "label":"法库县",
                        "value":"210124",
                        "key":"210124",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    },
                    {
                        "id":512,
                        "label":"新民市",
                        "value":"210181",
                        "key":"210181",
                        "parent_area_key":"210100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":513,
                "label":"大连市",
                "value":"210200",
                "key":"210200",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":514,
                        "label":"市辖区",
                        "value":"210201",
                        "key":"210201",
                        "parent_area_key":"210200",
                        "children":[

                        ]
                    },
                    {
                        "id":515,
                        "label":"中山区",
                        "value":"210202",
                        "key":"210202",
                        "parent_area_key":"210200",
                        "children":[

                        ]
                    },
                    {
                        "id":516,
                        "label":"西岗区",
                        "value":"210203",
                        "key":"210203",
                        "parent_area_key":"210200",
                        "children":[

                        ]
                    },
                    {
                        "id":517,
                        "label":"沙河口区",
                        "value":"210204",
                        "key":"210204",
                        "parent_area_key":"210200",
                        "children":[

                        ]
                    },
                    {
                        "id":518,
                        "label":"甘井子区",
                        "value":"210211",
                        "key":"210211",
                        "parent_area_key":"210200",
                        "children":[

                        ]
                    },
                    {
                        "id":519,
                        "label":"旅顺口区",
                        "value":"210212",
                        "key":"210212",
                        "parent_area_key":"210200",
                        "children":[

                        ]
                    },
                    {
                        "id":520,
                        "label":"金州区",
                        "value":"210213",
                        "key":"210213",
                        "parent_area_key":"210200",
                        "children":[

                        ]
                    },
                    {
                        "id":521,
                        "label":"普兰店区",
                        "value":"210214",
                        "key":"210214",
                        "parent_area_key":"210200",
                        "children":[

                        ]
                    },
                    {
                        "id":522,
                        "label":"长海县",
                        "value":"210224",
                        "key":"210224",
                        "parent_area_key":"210200",
                        "children":[

                        ]
                    },
                    {
                        "id":523,
                        "label":"瓦房店市",
                        "value":"210281",
                        "key":"210281",
                        "parent_area_key":"210200",
                        "children":[

                        ]
                    },
                    {
                        "id":524,
                        "label":"庄河市",
                        "value":"210283",
                        "key":"210283",
                        "parent_area_key":"210200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":525,
                "label":"鞍山市",
                "value":"210300",
                "key":"210300",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":526,
                        "label":"市辖区",
                        "value":"210301",
                        "key":"210301",
                        "parent_area_key":"210300",
                        "children":[

                        ]
                    },
                    {
                        "id":527,
                        "label":"铁东区",
                        "value":"210302",
                        "key":"210302",
                        "parent_area_key":"210300",
                        "children":[

                        ]
                    },
                    {
                        "id":528,
                        "label":"铁西区",
                        "value":"210303",
                        "key":"210303",
                        "parent_area_key":"210300",
                        "children":[

                        ]
                    },
                    {
                        "id":529,
                        "label":"立山区",
                        "value":"210304",
                        "key":"210304",
                        "parent_area_key":"210300",
                        "children":[

                        ]
                    },
                    {
                        "id":530,
                        "label":"千山区",
                        "value":"210311",
                        "key":"210311",
                        "parent_area_key":"210300",
                        "children":[

                        ]
                    },
                    {
                        "id":531,
                        "label":"台安县",
                        "value":"210321",
                        "key":"210321",
                        "parent_area_key":"210300",
                        "children":[

                        ]
                    },
                    {
                        "id":532,
                        "label":"岫岩满族自治县",
                        "value":"210323",
                        "key":"210323",
                        "parent_area_key":"210300",
                        "children":[

                        ]
                    },
                    {
                        "id":533,
                        "label":"海城市",
                        "value":"210381",
                        "key":"210381",
                        "parent_area_key":"210300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":534,
                "label":"抚顺市",
                "value":"210400",
                "key":"210400",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":535,
                        "label":"市辖区",
                        "value":"210401",
                        "key":"210401",
                        "parent_area_key":"210400",
                        "children":[

                        ]
                    },
                    {
                        "id":536,
                        "label":"新抚区",
                        "value":"210402",
                        "key":"210402",
                        "parent_area_key":"210400",
                        "children":[

                        ]
                    },
                    {
                        "id":537,
                        "label":"东洲区",
                        "value":"210403",
                        "key":"210403",
                        "parent_area_key":"210400",
                        "children":[

                        ]
                    },
                    {
                        "id":538,
                        "label":"望花区",
                        "value":"210404",
                        "key":"210404",
                        "parent_area_key":"210400",
                        "children":[

                        ]
                    },
                    {
                        "id":539,
                        "label":"顺城区",
                        "value":"210411",
                        "key":"210411",
                        "parent_area_key":"210400",
                        "children":[

                        ]
                    },
                    {
                        "id":540,
                        "label":"抚顺县",
                        "value":"210421",
                        "key":"210421",
                        "parent_area_key":"210400",
                        "children":[

                        ]
                    },
                    {
                        "id":541,
                        "label":"新宾满族自治县",
                        "value":"210422",
                        "key":"210422",
                        "parent_area_key":"210400",
                        "children":[

                        ]
                    },
                    {
                        "id":542,
                        "label":"清原满族自治县",
                        "value":"210423",
                        "key":"210423",
                        "parent_area_key":"210400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":543,
                "label":"本溪市",
                "value":"210500",
                "key":"210500",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":544,
                        "label":"市辖区",
                        "value":"210501",
                        "key":"210501",
                        "parent_area_key":"210500",
                        "children":[

                        ]
                    },
                    {
                        "id":545,
                        "label":"平山区",
                        "value":"210502",
                        "key":"210502",
                        "parent_area_key":"210500",
                        "children":[

                        ]
                    },
                    {
                        "id":546,
                        "label":"溪湖区",
                        "value":"210503",
                        "key":"210503",
                        "parent_area_key":"210500",
                        "children":[

                        ]
                    },
                    {
                        "id":547,
                        "label":"明山区",
                        "value":"210504",
                        "key":"210504",
                        "parent_area_key":"210500",
                        "children":[

                        ]
                    },
                    {
                        "id":548,
                        "label":"南芬区",
                        "value":"210505",
                        "key":"210505",
                        "parent_area_key":"210500",
                        "children":[

                        ]
                    },
                    {
                        "id":549,
                        "label":"本溪满族自治县",
                        "value":"210521",
                        "key":"210521",
                        "parent_area_key":"210500",
                        "children":[

                        ]
                    },
                    {
                        "id":550,
                        "label":"桓仁满族自治县",
                        "value":"210522",
                        "key":"210522",
                        "parent_area_key":"210500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":551,
                "label":"丹东市",
                "value":"210600",
                "key":"210600",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":552,
                        "label":"市辖区",
                        "value":"210601",
                        "key":"210601",
                        "parent_area_key":"210600",
                        "children":[

                        ]
                    },
                    {
                        "id":553,
                        "label":"元宝区",
                        "value":"210602",
                        "key":"210602",
                        "parent_area_key":"210600",
                        "children":[

                        ]
                    },
                    {
                        "id":554,
                        "label":"振兴区",
                        "value":"210603",
                        "key":"210603",
                        "parent_area_key":"210600",
                        "children":[

                        ]
                    },
                    {
                        "id":555,
                        "label":"振安区",
                        "value":"210604",
                        "key":"210604",
                        "parent_area_key":"210600",
                        "children":[

                        ]
                    },
                    {
                        "id":556,
                        "label":"宽甸满族自治县",
                        "value":"210624",
                        "key":"210624",
                        "parent_area_key":"210600",
                        "children":[

                        ]
                    },
                    {
                        "id":557,
                        "label":"东港市",
                        "value":"210681",
                        "key":"210681",
                        "parent_area_key":"210600",
                        "children":[

                        ]
                    },
                    {
                        "id":558,
                        "label":"凤城市",
                        "value":"210682",
                        "key":"210682",
                        "parent_area_key":"210600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":559,
                "label":"锦州市",
                "value":"210700",
                "key":"210700",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":560,
                        "label":"市辖区",
                        "value":"210701",
                        "key":"210701",
                        "parent_area_key":"210700",
                        "children":[

                        ]
                    },
                    {
                        "id":561,
                        "label":"古塔区",
                        "value":"210702",
                        "key":"210702",
                        "parent_area_key":"210700",
                        "children":[

                        ]
                    },
                    {
                        "id":562,
                        "label":"凌河区",
                        "value":"210703",
                        "key":"210703",
                        "parent_area_key":"210700",
                        "children":[

                        ]
                    },
                    {
                        "id":563,
                        "label":"太和区",
                        "value":"210711",
                        "key":"210711",
                        "parent_area_key":"210700",
                        "children":[

                        ]
                    },
                    {
                        "id":564,
                        "label":"黑山县",
                        "value":"210726",
                        "key":"210726",
                        "parent_area_key":"210700",
                        "children":[

                        ]
                    },
                    {
                        "id":565,
                        "label":"义县",
                        "value":"210727",
                        "key":"210727",
                        "parent_area_key":"210700",
                        "children":[

                        ]
                    },
                    {
                        "id":566,
                        "label":"凌海市",
                        "value":"210781",
                        "key":"210781",
                        "parent_area_key":"210700",
                        "children":[

                        ]
                    },
                    {
                        "id":567,
                        "label":"北镇市",
                        "value":"210782",
                        "key":"210782",
                        "parent_area_key":"210700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":568,
                "label":"营口市",
                "value":"210800",
                "key":"210800",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":569,
                        "label":"市辖区",
                        "value":"210801",
                        "key":"210801",
                        "parent_area_key":"210800",
                        "children":[

                        ]
                    },
                    {
                        "id":570,
                        "label":"站前区",
                        "value":"210802",
                        "key":"210802",
                        "parent_area_key":"210800",
                        "children":[

                        ]
                    },
                    {
                        "id":571,
                        "label":"西市区",
                        "value":"210803",
                        "key":"210803",
                        "parent_area_key":"210800",
                        "children":[

                        ]
                    },
                    {
                        "id":572,
                        "label":"鲅鱼圈区",
                        "value":"210804",
                        "key":"210804",
                        "parent_area_key":"210800",
                        "children":[

                        ]
                    },
                    {
                        "id":573,
                        "label":"老边区",
                        "value":"210811",
                        "key":"210811",
                        "parent_area_key":"210800",
                        "children":[

                        ]
                    },
                    {
                        "id":574,
                        "label":"盖州市",
                        "value":"210881",
                        "key":"210881",
                        "parent_area_key":"210800",
                        "children":[

                        ]
                    },
                    {
                        "id":575,
                        "label":"大石桥市",
                        "value":"210882",
                        "key":"210882",
                        "parent_area_key":"210800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":576,
                "label":"阜新市",
                "value":"210900",
                "key":"210900",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":577,
                        "label":"市辖区",
                        "value":"210901",
                        "key":"210901",
                        "parent_area_key":"210900",
                        "children":[

                        ]
                    },
                    {
                        "id":578,
                        "label":"海州区",
                        "value":"210902",
                        "key":"210902",
                        "parent_area_key":"210900",
                        "children":[

                        ]
                    },
                    {
                        "id":579,
                        "label":"新邱区",
                        "value":"210903",
                        "key":"210903",
                        "parent_area_key":"210900",
                        "children":[

                        ]
                    },
                    {
                        "id":580,
                        "label":"太平区",
                        "value":"210904",
                        "key":"210904",
                        "parent_area_key":"210900",
                        "children":[

                        ]
                    },
                    {
                        "id":581,
                        "label":"清河门区",
                        "value":"210905",
                        "key":"210905",
                        "parent_area_key":"210900",
                        "children":[

                        ]
                    },
                    {
                        "id":582,
                        "label":"细河区",
                        "value":"210911",
                        "key":"210911",
                        "parent_area_key":"210900",
                        "children":[

                        ]
                    },
                    {
                        "id":583,
                        "label":"阜新蒙古族自治县",
                        "value":"210921",
                        "key":"210921",
                        "parent_area_key":"210900",
                        "children":[

                        ]
                    },
                    {
                        "id":584,
                        "label":"彰武县",
                        "value":"210922",
                        "key":"210922",
                        "parent_area_key":"210900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":585,
                "label":"辽阳市",
                "value":"211000",
                "key":"211000",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":586,
                        "label":"市辖区",
                        "value":"211001",
                        "key":"211001",
                        "parent_area_key":"211000",
                        "children":[

                        ]
                    },
                    {
                        "id":587,
                        "label":"白塔区",
                        "value":"211002",
                        "key":"211002",
                        "parent_area_key":"211000",
                        "children":[

                        ]
                    },
                    {
                        "id":588,
                        "label":"文圣区",
                        "value":"211003",
                        "key":"211003",
                        "parent_area_key":"211000",
                        "children":[

                        ]
                    },
                    {
                        "id":589,
                        "label":"宏伟区",
                        "value":"211004",
                        "key":"211004",
                        "parent_area_key":"211000",
                        "children":[

                        ]
                    },
                    {
                        "id":590,
                        "label":"弓长岭区",
                        "value":"211005",
                        "key":"211005",
                        "parent_area_key":"211000",
                        "children":[

                        ]
                    },
                    {
                        "id":591,
                        "label":"太子河区",
                        "value":"211011",
                        "key":"211011",
                        "parent_area_key":"211000",
                        "children":[

                        ]
                    },
                    {
                        "id":592,
                        "label":"辽阳县",
                        "value":"211021",
                        "key":"211021",
                        "parent_area_key":"211000",
                        "children":[

                        ]
                    },
                    {
                        "id":593,
                        "label":"灯塔市",
                        "value":"211081",
                        "key":"211081",
                        "parent_area_key":"211000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":594,
                "label":"盘锦市",
                "value":"211100",
                "key":"211100",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":595,
                        "label":"市辖区",
                        "value":"211101",
                        "key":"211101",
                        "parent_area_key":"211100",
                        "children":[

                        ]
                    },
                    {
                        "id":596,
                        "label":"双台子区",
                        "value":"211102",
                        "key":"211102",
                        "parent_area_key":"211100",
                        "children":[

                        ]
                    },
                    {
                        "id":597,
                        "label":"兴隆台区",
                        "value":"211103",
                        "key":"211103",
                        "parent_area_key":"211100",
                        "children":[

                        ]
                    },
                    {
                        "id":598,
                        "label":"大洼区",
                        "value":"211104",
                        "key":"211104",
                        "parent_area_key":"211100",
                        "children":[

                        ]
                    },
                    {
                        "id":599,
                        "label":"盘山县",
                        "value":"211122",
                        "key":"211122",
                        "parent_area_key":"211100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":600,
                "label":"铁岭市",
                "value":"211200",
                "key":"211200",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":601,
                        "label":"市辖区",
                        "value":"211201",
                        "key":"211201",
                        "parent_area_key":"211200",
                        "children":[

                        ]
                    },
                    {
                        "id":602,
                        "label":"银州区",
                        "value":"211202",
                        "key":"211202",
                        "parent_area_key":"211200",
                        "children":[

                        ]
                    },
                    {
                        "id":603,
                        "label":"清河区",
                        "value":"211204",
                        "key":"211204",
                        "parent_area_key":"211200",
                        "children":[

                        ]
                    },
                    {
                        "id":604,
                        "label":"铁岭县",
                        "value":"211221",
                        "key":"211221",
                        "parent_area_key":"211200",
                        "children":[

                        ]
                    },
                    {
                        "id":605,
                        "label":"西丰县",
                        "value":"211223",
                        "key":"211223",
                        "parent_area_key":"211200",
                        "children":[

                        ]
                    },
                    {
                        "id":606,
                        "label":"昌图县",
                        "value":"211224",
                        "key":"211224",
                        "parent_area_key":"211200",
                        "children":[

                        ]
                    },
                    {
                        "id":607,
                        "label":"调兵山市",
                        "value":"211281",
                        "key":"211281",
                        "parent_area_key":"211200",
                        "children":[

                        ]
                    },
                    {
                        "id":608,
                        "label":"开原市",
                        "value":"211282",
                        "key":"211282",
                        "parent_area_key":"211200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":609,
                "label":"朝阳市",
                "value":"211300",
                "key":"211300",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":610,
                        "label":"市辖区",
                        "value":"211301",
                        "key":"211301",
                        "parent_area_key":"211300",
                        "children":[

                        ]
                    },
                    {
                        "id":611,
                        "label":"双塔区",
                        "value":"211302",
                        "key":"211302",
                        "parent_area_key":"211300",
                        "children":[

                        ]
                    },
                    {
                        "id":612,
                        "label":"龙城区",
                        "value":"211303",
                        "key":"211303",
                        "parent_area_key":"211300",
                        "children":[

                        ]
                    },
                    {
                        "id":613,
                        "label":"朝阳县",
                        "value":"211321",
                        "key":"211321",
                        "parent_area_key":"211300",
                        "children":[

                        ]
                    },
                    {
                        "id":614,
                        "label":"建平县",
                        "value":"211322",
                        "key":"211322",
                        "parent_area_key":"211300",
                        "children":[

                        ]
                    },
                    {
                        "id":615,
                        "label":"喀喇沁左翼蒙古族自治县",
                        "value":"211324",
                        "key":"211324",
                        "parent_area_key":"211300",
                        "children":[

                        ]
                    },
                    {
                        "id":616,
                        "label":"北票市",
                        "value":"211381",
                        "key":"211381",
                        "parent_area_key":"211300",
                        "children":[

                        ]
                    },
                    {
                        "id":617,
                        "label":"凌源市",
                        "value":"211382",
                        "key":"211382",
                        "parent_area_key":"211300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":618,
                "label":"葫芦岛市",
                "value":"211400",
                "key":"211400",
                "parent_area_key":"210000",
                "children":[
                    {
                        "id":619,
                        "label":"市辖区",
                        "value":"211401",
                        "key":"211401",
                        "parent_area_key":"211400",
                        "children":[

                        ]
                    },
                    {
                        "id":620,
                        "label":"连山区",
                        "value":"211402",
                        "key":"211402",
                        "parent_area_key":"211400",
                        "children":[

                        ]
                    },
                    {
                        "id":621,
                        "label":"龙港区",
                        "value":"211403",
                        "key":"211403",
                        "parent_area_key":"211400",
                        "children":[

                        ]
                    },
                    {
                        "id":622,
                        "label":"南票区",
                        "value":"211404",
                        "key":"211404",
                        "parent_area_key":"211400",
                        "children":[

                        ]
                    },
                    {
                        "id":623,
                        "label":"绥中县",
                        "value":"211421",
                        "key":"211421",
                        "parent_area_key":"211400",
                        "children":[

                        ]
                    },
                    {
                        "id":624,
                        "label":"建昌县",
                        "value":"211422",
                        "key":"211422",
                        "parent_area_key":"211400",
                        "children":[

                        ]
                    },
                    {
                        "id":625,
                        "label":"兴城市",
                        "value":"211481",
                        "key":"211481",
                        "parent_area_key":"211400",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":626,
        "label":"吉林省",
        "value":"220000",
        "key":"220000",
        "parent_area_key":"",
        "children":[
            {
                "id":627,
                "label":"长春市",
                "value":"220100",
                "key":"220100",
                "parent_area_key":"220000",
                "children":[
                    {
                        "id":628,
                        "label":"市辖区",
                        "value":"220101",
                        "key":"220101",
                        "parent_area_key":"220100",
                        "children":[

                        ]
                    },
                    {
                        "id":629,
                        "label":"南关区",
                        "value":"220102",
                        "key":"220102",
                        "parent_area_key":"220100",
                        "children":[

                        ]
                    },
                    {
                        "id":630,
                        "label":"宽城区",
                        "value":"220103",
                        "key":"220103",
                        "parent_area_key":"220100",
                        "children":[

                        ]
                    },
                    {
                        "id":631,
                        "label":"朝阳区",
                        "value":"220104",
                        "key":"220104",
                        "parent_area_key":"220100",
                        "children":[

                        ]
                    },
                    {
                        "id":632,
                        "label":"二道区",
                        "value":"220105",
                        "key":"220105",
                        "parent_area_key":"220100",
                        "children":[

                        ]
                    },
                    {
                        "id":633,
                        "label":"绿园区",
                        "value":"220106",
                        "key":"220106",
                        "parent_area_key":"220100",
                        "children":[

                        ]
                    },
                    {
                        "id":634,
                        "label":"双阳区",
                        "value":"220112",
                        "key":"220112",
                        "parent_area_key":"220100",
                        "children":[

                        ]
                    },
                    {
                        "id":635,
                        "label":"九台区",
                        "value":"220113",
                        "key":"220113",
                        "parent_area_key":"220100",
                        "children":[

                        ]
                    },
                    {
                        "id":636,
                        "label":"农安县",
                        "value":"220122",
                        "key":"220122",
                        "parent_area_key":"220100",
                        "children":[

                        ]
                    },
                    {
                        "id":637,
                        "label":"榆树市",
                        "value":"220182",
                        "key":"220182",
                        "parent_area_key":"220100",
                        "children":[

                        ]
                    },
                    {
                        "id":638,
                        "label":"德惠市",
                        "value":"220183",
                        "key":"220183",
                        "parent_area_key":"220100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":639,
                "label":"吉林市",
                "value":"220200",
                "key":"220200",
                "parent_area_key":"220000",
                "children":[
                    {
                        "id":640,
                        "label":"市辖区",
                        "value":"220201",
                        "key":"220201",
                        "parent_area_key":"220200",
                        "children":[

                        ]
                    },
                    {
                        "id":641,
                        "label":"昌邑区",
                        "value":"220202",
                        "key":"220202",
                        "parent_area_key":"220200",
                        "children":[

                        ]
                    },
                    {
                        "id":642,
                        "label":"龙潭区",
                        "value":"220203",
                        "key":"220203",
                        "parent_area_key":"220200",
                        "children":[

                        ]
                    },
                    {
                        "id":643,
                        "label":"船营区",
                        "value":"220204",
                        "key":"220204",
                        "parent_area_key":"220200",
                        "children":[

                        ]
                    },
                    {
                        "id":644,
                        "label":"丰满区",
                        "value":"220211",
                        "key":"220211",
                        "parent_area_key":"220200",
                        "children":[

                        ]
                    },
                    {
                        "id":645,
                        "label":"永吉县",
                        "value":"220221",
                        "key":"220221",
                        "parent_area_key":"220200",
                        "children":[

                        ]
                    },
                    {
                        "id":646,
                        "label":"蛟河市",
                        "value":"220281",
                        "key":"220281",
                        "parent_area_key":"220200",
                        "children":[

                        ]
                    },
                    {
                        "id":647,
                        "label":"桦甸市",
                        "value":"220282",
                        "key":"220282",
                        "parent_area_key":"220200",
                        "children":[

                        ]
                    },
                    {
                        "id":648,
                        "label":"舒兰市",
                        "value":"220283",
                        "key":"220283",
                        "parent_area_key":"220200",
                        "children":[

                        ]
                    },
                    {
                        "id":649,
                        "label":"磐石市",
                        "value":"220284",
                        "key":"220284",
                        "parent_area_key":"220200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":650,
                "label":"四平市",
                "value":"220300",
                "key":"220300",
                "parent_area_key":"220000",
                "children":[
                    {
                        "id":651,
                        "label":"市辖区",
                        "value":"220301",
                        "key":"220301",
                        "parent_area_key":"220300",
                        "children":[

                        ]
                    },
                    {
                        "id":652,
                        "label":"铁西区",
                        "value":"220302",
                        "key":"220302",
                        "parent_area_key":"220300",
                        "children":[

                        ]
                    },
                    {
                        "id":653,
                        "label":"铁东区",
                        "value":"220303",
                        "key":"220303",
                        "parent_area_key":"220300",
                        "children":[

                        ]
                    },
                    {
                        "id":654,
                        "label":"梨树县",
                        "value":"220322",
                        "key":"220322",
                        "parent_area_key":"220300",
                        "children":[

                        ]
                    },
                    {
                        "id":655,
                        "label":"伊通满族自治县",
                        "value":"220323",
                        "key":"220323",
                        "parent_area_key":"220300",
                        "children":[

                        ]
                    },
                    {
                        "id":656,
                        "label":"公主岭市",
                        "value":"220381",
                        "key":"220381",
                        "parent_area_key":"220300",
                        "children":[

                        ]
                    },
                    {
                        "id":657,
                        "label":"双辽市",
                        "value":"220382",
                        "key":"220382",
                        "parent_area_key":"220300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":658,
                "label":"辽源市",
                "value":"220400",
                "key":"220400",
                "parent_area_key":"220000",
                "children":[
                    {
                        "id":659,
                        "label":"市辖区",
                        "value":"220401",
                        "key":"220401",
                        "parent_area_key":"220400",
                        "children":[

                        ]
                    },
                    {
                        "id":660,
                        "label":"龙山区",
                        "value":"220402",
                        "key":"220402",
                        "parent_area_key":"220400",
                        "children":[

                        ]
                    },
                    {
                        "id":661,
                        "label":"西安区",
                        "value":"220403",
                        "key":"220403",
                        "parent_area_key":"220400",
                        "children":[

                        ]
                    },
                    {
                        "id":662,
                        "label":"东丰县",
                        "value":"220421",
                        "key":"220421",
                        "parent_area_key":"220400",
                        "children":[

                        ]
                    },
                    {
                        "id":663,
                        "label":"东辽县",
                        "value":"220422",
                        "key":"220422",
                        "parent_area_key":"220400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":664,
                "label":"通化市",
                "value":"220500",
                "key":"220500",
                "parent_area_key":"220000",
                "children":[
                    {
                        "id":665,
                        "label":"市辖区",
                        "value":"220501",
                        "key":"220501",
                        "parent_area_key":"220500",
                        "children":[

                        ]
                    },
                    {
                        "id":666,
                        "label":"东昌区",
                        "value":"220502",
                        "key":"220502",
                        "parent_area_key":"220500",
                        "children":[

                        ]
                    },
                    {
                        "id":667,
                        "label":"二道江区",
                        "value":"220503",
                        "key":"220503",
                        "parent_area_key":"220500",
                        "children":[

                        ]
                    },
                    {
                        "id":668,
                        "label":"通化县",
                        "value":"220521",
                        "key":"220521",
                        "parent_area_key":"220500",
                        "children":[

                        ]
                    },
                    {
                        "id":669,
                        "label":"辉南县",
                        "value":"220523",
                        "key":"220523",
                        "parent_area_key":"220500",
                        "children":[

                        ]
                    },
                    {
                        "id":670,
                        "label":"柳河县",
                        "value":"220524",
                        "key":"220524",
                        "parent_area_key":"220500",
                        "children":[

                        ]
                    },
                    {
                        "id":671,
                        "label":"梅河口市",
                        "value":"220581",
                        "key":"220581",
                        "parent_area_key":"220500",
                        "children":[

                        ]
                    },
                    {
                        "id":672,
                        "label":"集安市",
                        "value":"220582",
                        "key":"220582",
                        "parent_area_key":"220500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":673,
                "label":"白山市",
                "value":"220600",
                "key":"220600",
                "parent_area_key":"220000",
                "children":[
                    {
                        "id":674,
                        "label":"市辖区",
                        "value":"220601",
                        "key":"220601",
                        "parent_area_key":"220600",
                        "children":[

                        ]
                    },
                    {
                        "id":675,
                        "label":"浑江区",
                        "value":"220602",
                        "key":"220602",
                        "parent_area_key":"220600",
                        "children":[

                        ]
                    },
                    {
                        "id":676,
                        "label":"江源区",
                        "value":"220605",
                        "key":"220605",
                        "parent_area_key":"220600",
                        "children":[

                        ]
                    },
                    {
                        "id":677,
                        "label":"抚松县",
                        "value":"220621",
                        "key":"220621",
                        "parent_area_key":"220600",
                        "children":[

                        ]
                    },
                    {
                        "id":678,
                        "label":"靖宇县",
                        "value":"220622",
                        "key":"220622",
                        "parent_area_key":"220600",
                        "children":[

                        ]
                    },
                    {
                        "id":679,
                        "label":"长白朝鲜族自治县",
                        "value":"220623",
                        "key":"220623",
                        "parent_area_key":"220600",
                        "children":[

                        ]
                    },
                    {
                        "id":680,
                        "label":"临江市",
                        "value":"220681",
                        "key":"220681",
                        "parent_area_key":"220600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":681,
                "label":"松原市",
                "value":"220700",
                "key":"220700",
                "parent_area_key":"220000",
                "children":[
                    {
                        "id":682,
                        "label":"市辖区",
                        "value":"220701",
                        "key":"220701",
                        "parent_area_key":"220700",
                        "children":[

                        ]
                    },
                    {
                        "id":683,
                        "label":"宁江区",
                        "value":"220702",
                        "key":"220702",
                        "parent_area_key":"220700",
                        "children":[

                        ]
                    },
                    {
                        "id":684,
                        "label":"前郭尔罗斯蒙古族自治县",
                        "value":"220721",
                        "key":"220721",
                        "parent_area_key":"220700",
                        "children":[

                        ]
                    },
                    {
                        "id":685,
                        "label":"长岭县",
                        "value":"220722",
                        "key":"220722",
                        "parent_area_key":"220700",
                        "children":[

                        ]
                    },
                    {
                        "id":686,
                        "label":"乾安县",
                        "value":"220723",
                        "key":"220723",
                        "parent_area_key":"220700",
                        "children":[

                        ]
                    },
                    {
                        "id":687,
                        "label":"扶余市",
                        "value":"220781",
                        "key":"220781",
                        "parent_area_key":"220700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":688,
                "label":"白城市",
                "value":"220800",
                "key":"220800",
                "parent_area_key":"220000",
                "children":[
                    {
                        "id":689,
                        "label":"市辖区",
                        "value":"220801",
                        "key":"220801",
                        "parent_area_key":"220800",
                        "children":[

                        ]
                    },
                    {
                        "id":690,
                        "label":"洮北区",
                        "value":"220802",
                        "key":"220802",
                        "parent_area_key":"220800",
                        "children":[

                        ]
                    },
                    {
                        "id":691,
                        "label":"镇赉县",
                        "value":"220821",
                        "key":"220821",
                        "parent_area_key":"220800",
                        "children":[

                        ]
                    },
                    {
                        "id":692,
                        "label":"通榆县",
                        "value":"220822",
                        "key":"220822",
                        "parent_area_key":"220800",
                        "children":[

                        ]
                    },
                    {
                        "id":693,
                        "label":"洮南市",
                        "value":"220881",
                        "key":"220881",
                        "parent_area_key":"220800",
                        "children":[

                        ]
                    },
                    {
                        "id":694,
                        "label":"大安市",
                        "value":"220882",
                        "key":"220882",
                        "parent_area_key":"220800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":695,
                "label":"延边朝鲜族自治州",
                "value":"222400",
                "key":"222400",
                "parent_area_key":"220000",
                "children":[
                    {
                        "id":696,
                        "label":"延吉市",
                        "value":"222401",
                        "key":"222401",
                        "parent_area_key":"222400",
                        "children":[

                        ]
                    },
                    {
                        "id":697,
                        "label":"图们市",
                        "value":"222402",
                        "key":"222402",
                        "parent_area_key":"222400",
                        "children":[

                        ]
                    },
                    {
                        "id":698,
                        "label":"敦化市",
                        "value":"222403",
                        "key":"222403",
                        "parent_area_key":"222400",
                        "children":[

                        ]
                    },
                    {
                        "id":699,
                        "label":"珲春市",
                        "value":"222404",
                        "key":"222404",
                        "parent_area_key":"222400",
                        "children":[

                        ]
                    },
                    {
                        "id":700,
                        "label":"龙井市",
                        "value":"222405",
                        "key":"222405",
                        "parent_area_key":"222400",
                        "children":[

                        ]
                    },
                    {
                        "id":701,
                        "label":"和龙市",
                        "value":"222406",
                        "key":"222406",
                        "parent_area_key":"222400",
                        "children":[

                        ]
                    },
                    {
                        "id":702,
                        "label":"汪清县",
                        "value":"222424",
                        "key":"222424",
                        "parent_area_key":"222400",
                        "children":[

                        ]
                    },
                    {
                        "id":703,
                        "label":"安图县",
                        "value":"222426",
                        "key":"222426",
                        "parent_area_key":"222400",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":704,
        "label":"黑龙江省",
        "value":"230000",
        "key":"230000",
        "parent_area_key":"",
        "children":[
            {
                "id":705,
                "label":"哈尔滨市",
                "value":"230100",
                "key":"230100",
                "parent_area_key":"230000",
                "children":[
                    {
                        "id":706,
                        "label":"市辖区",
                        "value":"230101",
                        "key":"230101",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":707,
                        "label":"道里区",
                        "value":"230102",
                        "key":"230102",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":708,
                        "label":"南岗区",
                        "value":"230103",
                        "key":"230103",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":709,
                        "label":"道外区",
                        "value":"230104",
                        "key":"230104",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":710,
                        "label":"平房区",
                        "value":"230108",
                        "key":"230108",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":711,
                        "label":"松北区",
                        "value":"230109",
                        "key":"230109",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":712,
                        "label":"香坊区",
                        "value":"230110",
                        "key":"230110",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":713,
                        "label":"呼兰区",
                        "value":"230111",
                        "key":"230111",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":714,
                        "label":"阿城区",
                        "value":"230112",
                        "key":"230112",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":715,
                        "label":"双城区",
                        "value":"230113",
                        "key":"230113",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":716,
                        "label":"依兰县",
                        "value":"230123",
                        "key":"230123",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":717,
                        "label":"方正县",
                        "value":"230124",
                        "key":"230124",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":718,
                        "label":"宾县",
                        "value":"230125",
                        "key":"230125",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":719,
                        "label":"巴彦县",
                        "value":"230126",
                        "key":"230126",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":720,
                        "label":"木兰县",
                        "value":"230127",
                        "key":"230127",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":721,
                        "label":"通河县",
                        "value":"230128",
                        "key":"230128",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":722,
                        "label":"延寿县",
                        "value":"230129",
                        "key":"230129",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":723,
                        "label":"尚志市",
                        "value":"230183",
                        "key":"230183",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    },
                    {
                        "id":724,
                        "label":"五常市",
                        "value":"230184",
                        "key":"230184",
                        "parent_area_key":"230100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":725,
                "label":"齐齐哈尔市",
                "value":"230200",
                "key":"230200",
                "parent_area_key":"230000",
                "children":[
                    {
                        "id":726,
                        "label":"市辖区",
                        "value":"230201",
                        "key":"230201",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":727,
                        "label":"龙沙区",
                        "value":"230202",
                        "key":"230202",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":728,
                        "label":"建华区",
                        "value":"230203",
                        "key":"230203",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":729,
                        "label":"铁锋区",
                        "value":"230204",
                        "key":"230204",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":730,
                        "label":"昂昂溪区",
                        "value":"230205",
                        "key":"230205",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":731,
                        "label":"富拉尔基区",
                        "value":"230206",
                        "key":"230206",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":732,
                        "label":"碾子山区",
                        "value":"230207",
                        "key":"230207",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":733,
                        "label":"梅里斯达斡尔族区",
                        "value":"230208",
                        "key":"230208",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":734,
                        "label":"龙江县",
                        "value":"230221",
                        "key":"230221",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":735,
                        "label":"依安县",
                        "value":"230223",
                        "key":"230223",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":736,
                        "label":"泰来县",
                        "value":"230224",
                        "key":"230224",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":737,
                        "label":"甘南县",
                        "value":"230225",
                        "key":"230225",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":738,
                        "label":"富裕县",
                        "value":"230227",
                        "key":"230227",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":739,
                        "label":"克山县",
                        "value":"230229",
                        "key":"230229",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":740,
                        "label":"克东县",
                        "value":"230230",
                        "key":"230230",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":741,
                        "label":"拜泉县",
                        "value":"230231",
                        "key":"230231",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    },
                    {
                        "id":742,
                        "label":"讷河市",
                        "value":"230281",
                        "key":"230281",
                        "parent_area_key":"230200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":743,
                "label":"鸡西市",
                "value":"230300",
                "key":"230300",
                "parent_area_key":"230000",
                "children":[
                    {
                        "id":744,
                        "label":"市辖区",
                        "value":"230301",
                        "key":"230301",
                        "parent_area_key":"230300",
                        "children":[

                        ]
                    },
                    {
                        "id":745,
                        "label":"鸡冠区",
                        "value":"230302",
                        "key":"230302",
                        "parent_area_key":"230300",
                        "children":[

                        ]
                    },
                    {
                        "id":746,
                        "label":"恒山区",
                        "value":"230303",
                        "key":"230303",
                        "parent_area_key":"230300",
                        "children":[

                        ]
                    },
                    {
                        "id":747,
                        "label":"滴道区",
                        "value":"230304",
                        "key":"230304",
                        "parent_area_key":"230300",
                        "children":[

                        ]
                    },
                    {
                        "id":748,
                        "label":"梨树区",
                        "value":"230305",
                        "key":"230305",
                        "parent_area_key":"230300",
                        "children":[

                        ]
                    },
                    {
                        "id":749,
                        "label":"城子河区",
                        "value":"230306",
                        "key":"230306",
                        "parent_area_key":"230300",
                        "children":[

                        ]
                    },
                    {
                        "id":750,
                        "label":"麻山区",
                        "value":"230307",
                        "key":"230307",
                        "parent_area_key":"230300",
                        "children":[

                        ]
                    },
                    {
                        "id":751,
                        "label":"鸡东县",
                        "value":"230321",
                        "key":"230321",
                        "parent_area_key":"230300",
                        "children":[

                        ]
                    },
                    {
                        "id":752,
                        "label":"虎林市",
                        "value":"230381",
                        "key":"230381",
                        "parent_area_key":"230300",
                        "children":[

                        ]
                    },
                    {
                        "id":753,
                        "label":"密山市",
                        "value":"230382",
                        "key":"230382",
                        "parent_area_key":"230300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":754,
                "label":"鹤岗市",
                "value":"230400",
                "key":"230400",
                "parent_area_key":"230000",
                "children":[
                    {
                        "id":755,
                        "label":"市辖区",
                        "value":"230401",
                        "key":"230401",
                        "parent_area_key":"230400",
                        "children":[

                        ]
                    },
                    {
                        "id":756,
                        "label":"向阳区",
                        "value":"230402",
                        "key":"230402",
                        "parent_area_key":"230400",
                        "children":[

                        ]
                    },
                    {
                        "id":757,
                        "label":"工农区",
                        "value":"230403",
                        "key":"230403",
                        "parent_area_key":"230400",
                        "children":[

                        ]
                    },
                    {
                        "id":758,
                        "label":"南山区",
                        "value":"230404",
                        "key":"230404",
                        "parent_area_key":"230400",
                        "children":[

                        ]
                    },
                    {
                        "id":759,
                        "label":"兴安区",
                        "value":"230405",
                        "key":"230405",
                        "parent_area_key":"230400",
                        "children":[

                        ]
                    },
                    {
                        "id":760,
                        "label":"东山区",
                        "value":"230406",
                        "key":"230406",
                        "parent_area_key":"230400",
                        "children":[

                        ]
                    },
                    {
                        "id":761,
                        "label":"兴山区",
                        "value":"230407",
                        "key":"230407",
                        "parent_area_key":"230400",
                        "children":[

                        ]
                    },
                    {
                        "id":762,
                        "label":"萝北县",
                        "value":"230421",
                        "key":"230421",
                        "parent_area_key":"230400",
                        "children":[

                        ]
                    },
                    {
                        "id":763,
                        "label":"绥滨县",
                        "value":"230422",
                        "key":"230422",
                        "parent_area_key":"230400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":764,
                "label":"双鸭山市",
                "value":"230500",
                "key":"230500",
                "parent_area_key":"230000",
                "children":[
                    {
                        "id":765,
                        "label":"市辖区",
                        "value":"230501",
                        "key":"230501",
                        "parent_area_key":"230500",
                        "children":[

                        ]
                    },
                    {
                        "id":766,
                        "label":"尖山区",
                        "value":"230502",
                        "key":"230502",
                        "parent_area_key":"230500",
                        "children":[

                        ]
                    },
                    {
                        "id":767,
                        "label":"岭东区",
                        "value":"230503",
                        "key":"230503",
                        "parent_area_key":"230500",
                        "children":[

                        ]
                    },
                    {
                        "id":768,
                        "label":"四方台区",
                        "value":"230505",
                        "key":"230505",
                        "parent_area_key":"230500",
                        "children":[

                        ]
                    },
                    {
                        "id":769,
                        "label":"宝山区",
                        "value":"230506",
                        "key":"230506",
                        "parent_area_key":"230500",
                        "children":[

                        ]
                    },
                    {
                        "id":770,
                        "label":"集贤县",
                        "value":"230521",
                        "key":"230521",
                        "parent_area_key":"230500",
                        "children":[

                        ]
                    },
                    {
                        "id":771,
                        "label":"友谊县",
                        "value":"230522",
                        "key":"230522",
                        "parent_area_key":"230500",
                        "children":[

                        ]
                    },
                    {
                        "id":772,
                        "label":"宝清县",
                        "value":"230523",
                        "key":"230523",
                        "parent_area_key":"230500",
                        "children":[

                        ]
                    },
                    {
                        "id":773,
                        "label":"饶河县",
                        "value":"230524",
                        "key":"230524",
                        "parent_area_key":"230500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":774,
                "label":"大庆市",
                "value":"230600",
                "key":"230600",
                "parent_area_key":"230000",
                "children":[
                    {
                        "id":775,
                        "label":"市辖区",
                        "value":"230601",
                        "key":"230601",
                        "parent_area_key":"230600",
                        "children":[

                        ]
                    },
                    {
                        "id":776,
                        "label":"萨尔图区",
                        "value":"230602",
                        "key":"230602",
                        "parent_area_key":"230600",
                        "children":[

                        ]
                    },
                    {
                        "id":777,
                        "label":"龙凤区",
                        "value":"230603",
                        "key":"230603",
                        "parent_area_key":"230600",
                        "children":[

                        ]
                    },
                    {
                        "id":778,
                        "label":"让胡路区",
                        "value":"230604",
                        "key":"230604",
                        "parent_area_key":"230600",
                        "children":[

                        ]
                    },
                    {
                        "id":779,
                        "label":"红岗区",
                        "value":"230605",
                        "key":"230605",
                        "parent_area_key":"230600",
                        "children":[

                        ]
                    },
                    {
                        "id":780,
                        "label":"大同区",
                        "value":"230606",
                        "key":"230606",
                        "parent_area_key":"230600",
                        "children":[

                        ]
                    },
                    {
                        "id":781,
                        "label":"肇州县",
                        "value":"230621",
                        "key":"230621",
                        "parent_area_key":"230600",
                        "children":[

                        ]
                    },
                    {
                        "id":782,
                        "label":"肇源县",
                        "value":"230622",
                        "key":"230622",
                        "parent_area_key":"230600",
                        "children":[

                        ]
                    },
                    {
                        "id":783,
                        "label":"林甸县",
                        "value":"230623",
                        "key":"230623",
                        "parent_area_key":"230600",
                        "children":[

                        ]
                    },
                    {
                        "id":784,
                        "label":"杜尔伯特蒙古族自治县",
                        "value":"230624",
                        "key":"230624",
                        "parent_area_key":"230600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":785,
                "label":"伊春市",
                "value":"230700",
                "key":"230700",
                "parent_area_key":"230000",
                "children":[
                    {
                        "id":786,
                        "label":"市辖区",
                        "value":"230701",
                        "key":"230701",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":787,
                        "label":"伊春区",
                        "value":"230702",
                        "key":"230702",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":788,
                        "label":"南岔区",
                        "value":"230703",
                        "key":"230703",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":789,
                        "label":"友好区",
                        "value":"230704",
                        "key":"230704",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":790,
                        "label":"西林区",
                        "value":"230705",
                        "key":"230705",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":791,
                        "label":"翠峦区",
                        "value":"230706",
                        "key":"230706",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":792,
                        "label":"新青区",
                        "value":"230707",
                        "key":"230707",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":793,
                        "label":"美溪区",
                        "value":"230708",
                        "key":"230708",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":794,
                        "label":"金山屯区",
                        "value":"230709",
                        "key":"230709",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":795,
                        "label":"五营区",
                        "value":"230710",
                        "key":"230710",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":796,
                        "label":"乌马河区",
                        "value":"230711",
                        "key":"230711",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":797,
                        "label":"汤旺河区",
                        "value":"230712",
                        "key":"230712",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":798,
                        "label":"带岭区",
                        "value":"230713",
                        "key":"230713",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":799,
                        "label":"乌伊岭区",
                        "value":"230714",
                        "key":"230714",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":800,
                        "label":"红星区",
                        "value":"230715",
                        "key":"230715",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":801,
                        "label":"上甘岭区",
                        "value":"230716",
                        "key":"230716",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":802,
                        "label":"嘉荫县",
                        "value":"230722",
                        "key":"230722",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    },
                    {
                        "id":803,
                        "label":"铁力市",
                        "value":"230781",
                        "key":"230781",
                        "parent_area_key":"230700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":804,
                "label":"佳木斯市",
                "value":"230800",
                "key":"230800",
                "parent_area_key":"230000",
                "children":[
                    {
                        "id":805,
                        "label":"市辖区",
                        "value":"230801",
                        "key":"230801",
                        "parent_area_key":"230800",
                        "children":[

                        ]
                    },
                    {
                        "id":806,
                        "label":"向阳区",
                        "value":"230803",
                        "key":"230803",
                        "parent_area_key":"230800",
                        "children":[

                        ]
                    },
                    {
                        "id":807,
                        "label":"前进区",
                        "value":"230804",
                        "key":"230804",
                        "parent_area_key":"230800",
                        "children":[

                        ]
                    },
                    {
                        "id":808,
                        "label":"东风区",
                        "value":"230805",
                        "key":"230805",
                        "parent_area_key":"230800",
                        "children":[

                        ]
                    },
                    {
                        "id":809,
                        "label":"郊区",
                        "value":"230811",
                        "key":"230811",
                        "parent_area_key":"230800",
                        "children":[

                        ]
                    },
                    {
                        "id":810,
                        "label":"桦南县",
                        "value":"230822",
                        "key":"230822",
                        "parent_area_key":"230800",
                        "children":[

                        ]
                    },
                    {
                        "id":811,
                        "label":"桦川县",
                        "value":"230826",
                        "key":"230826",
                        "parent_area_key":"230800",
                        "children":[

                        ]
                    },
                    {
                        "id":812,
                        "label":"汤原县",
                        "value":"230828",
                        "key":"230828",
                        "parent_area_key":"230800",
                        "children":[

                        ]
                    },
                    {
                        "id":813,
                        "label":"同江市",
                        "value":"230881",
                        "key":"230881",
                        "parent_area_key":"230800",
                        "children":[

                        ]
                    },
                    {
                        "id":814,
                        "label":"富锦市",
                        "value":"230882",
                        "key":"230882",
                        "parent_area_key":"230800",
                        "children":[

                        ]
                    },
                    {
                        "id":815,
                        "label":"抚远市",
                        "value":"230883",
                        "key":"230883",
                        "parent_area_key":"230800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":816,
                "label":"七台河市",
                "value":"230900",
                "key":"230900",
                "parent_area_key":"230000",
                "children":[
                    {
                        "id":817,
                        "label":"市辖区",
                        "value":"230901",
                        "key":"230901",
                        "parent_area_key":"230900",
                        "children":[

                        ]
                    },
                    {
                        "id":818,
                        "label":"新兴区",
                        "value":"230902",
                        "key":"230902",
                        "parent_area_key":"230900",
                        "children":[

                        ]
                    },
                    {
                        "id":819,
                        "label":"桃山区",
                        "value":"230903",
                        "key":"230903",
                        "parent_area_key":"230900",
                        "children":[

                        ]
                    },
                    {
                        "id":820,
                        "label":"茄子河区",
                        "value":"230904",
                        "key":"230904",
                        "parent_area_key":"230900",
                        "children":[

                        ]
                    },
                    {
                        "id":821,
                        "label":"勃利县",
                        "value":"230921",
                        "key":"230921",
                        "parent_area_key":"230900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":822,
                "label":"牡丹江市",
                "value":"231000",
                "key":"231000",
                "parent_area_key":"230000",
                "children":[
                    {
                        "id":823,
                        "label":"市辖区",
                        "value":"231001",
                        "key":"231001",
                        "parent_area_key":"231000",
                        "children":[

                        ]
                    },
                    {
                        "id":824,
                        "label":"东安区",
                        "value":"231002",
                        "key":"231002",
                        "parent_area_key":"231000",
                        "children":[

                        ]
                    },
                    {
                        "id":825,
                        "label":"阳明区",
                        "value":"231003",
                        "key":"231003",
                        "parent_area_key":"231000",
                        "children":[

                        ]
                    },
                    {
                        "id":826,
                        "label":"爱民区",
                        "value":"231004",
                        "key":"231004",
                        "parent_area_key":"231000",
                        "children":[

                        ]
                    },
                    {
                        "id":827,
                        "label":"西安区",
                        "value":"231005",
                        "key":"231005",
                        "parent_area_key":"231000",
                        "children":[

                        ]
                    },
                    {
                        "id":828,
                        "label":"林口县",
                        "value":"231025",
                        "key":"231025",
                        "parent_area_key":"231000",
                        "children":[

                        ]
                    },
                    {
                        "id":829,
                        "label":"绥芬河市",
                        "value":"231081",
                        "key":"231081",
                        "parent_area_key":"231000",
                        "children":[

                        ]
                    },
                    {
                        "id":830,
                        "label":"海林市",
                        "value":"231083",
                        "key":"231083",
                        "parent_area_key":"231000",
                        "children":[

                        ]
                    },
                    {
                        "id":831,
                        "label":"宁安市",
                        "value":"231084",
                        "key":"231084",
                        "parent_area_key":"231000",
                        "children":[

                        ]
                    },
                    {
                        "id":832,
                        "label":"穆棱市",
                        "value":"231085",
                        "key":"231085",
                        "parent_area_key":"231000",
                        "children":[

                        ]
                    },
                    {
                        "id":833,
                        "label":"东宁市",
                        "value":"231086",
                        "key":"231086",
                        "parent_area_key":"231000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":834,
                "label":"黑河市",
                "value":"231100",
                "key":"231100",
                "parent_area_key":"230000",
                "children":[
                    {
                        "id":835,
                        "label":"市辖区",
                        "value":"231101",
                        "key":"231101",
                        "parent_area_key":"231100",
                        "children":[

                        ]
                    },
                    {
                        "id":836,
                        "label":"爱辉区",
                        "value":"231102",
                        "key":"231102",
                        "parent_area_key":"231100",
                        "children":[

                        ]
                    },
                    {
                        "id":837,
                        "label":"嫩江县",
                        "value":"231121",
                        "key":"231121",
                        "parent_area_key":"231100",
                        "children":[

                        ]
                    },
                    {
                        "id":838,
                        "label":"逊克县",
                        "value":"231123",
                        "key":"231123",
                        "parent_area_key":"231100",
                        "children":[

                        ]
                    },
                    {
                        "id":839,
                        "label":"孙吴县",
                        "value":"231124",
                        "key":"231124",
                        "parent_area_key":"231100",
                        "children":[

                        ]
                    },
                    {
                        "id":840,
                        "label":"北安市",
                        "value":"231181",
                        "key":"231181",
                        "parent_area_key":"231100",
                        "children":[

                        ]
                    },
                    {
                        "id":841,
                        "label":"五大连池市",
                        "value":"231182",
                        "key":"231182",
                        "parent_area_key":"231100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":842,
                "label":"绥化市",
                "value":"231200",
                "key":"231200",
                "parent_area_key":"230000",
                "children":[
                    {
                        "id":843,
                        "label":"市辖区",
                        "value":"231201",
                        "key":"231201",
                        "parent_area_key":"231200",
                        "children":[

                        ]
                    },
                    {
                        "id":844,
                        "label":"北林区",
                        "value":"231202",
                        "key":"231202",
                        "parent_area_key":"231200",
                        "children":[

                        ]
                    },
                    {
                        "id":845,
                        "label":"望奎县",
                        "value":"231221",
                        "key":"231221",
                        "parent_area_key":"231200",
                        "children":[

                        ]
                    },
                    {
                        "id":846,
                        "label":"兰西县",
                        "value":"231222",
                        "key":"231222",
                        "parent_area_key":"231200",
                        "children":[

                        ]
                    },
                    {
                        "id":847,
                        "label":"青冈县",
                        "value":"231223",
                        "key":"231223",
                        "parent_area_key":"231200",
                        "children":[

                        ]
                    },
                    {
                        "id":848,
                        "label":"庆安县",
                        "value":"231224",
                        "key":"231224",
                        "parent_area_key":"231200",
                        "children":[

                        ]
                    },
                    {
                        "id":849,
                        "label":"明水县",
                        "value":"231225",
                        "key":"231225",
                        "parent_area_key":"231200",
                        "children":[

                        ]
                    },
                    {
                        "id":850,
                        "label":"绥棱县",
                        "value":"231226",
                        "key":"231226",
                        "parent_area_key":"231200",
                        "children":[

                        ]
                    },
                    {
                        "id":851,
                        "label":"安达市",
                        "value":"231281",
                        "key":"231281",
                        "parent_area_key":"231200",
                        "children":[

                        ]
                    },
                    {
                        "id":852,
                        "label":"肇东市",
                        "value":"231282",
                        "key":"231282",
                        "parent_area_key":"231200",
                        "children":[

                        ]
                    },
                    {
                        "id":853,
                        "label":"海伦市",
                        "value":"231283",
                        "key":"231283",
                        "parent_area_key":"231200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":854,
                "label":"大兴安岭地区",
                "value":"232700",
                "key":"232700",
                "parent_area_key":"230000",
                "children":[
                    {
                        "id":855,
                        "label":"呼玛县",
                        "value":"232721",
                        "key":"232721",
                        "parent_area_key":"232700",
                        "children":[

                        ]
                    },
                    {
                        "id":856,
                        "label":"塔河县",
                        "value":"232722",
                        "key":"232722",
                        "parent_area_key":"232700",
                        "children":[

                        ]
                    },
                    {
                        "id":857,
                        "label":"漠河县",
                        "value":"232723",
                        "key":"232723",
                        "parent_area_key":"232700",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":858,
        "label":"上海市",
        "value":"310000",
        "key":"310000",
        "parent_area_key":"",
        "children":[
            {
                "id":859,
                "label":"市辖区",
                "value":"310100",
                "key":"310100",
                "parent_area_key":"310000",
                "children":[
                    {
                        "id":860,
                        "label":"黄浦区",
                        "value":"310101",
                        "key":"310101",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":861,
                        "label":"徐汇区",
                        "value":"310104",
                        "key":"310104",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":862,
                        "label":"长宁区",
                        "value":"310105",
                        "key":"310105",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":863,
                        "label":"静安区",
                        "value":"310106",
                        "key":"310106",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":864,
                        "label":"普陀区",
                        "value":"310107",
                        "key":"310107",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":865,
                        "label":"虹口区",
                        "value":"310109",
                        "key":"310109",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":866,
                        "label":"杨浦区",
                        "value":"310110",
                        "key":"310110",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":867,
                        "label":"闵行区",
                        "value":"310112",
                        "key":"310112",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":868,
                        "label":"宝山区",
                        "value":"310113",
                        "key":"310113",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":869,
                        "label":"嘉定区",
                        "value":"310114",
                        "key":"310114",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":870,
                        "label":"浦东新区",
                        "value":"310115",
                        "key":"310115",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":871,
                        "label":"金山区",
                        "value":"310116",
                        "key":"310116",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":872,
                        "label":"松江区",
                        "value":"310117",
                        "key":"310117",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":873,
                        "label":"青浦区",
                        "value":"310118",
                        "key":"310118",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":874,
                        "label":"奉贤区",
                        "value":"310120",
                        "key":"310120",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    },
                    {
                        "id":875,
                        "label":"崇明区",
                        "value":"310151",
                        "key":"310151",
                        "parent_area_key":"310100",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":876,
        "label":"江苏省",
        "value":"320000",
        "key":"320000",
        "parent_area_key":"",
        "children":[
            {
                "id":877,
                "label":"南京市",
                "value":"320100",
                "key":"320100",
                "parent_area_key":"320000",
                "children":[
                    {
                        "id":878,
                        "label":"市辖区",
                        "value":"320101",
                        "key":"320101",
                        "parent_area_key":"320100",
                        "children":[

                        ]
                    },
                    {
                        "id":879,
                        "label":"玄武区",
                        "value":"320102",
                        "key":"320102",
                        "parent_area_key":"320100",
                        "children":[

                        ]
                    },
                    {
                        "id":880,
                        "label":"秦淮区",
                        "value":"320104",
                        "key":"320104",
                        "parent_area_key":"320100",
                        "children":[

                        ]
                    },
                    {
                        "id":881,
                        "label":"建邺区",
                        "value":"320105",
                        "key":"320105",
                        "parent_area_key":"320100",
                        "children":[

                        ]
                    },
                    {
                        "id":882,
                        "label":"鼓楼区",
                        "value":"320106",
                        "key":"320106",
                        "parent_area_key":"320100",
                        "children":[

                        ]
                    },
                    {
                        "id":883,
                        "label":"浦口区",
                        "value":"320111",
                        "key":"320111",
                        "parent_area_key":"320100",
                        "children":[

                        ]
                    },
                    {
                        "id":884,
                        "label":"栖霞区",
                        "value":"320113",
                        "key":"320113",
                        "parent_area_key":"320100",
                        "children":[

                        ]
                    },
                    {
                        "id":885,
                        "label":"雨花台区",
                        "value":"320114",
                        "key":"320114",
                        "parent_area_key":"320100",
                        "children":[

                        ]
                    },
                    {
                        "id":886,
                        "label":"江宁区",
                        "value":"320115",
                        "key":"320115",
                        "parent_area_key":"320100",
                        "children":[

                        ]
                    },
                    {
                        "id":887,
                        "label":"六合区",
                        "value":"320116",
                        "key":"320116",
                        "parent_area_key":"320100",
                        "children":[

                        ]
                    },
                    {
                        "id":888,
                        "label":"溧水区",
                        "value":"320117",
                        "key":"320117",
                        "parent_area_key":"320100",
                        "children":[

                        ]
                    },
                    {
                        "id":889,
                        "label":"高淳区",
                        "value":"320118",
                        "key":"320118",
                        "parent_area_key":"320100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":890,
                "label":"无锡市",
                "value":"320200",
                "key":"320200",
                "parent_area_key":"320000",
                "children":[
                    {
                        "id":891,
                        "label":"市辖区",
                        "value":"320201",
                        "key":"320201",
                        "parent_area_key":"320200",
                        "children":[

                        ]
                    },
                    {
                        "id":892,
                        "label":"锡山区",
                        "value":"320205",
                        "key":"320205",
                        "parent_area_key":"320200",
                        "children":[

                        ]
                    },
                    {
                        "id":893,
                        "label":"惠山区",
                        "value":"320206",
                        "key":"320206",
                        "parent_area_key":"320200",
                        "children":[

                        ]
                    },
                    {
                        "id":894,
                        "label":"滨湖区",
                        "value":"320211",
                        "key":"320211",
                        "parent_area_key":"320200",
                        "children":[

                        ]
                    },
                    {
                        "id":895,
                        "label":"梁溪区",
                        "value":"320213",
                        "key":"320213",
                        "parent_area_key":"320200",
                        "children":[

                        ]
                    },
                    {
                        "id":896,
                        "label":"新吴区",
                        "value":"320214",
                        "key":"320214",
                        "parent_area_key":"320200",
                        "children":[

                        ]
                    },
                    {
                        "id":897,
                        "label":"江阴市",
                        "value":"320281",
                        "key":"320281",
                        "parent_area_key":"320200",
                        "children":[

                        ]
                    },
                    {
                        "id":898,
                        "label":"宜兴市",
                        "value":"320282",
                        "key":"320282",
                        "parent_area_key":"320200",
                        "children":[

                        ]
                    },
                    {
                        "id":3522,
                        "label":"南长区",
                        "value":"320203",
                        "key":"320203",
                        "parent_area_key":"320200",
                        "children":[

                        ]
                    },
                    {
                        "id":3523,
                        "label":"崇安区",
                        "value":"320202",
                        "key":"320202",
                        "parent_area_key":"320200",
                        "children":[

                        ]
                    },
                    {
                        "id":3524,
                        "label":"北塘区",
                        "value":"320204",
                        "key":"320204",
                        "parent_area_key":"320200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":899,
                "label":"徐州市",
                "value":"320300",
                "key":"320300",
                "parent_area_key":"320000",
                "children":[
                    {
                        "id":900,
                        "label":"市辖区",
                        "value":"320301",
                        "key":"320301",
                        "parent_area_key":"320300",
                        "children":[

                        ]
                    },
                    {
                        "id":901,
                        "label":"鼓楼区",
                        "value":"320302",
                        "key":"320302",
                        "parent_area_key":"320300",
                        "children":[

                        ]
                    },
                    {
                        "id":902,
                        "label":"云龙区",
                        "value":"320303",
                        "key":"320303",
                        "parent_area_key":"320300",
                        "children":[

                        ]
                    },
                    {
                        "id":903,
                        "label":"贾汪区",
                        "value":"320305",
                        "key":"320305",
                        "parent_area_key":"320300",
                        "children":[

                        ]
                    },
                    {
                        "id":904,
                        "label":"泉山区",
                        "value":"320311",
                        "key":"320311",
                        "parent_area_key":"320300",
                        "children":[

                        ]
                    },
                    {
                        "id":905,
                        "label":"铜山区",
                        "value":"320312",
                        "key":"320312",
                        "parent_area_key":"320300",
                        "children":[

                        ]
                    },
                    {
                        "id":906,
                        "label":"丰县",
                        "value":"320321",
                        "key":"320321",
                        "parent_area_key":"320300",
                        "children":[

                        ]
                    },
                    {
                        "id":907,
                        "label":"沛县",
                        "value":"320322",
                        "key":"320322",
                        "parent_area_key":"320300",
                        "children":[

                        ]
                    },
                    {
                        "id":908,
                        "label":"睢宁县",
                        "value":"320324",
                        "key":"320324",
                        "parent_area_key":"320300",
                        "children":[

                        ]
                    },
                    {
                        "id":909,
                        "label":"新沂市",
                        "value":"320381",
                        "key":"320381",
                        "parent_area_key":"320300",
                        "children":[

                        ]
                    },
                    {
                        "id":910,
                        "label":"邳州市",
                        "value":"320382",
                        "key":"320382",
                        "parent_area_key":"320300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":911,
                "label":"常州市",
                "value":"320400",
                "key":"320400",
                "parent_area_key":"320000",
                "children":[
                    {
                        "id":912,
                        "label":"市辖区",
                        "value":"320401",
                        "key":"320401",
                        "parent_area_key":"320400",
                        "children":[

                        ]
                    },
                    {
                        "id":913,
                        "label":"天宁区",
                        "value":"320402",
                        "key":"320402",
                        "parent_area_key":"320400",
                        "children":[

                        ]
                    },
                    {
                        "id":914,
                        "label":"钟楼区",
                        "value":"320404",
                        "key":"320404",
                        "parent_area_key":"320400",
                        "children":[

                        ]
                    },
                    {
                        "id":915,
                        "label":"新北区",
                        "value":"320411",
                        "key":"320411",
                        "parent_area_key":"320400",
                        "children":[

                        ]
                    },
                    {
                        "id":916,
                        "label":"武进区",
                        "value":"320412",
                        "key":"320412",
                        "parent_area_key":"320400",
                        "children":[

                        ]
                    },
                    {
                        "id":917,
                        "label":"金坛区",
                        "value":"320413",
                        "key":"320413",
                        "parent_area_key":"320400",
                        "children":[

                        ]
                    },
                    {
                        "id":918,
                        "label":"溧阳市",
                        "value":"320481",
                        "key":"320481",
                        "parent_area_key":"320400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":919,
                "label":"苏州市",
                "value":"320500",
                "key":"320500",
                "parent_area_key":"320000",
                "children":[
                    {
                        "id":920,
                        "label":"市辖区",
                        "value":"320501",
                        "key":"320501",
                        "parent_area_key":"320500",
                        "children":[

                        ]
                    },
                    {
                        "id":921,
                        "label":"虎丘区",
                        "value":"320505",
                        "key":"320505",
                        "parent_area_key":"320500",
                        "children":[

                        ]
                    },
                    {
                        "id":922,
                        "label":"吴中区",
                        "value":"320506",
                        "key":"320506",
                        "parent_area_key":"320500",
                        "children":[

                        ]
                    },
                    {
                        "id":923,
                        "label":"相城区",
                        "value":"320507",
                        "key":"320507",
                        "parent_area_key":"320500",
                        "children":[

                        ]
                    },
                    {
                        "id":924,
                        "label":"姑苏区",
                        "value":"320508",
                        "key":"320508",
                        "parent_area_key":"320500",
                        "children":[

                        ]
                    },
                    {
                        "id":925,
                        "label":"吴江区",
                        "value":"320509",
                        "key":"320509",
                        "parent_area_key":"320500",
                        "children":[

                        ]
                    },
                    {
                        "id":926,
                        "label":"常熟市",
                        "value":"320581",
                        "key":"320581",
                        "parent_area_key":"320500",
                        "children":[

                        ]
                    },
                    {
                        "id":927,
                        "label":"张家港市",
                        "value":"320582",
                        "key":"320582",
                        "parent_area_key":"320500",
                        "children":[

                        ]
                    },
                    {
                        "id":928,
                        "label":"昆山市",
                        "value":"320583",
                        "key":"320583",
                        "parent_area_key":"320500",
                        "children":[

                        ]
                    },
                    {
                        "id":929,
                        "label":"太仓市",
                        "value":"320585",
                        "key":"320585",
                        "parent_area_key":"320500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":930,
                "label":"南通市",
                "value":"320600",
                "key":"320600",
                "parent_area_key":"320000",
                "children":[
                    {
                        "id":931,
                        "label":"市辖区",
                        "value":"320601",
                        "key":"320601",
                        "parent_area_key":"320600",
                        "children":[

                        ]
                    },
                    {
                        "id":932,
                        "label":"崇川区",
                        "value":"320602",
                        "key":"320602",
                        "parent_area_key":"320600",
                        "children":[

                        ]
                    },
                    {
                        "id":933,
                        "label":"港闸区",
                        "value":"320611",
                        "key":"320611",
                        "parent_area_key":"320600",
                        "children":[

                        ]
                    },
                    {
                        "id":934,
                        "label":"通州区",
                        "value":"320612",
                        "key":"320612",
                        "parent_area_key":"320600",
                        "children":[

                        ]
                    },
                    {
                        "id":935,
                        "label":"海安县",
                        "value":"320621",
                        "key":"320621",
                        "parent_area_key":"320600",
                        "children":[

                        ]
                    },
                    {
                        "id":936,
                        "label":"如东县",
                        "value":"320623",
                        "key":"320623",
                        "parent_area_key":"320600",
                        "children":[

                        ]
                    },
                    {
                        "id":937,
                        "label":"启东市",
                        "value":"320681",
                        "key":"320681",
                        "parent_area_key":"320600",
                        "children":[

                        ]
                    },
                    {
                        "id":938,
                        "label":"如皋市",
                        "value":"320682",
                        "key":"320682",
                        "parent_area_key":"320600",
                        "children":[

                        ]
                    },
                    {
                        "id":939,
                        "label":"海门市",
                        "value":"320684",
                        "key":"320684",
                        "parent_area_key":"320600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":940,
                "label":"连云港市",
                "value":"320700",
                "key":"320700",
                "parent_area_key":"320000",
                "children":[
                    {
                        "id":941,
                        "label":"市辖区",
                        "value":"320701",
                        "key":"320701",
                        "parent_area_key":"320700",
                        "children":[

                        ]
                    },
                    {
                        "id":942,
                        "label":"连云区",
                        "value":"320703",
                        "key":"320703",
                        "parent_area_key":"320700",
                        "children":[

                        ]
                    },
                    {
                        "id":943,
                        "label":"海州区",
                        "value":"320706",
                        "key":"320706",
                        "parent_area_key":"320700",
                        "children":[

                        ]
                    },
                    {
                        "id":944,
                        "label":"赣榆区",
                        "value":"320707",
                        "key":"320707",
                        "parent_area_key":"320700",
                        "children":[

                        ]
                    },
                    {
                        "id":945,
                        "label":"东海县",
                        "value":"320722",
                        "key":"320722",
                        "parent_area_key":"320700",
                        "children":[

                        ]
                    },
                    {
                        "id":946,
                        "label":"灌云县",
                        "value":"320723",
                        "key":"320723",
                        "parent_area_key":"320700",
                        "children":[

                        ]
                    },
                    {
                        "id":947,
                        "label":"灌南县",
                        "value":"320724",
                        "key":"320724",
                        "parent_area_key":"320700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":948,
                "label":"淮安市",
                "value":"320800",
                "key":"320800",
                "parent_area_key":"320000",
                "children":[
                    {
                        "id":949,
                        "label":"市辖区",
                        "value":"320801",
                        "key":"320801",
                        "parent_area_key":"320800",
                        "children":[

                        ]
                    },
                    {
                        "id":950,
                        "label":"淮安区",
                        "value":"320803",
                        "key":"320803",
                        "parent_area_key":"320800",
                        "children":[

                        ]
                    },
                    {
                        "id":951,
                        "label":"淮阴区",
                        "value":"320804",
                        "key":"320804",
                        "parent_area_key":"320800",
                        "children":[

                        ]
                    },
                    {
                        "id":952,
                        "label":"清江浦区",
                        "value":"320812",
                        "key":"320812",
                        "parent_area_key":"320800",
                        "children":[

                        ]
                    },
                    {
                        "id":953,
                        "label":"洪泽区",
                        "value":"320813",
                        "key":"320813",
                        "parent_area_key":"320800",
                        "children":[

                        ]
                    },
                    {
                        "id":954,
                        "label":"涟水县",
                        "value":"320826",
                        "key":"320826",
                        "parent_area_key":"320800",
                        "children":[

                        ]
                    },
                    {
                        "id":955,
                        "label":"盱眙县",
                        "value":"320830",
                        "key":"320830",
                        "parent_area_key":"320800",
                        "children":[

                        ]
                    },
                    {
                        "id":956,
                        "label":"金湖县",
                        "value":"320831",
                        "key":"320831",
                        "parent_area_key":"320800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":957,
                "label":"盐城市",
                "value":"320900",
                "key":"320900",
                "parent_area_key":"320000",
                "children":[
                    {
                        "id":958,
                        "label":"市辖区",
                        "value":"320901",
                        "key":"320901",
                        "parent_area_key":"320900",
                        "children":[

                        ]
                    },
                    {
                        "id":959,
                        "label":"亭湖区",
                        "value":"320902",
                        "key":"320902",
                        "parent_area_key":"320900",
                        "children":[

                        ]
                    },
                    {
                        "id":960,
                        "label":"盐都区",
                        "value":"320903",
                        "key":"320903",
                        "parent_area_key":"320900",
                        "children":[

                        ]
                    },
                    {
                        "id":961,
                        "label":"大丰区",
                        "value":"320904",
                        "key":"320904",
                        "parent_area_key":"320900",
                        "children":[

                        ]
                    },
                    {
                        "id":962,
                        "label":"响水县",
                        "value":"320921",
                        "key":"320921",
                        "parent_area_key":"320900",
                        "children":[

                        ]
                    },
                    {
                        "id":963,
                        "label":"滨海县",
                        "value":"320922",
                        "key":"320922",
                        "parent_area_key":"320900",
                        "children":[

                        ]
                    },
                    {
                        "id":964,
                        "label":"阜宁县",
                        "value":"320923",
                        "key":"320923",
                        "parent_area_key":"320900",
                        "children":[

                        ]
                    },
                    {
                        "id":965,
                        "label":"射阳县",
                        "value":"320924",
                        "key":"320924",
                        "parent_area_key":"320900",
                        "children":[

                        ]
                    },
                    {
                        "id":966,
                        "label":"建湖县",
                        "value":"320925",
                        "key":"320925",
                        "parent_area_key":"320900",
                        "children":[

                        ]
                    },
                    {
                        "id":967,
                        "label":"东台市",
                        "value":"320981",
                        "key":"320981",
                        "parent_area_key":"320900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":968,
                "label":"扬州市",
                "value":"321000",
                "key":"321000",
                "parent_area_key":"320000",
                "children":[
                    {
                        "id":969,
                        "label":"市辖区",
                        "value":"321001",
                        "key":"321001",
                        "parent_area_key":"321000",
                        "children":[

                        ]
                    },
                    {
                        "id":970,
                        "label":"广陵区",
                        "value":"321002",
                        "key":"321002",
                        "parent_area_key":"321000",
                        "children":[

                        ]
                    },
                    {
                        "id":971,
                        "label":"邗江区",
                        "value":"321003",
                        "key":"321003",
                        "parent_area_key":"321000",
                        "children":[

                        ]
                    },
                    {
                        "id":972,
                        "label":"江都区",
                        "value":"321012",
                        "key":"321012",
                        "parent_area_key":"321000",
                        "children":[

                        ]
                    },
                    {
                        "id":973,
                        "label":"宝应县",
                        "value":"321023",
                        "key":"321023",
                        "parent_area_key":"321000",
                        "children":[

                        ]
                    },
                    {
                        "id":974,
                        "label":"仪征市",
                        "value":"321081",
                        "key":"321081",
                        "parent_area_key":"321000",
                        "children":[

                        ]
                    },
                    {
                        "id":975,
                        "label":"高邮市",
                        "value":"321084",
                        "key":"321084",
                        "parent_area_key":"321000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":976,
                "label":"镇江市",
                "value":"321100",
                "key":"321100",
                "parent_area_key":"320000",
                "children":[
                    {
                        "id":977,
                        "label":"市辖区",
                        "value":"321101",
                        "key":"321101",
                        "parent_area_key":"321100",
                        "children":[

                        ]
                    },
                    {
                        "id":978,
                        "label":"京口区",
                        "value":"321102",
                        "key":"321102",
                        "parent_area_key":"321100",
                        "children":[

                        ]
                    },
                    {
                        "id":979,
                        "label":"润州区",
                        "value":"321111",
                        "key":"321111",
                        "parent_area_key":"321100",
                        "children":[

                        ]
                    },
                    {
                        "id":980,
                        "label":"丹徒区",
                        "value":"321112",
                        "key":"321112",
                        "parent_area_key":"321100",
                        "children":[

                        ]
                    },
                    {
                        "id":981,
                        "label":"丹阳市",
                        "value":"321181",
                        "key":"321181",
                        "parent_area_key":"321100",
                        "children":[

                        ]
                    },
                    {
                        "id":982,
                        "label":"扬中市",
                        "value":"321182",
                        "key":"321182",
                        "parent_area_key":"321100",
                        "children":[

                        ]
                    },
                    {
                        "id":983,
                        "label":"句容市",
                        "value":"321183",
                        "key":"321183",
                        "parent_area_key":"321100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":984,
                "label":"泰州市",
                "value":"321200",
                "key":"321200",
                "parent_area_key":"320000",
                "children":[
                    {
                        "id":985,
                        "label":"市辖区",
                        "value":"321201",
                        "key":"321201",
                        "parent_area_key":"321200",
                        "children":[

                        ]
                    },
                    {
                        "id":986,
                        "label":"海陵区",
                        "value":"321202",
                        "key":"321202",
                        "parent_area_key":"321200",
                        "children":[

                        ]
                    },
                    {
                        "id":987,
                        "label":"高港区",
                        "value":"321203",
                        "key":"321203",
                        "parent_area_key":"321200",
                        "children":[

                        ]
                    },
                    {
                        "id":988,
                        "label":"姜堰区",
                        "value":"321204",
                        "key":"321204",
                        "parent_area_key":"321200",
                        "children":[

                        ]
                    },
                    {
                        "id":989,
                        "label":"兴化市",
                        "value":"321281",
                        "key":"321281",
                        "parent_area_key":"321200",
                        "children":[

                        ]
                    },
                    {
                        "id":990,
                        "label":"靖江市",
                        "value":"321282",
                        "key":"321282",
                        "parent_area_key":"321200",
                        "children":[

                        ]
                    },
                    {
                        "id":991,
                        "label":"泰兴市",
                        "value":"321283",
                        "key":"321283",
                        "parent_area_key":"321200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":992,
                "label":"宿迁市",
                "value":"321300",
                "key":"321300",
                "parent_area_key":"320000",
                "children":[
                    {
                        "id":993,
                        "label":"市辖区",
                        "value":"321301",
                        "key":"321301",
                        "parent_area_key":"321300",
                        "children":[

                        ]
                    },
                    {
                        "id":994,
                        "label":"宿城区",
                        "value":"321302",
                        "key":"321302",
                        "parent_area_key":"321300",
                        "children":[

                        ]
                    },
                    {
                        "id":995,
                        "label":"宿豫区",
                        "value":"321311",
                        "key":"321311",
                        "parent_area_key":"321300",
                        "children":[

                        ]
                    },
                    {
                        "id":996,
                        "label":"沭阳县",
                        "value":"321322",
                        "key":"321322",
                        "parent_area_key":"321300",
                        "children":[

                        ]
                    },
                    {
                        "id":997,
                        "label":"泗阳县",
                        "value":"321323",
                        "key":"321323",
                        "parent_area_key":"321300",
                        "children":[

                        ]
                    },
                    {
                        "id":998,
                        "label":"泗洪县",
                        "value":"321324",
                        "key":"321324",
                        "parent_area_key":"321300",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":999,
        "label":"浙江省",
        "value":"330000",
        "key":"330000",
        "parent_area_key":"",
        "children":[
            {
                "id":1000,
                "label":"杭州市",
                "value":"330100",
                "key":"330100",
                "parent_area_key":"330000",
                "children":[
                    {
                        "id":1001,
                        "label":"市辖区",
                        "value":"330101",
                        "key":"330101",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    },
                    {
                        "id":1002,
                        "label":"上城区",
                        "value":"330102",
                        "key":"330102",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    },
                    {
                        "id":1003,
                        "label":"下城区",
                        "value":"330103",
                        "key":"330103",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    },
                    {
                        "id":1004,
                        "label":"江干区",
                        "value":"330104",
                        "key":"330104",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    },
                    {
                        "id":1005,
                        "label":"拱墅区",
                        "value":"330105",
                        "key":"330105",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    },
                    {
                        "id":1006,
                        "label":"西湖区",
                        "value":"330106",
                        "key":"330106",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    },
                    {
                        "id":1007,
                        "label":"滨江区",
                        "value":"330108",
                        "key":"330108",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    },
                    {
                        "id":1008,
                        "label":"萧山区",
                        "value":"330109",
                        "key":"330109",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    },
                    {
                        "id":1009,
                        "label":"余杭区",
                        "value":"330110",
                        "key":"330110",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    },
                    {
                        "id":1010,
                        "label":"富阳区",
                        "value":"330111",
                        "key":"330111",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    },
                    {
                        "id":1011,
                        "label":"桐庐县",
                        "value":"330122",
                        "key":"330122",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    },
                    {
                        "id":1012,
                        "label":"淳安县",
                        "value":"330127",
                        "key":"330127",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    },
                    {
                        "id":1013,
                        "label":"建德市",
                        "value":"330182",
                        "key":"330182",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    },
                    {
                        "id":1014,
                        "label":"临安市",
                        "value":"330185",
                        "key":"330185",
                        "parent_area_key":"330100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1015,
                "label":"宁波市",
                "value":"330200",
                "key":"330200",
                "parent_area_key":"330000",
                "children":[
                    {
                        "id":1016,
                        "label":"市辖区",
                        "value":"330201",
                        "key":"330201",
                        "parent_area_key":"330200",
                        "children":[

                        ]
                    },
                    {
                        "id":1017,
                        "label":"海曙区",
                        "value":"330203",
                        "key":"330203",
                        "parent_area_key":"330200",
                        "children":[

                        ]
                    },
                    {
                        "id":1018,
                        "label":"江东区",
                        "value":"330204",
                        "key":"330204",
                        "parent_area_key":"330200",
                        "children":[

                        ]
                    },
                    {
                        "id":1019,
                        "label":"江北区",
                        "value":"330205",
                        "key":"330205",
                        "parent_area_key":"330200",
                        "children":[

                        ]
                    },
                    {
                        "id":1020,
                        "label":"北仑区",
                        "value":"330206",
                        "key":"330206",
                        "parent_area_key":"330200",
                        "children":[

                        ]
                    },
                    {
                        "id":1021,
                        "label":"镇海区",
                        "value":"330211",
                        "key":"330211",
                        "parent_area_key":"330200",
                        "children":[

                        ]
                    },
                    {
                        "id":1022,
                        "label":"鄞州区",
                        "value":"330212",
                        "key":"330212",
                        "parent_area_key":"330200",
                        "children":[

                        ]
                    },
                    {
                        "id":1023,
                        "label":"象山县",
                        "value":"330225",
                        "key":"330225",
                        "parent_area_key":"330200",
                        "children":[

                        ]
                    },
                    {
                        "id":1024,
                        "label":"宁海县",
                        "value":"330226",
                        "key":"330226",
                        "parent_area_key":"330200",
                        "children":[

                        ]
                    },
                    {
                        "id":1025,
                        "label":"余姚市",
                        "value":"330281",
                        "key":"330281",
                        "parent_area_key":"330200",
                        "children":[

                        ]
                    },
                    {
                        "id":1026,
                        "label":"慈溪市",
                        "value":"330282",
                        "key":"330282",
                        "parent_area_key":"330200",
                        "children":[

                        ]
                    },
                    {
                        "id":1027,
                        "label":"奉化市",
                        "value":"330283",
                        "key":"330283",
                        "parent_area_key":"330200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1028,
                "label":"温州市",
                "value":"330300",
                "key":"330300",
                "parent_area_key":"330000",
                "children":[
                    {
                        "id":1029,
                        "label":"市辖区",
                        "value":"330301",
                        "key":"330301",
                        "parent_area_key":"330300",
                        "children":[

                        ]
                    },
                    {
                        "id":1030,
                        "label":"鹿城区",
                        "value":"330302",
                        "key":"330302",
                        "parent_area_key":"330300",
                        "children":[

                        ]
                    },
                    {
                        "id":1031,
                        "label":"龙湾区",
                        "value":"330303",
                        "key":"330303",
                        "parent_area_key":"330300",
                        "children":[

                        ]
                    },
                    {
                        "id":1032,
                        "label":"瓯海区",
                        "value":"330304",
                        "key":"330304",
                        "parent_area_key":"330300",
                        "children":[

                        ]
                    },
                    {
                        "id":1033,
                        "label":"洞头区",
                        "value":"330305",
                        "key":"330305",
                        "parent_area_key":"330300",
                        "children":[

                        ]
                    },
                    {
                        "id":1034,
                        "label":"永嘉县",
                        "value":"330324",
                        "key":"330324",
                        "parent_area_key":"330300",
                        "children":[

                        ]
                    },
                    {
                        "id":1035,
                        "label":"平阳县",
                        "value":"330326",
                        "key":"330326",
                        "parent_area_key":"330300",
                        "children":[

                        ]
                    },
                    {
                        "id":1036,
                        "label":"苍南县",
                        "value":"330327",
                        "key":"330327",
                        "parent_area_key":"330300",
                        "children":[

                        ]
                    },
                    {
                        "id":1037,
                        "label":"文成县",
                        "value":"330328",
                        "key":"330328",
                        "parent_area_key":"330300",
                        "children":[

                        ]
                    },
                    {
                        "id":1038,
                        "label":"泰顺县",
                        "value":"330329",
                        "key":"330329",
                        "parent_area_key":"330300",
                        "children":[

                        ]
                    },
                    {
                        "id":1039,
                        "label":"瑞安市",
                        "value":"330381",
                        "key":"330381",
                        "parent_area_key":"330300",
                        "children":[

                        ]
                    },
                    {
                        "id":1040,
                        "label":"乐清市",
                        "value":"330382",
                        "key":"330382",
                        "parent_area_key":"330300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1041,
                "label":"嘉兴市",
                "value":"330400",
                "key":"330400",
                "parent_area_key":"330000",
                "children":[
                    {
                        "id":1042,
                        "label":"市辖区",
                        "value":"330401",
                        "key":"330401",
                        "parent_area_key":"330400",
                        "children":[

                        ]
                    },
                    {
                        "id":1043,
                        "label":"南湖区",
                        "value":"330402",
                        "key":"330402",
                        "parent_area_key":"330400",
                        "children":[

                        ]
                    },
                    {
                        "id":1044,
                        "label":"秀洲区",
                        "value":"330411",
                        "key":"330411",
                        "parent_area_key":"330400",
                        "children":[

                        ]
                    },
                    {
                        "id":1045,
                        "label":"嘉善县",
                        "value":"330421",
                        "key":"330421",
                        "parent_area_key":"330400",
                        "children":[

                        ]
                    },
                    {
                        "id":1046,
                        "label":"海盐县",
                        "value":"330424",
                        "key":"330424",
                        "parent_area_key":"330400",
                        "children":[

                        ]
                    },
                    {
                        "id":1047,
                        "label":"海宁市",
                        "value":"330481",
                        "key":"330481",
                        "parent_area_key":"330400",
                        "children":[

                        ]
                    },
                    {
                        "id":1048,
                        "label":"平湖市",
                        "value":"330482",
                        "key":"330482",
                        "parent_area_key":"330400",
                        "children":[

                        ]
                    },
                    {
                        "id":1049,
                        "label":"桐乡市",
                        "value":"330483",
                        "key":"330483",
                        "parent_area_key":"330400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1050,
                "label":"湖州市",
                "value":"330500",
                "key":"330500",
                "parent_area_key":"330000",
                "children":[
                    {
                        "id":1051,
                        "label":"市辖区",
                        "value":"330501",
                        "key":"330501",
                        "parent_area_key":"330500",
                        "children":[

                        ]
                    },
                    {
                        "id":1052,
                        "label":"吴兴区",
                        "value":"330502",
                        "key":"330502",
                        "parent_area_key":"330500",
                        "children":[

                        ]
                    },
                    {
                        "id":1053,
                        "label":"南浔区",
                        "value":"330503",
                        "key":"330503",
                        "parent_area_key":"330500",
                        "children":[

                        ]
                    },
                    {
                        "id":1054,
                        "label":"德清县",
                        "value":"330521",
                        "key":"330521",
                        "parent_area_key":"330500",
                        "children":[

                        ]
                    },
                    {
                        "id":1055,
                        "label":"长兴县",
                        "value":"330522",
                        "key":"330522",
                        "parent_area_key":"330500",
                        "children":[

                        ]
                    },
                    {
                        "id":1056,
                        "label":"安吉县",
                        "value":"330523",
                        "key":"330523",
                        "parent_area_key":"330500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1057,
                "label":"绍兴市",
                "value":"330600",
                "key":"330600",
                "parent_area_key":"330000",
                "children":[
                    {
                        "id":1058,
                        "label":"市辖区",
                        "value":"330601",
                        "key":"330601",
                        "parent_area_key":"330600",
                        "children":[

                        ]
                    },
                    {
                        "id":1059,
                        "label":"越城区",
                        "value":"330602",
                        "key":"330602",
                        "parent_area_key":"330600",
                        "children":[

                        ]
                    },
                    {
                        "id":1060,
                        "label":"柯桥区",
                        "value":"330603",
                        "key":"330603",
                        "parent_area_key":"330600",
                        "children":[

                        ]
                    },
                    {
                        "id":1061,
                        "label":"上虞区",
                        "value":"330604",
                        "key":"330604",
                        "parent_area_key":"330600",
                        "children":[

                        ]
                    },
                    {
                        "id":1062,
                        "label":"新昌县",
                        "value":"330624",
                        "key":"330624",
                        "parent_area_key":"330600",
                        "children":[

                        ]
                    },
                    {
                        "id":1063,
                        "label":"诸暨市",
                        "value":"330681",
                        "key":"330681",
                        "parent_area_key":"330600",
                        "children":[

                        ]
                    },
                    {
                        "id":1064,
                        "label":"嵊州市",
                        "value":"330683",
                        "key":"330683",
                        "parent_area_key":"330600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1065,
                "label":"金华市",
                "value":"330700",
                "key":"330700",
                "parent_area_key":"330000",
                "children":[
                    {
                        "id":1066,
                        "label":"市辖区",
                        "value":"330701",
                        "key":"330701",
                        "parent_area_key":"330700",
                        "children":[

                        ]
                    },
                    {
                        "id":1067,
                        "label":"婺城区",
                        "value":"330702",
                        "key":"330702",
                        "parent_area_key":"330700",
                        "children":[

                        ]
                    },
                    {
                        "id":1068,
                        "label":"金东区",
                        "value":"330703",
                        "key":"330703",
                        "parent_area_key":"330700",
                        "children":[

                        ]
                    },
                    {
                        "id":1069,
                        "label":"武义县",
                        "value":"330723",
                        "key":"330723",
                        "parent_area_key":"330700",
                        "children":[

                        ]
                    },
                    {
                        "id":1070,
                        "label":"浦江县",
                        "value":"330726",
                        "key":"330726",
                        "parent_area_key":"330700",
                        "children":[

                        ]
                    },
                    {
                        "id":1071,
                        "label":"磐安县",
                        "value":"330727",
                        "key":"330727",
                        "parent_area_key":"330700",
                        "children":[

                        ]
                    },
                    {
                        "id":1072,
                        "label":"兰溪市",
                        "value":"330781",
                        "key":"330781",
                        "parent_area_key":"330700",
                        "children":[

                        ]
                    },
                    {
                        "id":1073,
                        "label":"义乌市",
                        "value":"330782",
                        "key":"330782",
                        "parent_area_key":"330700",
                        "children":[

                        ]
                    },
                    {
                        "id":1074,
                        "label":"东阳市",
                        "value":"330783",
                        "key":"330783",
                        "parent_area_key":"330700",
                        "children":[

                        ]
                    },
                    {
                        "id":1075,
                        "label":"永康市",
                        "value":"330784",
                        "key":"330784",
                        "parent_area_key":"330700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1076,
                "label":"衢州市",
                "value":"330800",
                "key":"330800",
                "parent_area_key":"330000",
                "children":[
                    {
                        "id":1077,
                        "label":"市辖区",
                        "value":"330801",
                        "key":"330801",
                        "parent_area_key":"330800",
                        "children":[

                        ]
                    },
                    {
                        "id":1078,
                        "label":"柯城区",
                        "value":"330802",
                        "key":"330802",
                        "parent_area_key":"330800",
                        "children":[

                        ]
                    },
                    {
                        "id":1079,
                        "label":"衢江区",
                        "value":"330803",
                        "key":"330803",
                        "parent_area_key":"330800",
                        "children":[

                        ]
                    },
                    {
                        "id":1080,
                        "label":"常山县",
                        "value":"330822",
                        "key":"330822",
                        "parent_area_key":"330800",
                        "children":[

                        ]
                    },
                    {
                        "id":1081,
                        "label":"开化县",
                        "value":"330824",
                        "key":"330824",
                        "parent_area_key":"330800",
                        "children":[

                        ]
                    },
                    {
                        "id":1082,
                        "label":"龙游县",
                        "value":"330825",
                        "key":"330825",
                        "parent_area_key":"330800",
                        "children":[

                        ]
                    },
                    {
                        "id":1083,
                        "label":"江山市",
                        "value":"330881",
                        "key":"330881",
                        "parent_area_key":"330800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1084,
                "label":"舟山市",
                "value":"330900",
                "key":"330900",
                "parent_area_key":"330000",
                "children":[
                    {
                        "id":1085,
                        "label":"市辖区",
                        "value":"330901",
                        "key":"330901",
                        "parent_area_key":"330900",
                        "children":[

                        ]
                    },
                    {
                        "id":1086,
                        "label":"定海区",
                        "value":"330902",
                        "key":"330902",
                        "parent_area_key":"330900",
                        "children":[

                        ]
                    },
                    {
                        "id":1087,
                        "label":"普陀区",
                        "value":"330903",
                        "key":"330903",
                        "parent_area_key":"330900",
                        "children":[

                        ]
                    },
                    {
                        "id":1088,
                        "label":"岱山县",
                        "value":"330921",
                        "key":"330921",
                        "parent_area_key":"330900",
                        "children":[

                        ]
                    },
                    {
                        "id":1089,
                        "label":"嵊泗县",
                        "value":"330922",
                        "key":"330922",
                        "parent_area_key":"330900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1090,
                "label":"台州市",
                "value":"331000",
                "key":"331000",
                "parent_area_key":"330000",
                "children":[
                    {
                        "id":1091,
                        "label":"市辖区",
                        "value":"331001",
                        "key":"331001",
                        "parent_area_key":"331000",
                        "children":[

                        ]
                    },
                    {
                        "id":1092,
                        "label":"椒江区",
                        "value":"331002",
                        "key":"331002",
                        "parent_area_key":"331000",
                        "children":[

                        ]
                    },
                    {
                        "id":1093,
                        "label":"黄岩区",
                        "value":"331003",
                        "key":"331003",
                        "parent_area_key":"331000",
                        "children":[

                        ]
                    },
                    {
                        "id":1094,
                        "label":"路桥区",
                        "value":"331004",
                        "key":"331004",
                        "parent_area_key":"331000",
                        "children":[

                        ]
                    },
                    {
                        "id":1095,
                        "label":"玉环县",
                        "value":"331021",
                        "key":"331021",
                        "parent_area_key":"331000",
                        "children":[

                        ]
                    },
                    {
                        "id":1096,
                        "label":"三门县",
                        "value":"331022",
                        "key":"331022",
                        "parent_area_key":"331000",
                        "children":[

                        ]
                    },
                    {
                        "id":1097,
                        "label":"天台县",
                        "value":"331023",
                        "key":"331023",
                        "parent_area_key":"331000",
                        "children":[

                        ]
                    },
                    {
                        "id":1098,
                        "label":"仙居县",
                        "value":"331024",
                        "key":"331024",
                        "parent_area_key":"331000",
                        "children":[

                        ]
                    },
                    {
                        "id":1099,
                        "label":"温岭市",
                        "value":"331081",
                        "key":"331081",
                        "parent_area_key":"331000",
                        "children":[

                        ]
                    },
                    {
                        "id":1100,
                        "label":"临海市",
                        "value":"331082",
                        "key":"331082",
                        "parent_area_key":"331000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1101,
                "label":"丽水市",
                "value":"331100",
                "key":"331100",
                "parent_area_key":"330000",
                "children":[
                    {
                        "id":1102,
                        "label":"市辖区",
                        "value":"331101",
                        "key":"331101",
                        "parent_area_key":"331100",
                        "children":[

                        ]
                    },
                    {
                        "id":1103,
                        "label":"莲都区",
                        "value":"331102",
                        "key":"331102",
                        "parent_area_key":"331100",
                        "children":[

                        ]
                    },
                    {
                        "id":1104,
                        "label":"青田县",
                        "value":"331121",
                        "key":"331121",
                        "parent_area_key":"331100",
                        "children":[

                        ]
                    },
                    {
                        "id":1105,
                        "label":"缙云县",
                        "value":"331122",
                        "key":"331122",
                        "parent_area_key":"331100",
                        "children":[

                        ]
                    },
                    {
                        "id":1106,
                        "label":"遂昌县",
                        "value":"331123",
                        "key":"331123",
                        "parent_area_key":"331100",
                        "children":[

                        ]
                    },
                    {
                        "id":1107,
                        "label":"松阳县",
                        "value":"331124",
                        "key":"331124",
                        "parent_area_key":"331100",
                        "children":[

                        ]
                    },
                    {
                        "id":1108,
                        "label":"云和县",
                        "value":"331125",
                        "key":"331125",
                        "parent_area_key":"331100",
                        "children":[

                        ]
                    },
                    {
                        "id":1109,
                        "label":"庆元县",
                        "value":"331126",
                        "key":"331126",
                        "parent_area_key":"331100",
                        "children":[

                        ]
                    },
                    {
                        "id":1110,
                        "label":"景宁畲族自治县",
                        "value":"331127",
                        "key":"331127",
                        "parent_area_key":"331100",
                        "children":[

                        ]
                    },
                    {
                        "id":1111,
                        "label":"龙泉市",
                        "value":"331181",
                        "key":"331181",
                        "parent_area_key":"331100",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":1112,
        "label":"安徽省",
        "value":"340000",
        "key":"340000",
        "parent_area_key":"",
        "children":[
            {
                "id":1113,
                "label":"合肥市",
                "value":"340100",
                "key":"340100",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1114,
                        "label":"市辖区",
                        "value":"340101",
                        "key":"340101",
                        "parent_area_key":"340100",
                        "children":[

                        ]
                    },
                    {
                        "id":1115,
                        "label":"瑶海区",
                        "value":"340102",
                        "key":"340102",
                        "parent_area_key":"340100",
                        "children":[

                        ]
                    },
                    {
                        "id":1116,
                        "label":"庐阳区",
                        "value":"340103",
                        "key":"340103",
                        "parent_area_key":"340100",
                        "children":[

                        ]
                    },
                    {
                        "id":1117,
                        "label":"蜀山区",
                        "value":"340104",
                        "key":"340104",
                        "parent_area_key":"340100",
                        "children":[

                        ]
                    },
                    {
                        "id":1118,
                        "label":"包河区",
                        "value":"340111",
                        "key":"340111",
                        "parent_area_key":"340100",
                        "children":[

                        ]
                    },
                    {
                        "id":1119,
                        "label":"长丰县",
                        "value":"340121",
                        "key":"340121",
                        "parent_area_key":"340100",
                        "children":[

                        ]
                    },
                    {
                        "id":1120,
                        "label":"肥东县",
                        "value":"340122",
                        "key":"340122",
                        "parent_area_key":"340100",
                        "children":[

                        ]
                    },
                    {
                        "id":1121,
                        "label":"肥西县",
                        "value":"340123",
                        "key":"340123",
                        "parent_area_key":"340100",
                        "children":[

                        ]
                    },
                    {
                        "id":1122,
                        "label":"庐江县",
                        "value":"340124",
                        "key":"340124",
                        "parent_area_key":"340100",
                        "children":[

                        ]
                    },
                    {
                        "id":1123,
                        "label":"巢湖市",
                        "value":"340181",
                        "key":"340181",
                        "parent_area_key":"340100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1124,
                "label":"芜湖市",
                "value":"340200",
                "key":"340200",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1125,
                        "label":"市辖区",
                        "value":"340201",
                        "key":"340201",
                        "parent_area_key":"340200",
                        "children":[

                        ]
                    },
                    {
                        "id":1126,
                        "label":"镜湖区",
                        "value":"340202",
                        "key":"340202",
                        "parent_area_key":"340200",
                        "children":[

                        ]
                    },
                    {
                        "id":1127,
                        "label":"弋江区",
                        "value":"340203",
                        "key":"340203",
                        "parent_area_key":"340200",
                        "children":[

                        ]
                    },
                    {
                        "id":1128,
                        "label":"鸠江区",
                        "value":"340207",
                        "key":"340207",
                        "parent_area_key":"340200",
                        "children":[

                        ]
                    },
                    {
                        "id":1129,
                        "label":"三山区",
                        "value":"340208",
                        "key":"340208",
                        "parent_area_key":"340200",
                        "children":[

                        ]
                    },
                    {
                        "id":1130,
                        "label":"芜湖县",
                        "value":"340221",
                        "key":"340221",
                        "parent_area_key":"340200",
                        "children":[

                        ]
                    },
                    {
                        "id":1131,
                        "label":"繁昌县",
                        "value":"340222",
                        "key":"340222",
                        "parent_area_key":"340200",
                        "children":[

                        ]
                    },
                    {
                        "id":1132,
                        "label":"南陵县",
                        "value":"340223",
                        "key":"340223",
                        "parent_area_key":"340200",
                        "children":[

                        ]
                    },
                    {
                        "id":1133,
                        "label":"无为县",
                        "value":"340225",
                        "key":"340225",
                        "parent_area_key":"340200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1134,
                "label":"蚌埠市",
                "value":"340300",
                "key":"340300",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1135,
                        "label":"市辖区",
                        "value":"340301",
                        "key":"340301",
                        "parent_area_key":"340300",
                        "children":[

                        ]
                    },
                    {
                        "id":1136,
                        "label":"龙子湖区",
                        "value":"340302",
                        "key":"340302",
                        "parent_area_key":"340300",
                        "children":[

                        ]
                    },
                    {
                        "id":1137,
                        "label":"蚌山区",
                        "value":"340303",
                        "key":"340303",
                        "parent_area_key":"340300",
                        "children":[

                        ]
                    },
                    {
                        "id":1138,
                        "label":"禹会区",
                        "value":"340304",
                        "key":"340304",
                        "parent_area_key":"340300",
                        "children":[

                        ]
                    },
                    {
                        "id":1139,
                        "label":"淮上区",
                        "value":"340311",
                        "key":"340311",
                        "parent_area_key":"340300",
                        "children":[

                        ]
                    },
                    {
                        "id":1140,
                        "label":"怀远县",
                        "value":"340321",
                        "key":"340321",
                        "parent_area_key":"340300",
                        "children":[

                        ]
                    },
                    {
                        "id":1141,
                        "label":"五河县",
                        "value":"340322",
                        "key":"340322",
                        "parent_area_key":"340300",
                        "children":[

                        ]
                    },
                    {
                        "id":1142,
                        "label":"固镇县",
                        "value":"340323",
                        "key":"340323",
                        "parent_area_key":"340300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1143,
                "label":"淮南市",
                "value":"340400",
                "key":"340400",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1144,
                        "label":"市辖区",
                        "value":"340401",
                        "key":"340401",
                        "parent_area_key":"340400",
                        "children":[

                        ]
                    },
                    {
                        "id":1145,
                        "label":"大通区",
                        "value":"340402",
                        "key":"340402",
                        "parent_area_key":"340400",
                        "children":[

                        ]
                    },
                    {
                        "id":1146,
                        "label":"田家庵区",
                        "value":"340403",
                        "key":"340403",
                        "parent_area_key":"340400",
                        "children":[

                        ]
                    },
                    {
                        "id":1147,
                        "label":"谢家集区",
                        "value":"340404",
                        "key":"340404",
                        "parent_area_key":"340400",
                        "children":[

                        ]
                    },
                    {
                        "id":1148,
                        "label":"八公山区",
                        "value":"340405",
                        "key":"340405",
                        "parent_area_key":"340400",
                        "children":[

                        ]
                    },
                    {
                        "id":1149,
                        "label":"潘集区",
                        "value":"340406",
                        "key":"340406",
                        "parent_area_key":"340400",
                        "children":[

                        ]
                    },
                    {
                        "id":1150,
                        "label":"凤台县",
                        "value":"340421",
                        "key":"340421",
                        "parent_area_key":"340400",
                        "children":[

                        ]
                    },
                    {
                        "id":1151,
                        "label":"寿县",
                        "value":"340422",
                        "key":"340422",
                        "parent_area_key":"340400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1152,
                "label":"马鞍山市",
                "value":"340500",
                "key":"340500",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1153,
                        "label":"市辖区",
                        "value":"340501",
                        "key":"340501",
                        "parent_area_key":"340500",
                        "children":[

                        ]
                    },
                    {
                        "id":1154,
                        "label":"花山区",
                        "value":"340503",
                        "key":"340503",
                        "parent_area_key":"340500",
                        "children":[

                        ]
                    },
                    {
                        "id":1155,
                        "label":"雨山区",
                        "value":"340504",
                        "key":"340504",
                        "parent_area_key":"340500",
                        "children":[

                        ]
                    },
                    {
                        "id":1156,
                        "label":"博望区",
                        "value":"340506",
                        "key":"340506",
                        "parent_area_key":"340500",
                        "children":[

                        ]
                    },
                    {
                        "id":1157,
                        "label":"当涂县",
                        "value":"340521",
                        "key":"340521",
                        "parent_area_key":"340500",
                        "children":[

                        ]
                    },
                    {
                        "id":1158,
                        "label":"含山县",
                        "value":"340522",
                        "key":"340522",
                        "parent_area_key":"340500",
                        "children":[

                        ]
                    },
                    {
                        "id":1159,
                        "label":"和县",
                        "value":"340523",
                        "key":"340523",
                        "parent_area_key":"340500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1160,
                "label":"淮北市",
                "value":"340600",
                "key":"340600",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1161,
                        "label":"市辖区",
                        "value":"340601",
                        "key":"340601",
                        "parent_area_key":"340600",
                        "children":[

                        ]
                    },
                    {
                        "id":1162,
                        "label":"杜集区",
                        "value":"340602",
                        "key":"340602",
                        "parent_area_key":"340600",
                        "children":[

                        ]
                    },
                    {
                        "id":1163,
                        "label":"相山区",
                        "value":"340603",
                        "key":"340603",
                        "parent_area_key":"340600",
                        "children":[

                        ]
                    },
                    {
                        "id":1164,
                        "label":"烈山区",
                        "value":"340604",
                        "key":"340604",
                        "parent_area_key":"340600",
                        "children":[

                        ]
                    },
                    {
                        "id":1165,
                        "label":"濉溪县",
                        "value":"340621",
                        "key":"340621",
                        "parent_area_key":"340600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1166,
                "label":"铜陵市",
                "value":"340700",
                "key":"340700",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1167,
                        "label":"市辖区",
                        "value":"340701",
                        "key":"340701",
                        "parent_area_key":"340700",
                        "children":[

                        ]
                    },
                    {
                        "id":1168,
                        "label":"铜官区",
                        "value":"340705",
                        "key":"340705",
                        "parent_area_key":"340700",
                        "children":[

                        ]
                    },
                    {
                        "id":1169,
                        "label":"义安区",
                        "value":"340706",
                        "key":"340706",
                        "parent_area_key":"340700",
                        "children":[

                        ]
                    },
                    {
                        "id":1170,
                        "label":"郊区",
                        "value":"340711",
                        "key":"340711",
                        "parent_area_key":"340700",
                        "children":[

                        ]
                    },
                    {
                        "id":1171,
                        "label":"枞阳县",
                        "value":"340722",
                        "key":"340722",
                        "parent_area_key":"340700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1172,
                "label":"安庆市",
                "value":"340800",
                "key":"340800",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1173,
                        "label":"市辖区",
                        "value":"340801",
                        "key":"340801",
                        "parent_area_key":"340800",
                        "children":[

                        ]
                    },
                    {
                        "id":1174,
                        "label":"迎江区",
                        "value":"340802",
                        "key":"340802",
                        "parent_area_key":"340800",
                        "children":[

                        ]
                    },
                    {
                        "id":1175,
                        "label":"大观区",
                        "value":"340803",
                        "key":"340803",
                        "parent_area_key":"340800",
                        "children":[

                        ]
                    },
                    {
                        "id":1176,
                        "label":"宜秀区",
                        "value":"340811",
                        "key":"340811",
                        "parent_area_key":"340800",
                        "children":[

                        ]
                    },
                    {
                        "id":1177,
                        "label":"怀宁县",
                        "value":"340822",
                        "key":"340822",
                        "parent_area_key":"340800",
                        "children":[

                        ]
                    },
                    {
                        "id":1178,
                        "label":"潜山县",
                        "value":"340824",
                        "key":"340824",
                        "parent_area_key":"340800",
                        "children":[

                        ]
                    },
                    {
                        "id":1179,
                        "label":"太湖县",
                        "value":"340825",
                        "key":"340825",
                        "parent_area_key":"340800",
                        "children":[

                        ]
                    },
                    {
                        "id":1180,
                        "label":"宿松县",
                        "value":"340826",
                        "key":"340826",
                        "parent_area_key":"340800",
                        "children":[

                        ]
                    },
                    {
                        "id":1181,
                        "label":"望江县",
                        "value":"340827",
                        "key":"340827",
                        "parent_area_key":"340800",
                        "children":[

                        ]
                    },
                    {
                        "id":1182,
                        "label":"岳西县",
                        "value":"340828",
                        "key":"340828",
                        "parent_area_key":"340800",
                        "children":[

                        ]
                    },
                    {
                        "id":1183,
                        "label":"桐城市",
                        "value":"340881",
                        "key":"340881",
                        "parent_area_key":"340800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1184,
                "label":"黄山市",
                "value":"341000",
                "key":"341000",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1185,
                        "label":"市辖区",
                        "value":"341001",
                        "key":"341001",
                        "parent_area_key":"341000",
                        "children":[

                        ]
                    },
                    {
                        "id":1186,
                        "label":"屯溪区",
                        "value":"341002",
                        "key":"341002",
                        "parent_area_key":"341000",
                        "children":[

                        ]
                    },
                    {
                        "id":1187,
                        "label":"黄山区",
                        "value":"341003",
                        "key":"341003",
                        "parent_area_key":"341000",
                        "children":[

                        ]
                    },
                    {
                        "id":1188,
                        "label":"徽州区",
                        "value":"341004",
                        "key":"341004",
                        "parent_area_key":"341000",
                        "children":[

                        ]
                    },
                    {
                        "id":1189,
                        "label":"歙县",
                        "value":"341021",
                        "key":"341021",
                        "parent_area_key":"341000",
                        "children":[

                        ]
                    },
                    {
                        "id":1190,
                        "label":"休宁县",
                        "value":"341022",
                        "key":"341022",
                        "parent_area_key":"341000",
                        "children":[

                        ]
                    },
                    {
                        "id":1191,
                        "label":"黟县",
                        "value":"341023",
                        "key":"341023",
                        "parent_area_key":"341000",
                        "children":[

                        ]
                    },
                    {
                        "id":1192,
                        "label":"祁门县",
                        "value":"341024",
                        "key":"341024",
                        "parent_area_key":"341000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1193,
                "label":"滁州市",
                "value":"341100",
                "key":"341100",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1194,
                        "label":"市辖区",
                        "value":"341101",
                        "key":"341101",
                        "parent_area_key":"341100",
                        "children":[

                        ]
                    },
                    {
                        "id":1195,
                        "label":"琅琊区",
                        "value":"341102",
                        "key":"341102",
                        "parent_area_key":"341100",
                        "children":[

                        ]
                    },
                    {
                        "id":1196,
                        "label":"南谯区",
                        "value":"341103",
                        "key":"341103",
                        "parent_area_key":"341100",
                        "children":[

                        ]
                    },
                    {
                        "id":1197,
                        "label":"来安县",
                        "value":"341122",
                        "key":"341122",
                        "parent_area_key":"341100",
                        "children":[

                        ]
                    },
                    {
                        "id":1198,
                        "label":"全椒县",
                        "value":"341124",
                        "key":"341124",
                        "parent_area_key":"341100",
                        "children":[

                        ]
                    },
                    {
                        "id":1199,
                        "label":"定远县",
                        "value":"341125",
                        "key":"341125",
                        "parent_area_key":"341100",
                        "children":[

                        ]
                    },
                    {
                        "id":1200,
                        "label":"凤阳县",
                        "value":"341126",
                        "key":"341126",
                        "parent_area_key":"341100",
                        "children":[

                        ]
                    },
                    {
                        "id":1201,
                        "label":"天长市",
                        "value":"341181",
                        "key":"341181",
                        "parent_area_key":"341100",
                        "children":[

                        ]
                    },
                    {
                        "id":1202,
                        "label":"明光市",
                        "value":"341182",
                        "key":"341182",
                        "parent_area_key":"341100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1203,
                "label":"阜阳市",
                "value":"341200",
                "key":"341200",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1204,
                        "label":"市辖区",
                        "value":"341201",
                        "key":"341201",
                        "parent_area_key":"341200",
                        "children":[

                        ]
                    },
                    {
                        "id":1205,
                        "label":"颍州区",
                        "value":"341202",
                        "key":"341202",
                        "parent_area_key":"341200",
                        "children":[

                        ]
                    },
                    {
                        "id":1206,
                        "label":"颍东区",
                        "value":"341203",
                        "key":"341203",
                        "parent_area_key":"341200",
                        "children":[

                        ]
                    },
                    {
                        "id":1207,
                        "label":"颍泉区",
                        "value":"341204",
                        "key":"341204",
                        "parent_area_key":"341200",
                        "children":[

                        ]
                    },
                    {
                        "id":1208,
                        "label":"临泉县",
                        "value":"341221",
                        "key":"341221",
                        "parent_area_key":"341200",
                        "children":[

                        ]
                    },
                    {
                        "id":1209,
                        "label":"太和县",
                        "value":"341222",
                        "key":"341222",
                        "parent_area_key":"341200",
                        "children":[

                        ]
                    },
                    {
                        "id":1210,
                        "label":"阜南县",
                        "value":"341225",
                        "key":"341225",
                        "parent_area_key":"341200",
                        "children":[

                        ]
                    },
                    {
                        "id":1211,
                        "label":"颍上县",
                        "value":"341226",
                        "key":"341226",
                        "parent_area_key":"341200",
                        "children":[

                        ]
                    },
                    {
                        "id":1212,
                        "label":"界首市",
                        "value":"341282",
                        "key":"341282",
                        "parent_area_key":"341200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1213,
                "label":"宿州市",
                "value":"341300",
                "key":"341300",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1214,
                        "label":"市辖区",
                        "value":"341301",
                        "key":"341301",
                        "parent_area_key":"341300",
                        "children":[

                        ]
                    },
                    {
                        "id":1215,
                        "label":"埇桥区",
                        "value":"341302",
                        "key":"341302",
                        "parent_area_key":"341300",
                        "children":[

                        ]
                    },
                    {
                        "id":1216,
                        "label":"砀山县",
                        "value":"341321",
                        "key":"341321",
                        "parent_area_key":"341300",
                        "children":[

                        ]
                    },
                    {
                        "id":1217,
                        "label":"萧县",
                        "value":"341322",
                        "key":"341322",
                        "parent_area_key":"341300",
                        "children":[

                        ]
                    },
                    {
                        "id":1218,
                        "label":"灵璧县",
                        "value":"341323",
                        "key":"341323",
                        "parent_area_key":"341300",
                        "children":[

                        ]
                    },
                    {
                        "id":1219,
                        "label":"泗县",
                        "value":"341324",
                        "key":"341324",
                        "parent_area_key":"341300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1220,
                "label":"六安市",
                "value":"341500",
                "key":"341500",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1221,
                        "label":"市辖区",
                        "value":"341501",
                        "key":"341501",
                        "parent_area_key":"341500",
                        "children":[

                        ]
                    },
                    {
                        "id":1222,
                        "label":"金安区",
                        "value":"341502",
                        "key":"341502",
                        "parent_area_key":"341500",
                        "children":[

                        ]
                    },
                    {
                        "id":1223,
                        "label":"裕安区",
                        "value":"341503",
                        "key":"341503",
                        "parent_area_key":"341500",
                        "children":[

                        ]
                    },
                    {
                        "id":1224,
                        "label":"叶集区",
                        "value":"341504",
                        "key":"341504",
                        "parent_area_key":"341500",
                        "children":[

                        ]
                    },
                    {
                        "id":1225,
                        "label":"霍邱县",
                        "value":"341522",
                        "key":"341522",
                        "parent_area_key":"341500",
                        "children":[

                        ]
                    },
                    {
                        "id":1226,
                        "label":"舒城县",
                        "value":"341523",
                        "key":"341523",
                        "parent_area_key":"341500",
                        "children":[

                        ]
                    },
                    {
                        "id":1227,
                        "label":"金寨县",
                        "value":"341524",
                        "key":"341524",
                        "parent_area_key":"341500",
                        "children":[

                        ]
                    },
                    {
                        "id":1228,
                        "label":"霍山县",
                        "value":"341525",
                        "key":"341525",
                        "parent_area_key":"341500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1229,
                "label":"亳州市",
                "value":"341600",
                "key":"341600",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1230,
                        "label":"市辖区",
                        "value":"341601",
                        "key":"341601",
                        "parent_area_key":"341600",
                        "children":[

                        ]
                    },
                    {
                        "id":1231,
                        "label":"谯城区",
                        "value":"341602",
                        "key":"341602",
                        "parent_area_key":"341600",
                        "children":[

                        ]
                    },
                    {
                        "id":1232,
                        "label":"涡阳县",
                        "value":"341621",
                        "key":"341621",
                        "parent_area_key":"341600",
                        "children":[

                        ]
                    },
                    {
                        "id":1233,
                        "label":"蒙城县",
                        "value":"341622",
                        "key":"341622",
                        "parent_area_key":"341600",
                        "children":[

                        ]
                    },
                    {
                        "id":1234,
                        "label":"利辛县",
                        "value":"341623",
                        "key":"341623",
                        "parent_area_key":"341600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1235,
                "label":"池州市",
                "value":"341700",
                "key":"341700",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1236,
                        "label":"市辖区",
                        "value":"341701",
                        "key":"341701",
                        "parent_area_key":"341700",
                        "children":[

                        ]
                    },
                    {
                        "id":1237,
                        "label":"贵池区",
                        "value":"341702",
                        "key":"341702",
                        "parent_area_key":"341700",
                        "children":[

                        ]
                    },
                    {
                        "id":1238,
                        "label":"东至县",
                        "value":"341721",
                        "key":"341721",
                        "parent_area_key":"341700",
                        "children":[

                        ]
                    },
                    {
                        "id":1239,
                        "label":"石台县",
                        "value":"341722",
                        "key":"341722",
                        "parent_area_key":"341700",
                        "children":[

                        ]
                    },
                    {
                        "id":1240,
                        "label":"青阳县",
                        "value":"341723",
                        "key":"341723",
                        "parent_area_key":"341700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1241,
                "label":"宣城市",
                "value":"341800",
                "key":"341800",
                "parent_area_key":"340000",
                "children":[
                    {
                        "id":1242,
                        "label":"市辖区",
                        "value":"341801",
                        "key":"341801",
                        "parent_area_key":"341800",
                        "children":[

                        ]
                    },
                    {
                        "id":1243,
                        "label":"宣州区",
                        "value":"341802",
                        "key":"341802",
                        "parent_area_key":"341800",
                        "children":[

                        ]
                    },
                    {
                        "id":1244,
                        "label":"郎溪县",
                        "value":"341821",
                        "key":"341821",
                        "parent_area_key":"341800",
                        "children":[

                        ]
                    },
                    {
                        "id":1245,
                        "label":"广德县",
                        "value":"341822",
                        "key":"341822",
                        "parent_area_key":"341800",
                        "children":[

                        ]
                    },
                    {
                        "id":1246,
                        "label":"泾县",
                        "value":"341823",
                        "key":"341823",
                        "parent_area_key":"341800",
                        "children":[

                        ]
                    },
                    {
                        "id":1247,
                        "label":"绩溪县",
                        "value":"341824",
                        "key":"341824",
                        "parent_area_key":"341800",
                        "children":[

                        ]
                    },
                    {
                        "id":1248,
                        "label":"旌德县",
                        "value":"341825",
                        "key":"341825",
                        "parent_area_key":"341800",
                        "children":[

                        ]
                    },
                    {
                        "id":1249,
                        "label":"宁国市",
                        "value":"341881",
                        "key":"341881",
                        "parent_area_key":"341800",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":1250,
        "label":"福建省",
        "value":"350000",
        "key":"350000",
        "parent_area_key":"",
        "children":[
            {
                "id":1251,
                "label":"福州市",
                "value":"350100",
                "key":"350100",
                "parent_area_key":"350000",
                "children":[
                    {
                        "id":1252,
                        "label":"市辖区",
                        "value":"350101",
                        "key":"350101",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    },
                    {
                        "id":1253,
                        "label":"鼓楼区",
                        "value":"350102",
                        "key":"350102",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    },
                    {
                        "id":1254,
                        "label":"台江区",
                        "value":"350103",
                        "key":"350103",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    },
                    {
                        "id":1255,
                        "label":"仓山区",
                        "value":"350104",
                        "key":"350104",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    },
                    {
                        "id":1256,
                        "label":"马尾区",
                        "value":"350105",
                        "key":"350105",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    },
                    {
                        "id":1257,
                        "label":"晋安区",
                        "value":"350111",
                        "key":"350111",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    },
                    {
                        "id":1258,
                        "label":"闽侯县",
                        "value":"350121",
                        "key":"350121",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    },
                    {
                        "id":1259,
                        "label":"连江县",
                        "value":"350122",
                        "key":"350122",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    },
                    {
                        "id":1260,
                        "label":"罗源县",
                        "value":"350123",
                        "key":"350123",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    },
                    {
                        "id":1261,
                        "label":"闽清县",
                        "value":"350124",
                        "key":"350124",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    },
                    {
                        "id":1262,
                        "label":"永泰县",
                        "value":"350125",
                        "key":"350125",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    },
                    {
                        "id":1263,
                        "label":"平潭县",
                        "value":"350128",
                        "key":"350128",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    },
                    {
                        "id":1264,
                        "label":"福清市",
                        "value":"350181",
                        "key":"350181",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    },
                    {
                        "id":1265,
                        "label":"长乐市",
                        "value":"350182",
                        "key":"350182",
                        "parent_area_key":"350100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1266,
                "label":"厦门市",
                "value":"350200",
                "key":"350200",
                "parent_area_key":"350000",
                "children":[
                    {
                        "id":1267,
                        "label":"市辖区",
                        "value":"350201",
                        "key":"350201",
                        "parent_area_key":"350200",
                        "children":[

                        ]
                    },
                    {
                        "id":1268,
                        "label":"思明区",
                        "value":"350203",
                        "key":"350203",
                        "parent_area_key":"350200",
                        "children":[

                        ]
                    },
                    {
                        "id":1269,
                        "label":"海沧区",
                        "value":"350205",
                        "key":"350205",
                        "parent_area_key":"350200",
                        "children":[

                        ]
                    },
                    {
                        "id":1270,
                        "label":"湖里区",
                        "value":"350206",
                        "key":"350206",
                        "parent_area_key":"350200",
                        "children":[

                        ]
                    },
                    {
                        "id":1271,
                        "label":"集美区",
                        "value":"350211",
                        "key":"350211",
                        "parent_area_key":"350200",
                        "children":[

                        ]
                    },
                    {
                        "id":1272,
                        "label":"同安区",
                        "value":"350212",
                        "key":"350212",
                        "parent_area_key":"350200",
                        "children":[

                        ]
                    },
                    {
                        "id":1273,
                        "label":"翔安区",
                        "value":"350213",
                        "key":"350213",
                        "parent_area_key":"350200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1274,
                "label":"莆田市",
                "value":"350300",
                "key":"350300",
                "parent_area_key":"350000",
                "children":[
                    {
                        "id":1275,
                        "label":"市辖区",
                        "value":"350301",
                        "key":"350301",
                        "parent_area_key":"350300",
                        "children":[

                        ]
                    },
                    {
                        "id":1276,
                        "label":"城厢区",
                        "value":"350302",
                        "key":"350302",
                        "parent_area_key":"350300",
                        "children":[

                        ]
                    },
                    {
                        "id":1277,
                        "label":"涵江区",
                        "value":"350303",
                        "key":"350303",
                        "parent_area_key":"350300",
                        "children":[

                        ]
                    },
                    {
                        "id":1278,
                        "label":"荔城区",
                        "value":"350304",
                        "key":"350304",
                        "parent_area_key":"350300",
                        "children":[

                        ]
                    },
                    {
                        "id":1279,
                        "label":"秀屿区",
                        "value":"350305",
                        "key":"350305",
                        "parent_area_key":"350300",
                        "children":[

                        ]
                    },
                    {
                        "id":1280,
                        "label":"仙游县",
                        "value":"350322",
                        "key":"350322",
                        "parent_area_key":"350300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1281,
                "label":"三明市",
                "value":"350400",
                "key":"350400",
                "parent_area_key":"350000",
                "children":[
                    {
                        "id":1282,
                        "label":"市辖区",
                        "value":"350401",
                        "key":"350401",
                        "parent_area_key":"350400",
                        "children":[

                        ]
                    },
                    {
                        "id":1283,
                        "label":"梅列区",
                        "value":"350402",
                        "key":"350402",
                        "parent_area_key":"350400",
                        "children":[

                        ]
                    },
                    {
                        "id":1284,
                        "label":"三元区",
                        "value":"350403",
                        "key":"350403",
                        "parent_area_key":"350400",
                        "children":[

                        ]
                    },
                    {
                        "id":1285,
                        "label":"明溪县",
                        "value":"350421",
                        "key":"350421",
                        "parent_area_key":"350400",
                        "children":[

                        ]
                    },
                    {
                        "id":1286,
                        "label":"清流县",
                        "value":"350423",
                        "key":"350423",
                        "parent_area_key":"350400",
                        "children":[

                        ]
                    },
                    {
                        "id":1287,
                        "label":"宁化县",
                        "value":"350424",
                        "key":"350424",
                        "parent_area_key":"350400",
                        "children":[

                        ]
                    },
                    {
                        "id":1288,
                        "label":"大田县",
                        "value":"350425",
                        "key":"350425",
                        "parent_area_key":"350400",
                        "children":[

                        ]
                    },
                    {
                        "id":1289,
                        "label":"尤溪县",
                        "value":"350426",
                        "key":"350426",
                        "parent_area_key":"350400",
                        "children":[

                        ]
                    },
                    {
                        "id":1290,
                        "label":"沙县",
                        "value":"350427",
                        "key":"350427",
                        "parent_area_key":"350400",
                        "children":[

                        ]
                    },
                    {
                        "id":1291,
                        "label":"将乐县",
                        "value":"350428",
                        "key":"350428",
                        "parent_area_key":"350400",
                        "children":[

                        ]
                    },
                    {
                        "id":1292,
                        "label":"泰宁县",
                        "value":"350429",
                        "key":"350429",
                        "parent_area_key":"350400",
                        "children":[

                        ]
                    },
                    {
                        "id":1293,
                        "label":"建宁县",
                        "value":"350430",
                        "key":"350430",
                        "parent_area_key":"350400",
                        "children":[

                        ]
                    },
                    {
                        "id":1294,
                        "label":"永安市",
                        "value":"350481",
                        "key":"350481",
                        "parent_area_key":"350400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1295,
                "label":"泉州市",
                "value":"350500",
                "key":"350500",
                "parent_area_key":"350000",
                "children":[
                    {
                        "id":1296,
                        "label":"市辖区",
                        "value":"350501",
                        "key":"350501",
                        "parent_area_key":"350500",
                        "children":[

                        ]
                    },
                    {
                        "id":1297,
                        "label":"鲤城区",
                        "value":"350502",
                        "key":"350502",
                        "parent_area_key":"350500",
                        "children":[

                        ]
                    },
                    {
                        "id":1298,
                        "label":"丰泽区",
                        "value":"350503",
                        "key":"350503",
                        "parent_area_key":"350500",
                        "children":[

                        ]
                    },
                    {
                        "id":1299,
                        "label":"洛江区",
                        "value":"350504",
                        "key":"350504",
                        "parent_area_key":"350500",
                        "children":[

                        ]
                    },
                    {
                        "id":1300,
                        "label":"泉港区",
                        "value":"350505",
                        "key":"350505",
                        "parent_area_key":"350500",
                        "children":[

                        ]
                    },
                    {
                        "id":1301,
                        "label":"惠安县",
                        "value":"350521",
                        "key":"350521",
                        "parent_area_key":"350500",
                        "children":[

                        ]
                    },
                    {
                        "id":1302,
                        "label":"安溪县",
                        "value":"350524",
                        "key":"350524",
                        "parent_area_key":"350500",
                        "children":[

                        ]
                    },
                    {
                        "id":1303,
                        "label":"永春县",
                        "value":"350525",
                        "key":"350525",
                        "parent_area_key":"350500",
                        "children":[

                        ]
                    },
                    {
                        "id":1304,
                        "label":"德化县",
                        "value":"350526",
                        "key":"350526",
                        "parent_area_key":"350500",
                        "children":[

                        ]
                    },
                    {
                        "id":1305,
                        "label":"金门县",
                        "value":"350527",
                        "key":"350527",
                        "parent_area_key":"350500",
                        "children":[

                        ]
                    },
                    {
                        "id":1306,
                        "label":"石狮市",
                        "value":"350581",
                        "key":"350581",
                        "parent_area_key":"350500",
                        "children":[

                        ]
                    },
                    {
                        "id":1307,
                        "label":"晋江市",
                        "value":"350582",
                        "key":"350582",
                        "parent_area_key":"350500",
                        "children":[

                        ]
                    },
                    {
                        "id":1308,
                        "label":"南安市",
                        "value":"350583",
                        "key":"350583",
                        "parent_area_key":"350500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1309,
                "label":"漳州市",
                "value":"350600",
                "key":"350600",
                "parent_area_key":"350000",
                "children":[
                    {
                        "id":1310,
                        "label":"市辖区",
                        "value":"350601",
                        "key":"350601",
                        "parent_area_key":"350600",
                        "children":[

                        ]
                    },
                    {
                        "id":1311,
                        "label":"芗城区",
                        "value":"350602",
                        "key":"350602",
                        "parent_area_key":"350600",
                        "children":[

                        ]
                    },
                    {
                        "id":1312,
                        "label":"龙文区",
                        "value":"350603",
                        "key":"350603",
                        "parent_area_key":"350600",
                        "children":[

                        ]
                    },
                    {
                        "id":1313,
                        "label":"云霄县",
                        "value":"350622",
                        "key":"350622",
                        "parent_area_key":"350600",
                        "children":[

                        ]
                    },
                    {
                        "id":1314,
                        "label":"漳浦县",
                        "value":"350623",
                        "key":"350623",
                        "parent_area_key":"350600",
                        "children":[

                        ]
                    },
                    {
                        "id":1315,
                        "label":"诏安县",
                        "value":"350624",
                        "key":"350624",
                        "parent_area_key":"350600",
                        "children":[

                        ]
                    },
                    {
                        "id":1316,
                        "label":"长泰县",
                        "value":"350625",
                        "key":"350625",
                        "parent_area_key":"350600",
                        "children":[

                        ]
                    },
                    {
                        "id":1317,
                        "label":"东山县",
                        "value":"350626",
                        "key":"350626",
                        "parent_area_key":"350600",
                        "children":[

                        ]
                    },
                    {
                        "id":1318,
                        "label":"南靖县",
                        "value":"350627",
                        "key":"350627",
                        "parent_area_key":"350600",
                        "children":[

                        ]
                    },
                    {
                        "id":1319,
                        "label":"平和县",
                        "value":"350628",
                        "key":"350628",
                        "parent_area_key":"350600",
                        "children":[

                        ]
                    },
                    {
                        "id":1320,
                        "label":"华安县",
                        "value":"350629",
                        "key":"350629",
                        "parent_area_key":"350600",
                        "children":[

                        ]
                    },
                    {
                        "id":1321,
                        "label":"龙海市",
                        "value":"350681",
                        "key":"350681",
                        "parent_area_key":"350600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1322,
                "label":"南平市",
                "value":"350700",
                "key":"350700",
                "parent_area_key":"350000",
                "children":[
                    {
                        "id":1323,
                        "label":"市辖区",
                        "value":"350701",
                        "key":"350701",
                        "parent_area_key":"350700",
                        "children":[

                        ]
                    },
                    {
                        "id":1324,
                        "label":"延平区",
                        "value":"350702",
                        "key":"350702",
                        "parent_area_key":"350700",
                        "children":[

                        ]
                    },
                    {
                        "id":1325,
                        "label":"建阳区",
                        "value":"350703",
                        "key":"350703",
                        "parent_area_key":"350700",
                        "children":[

                        ]
                    },
                    {
                        "id":1326,
                        "label":"顺昌县",
                        "value":"350721",
                        "key":"350721",
                        "parent_area_key":"350700",
                        "children":[

                        ]
                    },
                    {
                        "id":1327,
                        "label":"浦城县",
                        "value":"350722",
                        "key":"350722",
                        "parent_area_key":"350700",
                        "children":[

                        ]
                    },
                    {
                        "id":1328,
                        "label":"光泽县",
                        "value":"350723",
                        "key":"350723",
                        "parent_area_key":"350700",
                        "children":[

                        ]
                    },
                    {
                        "id":1329,
                        "label":"松溪县",
                        "value":"350724",
                        "key":"350724",
                        "parent_area_key":"350700",
                        "children":[

                        ]
                    },
                    {
                        "id":1330,
                        "label":"政和县",
                        "value":"350725",
                        "key":"350725",
                        "parent_area_key":"350700",
                        "children":[

                        ]
                    },
                    {
                        "id":1331,
                        "label":"邵武市",
                        "value":"350781",
                        "key":"350781",
                        "parent_area_key":"350700",
                        "children":[

                        ]
                    },
                    {
                        "id":1332,
                        "label":"武夷山市",
                        "value":"350782",
                        "key":"350782",
                        "parent_area_key":"350700",
                        "children":[

                        ]
                    },
                    {
                        "id":1333,
                        "label":"建瓯市",
                        "value":"350783",
                        "key":"350783",
                        "parent_area_key":"350700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1334,
                "label":"龙岩市",
                "value":"350800",
                "key":"350800",
                "parent_area_key":"350000",
                "children":[
                    {
                        "id":1335,
                        "label":"市辖区",
                        "value":"350801",
                        "key":"350801",
                        "parent_area_key":"350800",
                        "children":[

                        ]
                    },
                    {
                        "id":1336,
                        "label":"新罗区",
                        "value":"350802",
                        "key":"350802",
                        "parent_area_key":"350800",
                        "children":[

                        ]
                    },
                    {
                        "id":1337,
                        "label":"永定区",
                        "value":"350803",
                        "key":"350803",
                        "parent_area_key":"350800",
                        "children":[

                        ]
                    },
                    {
                        "id":1338,
                        "label":"长汀县",
                        "value":"350821",
                        "key":"350821",
                        "parent_area_key":"350800",
                        "children":[

                        ]
                    },
                    {
                        "id":1339,
                        "label":"上杭县",
                        "value":"350823",
                        "key":"350823",
                        "parent_area_key":"350800",
                        "children":[

                        ]
                    },
                    {
                        "id":1340,
                        "label":"武平县",
                        "value":"350824",
                        "key":"350824",
                        "parent_area_key":"350800",
                        "children":[

                        ]
                    },
                    {
                        "id":1341,
                        "label":"连城县",
                        "value":"350825",
                        "key":"350825",
                        "parent_area_key":"350800",
                        "children":[

                        ]
                    },
                    {
                        "id":1342,
                        "label":"漳平市",
                        "value":"350881",
                        "key":"350881",
                        "parent_area_key":"350800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1343,
                "label":"宁德市",
                "value":"350900",
                "key":"350900",
                "parent_area_key":"350000",
                "children":[
                    {
                        "id":1344,
                        "label":"市辖区",
                        "value":"350901",
                        "key":"350901",
                        "parent_area_key":"350900",
                        "children":[

                        ]
                    },
                    {
                        "id":1345,
                        "label":"蕉城区",
                        "value":"350902",
                        "key":"350902",
                        "parent_area_key":"350900",
                        "children":[

                        ]
                    },
                    {
                        "id":1346,
                        "label":"霞浦县",
                        "value":"350921",
                        "key":"350921",
                        "parent_area_key":"350900",
                        "children":[

                        ]
                    },
                    {
                        "id":1347,
                        "label":"古田县",
                        "value":"350922",
                        "key":"350922",
                        "parent_area_key":"350900",
                        "children":[

                        ]
                    },
                    {
                        "id":1348,
                        "label":"屏南县",
                        "value":"350923",
                        "key":"350923",
                        "parent_area_key":"350900",
                        "children":[

                        ]
                    },
                    {
                        "id":1349,
                        "label":"寿宁县",
                        "value":"350924",
                        "key":"350924",
                        "parent_area_key":"350900",
                        "children":[

                        ]
                    },
                    {
                        "id":1350,
                        "label":"周宁县",
                        "value":"350925",
                        "key":"350925",
                        "parent_area_key":"350900",
                        "children":[

                        ]
                    },
                    {
                        "id":1351,
                        "label":"柘荣县",
                        "value":"350926",
                        "key":"350926",
                        "parent_area_key":"350900",
                        "children":[

                        ]
                    },
                    {
                        "id":1352,
                        "label":"福安市",
                        "value":"350981",
                        "key":"350981",
                        "parent_area_key":"350900",
                        "children":[

                        ]
                    },
                    {
                        "id":1353,
                        "label":"福鼎市",
                        "value":"350982",
                        "key":"350982",
                        "parent_area_key":"350900",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":1354,
        "label":"江西省",
        "value":"360000",
        "key":"360000",
        "parent_area_key":"",
        "children":[
            {
                "id":1355,
                "label":"南昌市",
                "value":"360100",
                "key":"360100",
                "parent_area_key":"360000",
                "children":[
                    {
                        "id":1356,
                        "label":"市辖区",
                        "value":"360101",
                        "key":"360101",
                        "parent_area_key":"360100",
                        "children":[

                        ]
                    },
                    {
                        "id":1357,
                        "label":"东湖区",
                        "value":"360102",
                        "key":"360102",
                        "parent_area_key":"360100",
                        "children":[

                        ]
                    },
                    {
                        "id":1358,
                        "label":"西湖区",
                        "value":"360103",
                        "key":"360103",
                        "parent_area_key":"360100",
                        "children":[

                        ]
                    },
                    {
                        "id":1359,
                        "label":"青云谱区",
                        "value":"360104",
                        "key":"360104",
                        "parent_area_key":"360100",
                        "children":[

                        ]
                    },
                    {
                        "id":1360,
                        "label":"湾里区",
                        "value":"360105",
                        "key":"360105",
                        "parent_area_key":"360100",
                        "children":[

                        ]
                    },
                    {
                        "id":1361,
                        "label":"青山湖区",
                        "value":"360111",
                        "key":"360111",
                        "parent_area_key":"360100",
                        "children":[

                        ]
                    },
                    {
                        "id":1362,
                        "label":"新建区",
                        "value":"360112",
                        "key":"360112",
                        "parent_area_key":"360100",
                        "children":[

                        ]
                    },
                    {
                        "id":1363,
                        "label":"南昌县",
                        "value":"360121",
                        "key":"360121",
                        "parent_area_key":"360100",
                        "children":[

                        ]
                    },
                    {
                        "id":1364,
                        "label":"安义县",
                        "value":"360123",
                        "key":"360123",
                        "parent_area_key":"360100",
                        "children":[

                        ]
                    },
                    {
                        "id":1365,
                        "label":"进贤县",
                        "value":"360124",
                        "key":"360124",
                        "parent_area_key":"360100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1366,
                "label":"景德镇市",
                "value":"360200",
                "key":"360200",
                "parent_area_key":"360000",
                "children":[
                    {
                        "id":1367,
                        "label":"市辖区",
                        "value":"360201",
                        "key":"360201",
                        "parent_area_key":"360200",
                        "children":[

                        ]
                    },
                    {
                        "id":1368,
                        "label":"昌江区",
                        "value":"360202",
                        "key":"360202",
                        "parent_area_key":"360200",
                        "children":[

                        ]
                    },
                    {
                        "id":1369,
                        "label":"珠山区",
                        "value":"360203",
                        "key":"360203",
                        "parent_area_key":"360200",
                        "children":[

                        ]
                    },
                    {
                        "id":1370,
                        "label":"浮梁县",
                        "value":"360222",
                        "key":"360222",
                        "parent_area_key":"360200",
                        "children":[

                        ]
                    },
                    {
                        "id":1371,
                        "label":"乐平市",
                        "value":"360281",
                        "key":"360281",
                        "parent_area_key":"360200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1372,
                "label":"萍乡市",
                "value":"360300",
                "key":"360300",
                "parent_area_key":"360000",
                "children":[
                    {
                        "id":1373,
                        "label":"市辖区",
                        "value":"360301",
                        "key":"360301",
                        "parent_area_key":"360300",
                        "children":[

                        ]
                    },
                    {
                        "id":1374,
                        "label":"安源区",
                        "value":"360302",
                        "key":"360302",
                        "parent_area_key":"360300",
                        "children":[

                        ]
                    },
                    {
                        "id":1375,
                        "label":"湘东区",
                        "value":"360313",
                        "key":"360313",
                        "parent_area_key":"360300",
                        "children":[

                        ]
                    },
                    {
                        "id":1376,
                        "label":"莲花县",
                        "value":"360321",
                        "key":"360321",
                        "parent_area_key":"360300",
                        "children":[

                        ]
                    },
                    {
                        "id":1377,
                        "label":"上栗县",
                        "value":"360322",
                        "key":"360322",
                        "parent_area_key":"360300",
                        "children":[

                        ]
                    },
                    {
                        "id":1378,
                        "label":"芦溪县",
                        "value":"360323",
                        "key":"360323",
                        "parent_area_key":"360300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1379,
                "label":"九江市",
                "value":"360400",
                "key":"360400",
                "parent_area_key":"360000",
                "children":[
                    {
                        "id":1380,
                        "label":"市辖区",
                        "value":"360401",
                        "key":"360401",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    },
                    {
                        "id":1381,
                        "label":"濂溪区",
                        "value":"360402",
                        "key":"360402",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    },
                    {
                        "id":1382,
                        "label":"浔阳区",
                        "value":"360403",
                        "key":"360403",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    },
                    {
                        "id":1383,
                        "label":"九江县",
                        "value":"360421",
                        "key":"360421",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    },
                    {
                        "id":1384,
                        "label":"武宁县",
                        "value":"360423",
                        "key":"360423",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    },
                    {
                        "id":1385,
                        "label":"修水县",
                        "value":"360424",
                        "key":"360424",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    },
                    {
                        "id":1386,
                        "label":"永修县",
                        "value":"360425",
                        "key":"360425",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    },
                    {
                        "id":1387,
                        "label":"德安县",
                        "value":"360426",
                        "key":"360426",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    },
                    {
                        "id":1388,
                        "label":"都昌县",
                        "value":"360428",
                        "key":"360428",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    },
                    {
                        "id":1389,
                        "label":"湖口县",
                        "value":"360429",
                        "key":"360429",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    },
                    {
                        "id":1390,
                        "label":"彭泽县",
                        "value":"360430",
                        "key":"360430",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    },
                    {
                        "id":1391,
                        "label":"瑞昌市",
                        "value":"360481",
                        "key":"360481",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    },
                    {
                        "id":1392,
                        "label":"共青城市",
                        "value":"360482",
                        "key":"360482",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    },
                    {
                        "id":1393,
                        "label":"庐山市",
                        "value":"360483",
                        "key":"360483",
                        "parent_area_key":"360400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1394,
                "label":"新余市",
                "value":"360500",
                "key":"360500",
                "parent_area_key":"360000",
                "children":[
                    {
                        "id":1395,
                        "label":"市辖区",
                        "value":"360501",
                        "key":"360501",
                        "parent_area_key":"360500",
                        "children":[

                        ]
                    },
                    {
                        "id":1396,
                        "label":"渝水区",
                        "value":"360502",
                        "key":"360502",
                        "parent_area_key":"360500",
                        "children":[

                        ]
                    },
                    {
                        "id":1397,
                        "label":"分宜县",
                        "value":"360521",
                        "key":"360521",
                        "parent_area_key":"360500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1398,
                "label":"鹰潭市",
                "value":"360600",
                "key":"360600",
                "parent_area_key":"360000",
                "children":[
                    {
                        "id":1399,
                        "label":"市辖区",
                        "value":"360601",
                        "key":"360601",
                        "parent_area_key":"360600",
                        "children":[

                        ]
                    },
                    {
                        "id":1400,
                        "label":"月湖区",
                        "value":"360602",
                        "key":"360602",
                        "parent_area_key":"360600",
                        "children":[

                        ]
                    },
                    {
                        "id":1401,
                        "label":"余江县",
                        "value":"360622",
                        "key":"360622",
                        "parent_area_key":"360600",
                        "children":[

                        ]
                    },
                    {
                        "id":1402,
                        "label":"贵溪市",
                        "value":"360681",
                        "key":"360681",
                        "parent_area_key":"360600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1403,
                "label":"赣州市",
                "value":"360700",
                "key":"360700",
                "parent_area_key":"360000",
                "children":[
                    {
                        "id":1404,
                        "label":"市辖区",
                        "value":"360701",
                        "key":"360701",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1405,
                        "label":"章贡区",
                        "value":"360702",
                        "key":"360702",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1406,
                        "label":"南康区",
                        "value":"360703",
                        "key":"360703",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1407,
                        "label":"赣县",
                        "value":"360721",
                        "key":"360721",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1408,
                        "label":"信丰县",
                        "value":"360722",
                        "key":"360722",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1409,
                        "label":"大余县",
                        "value":"360723",
                        "key":"360723",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1410,
                        "label":"上犹县",
                        "value":"360724",
                        "key":"360724",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1411,
                        "label":"崇义县",
                        "value":"360725",
                        "key":"360725",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1412,
                        "label":"安远县",
                        "value":"360726",
                        "key":"360726",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1413,
                        "label":"龙南县",
                        "value":"360727",
                        "key":"360727",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1414,
                        "label":"定南县",
                        "value":"360728",
                        "key":"360728",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1415,
                        "label":"全南县",
                        "value":"360729",
                        "key":"360729",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1416,
                        "label":"宁都县",
                        "value":"360730",
                        "key":"360730",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1417,
                        "label":"于都县",
                        "value":"360731",
                        "key":"360731",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1418,
                        "label":"兴国县",
                        "value":"360732",
                        "key":"360732",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1419,
                        "label":"会昌县",
                        "value":"360733",
                        "key":"360733",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1420,
                        "label":"寻乌县",
                        "value":"360734",
                        "key":"360734",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1421,
                        "label":"石城县",
                        "value":"360735",
                        "key":"360735",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":1422,
                        "label":"瑞金市",
                        "value":"360781",
                        "key":"360781",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":3520,
                        "label":"赣州经济技术开发区",
                        "value":"360799",
                        "key":"360799",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    },
                    {
                        "id":3521,
                        "label":"蓉江新区",
                        "value":"360798",
                        "key":"360798",
                        "parent_area_key":"360700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1423,
                "label":"吉安市",
                "value":"360800",
                "key":"360800",
                "parent_area_key":"360000",
                "children":[
                    {
                        "id":1424,
                        "label":"市辖区",
                        "value":"360801",
                        "key":"360801",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    },
                    {
                        "id":1425,
                        "label":"吉州区",
                        "value":"360802",
                        "key":"360802",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    },
                    {
                        "id":1426,
                        "label":"青原区",
                        "value":"360803",
                        "key":"360803",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    },
                    {
                        "id":1427,
                        "label":"吉安县",
                        "value":"360821",
                        "key":"360821",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    },
                    {
                        "id":1428,
                        "label":"吉水县",
                        "value":"360822",
                        "key":"360822",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    },
                    {
                        "id":1429,
                        "label":"峡江县",
                        "value":"360823",
                        "key":"360823",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    },
                    {
                        "id":1430,
                        "label":"新干县",
                        "value":"360824",
                        "key":"360824",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    },
                    {
                        "id":1431,
                        "label":"永丰县",
                        "value":"360825",
                        "key":"360825",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    },
                    {
                        "id":1432,
                        "label":"泰和县",
                        "value":"360826",
                        "key":"360826",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    },
                    {
                        "id":1433,
                        "label":"遂川县",
                        "value":"360827",
                        "key":"360827",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    },
                    {
                        "id":1434,
                        "label":"万安县",
                        "value":"360828",
                        "key":"360828",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    },
                    {
                        "id":1435,
                        "label":"安福县",
                        "value":"360829",
                        "key":"360829",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    },
                    {
                        "id":1436,
                        "label":"永新县",
                        "value":"360830",
                        "key":"360830",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    },
                    {
                        "id":1437,
                        "label":"井冈山市",
                        "value":"360881",
                        "key":"360881",
                        "parent_area_key":"360800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1438,
                "label":"宜春市",
                "value":"360900",
                "key":"360900",
                "parent_area_key":"360000",
                "children":[
                    {
                        "id":1439,
                        "label":"市辖区",
                        "value":"360901",
                        "key":"360901",
                        "parent_area_key":"360900",
                        "children":[

                        ]
                    },
                    {
                        "id":1440,
                        "label":"袁州区",
                        "value":"360902",
                        "key":"360902",
                        "parent_area_key":"360900",
                        "children":[

                        ]
                    },
                    {
                        "id":1441,
                        "label":"奉新县",
                        "value":"360921",
                        "key":"360921",
                        "parent_area_key":"360900",
                        "children":[

                        ]
                    },
                    {
                        "id":1442,
                        "label":"万载县",
                        "value":"360922",
                        "key":"360922",
                        "parent_area_key":"360900",
                        "children":[

                        ]
                    },
                    {
                        "id":1443,
                        "label":"上高县",
                        "value":"360923",
                        "key":"360923",
                        "parent_area_key":"360900",
                        "children":[

                        ]
                    },
                    {
                        "id":1444,
                        "label":"宜丰县",
                        "value":"360924",
                        "key":"360924",
                        "parent_area_key":"360900",
                        "children":[

                        ]
                    },
                    {
                        "id":1445,
                        "label":"靖安县",
                        "value":"360925",
                        "key":"360925",
                        "parent_area_key":"360900",
                        "children":[

                        ]
                    },
                    {
                        "id":1446,
                        "label":"铜鼓县",
                        "value":"360926",
                        "key":"360926",
                        "parent_area_key":"360900",
                        "children":[

                        ]
                    },
                    {
                        "id":1447,
                        "label":"丰城市",
                        "value":"360981",
                        "key":"360981",
                        "parent_area_key":"360900",
                        "children":[

                        ]
                    },
                    {
                        "id":1448,
                        "label":"樟树市",
                        "value":"360982",
                        "key":"360982",
                        "parent_area_key":"360900",
                        "children":[

                        ]
                    },
                    {
                        "id":1449,
                        "label":"高安市",
                        "value":"360983",
                        "key":"360983",
                        "parent_area_key":"360900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1450,
                "label":"抚州市",
                "value":"361000",
                "key":"361000",
                "parent_area_key":"360000",
                "children":[
                    {
                        "id":1451,
                        "label":"市辖区",
                        "value":"361001",
                        "key":"361001",
                        "parent_area_key":"361000",
                        "children":[

                        ]
                    },
                    {
                        "id":1452,
                        "label":"临川区",
                        "value":"361002",
                        "key":"361002",
                        "parent_area_key":"361000",
                        "children":[

                        ]
                    },
                    {
                        "id":1453,
                        "label":"南城县",
                        "value":"361021",
                        "key":"361021",
                        "parent_area_key":"361000",
                        "children":[

                        ]
                    },
                    {
                        "id":1454,
                        "label":"黎川县",
                        "value":"361022",
                        "key":"361022",
                        "parent_area_key":"361000",
                        "children":[

                        ]
                    },
                    {
                        "id":1455,
                        "label":"南丰县",
                        "value":"361023",
                        "key":"361023",
                        "parent_area_key":"361000",
                        "children":[

                        ]
                    },
                    {
                        "id":1456,
                        "label":"崇仁县",
                        "value":"361024",
                        "key":"361024",
                        "parent_area_key":"361000",
                        "children":[

                        ]
                    },
                    {
                        "id":1457,
                        "label":"乐安县",
                        "value":"361025",
                        "key":"361025",
                        "parent_area_key":"361000",
                        "children":[

                        ]
                    },
                    {
                        "id":1458,
                        "label":"宜黄县",
                        "value":"361026",
                        "key":"361026",
                        "parent_area_key":"361000",
                        "children":[

                        ]
                    },
                    {
                        "id":1459,
                        "label":"金溪县",
                        "value":"361027",
                        "key":"361027",
                        "parent_area_key":"361000",
                        "children":[

                        ]
                    },
                    {
                        "id":1460,
                        "label":"资溪县",
                        "value":"361028",
                        "key":"361028",
                        "parent_area_key":"361000",
                        "children":[

                        ]
                    },
                    {
                        "id":1461,
                        "label":"东乡县",
                        "value":"361029",
                        "key":"361029",
                        "parent_area_key":"361000",
                        "children":[

                        ]
                    },
                    {
                        "id":1462,
                        "label":"广昌县",
                        "value":"361030",
                        "key":"361030",
                        "parent_area_key":"361000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1463,
                "label":"上饶市",
                "value":"361100",
                "key":"361100",
                "parent_area_key":"360000",
                "children":[
                    {
                        "id":1464,
                        "label":"市辖区",
                        "value":"361101",
                        "key":"361101",
                        "parent_area_key":"361100",
                        "children":[

                        ]
                    },
                    {
                        "id":1465,
                        "label":"信州区",
                        "value":"361102",
                        "key":"361102",
                        "parent_area_key":"361100",
                        "children":[

                        ]
                    },
                    {
                        "id":1466,
                        "label":"广丰区",
                        "value":"361103",
                        "key":"361103",
                        "parent_area_key":"361100",
                        "children":[

                        ]
                    },
                    {
                        "id":1467,
                        "label":"上饶县",
                        "value":"361121",
                        "key":"361121",
                        "parent_area_key":"361100",
                        "children":[

                        ]
                    },
                    {
                        "id":1468,
                        "label":"玉山县",
                        "value":"361123",
                        "key":"361123",
                        "parent_area_key":"361100",
                        "children":[

                        ]
                    },
                    {
                        "id":1469,
                        "label":"铅山县",
                        "value":"361124",
                        "key":"361124",
                        "parent_area_key":"361100",
                        "children":[

                        ]
                    },
                    {
                        "id":1470,
                        "label":"横峰县",
                        "value":"361125",
                        "key":"361125",
                        "parent_area_key":"361100",
                        "children":[

                        ]
                    },
                    {
                        "id":1471,
                        "label":"弋阳县",
                        "value":"361126",
                        "key":"361126",
                        "parent_area_key":"361100",
                        "children":[

                        ]
                    },
                    {
                        "id":1472,
                        "label":"余干县",
                        "value":"361127",
                        "key":"361127",
                        "parent_area_key":"361100",
                        "children":[

                        ]
                    },
                    {
                        "id":1473,
                        "label":"鄱阳县",
                        "value":"361128",
                        "key":"361128",
                        "parent_area_key":"361100",
                        "children":[

                        ]
                    },
                    {
                        "id":1474,
                        "label":"万年县",
                        "value":"361129",
                        "key":"361129",
                        "parent_area_key":"361100",
                        "children":[

                        ]
                    },
                    {
                        "id":1475,
                        "label":"婺源县",
                        "value":"361130",
                        "key":"361130",
                        "parent_area_key":"361100",
                        "children":[

                        ]
                    },
                    {
                        "id":1476,
                        "label":"德兴市",
                        "value":"361181",
                        "key":"361181",
                        "parent_area_key":"361100",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":1477,
        "label":"山东省",
        "value":"370000",
        "key":"370000",
        "parent_area_key":"",
        "children":[
            {
                "id":1478,
                "label":"济南市",
                "value":"370100",
                "key":"370100",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1479,
                        "label":"市辖区",
                        "value":"370101",
                        "key":"370101",
                        "parent_area_key":"370100",
                        "children":[

                        ]
                    },
                    {
                        "id":1480,
                        "label":"历下区",
                        "value":"370102",
                        "key":"370102",
                        "parent_area_key":"370100",
                        "children":[

                        ]
                    },
                    {
                        "id":1481,
                        "label":"市中区",
                        "value":"370103",
                        "key":"370103",
                        "parent_area_key":"370100",
                        "children":[

                        ]
                    },
                    {
                        "id":1482,
                        "label":"槐荫区",
                        "value":"370104",
                        "key":"370104",
                        "parent_area_key":"370100",
                        "children":[

                        ]
                    },
                    {
                        "id":1483,
                        "label":"天桥区",
                        "value":"370105",
                        "key":"370105",
                        "parent_area_key":"370100",
                        "children":[

                        ]
                    },
                    {
                        "id":1484,
                        "label":"历城区",
                        "value":"370112",
                        "key":"370112",
                        "parent_area_key":"370100",
                        "children":[

                        ]
                    },
                    {
                        "id":1485,
                        "label":"长清区",
                        "value":"370113",
                        "key":"370113",
                        "parent_area_key":"370100",
                        "children":[

                        ]
                    },
                    {
                        "id":1486,
                        "label":"平阴县",
                        "value":"370124",
                        "key":"370124",
                        "parent_area_key":"370100",
                        "children":[

                        ]
                    },
                    {
                        "id":1487,
                        "label":"济阳县",
                        "value":"370125",
                        "key":"370125",
                        "parent_area_key":"370100",
                        "children":[

                        ]
                    },
                    {
                        "id":1488,
                        "label":"商河县",
                        "value":"370126",
                        "key":"370126",
                        "parent_area_key":"370100",
                        "children":[

                        ]
                    },
                    {
                        "id":1489,
                        "label":"章丘市",
                        "value":"370181",
                        "key":"370181",
                        "parent_area_key":"370100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1490,
                "label":"青岛市",
                "value":"370200",
                "key":"370200",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1491,
                        "label":"市辖区",
                        "value":"370201",
                        "key":"370201",
                        "parent_area_key":"370200",
                        "children":[

                        ]
                    },
                    {
                        "id":1492,
                        "label":"市南区",
                        "value":"370202",
                        "key":"370202",
                        "parent_area_key":"370200",
                        "children":[

                        ]
                    },
                    {
                        "id":1493,
                        "label":"市北区",
                        "value":"370203",
                        "key":"370203",
                        "parent_area_key":"370200",
                        "children":[

                        ]
                    },
                    {
                        "id":1494,
                        "label":"黄岛区",
                        "value":"370211",
                        "key":"370211",
                        "parent_area_key":"370200",
                        "children":[

                        ]
                    },
                    {
                        "id":1495,
                        "label":"崂山区",
                        "value":"370212",
                        "key":"370212",
                        "parent_area_key":"370200",
                        "children":[

                        ]
                    },
                    {
                        "id":1496,
                        "label":"李沧区",
                        "value":"370213",
                        "key":"370213",
                        "parent_area_key":"370200",
                        "children":[

                        ]
                    },
                    {
                        "id":1497,
                        "label":"城阳区",
                        "value":"370214",
                        "key":"370214",
                        "parent_area_key":"370200",
                        "children":[

                        ]
                    },
                    {
                        "id":1498,
                        "label":"胶州市",
                        "value":"370281",
                        "key":"370281",
                        "parent_area_key":"370200",
                        "children":[

                        ]
                    },
                    {
                        "id":1499,
                        "label":"即墨市",
                        "value":"370282",
                        "key":"370282",
                        "parent_area_key":"370200",
                        "children":[

                        ]
                    },
                    {
                        "id":1500,
                        "label":"平度市",
                        "value":"370283",
                        "key":"370283",
                        "parent_area_key":"370200",
                        "children":[

                        ]
                    },
                    {
                        "id":1501,
                        "label":"莱西市",
                        "value":"370285",
                        "key":"370285",
                        "parent_area_key":"370200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1502,
                "label":"淄博市",
                "value":"370300",
                "key":"370300",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1503,
                        "label":"市辖区",
                        "value":"370301",
                        "key":"370301",
                        "parent_area_key":"370300",
                        "children":[

                        ]
                    },
                    {
                        "id":1504,
                        "label":"淄川区",
                        "value":"370302",
                        "key":"370302",
                        "parent_area_key":"370300",
                        "children":[

                        ]
                    },
                    {
                        "id":1505,
                        "label":"张店区",
                        "value":"370303",
                        "key":"370303",
                        "parent_area_key":"370300",
                        "children":[

                        ]
                    },
                    {
                        "id":1506,
                        "label":"博山区",
                        "value":"370304",
                        "key":"370304",
                        "parent_area_key":"370300",
                        "children":[

                        ]
                    },
                    {
                        "id":1507,
                        "label":"临淄区",
                        "value":"370305",
                        "key":"370305",
                        "parent_area_key":"370300",
                        "children":[

                        ]
                    },
                    {
                        "id":1508,
                        "label":"周村区",
                        "value":"370306",
                        "key":"370306",
                        "parent_area_key":"370300",
                        "children":[

                        ]
                    },
                    {
                        "id":1509,
                        "label":"桓台县",
                        "value":"370321",
                        "key":"370321",
                        "parent_area_key":"370300",
                        "children":[

                        ]
                    },
                    {
                        "id":1510,
                        "label":"高青县",
                        "value":"370322",
                        "key":"370322",
                        "parent_area_key":"370300",
                        "children":[

                        ]
                    },
                    {
                        "id":1511,
                        "label":"沂源县",
                        "value":"370323",
                        "key":"370323",
                        "parent_area_key":"370300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1512,
                "label":"枣庄市",
                "value":"370400",
                "key":"370400",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1513,
                        "label":"市辖区",
                        "value":"370401",
                        "key":"370401",
                        "parent_area_key":"370400",
                        "children":[

                        ]
                    },
                    {
                        "id":1514,
                        "label":"市中区",
                        "value":"370402",
                        "key":"370402",
                        "parent_area_key":"370400",
                        "children":[

                        ]
                    },
                    {
                        "id":1515,
                        "label":"薛城区",
                        "value":"370403",
                        "key":"370403",
                        "parent_area_key":"370400",
                        "children":[

                        ]
                    },
                    {
                        "id":1516,
                        "label":"峄城区",
                        "value":"370404",
                        "key":"370404",
                        "parent_area_key":"370400",
                        "children":[

                        ]
                    },
                    {
                        "id":1517,
                        "label":"台儿庄区",
                        "value":"370405",
                        "key":"370405",
                        "parent_area_key":"370400",
                        "children":[

                        ]
                    },
                    {
                        "id":1518,
                        "label":"山亭区",
                        "value":"370406",
                        "key":"370406",
                        "parent_area_key":"370400",
                        "children":[

                        ]
                    },
                    {
                        "id":1519,
                        "label":"滕州市",
                        "value":"370481",
                        "key":"370481",
                        "parent_area_key":"370400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1520,
                "label":"东营市",
                "value":"370500",
                "key":"370500",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1521,
                        "label":"市辖区",
                        "value":"370501",
                        "key":"370501",
                        "parent_area_key":"370500",
                        "children":[

                        ]
                    },
                    {
                        "id":1522,
                        "label":"东营区",
                        "value":"370502",
                        "key":"370502",
                        "parent_area_key":"370500",
                        "children":[

                        ]
                    },
                    {
                        "id":1523,
                        "label":"河口区",
                        "value":"370503",
                        "key":"370503",
                        "parent_area_key":"370500",
                        "children":[

                        ]
                    },
                    {
                        "id":1524,
                        "label":"垦利区",
                        "value":"370505",
                        "key":"370505",
                        "parent_area_key":"370500",
                        "children":[

                        ]
                    },
                    {
                        "id":1525,
                        "label":"利津县",
                        "value":"370522",
                        "key":"370522",
                        "parent_area_key":"370500",
                        "children":[

                        ]
                    },
                    {
                        "id":1526,
                        "label":"广饶县",
                        "value":"370523",
                        "key":"370523",
                        "parent_area_key":"370500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1527,
                "label":"烟台市",
                "value":"370600",
                "key":"370600",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1528,
                        "label":"市辖区",
                        "value":"370601",
                        "key":"370601",
                        "parent_area_key":"370600",
                        "children":[

                        ]
                    },
                    {
                        "id":1529,
                        "label":"芝罘区",
                        "value":"370602",
                        "key":"370602",
                        "parent_area_key":"370600",
                        "children":[

                        ]
                    },
                    {
                        "id":1530,
                        "label":"福山区",
                        "value":"370611",
                        "key":"370611",
                        "parent_area_key":"370600",
                        "children":[

                        ]
                    },
                    {
                        "id":1531,
                        "label":"牟平区",
                        "value":"370612",
                        "key":"370612",
                        "parent_area_key":"370600",
                        "children":[

                        ]
                    },
                    {
                        "id":1532,
                        "label":"莱山区",
                        "value":"370613",
                        "key":"370613",
                        "parent_area_key":"370600",
                        "children":[

                        ]
                    },
                    {
                        "id":1533,
                        "label":"长岛县",
                        "value":"370634",
                        "key":"370634",
                        "parent_area_key":"370600",
                        "children":[

                        ]
                    },
                    {
                        "id":1534,
                        "label":"龙口市",
                        "value":"370681",
                        "key":"370681",
                        "parent_area_key":"370600",
                        "children":[

                        ]
                    },
                    {
                        "id":1535,
                        "label":"莱阳市",
                        "value":"370682",
                        "key":"370682",
                        "parent_area_key":"370600",
                        "children":[

                        ]
                    },
                    {
                        "id":1536,
                        "label":"莱州市",
                        "value":"370683",
                        "key":"370683",
                        "parent_area_key":"370600",
                        "children":[

                        ]
                    },
                    {
                        "id":1537,
                        "label":"蓬莱市",
                        "value":"370684",
                        "key":"370684",
                        "parent_area_key":"370600",
                        "children":[

                        ]
                    },
                    {
                        "id":1538,
                        "label":"招远市",
                        "value":"370685",
                        "key":"370685",
                        "parent_area_key":"370600",
                        "children":[

                        ]
                    },
                    {
                        "id":1539,
                        "label":"栖霞市",
                        "value":"370686",
                        "key":"370686",
                        "parent_area_key":"370600",
                        "children":[

                        ]
                    },
                    {
                        "id":1540,
                        "label":"海阳市",
                        "value":"370687",
                        "key":"370687",
                        "parent_area_key":"370600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1541,
                "label":"潍坊市",
                "value":"370700",
                "key":"370700",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1542,
                        "label":"市辖区",
                        "value":"370701",
                        "key":"370701",
                        "parent_area_key":"370700",
                        "children":[

                        ]
                    },
                    {
                        "id":1543,
                        "label":"潍城区",
                        "value":"370702",
                        "key":"370702",
                        "parent_area_key":"370700",
                        "children":[

                        ]
                    },
                    {
                        "id":1544,
                        "label":"寒亭区",
                        "value":"370703",
                        "key":"370703",
                        "parent_area_key":"370700",
                        "children":[

                        ]
                    },
                    {
                        "id":1545,
                        "label":"坊子区",
                        "value":"370704",
                        "key":"370704",
                        "parent_area_key":"370700",
                        "children":[

                        ]
                    },
                    {
                        "id":1546,
                        "label":"奎文区",
                        "value":"370705",
                        "key":"370705",
                        "parent_area_key":"370700",
                        "children":[

                        ]
                    },
                    {
                        "id":1547,
                        "label":"临朐县",
                        "value":"370724",
                        "key":"370724",
                        "parent_area_key":"370700",
                        "children":[

                        ]
                    },
                    {
                        "id":1548,
                        "label":"昌乐县",
                        "value":"370725",
                        "key":"370725",
                        "parent_area_key":"370700",
                        "children":[

                        ]
                    },
                    {
                        "id":1549,
                        "label":"青州市",
                        "value":"370781",
                        "key":"370781",
                        "parent_area_key":"370700",
                        "children":[

                        ]
                    },
                    {
                        "id":1550,
                        "label":"诸城市",
                        "value":"370782",
                        "key":"370782",
                        "parent_area_key":"370700",
                        "children":[

                        ]
                    },
                    {
                        "id":1551,
                        "label":"寿光市",
                        "value":"370783",
                        "key":"370783",
                        "parent_area_key":"370700",
                        "children":[

                        ]
                    },
                    {
                        "id":1552,
                        "label":"安丘市",
                        "value":"370784",
                        "key":"370784",
                        "parent_area_key":"370700",
                        "children":[

                        ]
                    },
                    {
                        "id":1553,
                        "label":"高密市",
                        "value":"370785",
                        "key":"370785",
                        "parent_area_key":"370700",
                        "children":[

                        ]
                    },
                    {
                        "id":1554,
                        "label":"昌邑市",
                        "value":"370786",
                        "key":"370786",
                        "parent_area_key":"370700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1555,
                "label":"济宁市",
                "value":"370800",
                "key":"370800",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1556,
                        "label":"市辖区",
                        "value":"370801",
                        "key":"370801",
                        "parent_area_key":"370800",
                        "children":[

                        ]
                    },
                    {
                        "id":1557,
                        "label":"任城区",
                        "value":"370811",
                        "key":"370811",
                        "parent_area_key":"370800",
                        "children":[

                        ]
                    },
                    {
                        "id":1558,
                        "label":"兖州区",
                        "value":"370812",
                        "key":"370812",
                        "parent_area_key":"370800",
                        "children":[

                        ]
                    },
                    {
                        "id":1559,
                        "label":"微山县",
                        "value":"370826",
                        "key":"370826",
                        "parent_area_key":"370800",
                        "children":[

                        ]
                    },
                    {
                        "id":1560,
                        "label":"鱼台县",
                        "value":"370827",
                        "key":"370827",
                        "parent_area_key":"370800",
                        "children":[

                        ]
                    },
                    {
                        "id":1561,
                        "label":"金乡县",
                        "value":"370828",
                        "key":"370828",
                        "parent_area_key":"370800",
                        "children":[

                        ]
                    },
                    {
                        "id":1562,
                        "label":"嘉祥县",
                        "value":"370829",
                        "key":"370829",
                        "parent_area_key":"370800",
                        "children":[

                        ]
                    },
                    {
                        "id":1563,
                        "label":"汶上县",
                        "value":"370830",
                        "key":"370830",
                        "parent_area_key":"370800",
                        "children":[

                        ]
                    },
                    {
                        "id":1564,
                        "label":"泗水县",
                        "value":"370831",
                        "key":"370831",
                        "parent_area_key":"370800",
                        "children":[

                        ]
                    },
                    {
                        "id":1565,
                        "label":"梁山县",
                        "value":"370832",
                        "key":"370832",
                        "parent_area_key":"370800",
                        "children":[

                        ]
                    },
                    {
                        "id":1566,
                        "label":"曲阜市",
                        "value":"370881",
                        "key":"370881",
                        "parent_area_key":"370800",
                        "children":[

                        ]
                    },
                    {
                        "id":1567,
                        "label":"邹城市",
                        "value":"370883",
                        "key":"370883",
                        "parent_area_key":"370800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1568,
                "label":"泰安市",
                "value":"370900",
                "key":"370900",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1569,
                        "label":"市辖区",
                        "value":"370901",
                        "key":"370901",
                        "parent_area_key":"370900",
                        "children":[

                        ]
                    },
                    {
                        "id":1570,
                        "label":"泰山区",
                        "value":"370902",
                        "key":"370902",
                        "parent_area_key":"370900",
                        "children":[

                        ]
                    },
                    {
                        "id":1571,
                        "label":"岱岳区",
                        "value":"370911",
                        "key":"370911",
                        "parent_area_key":"370900",
                        "children":[

                        ]
                    },
                    {
                        "id":1572,
                        "label":"宁阳县",
                        "value":"370921",
                        "key":"370921",
                        "parent_area_key":"370900",
                        "children":[

                        ]
                    },
                    {
                        "id":1573,
                        "label":"东平县",
                        "value":"370923",
                        "key":"370923",
                        "parent_area_key":"370900",
                        "children":[

                        ]
                    },
                    {
                        "id":1574,
                        "label":"新泰市",
                        "value":"370982",
                        "key":"370982",
                        "parent_area_key":"370900",
                        "children":[

                        ]
                    },
                    {
                        "id":1575,
                        "label":"肥城市",
                        "value":"370983",
                        "key":"370983",
                        "parent_area_key":"370900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1576,
                "label":"威海市",
                "value":"371000",
                "key":"371000",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1577,
                        "label":"市辖区",
                        "value":"371001",
                        "key":"371001",
                        "parent_area_key":"371000",
                        "children":[

                        ]
                    },
                    {
                        "id":1578,
                        "label":"环翠区",
                        "value":"371002",
                        "key":"371002",
                        "parent_area_key":"371000",
                        "children":[

                        ]
                    },
                    {
                        "id":1579,
                        "label":"文登区",
                        "value":"371003",
                        "key":"371003",
                        "parent_area_key":"371000",
                        "children":[

                        ]
                    },
                    {
                        "id":1580,
                        "label":"荣成市",
                        "value":"371082",
                        "key":"371082",
                        "parent_area_key":"371000",
                        "children":[

                        ]
                    },
                    {
                        "id":1581,
                        "label":"乳山市",
                        "value":"371083",
                        "key":"371083",
                        "parent_area_key":"371000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1582,
                "label":"日照市",
                "value":"371100",
                "key":"371100",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1583,
                        "label":"市辖区",
                        "value":"371101",
                        "key":"371101",
                        "parent_area_key":"371100",
                        "children":[

                        ]
                    },
                    {
                        "id":1584,
                        "label":"东港区",
                        "value":"371102",
                        "key":"371102",
                        "parent_area_key":"371100",
                        "children":[

                        ]
                    },
                    {
                        "id":1585,
                        "label":"岚山区",
                        "value":"371103",
                        "key":"371103",
                        "parent_area_key":"371100",
                        "children":[

                        ]
                    },
                    {
                        "id":1586,
                        "label":"五莲县",
                        "value":"371121",
                        "key":"371121",
                        "parent_area_key":"371100",
                        "children":[

                        ]
                    },
                    {
                        "id":1587,
                        "label":"莒县",
                        "value":"371122",
                        "key":"371122",
                        "parent_area_key":"371100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1588,
                "label":"莱芜市",
                "value":"371200",
                "key":"371200",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1589,
                        "label":"市辖区",
                        "value":"371201",
                        "key":"371201",
                        "parent_area_key":"371200",
                        "children":[

                        ]
                    },
                    {
                        "id":1590,
                        "label":"莱城区",
                        "value":"371202",
                        "key":"371202",
                        "parent_area_key":"371200",
                        "children":[

                        ]
                    },
                    {
                        "id":1591,
                        "label":"钢城区",
                        "value":"371203",
                        "key":"371203",
                        "parent_area_key":"371200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1592,
                "label":"临沂市",
                "value":"371300",
                "key":"371300",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1593,
                        "label":"市辖区",
                        "value":"371301",
                        "key":"371301",
                        "parent_area_key":"371300",
                        "children":[

                        ]
                    },
                    {
                        "id":1594,
                        "label":"兰山区",
                        "value":"371302",
                        "key":"371302",
                        "parent_area_key":"371300",
                        "children":[

                        ]
                    },
                    {
                        "id":1595,
                        "label":"罗庄区",
                        "value":"371311",
                        "key":"371311",
                        "parent_area_key":"371300",
                        "children":[

                        ]
                    },
                    {
                        "id":1596,
                        "label":"河东区",
                        "value":"371312",
                        "key":"371312",
                        "parent_area_key":"371300",
                        "children":[

                        ]
                    },
                    {
                        "id":1597,
                        "label":"沂南县",
                        "value":"371321",
                        "key":"371321",
                        "parent_area_key":"371300",
                        "children":[

                        ]
                    },
                    {
                        "id":1598,
                        "label":"郯城县",
                        "value":"371322",
                        "key":"371322",
                        "parent_area_key":"371300",
                        "children":[

                        ]
                    },
                    {
                        "id":1599,
                        "label":"沂水县",
                        "value":"371323",
                        "key":"371323",
                        "parent_area_key":"371300",
                        "children":[

                        ]
                    },
                    {
                        "id":1600,
                        "label":"兰陵县",
                        "value":"371324",
                        "key":"371324",
                        "parent_area_key":"371300",
                        "children":[

                        ]
                    },
                    {
                        "id":1601,
                        "label":"费县",
                        "value":"371325",
                        "key":"371325",
                        "parent_area_key":"371300",
                        "children":[

                        ]
                    },
                    {
                        "id":1602,
                        "label":"平邑县",
                        "value":"371326",
                        "key":"371326",
                        "parent_area_key":"371300",
                        "children":[

                        ]
                    },
                    {
                        "id":1603,
                        "label":"莒南县",
                        "value":"371327",
                        "key":"371327",
                        "parent_area_key":"371300",
                        "children":[

                        ]
                    },
                    {
                        "id":1604,
                        "label":"蒙阴县",
                        "value":"371328",
                        "key":"371328",
                        "parent_area_key":"371300",
                        "children":[

                        ]
                    },
                    {
                        "id":1605,
                        "label":"临沭县",
                        "value":"371329",
                        "key":"371329",
                        "parent_area_key":"371300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1606,
                "label":"德州市",
                "value":"371400",
                "key":"371400",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1607,
                        "label":"市辖区",
                        "value":"371401",
                        "key":"371401",
                        "parent_area_key":"371400",
                        "children":[

                        ]
                    },
                    {
                        "id":1608,
                        "label":"德城区",
                        "value":"371402",
                        "key":"371402",
                        "parent_area_key":"371400",
                        "children":[

                        ]
                    },
                    {
                        "id":1609,
                        "label":"陵城区",
                        "value":"371403",
                        "key":"371403",
                        "parent_area_key":"371400",
                        "children":[

                        ]
                    },
                    {
                        "id":1610,
                        "label":"宁津县",
                        "value":"371422",
                        "key":"371422",
                        "parent_area_key":"371400",
                        "children":[

                        ]
                    },
                    {
                        "id":1611,
                        "label":"庆云县",
                        "value":"371423",
                        "key":"371423",
                        "parent_area_key":"371400",
                        "children":[

                        ]
                    },
                    {
                        "id":1612,
                        "label":"临邑县",
                        "value":"371424",
                        "key":"371424",
                        "parent_area_key":"371400",
                        "children":[

                        ]
                    },
                    {
                        "id":1613,
                        "label":"齐河县",
                        "value":"371425",
                        "key":"371425",
                        "parent_area_key":"371400",
                        "children":[

                        ]
                    },
                    {
                        "id":1614,
                        "label":"平原县",
                        "value":"371426",
                        "key":"371426",
                        "parent_area_key":"371400",
                        "children":[

                        ]
                    },
                    {
                        "id":1615,
                        "label":"夏津县",
                        "value":"371427",
                        "key":"371427",
                        "parent_area_key":"371400",
                        "children":[

                        ]
                    },
                    {
                        "id":1616,
                        "label":"武城县",
                        "value":"371428",
                        "key":"371428",
                        "parent_area_key":"371400",
                        "children":[

                        ]
                    },
                    {
                        "id":1617,
                        "label":"乐陵市",
                        "value":"371481",
                        "key":"371481",
                        "parent_area_key":"371400",
                        "children":[

                        ]
                    },
                    {
                        "id":1618,
                        "label":"禹城市",
                        "value":"371482",
                        "key":"371482",
                        "parent_area_key":"371400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1619,
                "label":"聊城市",
                "value":"371500",
                "key":"371500",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1620,
                        "label":"市辖区",
                        "value":"371501",
                        "key":"371501",
                        "parent_area_key":"371500",
                        "children":[

                        ]
                    },
                    {
                        "id":1621,
                        "label":"东昌府区",
                        "value":"371502",
                        "key":"371502",
                        "parent_area_key":"371500",
                        "children":[

                        ]
                    },
                    {
                        "id":1622,
                        "label":"阳谷县",
                        "value":"371521",
                        "key":"371521",
                        "parent_area_key":"371500",
                        "children":[

                        ]
                    },
                    {
                        "id":1623,
                        "label":"莘县",
                        "value":"371522",
                        "key":"371522",
                        "parent_area_key":"371500",
                        "children":[

                        ]
                    },
                    {
                        "id":1624,
                        "label":"茌平县",
                        "value":"371523",
                        "key":"371523",
                        "parent_area_key":"371500",
                        "children":[

                        ]
                    },
                    {
                        "id":1625,
                        "label":"东阿县",
                        "value":"371524",
                        "key":"371524",
                        "parent_area_key":"371500",
                        "children":[

                        ]
                    },
                    {
                        "id":1626,
                        "label":"冠县",
                        "value":"371525",
                        "key":"371525",
                        "parent_area_key":"371500",
                        "children":[

                        ]
                    },
                    {
                        "id":1627,
                        "label":"高唐县",
                        "value":"371526",
                        "key":"371526",
                        "parent_area_key":"371500",
                        "children":[

                        ]
                    },
                    {
                        "id":1628,
                        "label":"临清市",
                        "value":"371581",
                        "key":"371581",
                        "parent_area_key":"371500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1629,
                "label":"滨州市",
                "value":"371600",
                "key":"371600",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1630,
                        "label":"市辖区",
                        "value":"371601",
                        "key":"371601",
                        "parent_area_key":"371600",
                        "children":[

                        ]
                    },
                    {
                        "id":1631,
                        "label":"滨城区",
                        "value":"371602",
                        "key":"371602",
                        "parent_area_key":"371600",
                        "children":[

                        ]
                    },
                    {
                        "id":1632,
                        "label":"沾化区",
                        "value":"371603",
                        "key":"371603",
                        "parent_area_key":"371600",
                        "children":[

                        ]
                    },
                    {
                        "id":1633,
                        "label":"惠民县",
                        "value":"371621",
                        "key":"371621",
                        "parent_area_key":"371600",
                        "children":[

                        ]
                    },
                    {
                        "id":1634,
                        "label":"阳信县",
                        "value":"371622",
                        "key":"371622",
                        "parent_area_key":"371600",
                        "children":[

                        ]
                    },
                    {
                        "id":1635,
                        "label":"无棣县",
                        "value":"371623",
                        "key":"371623",
                        "parent_area_key":"371600",
                        "children":[

                        ]
                    },
                    {
                        "id":1636,
                        "label":"博兴县",
                        "value":"371625",
                        "key":"371625",
                        "parent_area_key":"371600",
                        "children":[

                        ]
                    },
                    {
                        "id":1637,
                        "label":"邹平县",
                        "value":"371626",
                        "key":"371626",
                        "parent_area_key":"371600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1638,
                "label":"菏泽市",
                "value":"371700",
                "key":"371700",
                "parent_area_key":"370000",
                "children":[
                    {
                        "id":1639,
                        "label":"市辖区",
                        "value":"371701",
                        "key":"371701",
                        "parent_area_key":"371700",
                        "children":[

                        ]
                    },
                    {
                        "id":1640,
                        "label":"牡丹区",
                        "value":"371702",
                        "key":"371702",
                        "parent_area_key":"371700",
                        "children":[

                        ]
                    },
                    {
                        "id":1641,
                        "label":"定陶区",
                        "value":"371703",
                        "key":"371703",
                        "parent_area_key":"371700",
                        "children":[

                        ]
                    },
                    {
                        "id":1642,
                        "label":"曹县",
                        "value":"371721",
                        "key":"371721",
                        "parent_area_key":"371700",
                        "children":[

                        ]
                    },
                    {
                        "id":1643,
                        "label":"单县",
                        "value":"371722",
                        "key":"371722",
                        "parent_area_key":"371700",
                        "children":[

                        ]
                    },
                    {
                        "id":1644,
                        "label":"成武县",
                        "value":"371723",
                        "key":"371723",
                        "parent_area_key":"371700",
                        "children":[

                        ]
                    },
                    {
                        "id":1645,
                        "label":"巨野县",
                        "value":"371724",
                        "key":"371724",
                        "parent_area_key":"371700",
                        "children":[

                        ]
                    },
                    {
                        "id":1646,
                        "label":"郓城县",
                        "value":"371725",
                        "key":"371725",
                        "parent_area_key":"371700",
                        "children":[

                        ]
                    },
                    {
                        "id":1647,
                        "label":"鄄城县",
                        "value":"371726",
                        "key":"371726",
                        "parent_area_key":"371700",
                        "children":[

                        ]
                    },
                    {
                        "id":1648,
                        "label":"东明县",
                        "value":"371728",
                        "key":"371728",
                        "parent_area_key":"371700",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":1649,
        "label":"河南省",
        "value":"410000",
        "key":"410000",
        "parent_area_key":"",
        "children":[
            {
                "id":1650,
                "label":"郑州市",
                "value":"410100",
                "key":"410100",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1651,
                        "label":"市辖区",
                        "value":"410101",
                        "key":"410101",
                        "parent_area_key":"410100",
                        "children":[

                        ]
                    },
                    {
                        "id":1652,
                        "label":"中原区",
                        "value":"410102",
                        "key":"410102",
                        "parent_area_key":"410100",
                        "children":[

                        ]
                    },
                    {
                        "id":1653,
                        "label":"二七区",
                        "value":"410103",
                        "key":"410103",
                        "parent_area_key":"410100",
                        "children":[

                        ]
                    },
                    {
                        "id":1654,
                        "label":"管城回族区",
                        "value":"410104",
                        "key":"410104",
                        "parent_area_key":"410100",
                        "children":[

                        ]
                    },
                    {
                        "id":1655,
                        "label":"金水区",
                        "value":"410105",
                        "key":"410105",
                        "parent_area_key":"410100",
                        "children":[

                        ]
                    },
                    {
                        "id":1656,
                        "label":"上街区",
                        "value":"410106",
                        "key":"410106",
                        "parent_area_key":"410100",
                        "children":[

                        ]
                    },
                    {
                        "id":1657,
                        "label":"惠济区",
                        "value":"410108",
                        "key":"410108",
                        "parent_area_key":"410100",
                        "children":[

                        ]
                    },
                    {
                        "id":1658,
                        "label":"中牟县",
                        "value":"410122",
                        "key":"410122",
                        "parent_area_key":"410100",
                        "children":[

                        ]
                    },
                    {
                        "id":1659,
                        "label":"巩义市",
                        "value":"410181",
                        "key":"410181",
                        "parent_area_key":"410100",
                        "children":[

                        ]
                    },
                    {
                        "id":1660,
                        "label":"荥阳市",
                        "value":"410182",
                        "key":"410182",
                        "parent_area_key":"410100",
                        "children":[

                        ]
                    },
                    {
                        "id":1661,
                        "label":"新密市",
                        "value":"410183",
                        "key":"410183",
                        "parent_area_key":"410100",
                        "children":[

                        ]
                    },
                    {
                        "id":1662,
                        "label":"新郑市",
                        "value":"410184",
                        "key":"410184",
                        "parent_area_key":"410100",
                        "children":[

                        ]
                    },
                    {
                        "id":1663,
                        "label":"登封市",
                        "value":"410185",
                        "key":"410185",
                        "parent_area_key":"410100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1664,
                "label":"开封市",
                "value":"410200",
                "key":"410200",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1665,
                        "label":"市辖区",
                        "value":"410201",
                        "key":"410201",
                        "parent_area_key":"410200",
                        "children":[

                        ]
                    },
                    {
                        "id":1666,
                        "label":"龙亭区",
                        "value":"410202",
                        "key":"410202",
                        "parent_area_key":"410200",
                        "children":[

                        ]
                    },
                    {
                        "id":1667,
                        "label":"顺河回族区",
                        "value":"410203",
                        "key":"410203",
                        "parent_area_key":"410200",
                        "children":[

                        ]
                    },
                    {
                        "id":1668,
                        "label":"鼓楼区",
                        "value":"410204",
                        "key":"410204",
                        "parent_area_key":"410200",
                        "children":[

                        ]
                    },
                    {
                        "id":1669,
                        "label":"禹王台区",
                        "value":"410205",
                        "key":"410205",
                        "parent_area_key":"410200",
                        "children":[

                        ]
                    },
                    {
                        "id":1670,
                        "label":"金明区",
                        "value":"410211",
                        "key":"410211",
                        "parent_area_key":"410200",
                        "children":[

                        ]
                    },
                    {
                        "id":1671,
                        "label":"祥符区",
                        "value":"410212",
                        "key":"410212",
                        "parent_area_key":"410200",
                        "children":[

                        ]
                    },
                    {
                        "id":1672,
                        "label":"杞县",
                        "value":"410221",
                        "key":"410221",
                        "parent_area_key":"410200",
                        "children":[

                        ]
                    },
                    {
                        "id":1673,
                        "label":"通许县",
                        "value":"410222",
                        "key":"410222",
                        "parent_area_key":"410200",
                        "children":[

                        ]
                    },
                    {
                        "id":1674,
                        "label":"尉氏县",
                        "value":"410223",
                        "key":"410223",
                        "parent_area_key":"410200",
                        "children":[

                        ]
                    },
                    {
                        "id":1675,
                        "label":"兰考县",
                        "value":"410225",
                        "key":"410225",
                        "parent_area_key":"410200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1676,
                "label":"洛阳市",
                "value":"410300",
                "key":"410300",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1677,
                        "label":"市辖区",
                        "value":"410301",
                        "key":"410301",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1678,
                        "label":"老城区",
                        "value":"410302",
                        "key":"410302",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1679,
                        "label":"西工区",
                        "value":"410303",
                        "key":"410303",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1680,
                        "label":"瀍河回族区",
                        "value":"410304",
                        "key":"410304",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1681,
                        "label":"涧西区",
                        "value":"410305",
                        "key":"410305",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1682,
                        "label":"吉利区",
                        "value":"410306",
                        "key":"410306",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1683,
                        "label":"洛龙区",
                        "value":"410311",
                        "key":"410311",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1684,
                        "label":"孟津县",
                        "value":"410322",
                        "key":"410322",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1685,
                        "label":"新安县",
                        "value":"410323",
                        "key":"410323",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1686,
                        "label":"栾川县",
                        "value":"410324",
                        "key":"410324",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1687,
                        "label":"嵩县",
                        "value":"410325",
                        "key":"410325",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1688,
                        "label":"汝阳县",
                        "value":"410326",
                        "key":"410326",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1689,
                        "label":"宜阳县",
                        "value":"410327",
                        "key":"410327",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1690,
                        "label":"洛宁县",
                        "value":"410328",
                        "key":"410328",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1691,
                        "label":"伊川县",
                        "value":"410329",
                        "key":"410329",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    },
                    {
                        "id":1692,
                        "label":"偃师市",
                        "value":"410381",
                        "key":"410381",
                        "parent_area_key":"410300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1693,
                "label":"平顶山市",
                "value":"410400",
                "key":"410400",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1694,
                        "label":"市辖区",
                        "value":"410401",
                        "key":"410401",
                        "parent_area_key":"410400",
                        "children":[

                        ]
                    },
                    {
                        "id":1695,
                        "label":"新华区",
                        "value":"410402",
                        "key":"410402",
                        "parent_area_key":"410400",
                        "children":[

                        ]
                    },
                    {
                        "id":1696,
                        "label":"卫东区",
                        "value":"410403",
                        "key":"410403",
                        "parent_area_key":"410400",
                        "children":[

                        ]
                    },
                    {
                        "id":1697,
                        "label":"石龙区",
                        "value":"410404",
                        "key":"410404",
                        "parent_area_key":"410400",
                        "children":[

                        ]
                    },
                    {
                        "id":1698,
                        "label":"湛河区",
                        "value":"410411",
                        "key":"410411",
                        "parent_area_key":"410400",
                        "children":[

                        ]
                    },
                    {
                        "id":1699,
                        "label":"宝丰县",
                        "value":"410421",
                        "key":"410421",
                        "parent_area_key":"410400",
                        "children":[

                        ]
                    },
                    {
                        "id":1700,
                        "label":"叶县",
                        "value":"410422",
                        "key":"410422",
                        "parent_area_key":"410400",
                        "children":[

                        ]
                    },
                    {
                        "id":1701,
                        "label":"鲁山县",
                        "value":"410423",
                        "key":"410423",
                        "parent_area_key":"410400",
                        "children":[

                        ]
                    },
                    {
                        "id":1702,
                        "label":"郏县",
                        "value":"410425",
                        "key":"410425",
                        "parent_area_key":"410400",
                        "children":[

                        ]
                    },
                    {
                        "id":1703,
                        "label":"舞钢市",
                        "value":"410481",
                        "key":"410481",
                        "parent_area_key":"410400",
                        "children":[

                        ]
                    },
                    {
                        "id":1704,
                        "label":"汝州市",
                        "value":"410482",
                        "key":"410482",
                        "parent_area_key":"410400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1705,
                "label":"安阳市",
                "value":"410500",
                "key":"410500",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1706,
                        "label":"市辖区",
                        "value":"410501",
                        "key":"410501",
                        "parent_area_key":"410500",
                        "children":[

                        ]
                    },
                    {
                        "id":1707,
                        "label":"文峰区",
                        "value":"410502",
                        "key":"410502",
                        "parent_area_key":"410500",
                        "children":[

                        ]
                    },
                    {
                        "id":1708,
                        "label":"北关区",
                        "value":"410503",
                        "key":"410503",
                        "parent_area_key":"410500",
                        "children":[

                        ]
                    },
                    {
                        "id":1709,
                        "label":"殷都区",
                        "value":"410505",
                        "key":"410505",
                        "parent_area_key":"410500",
                        "children":[

                        ]
                    },
                    {
                        "id":1710,
                        "label":"龙安区",
                        "value":"410506",
                        "key":"410506",
                        "parent_area_key":"410500",
                        "children":[

                        ]
                    },
                    {
                        "id":1711,
                        "label":"安阳县",
                        "value":"410522",
                        "key":"410522",
                        "parent_area_key":"410500",
                        "children":[

                        ]
                    },
                    {
                        "id":1712,
                        "label":"汤阴县",
                        "value":"410523",
                        "key":"410523",
                        "parent_area_key":"410500",
                        "children":[

                        ]
                    },
                    {
                        "id":1713,
                        "label":"滑县",
                        "value":"410526",
                        "key":"410526",
                        "parent_area_key":"410500",
                        "children":[

                        ]
                    },
                    {
                        "id":1714,
                        "label":"内黄县",
                        "value":"410527",
                        "key":"410527",
                        "parent_area_key":"410500",
                        "children":[

                        ]
                    },
                    {
                        "id":1715,
                        "label":"林州市",
                        "value":"410581",
                        "key":"410581",
                        "parent_area_key":"410500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1716,
                "label":"鹤壁市",
                "value":"410600",
                "key":"410600",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1717,
                        "label":"市辖区",
                        "value":"410601",
                        "key":"410601",
                        "parent_area_key":"410600",
                        "children":[

                        ]
                    },
                    {
                        "id":1718,
                        "label":"鹤山区",
                        "value":"410602",
                        "key":"410602",
                        "parent_area_key":"410600",
                        "children":[

                        ]
                    },
                    {
                        "id":1719,
                        "label":"山城区",
                        "value":"410603",
                        "key":"410603",
                        "parent_area_key":"410600",
                        "children":[

                        ]
                    },
                    {
                        "id":1720,
                        "label":"淇滨区",
                        "value":"410611",
                        "key":"410611",
                        "parent_area_key":"410600",
                        "children":[

                        ]
                    },
                    {
                        "id":1721,
                        "label":"浚县",
                        "value":"410621",
                        "key":"410621",
                        "parent_area_key":"410600",
                        "children":[

                        ]
                    },
                    {
                        "id":1722,
                        "label":"淇县",
                        "value":"410622",
                        "key":"410622",
                        "parent_area_key":"410600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1723,
                "label":"新乡市",
                "value":"410700",
                "key":"410700",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1724,
                        "label":"市辖区",
                        "value":"410701",
                        "key":"410701",
                        "parent_area_key":"410700",
                        "children":[

                        ]
                    },
                    {
                        "id":1725,
                        "label":"红旗区",
                        "value":"410702",
                        "key":"410702",
                        "parent_area_key":"410700",
                        "children":[

                        ]
                    },
                    {
                        "id":1726,
                        "label":"卫滨区",
                        "value":"410703",
                        "key":"410703",
                        "parent_area_key":"410700",
                        "children":[

                        ]
                    },
                    {
                        "id":1727,
                        "label":"凤泉区",
                        "value":"410704",
                        "key":"410704",
                        "parent_area_key":"410700",
                        "children":[

                        ]
                    },
                    {
                        "id":1728,
                        "label":"牧野区",
                        "value":"410711",
                        "key":"410711",
                        "parent_area_key":"410700",
                        "children":[

                        ]
                    },
                    {
                        "id":1729,
                        "label":"新乡县",
                        "value":"410721",
                        "key":"410721",
                        "parent_area_key":"410700",
                        "children":[

                        ]
                    },
                    {
                        "id":1730,
                        "label":"获嘉县",
                        "value":"410724",
                        "key":"410724",
                        "parent_area_key":"410700",
                        "children":[

                        ]
                    },
                    {
                        "id":1731,
                        "label":"原阳县",
                        "value":"410725",
                        "key":"410725",
                        "parent_area_key":"410700",
                        "children":[

                        ]
                    },
                    {
                        "id":1732,
                        "label":"延津县",
                        "value":"410726",
                        "key":"410726",
                        "parent_area_key":"410700",
                        "children":[

                        ]
                    },
                    {
                        "id":1733,
                        "label":"封丘县",
                        "value":"410727",
                        "key":"410727",
                        "parent_area_key":"410700",
                        "children":[

                        ]
                    },
                    {
                        "id":1734,
                        "label":"长垣县",
                        "value":"410728",
                        "key":"410728",
                        "parent_area_key":"410700",
                        "children":[

                        ]
                    },
                    {
                        "id":1735,
                        "label":"卫辉市",
                        "value":"410781",
                        "key":"410781",
                        "parent_area_key":"410700",
                        "children":[

                        ]
                    },
                    {
                        "id":1736,
                        "label":"辉县市",
                        "value":"410782",
                        "key":"410782",
                        "parent_area_key":"410700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1737,
                "label":"焦作市",
                "value":"410800",
                "key":"410800",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1738,
                        "label":"市辖区",
                        "value":"410801",
                        "key":"410801",
                        "parent_area_key":"410800",
                        "children":[

                        ]
                    },
                    {
                        "id":1739,
                        "label":"解放区",
                        "value":"410802",
                        "key":"410802",
                        "parent_area_key":"410800",
                        "children":[

                        ]
                    },
                    {
                        "id":1740,
                        "label":"中站区",
                        "value":"410803",
                        "key":"410803",
                        "parent_area_key":"410800",
                        "children":[

                        ]
                    },
                    {
                        "id":1741,
                        "label":"马村区",
                        "value":"410804",
                        "key":"410804",
                        "parent_area_key":"410800",
                        "children":[

                        ]
                    },
                    {
                        "id":1742,
                        "label":"山阳区",
                        "value":"410811",
                        "key":"410811",
                        "parent_area_key":"410800",
                        "children":[

                        ]
                    },
                    {
                        "id":1743,
                        "label":"修武县",
                        "value":"410821",
                        "key":"410821",
                        "parent_area_key":"410800",
                        "children":[

                        ]
                    },
                    {
                        "id":1744,
                        "label":"博爱县",
                        "value":"410822",
                        "key":"410822",
                        "parent_area_key":"410800",
                        "children":[

                        ]
                    },
                    {
                        "id":1745,
                        "label":"武陟县",
                        "value":"410823",
                        "key":"410823",
                        "parent_area_key":"410800",
                        "children":[

                        ]
                    },
                    {
                        "id":1746,
                        "label":"温县",
                        "value":"410825",
                        "key":"410825",
                        "parent_area_key":"410800",
                        "children":[

                        ]
                    },
                    {
                        "id":1747,
                        "label":"沁阳市",
                        "value":"410882",
                        "key":"410882",
                        "parent_area_key":"410800",
                        "children":[

                        ]
                    },
                    {
                        "id":1748,
                        "label":"孟州市",
                        "value":"410883",
                        "key":"410883",
                        "parent_area_key":"410800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1749,
                "label":"濮阳市",
                "value":"410900",
                "key":"410900",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1750,
                        "label":"市辖区",
                        "value":"410901",
                        "key":"410901",
                        "parent_area_key":"410900",
                        "children":[

                        ]
                    },
                    {
                        "id":1751,
                        "label":"华龙区",
                        "value":"410902",
                        "key":"410902",
                        "parent_area_key":"410900",
                        "children":[

                        ]
                    },
                    {
                        "id":1752,
                        "label":"清丰县",
                        "value":"410922",
                        "key":"410922",
                        "parent_area_key":"410900",
                        "children":[

                        ]
                    },
                    {
                        "id":1753,
                        "label":"南乐县",
                        "value":"410923",
                        "key":"410923",
                        "parent_area_key":"410900",
                        "children":[

                        ]
                    },
                    {
                        "id":1754,
                        "label":"范县",
                        "value":"410926",
                        "key":"410926",
                        "parent_area_key":"410900",
                        "children":[

                        ]
                    },
                    {
                        "id":1755,
                        "label":"台前县",
                        "value":"410927",
                        "key":"410927",
                        "parent_area_key":"410900",
                        "children":[

                        ]
                    },
                    {
                        "id":1756,
                        "label":"濮阳县",
                        "value":"410928",
                        "key":"410928",
                        "parent_area_key":"410900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1757,
                "label":"许昌市",
                "value":"411000",
                "key":"411000",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1758,
                        "label":"市辖区",
                        "value":"411001",
                        "key":"411001",
                        "parent_area_key":"411000",
                        "children":[

                        ]
                    },
                    {
                        "id":1759,
                        "label":"魏都区",
                        "value":"411002",
                        "key":"411002",
                        "parent_area_key":"411000",
                        "children":[

                        ]
                    },
                    {
                        "id":1760,
                        "label":"许昌县",
                        "value":"411023",
                        "key":"411023",
                        "parent_area_key":"411000",
                        "children":[

                        ]
                    },
                    {
                        "id":1761,
                        "label":"鄢陵县",
                        "value":"411024",
                        "key":"411024",
                        "parent_area_key":"411000",
                        "children":[

                        ]
                    },
                    {
                        "id":1762,
                        "label":"襄城县",
                        "value":"411025",
                        "key":"411025",
                        "parent_area_key":"411000",
                        "children":[

                        ]
                    },
                    {
                        "id":1763,
                        "label":"禹州市",
                        "value":"411081",
                        "key":"411081",
                        "parent_area_key":"411000",
                        "children":[

                        ]
                    },
                    {
                        "id":1764,
                        "label":"长葛市",
                        "value":"411082",
                        "key":"411082",
                        "parent_area_key":"411000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1765,
                "label":"漯河市",
                "value":"411100",
                "key":"411100",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1766,
                        "label":"市辖区",
                        "value":"411101",
                        "key":"411101",
                        "parent_area_key":"411100",
                        "children":[

                        ]
                    },
                    {
                        "id":1767,
                        "label":"源汇区",
                        "value":"411102",
                        "key":"411102",
                        "parent_area_key":"411100",
                        "children":[

                        ]
                    },
                    {
                        "id":1768,
                        "label":"郾城区",
                        "value":"411103",
                        "key":"411103",
                        "parent_area_key":"411100",
                        "children":[

                        ]
                    },
                    {
                        "id":1769,
                        "label":"召陵区",
                        "value":"411104",
                        "key":"411104",
                        "parent_area_key":"411100",
                        "children":[

                        ]
                    },
                    {
                        "id":1770,
                        "label":"舞阳县",
                        "value":"411121",
                        "key":"411121",
                        "parent_area_key":"411100",
                        "children":[

                        ]
                    },
                    {
                        "id":1771,
                        "label":"临颍县",
                        "value":"411122",
                        "key":"411122",
                        "parent_area_key":"411100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1772,
                "label":"三门峡市",
                "value":"411200",
                "key":"411200",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1773,
                        "label":"市辖区",
                        "value":"411201",
                        "key":"411201",
                        "parent_area_key":"411200",
                        "children":[

                        ]
                    },
                    {
                        "id":1774,
                        "label":"湖滨区",
                        "value":"411202",
                        "key":"411202",
                        "parent_area_key":"411200",
                        "children":[

                        ]
                    },
                    {
                        "id":1775,
                        "label":"陕州区",
                        "value":"411203",
                        "key":"411203",
                        "parent_area_key":"411200",
                        "children":[

                        ]
                    },
                    {
                        "id":1776,
                        "label":"渑池县",
                        "value":"411221",
                        "key":"411221",
                        "parent_area_key":"411200",
                        "children":[

                        ]
                    },
                    {
                        "id":1777,
                        "label":"卢氏县",
                        "value":"411224",
                        "key":"411224",
                        "parent_area_key":"411200",
                        "children":[

                        ]
                    },
                    {
                        "id":1778,
                        "label":"义马市",
                        "value":"411281",
                        "key":"411281",
                        "parent_area_key":"411200",
                        "children":[

                        ]
                    },
                    {
                        "id":1779,
                        "label":"灵宝市",
                        "value":"411282",
                        "key":"411282",
                        "parent_area_key":"411200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1780,
                "label":"南阳市",
                "value":"411300",
                "key":"411300",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1781,
                        "label":"市辖区",
                        "value":"411301",
                        "key":"411301",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    },
                    {
                        "id":1782,
                        "label":"宛城区",
                        "value":"411302",
                        "key":"411302",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    },
                    {
                        "id":1783,
                        "label":"卧龙区",
                        "value":"411303",
                        "key":"411303",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    },
                    {
                        "id":1784,
                        "label":"南召县",
                        "value":"411321",
                        "key":"411321",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    },
                    {
                        "id":1785,
                        "label":"方城县",
                        "value":"411322",
                        "key":"411322",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    },
                    {
                        "id":1786,
                        "label":"西峡县",
                        "value":"411323",
                        "key":"411323",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    },
                    {
                        "id":1787,
                        "label":"镇平县",
                        "value":"411324",
                        "key":"411324",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    },
                    {
                        "id":1788,
                        "label":"内乡县",
                        "value":"411325",
                        "key":"411325",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    },
                    {
                        "id":1789,
                        "label":"淅川县",
                        "value":"411326",
                        "key":"411326",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    },
                    {
                        "id":1790,
                        "label":"社旗县",
                        "value":"411327",
                        "key":"411327",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    },
                    {
                        "id":1791,
                        "label":"唐河县",
                        "value":"411328",
                        "key":"411328",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    },
                    {
                        "id":1792,
                        "label":"新野县",
                        "value":"411329",
                        "key":"411329",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    },
                    {
                        "id":1793,
                        "label":"桐柏县",
                        "value":"411330",
                        "key":"411330",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    },
                    {
                        "id":1794,
                        "label":"邓州市",
                        "value":"411381",
                        "key":"411381",
                        "parent_area_key":"411300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1795,
                "label":"商丘市",
                "value":"411400",
                "key":"411400",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1796,
                        "label":"市辖区",
                        "value":"411401",
                        "key":"411401",
                        "parent_area_key":"411400",
                        "children":[

                        ]
                    },
                    {
                        "id":1797,
                        "label":"梁园区",
                        "value":"411402",
                        "key":"411402",
                        "parent_area_key":"411400",
                        "children":[

                        ]
                    },
                    {
                        "id":1798,
                        "label":"睢阳区",
                        "value":"411403",
                        "key":"411403",
                        "parent_area_key":"411400",
                        "children":[

                        ]
                    },
                    {
                        "id":1799,
                        "label":"民权县",
                        "value":"411421",
                        "key":"411421",
                        "parent_area_key":"411400",
                        "children":[

                        ]
                    },
                    {
                        "id":1800,
                        "label":"睢县",
                        "value":"411422",
                        "key":"411422",
                        "parent_area_key":"411400",
                        "children":[

                        ]
                    },
                    {
                        "id":1801,
                        "label":"宁陵县",
                        "value":"411423",
                        "key":"411423",
                        "parent_area_key":"411400",
                        "children":[

                        ]
                    },
                    {
                        "id":1802,
                        "label":"柘城县",
                        "value":"411424",
                        "key":"411424",
                        "parent_area_key":"411400",
                        "children":[

                        ]
                    },
                    {
                        "id":1803,
                        "label":"虞城县",
                        "value":"411425",
                        "key":"411425",
                        "parent_area_key":"411400",
                        "children":[

                        ]
                    },
                    {
                        "id":1804,
                        "label":"夏邑县",
                        "value":"411426",
                        "key":"411426",
                        "parent_area_key":"411400",
                        "children":[

                        ]
                    },
                    {
                        "id":1805,
                        "label":"永城市",
                        "value":"411481",
                        "key":"411481",
                        "parent_area_key":"411400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1806,
                "label":"信阳市",
                "value":"411500",
                "key":"411500",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1807,
                        "label":"市辖区",
                        "value":"411501",
                        "key":"411501",
                        "parent_area_key":"411500",
                        "children":[

                        ]
                    },
                    {
                        "id":1808,
                        "label":"浉河区",
                        "value":"411502",
                        "key":"411502",
                        "parent_area_key":"411500",
                        "children":[

                        ]
                    },
                    {
                        "id":1809,
                        "label":"平桥区",
                        "value":"411503",
                        "key":"411503",
                        "parent_area_key":"411500",
                        "children":[

                        ]
                    },
                    {
                        "id":1810,
                        "label":"罗山县",
                        "value":"411521",
                        "key":"411521",
                        "parent_area_key":"411500",
                        "children":[

                        ]
                    },
                    {
                        "id":1811,
                        "label":"光山县",
                        "value":"411522",
                        "key":"411522",
                        "parent_area_key":"411500",
                        "children":[

                        ]
                    },
                    {
                        "id":1812,
                        "label":"新县",
                        "value":"411523",
                        "key":"411523",
                        "parent_area_key":"411500",
                        "children":[

                        ]
                    },
                    {
                        "id":1813,
                        "label":"商城县",
                        "value":"411524",
                        "key":"411524",
                        "parent_area_key":"411500",
                        "children":[

                        ]
                    },
                    {
                        "id":1814,
                        "label":"固始县",
                        "value":"411525",
                        "key":"411525",
                        "parent_area_key":"411500",
                        "children":[

                        ]
                    },
                    {
                        "id":1815,
                        "label":"潢川县",
                        "value":"411526",
                        "key":"411526",
                        "parent_area_key":"411500",
                        "children":[

                        ]
                    },
                    {
                        "id":1816,
                        "label":"淮滨县",
                        "value":"411527",
                        "key":"411527",
                        "parent_area_key":"411500",
                        "children":[

                        ]
                    },
                    {
                        "id":1817,
                        "label":"息县",
                        "value":"411528",
                        "key":"411528",
                        "parent_area_key":"411500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1818,
                "label":"周口市",
                "value":"411600",
                "key":"411600",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1819,
                        "label":"市辖区",
                        "value":"411601",
                        "key":"411601",
                        "parent_area_key":"411600",
                        "children":[

                        ]
                    },
                    {
                        "id":1820,
                        "label":"川汇区",
                        "value":"411602",
                        "key":"411602",
                        "parent_area_key":"411600",
                        "children":[

                        ]
                    },
                    {
                        "id":1821,
                        "label":"扶沟县",
                        "value":"411621",
                        "key":"411621",
                        "parent_area_key":"411600",
                        "children":[

                        ]
                    },
                    {
                        "id":1822,
                        "label":"西华县",
                        "value":"411622",
                        "key":"411622",
                        "parent_area_key":"411600",
                        "children":[

                        ]
                    },
                    {
                        "id":1823,
                        "label":"商水县",
                        "value":"411623",
                        "key":"411623",
                        "parent_area_key":"411600",
                        "children":[

                        ]
                    },
                    {
                        "id":1824,
                        "label":"沈丘县",
                        "value":"411624",
                        "key":"411624",
                        "parent_area_key":"411600",
                        "children":[

                        ]
                    },
                    {
                        "id":1825,
                        "label":"郸城县",
                        "value":"411625",
                        "key":"411625",
                        "parent_area_key":"411600",
                        "children":[

                        ]
                    },
                    {
                        "id":1826,
                        "label":"淮阳县",
                        "value":"411626",
                        "key":"411626",
                        "parent_area_key":"411600",
                        "children":[

                        ]
                    },
                    {
                        "id":1827,
                        "label":"太康县",
                        "value":"411627",
                        "key":"411627",
                        "parent_area_key":"411600",
                        "children":[

                        ]
                    },
                    {
                        "id":1828,
                        "label":"鹿邑县",
                        "value":"411628",
                        "key":"411628",
                        "parent_area_key":"411600",
                        "children":[

                        ]
                    },
                    {
                        "id":1829,
                        "label":"项城市",
                        "value":"411681",
                        "key":"411681",
                        "parent_area_key":"411600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1830,
                "label":"驻马店市",
                "value":"411700",
                "key":"411700",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1831,
                        "label":"市辖区",
                        "value":"411701",
                        "key":"411701",
                        "parent_area_key":"411700",
                        "children":[

                        ]
                    },
                    {
                        "id":1832,
                        "label":"驿城区",
                        "value":"411702",
                        "key":"411702",
                        "parent_area_key":"411700",
                        "children":[

                        ]
                    },
                    {
                        "id":1833,
                        "label":"西平县",
                        "value":"411721",
                        "key":"411721",
                        "parent_area_key":"411700",
                        "children":[

                        ]
                    },
                    {
                        "id":1834,
                        "label":"上蔡县",
                        "value":"411722",
                        "key":"411722",
                        "parent_area_key":"411700",
                        "children":[

                        ]
                    },
                    {
                        "id":1835,
                        "label":"平舆县",
                        "value":"411723",
                        "key":"411723",
                        "parent_area_key":"411700",
                        "children":[

                        ]
                    },
                    {
                        "id":1836,
                        "label":"正阳县",
                        "value":"411724",
                        "key":"411724",
                        "parent_area_key":"411700",
                        "children":[

                        ]
                    },
                    {
                        "id":1837,
                        "label":"确山县",
                        "value":"411725",
                        "key":"411725",
                        "parent_area_key":"411700",
                        "children":[

                        ]
                    },
                    {
                        "id":1838,
                        "label":"泌阳县",
                        "value":"411726",
                        "key":"411726",
                        "parent_area_key":"411700",
                        "children":[

                        ]
                    },
                    {
                        "id":1839,
                        "label":"汝南县",
                        "value":"411727",
                        "key":"411727",
                        "parent_area_key":"411700",
                        "children":[

                        ]
                    },
                    {
                        "id":1840,
                        "label":"遂平县",
                        "value":"411728",
                        "key":"411728",
                        "parent_area_key":"411700",
                        "children":[

                        ]
                    },
                    {
                        "id":1841,
                        "label":"新蔡县",
                        "value":"411729",
                        "key":"411729",
                        "parent_area_key":"411700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1842,
                "label":"省直辖县级行政区划",
                "value":"419000",
                "key":"419000",
                "parent_area_key":"410000",
                "children":[
                    {
                        "id":1843,
                        "label":"济源市",
                        "value":"419001",
                        "key":"419001",
                        "parent_area_key":"419000",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":1844,
        "label":"湖北省",
        "value":"420000",
        "key":"420000",
        "parent_area_key":"",
        "children":[
            {
                "id":1845,
                "label":"武汉市",
                "value":"420100",
                "key":"420100",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1846,
                        "label":"市辖区",
                        "value":"420101",
                        "key":"420101",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    },
                    {
                        "id":1847,
                        "label":"江岸区",
                        "value":"420102",
                        "key":"420102",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    },
                    {
                        "id":1848,
                        "label":"江汉区",
                        "value":"420103",
                        "key":"420103",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    },
                    {
                        "id":1849,
                        "label":"硚口区",
                        "value":"420104",
                        "key":"420104",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    },
                    {
                        "id":1850,
                        "label":"汉阳区",
                        "value":"420105",
                        "key":"420105",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    },
                    {
                        "id":1851,
                        "label":"武昌区",
                        "value":"420106",
                        "key":"420106",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    },
                    {
                        "id":1852,
                        "label":"青山区",
                        "value":"420107",
                        "key":"420107",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    },
                    {
                        "id":1853,
                        "label":"洪山区",
                        "value":"420111",
                        "key":"420111",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    },
                    {
                        "id":1854,
                        "label":"东西湖区",
                        "value":"420112",
                        "key":"420112",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    },
                    {
                        "id":1855,
                        "label":"汉南区",
                        "value":"420113",
                        "key":"420113",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    },
                    {
                        "id":1856,
                        "label":"蔡甸区",
                        "value":"420114",
                        "key":"420114",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    },
                    {
                        "id":1857,
                        "label":"江夏区",
                        "value":"420115",
                        "key":"420115",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    },
                    {
                        "id":1858,
                        "label":"黄陂区",
                        "value":"420116",
                        "key":"420116",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    },
                    {
                        "id":1859,
                        "label":"新洲区",
                        "value":"420117",
                        "key":"420117",
                        "parent_area_key":"420100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1860,
                "label":"黄石市",
                "value":"420200",
                "key":"420200",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1861,
                        "label":"市辖区",
                        "value":"420201",
                        "key":"420201",
                        "parent_area_key":"420200",
                        "children":[

                        ]
                    },
                    {
                        "id":1862,
                        "label":"黄石港区",
                        "value":"420202",
                        "key":"420202",
                        "parent_area_key":"420200",
                        "children":[

                        ]
                    },
                    {
                        "id":1863,
                        "label":"西塞山区",
                        "value":"420203",
                        "key":"420203",
                        "parent_area_key":"420200",
                        "children":[

                        ]
                    },
                    {
                        "id":1864,
                        "label":"下陆区",
                        "value":"420204",
                        "key":"420204",
                        "parent_area_key":"420200",
                        "children":[

                        ]
                    },
                    {
                        "id":1865,
                        "label":"铁山区",
                        "value":"420205",
                        "key":"420205",
                        "parent_area_key":"420200",
                        "children":[

                        ]
                    },
                    {
                        "id":1866,
                        "label":"阳新县",
                        "value":"420222",
                        "key":"420222",
                        "parent_area_key":"420200",
                        "children":[

                        ]
                    },
                    {
                        "id":1867,
                        "label":"大冶市",
                        "value":"420281",
                        "key":"420281",
                        "parent_area_key":"420200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1868,
                "label":"十堰市",
                "value":"420300",
                "key":"420300",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1869,
                        "label":"市辖区",
                        "value":"420301",
                        "key":"420301",
                        "parent_area_key":"420300",
                        "children":[

                        ]
                    },
                    {
                        "id":1870,
                        "label":"茅箭区",
                        "value":"420302",
                        "key":"420302",
                        "parent_area_key":"420300",
                        "children":[

                        ]
                    },
                    {
                        "id":1871,
                        "label":"张湾区",
                        "value":"420303",
                        "key":"420303",
                        "parent_area_key":"420300",
                        "children":[

                        ]
                    },
                    {
                        "id":1872,
                        "label":"郧阳区",
                        "value":"420304",
                        "key":"420304",
                        "parent_area_key":"420300",
                        "children":[

                        ]
                    },
                    {
                        "id":1873,
                        "label":"郧西县",
                        "value":"420322",
                        "key":"420322",
                        "parent_area_key":"420300",
                        "children":[

                        ]
                    },
                    {
                        "id":1874,
                        "label":"竹山县",
                        "value":"420323",
                        "key":"420323",
                        "parent_area_key":"420300",
                        "children":[

                        ]
                    },
                    {
                        "id":1875,
                        "label":"竹溪县",
                        "value":"420324",
                        "key":"420324",
                        "parent_area_key":"420300",
                        "children":[

                        ]
                    },
                    {
                        "id":1876,
                        "label":"房县",
                        "value":"420325",
                        "key":"420325",
                        "parent_area_key":"420300",
                        "children":[

                        ]
                    },
                    {
                        "id":1877,
                        "label":"丹江口市",
                        "value":"420381",
                        "key":"420381",
                        "parent_area_key":"420300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1878,
                "label":"宜昌市",
                "value":"420500",
                "key":"420500",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1879,
                        "label":"市辖区",
                        "value":"420501",
                        "key":"420501",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    },
                    {
                        "id":1880,
                        "label":"西陵区",
                        "value":"420502",
                        "key":"420502",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    },
                    {
                        "id":1881,
                        "label":"伍家岗区",
                        "value":"420503",
                        "key":"420503",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    },
                    {
                        "id":1882,
                        "label":"点军区",
                        "value":"420504",
                        "key":"420504",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    },
                    {
                        "id":1883,
                        "label":"猇亭区",
                        "value":"420505",
                        "key":"420505",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    },
                    {
                        "id":1884,
                        "label":"夷陵区",
                        "value":"420506",
                        "key":"420506",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    },
                    {
                        "id":1885,
                        "label":"远安县",
                        "value":"420525",
                        "key":"420525",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    },
                    {
                        "id":1886,
                        "label":"兴山县",
                        "value":"420526",
                        "key":"420526",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    },
                    {
                        "id":1887,
                        "label":"秭归县",
                        "value":"420527",
                        "key":"420527",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    },
                    {
                        "id":1888,
                        "label":"长阳土家族自治县",
                        "value":"420528",
                        "key":"420528",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    },
                    {
                        "id":1889,
                        "label":"五峰土家族自治县",
                        "value":"420529",
                        "key":"420529",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    },
                    {
                        "id":1890,
                        "label":"宜都市",
                        "value":"420581",
                        "key":"420581",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    },
                    {
                        "id":1891,
                        "label":"当阳市",
                        "value":"420582",
                        "key":"420582",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    },
                    {
                        "id":1892,
                        "label":"枝江市",
                        "value":"420583",
                        "key":"420583",
                        "parent_area_key":"420500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1893,
                "label":"襄阳市",
                "value":"420600",
                "key":"420600",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1894,
                        "label":"市辖区",
                        "value":"420601",
                        "key":"420601",
                        "parent_area_key":"420600",
                        "children":[

                        ]
                    },
                    {
                        "id":1895,
                        "label":"襄城区",
                        "value":"420602",
                        "key":"420602",
                        "parent_area_key":"420600",
                        "children":[

                        ]
                    },
                    {
                        "id":1896,
                        "label":"樊城区",
                        "value":"420606",
                        "key":"420606",
                        "parent_area_key":"420600",
                        "children":[

                        ]
                    },
                    {
                        "id":1897,
                        "label":"襄州区",
                        "value":"420607",
                        "key":"420607",
                        "parent_area_key":"420600",
                        "children":[

                        ]
                    },
                    {
                        "id":1898,
                        "label":"南漳县",
                        "value":"420624",
                        "key":"420624",
                        "parent_area_key":"420600",
                        "children":[

                        ]
                    },
                    {
                        "id":1899,
                        "label":"谷城县",
                        "value":"420625",
                        "key":"420625",
                        "parent_area_key":"420600",
                        "children":[

                        ]
                    },
                    {
                        "id":1900,
                        "label":"保康县",
                        "value":"420626",
                        "key":"420626",
                        "parent_area_key":"420600",
                        "children":[

                        ]
                    },
                    {
                        "id":1901,
                        "label":"老河口市",
                        "value":"420682",
                        "key":"420682",
                        "parent_area_key":"420600",
                        "children":[

                        ]
                    },
                    {
                        "id":1902,
                        "label":"枣阳市",
                        "value":"420683",
                        "key":"420683",
                        "parent_area_key":"420600",
                        "children":[

                        ]
                    },
                    {
                        "id":1903,
                        "label":"宜城市",
                        "value":"420684",
                        "key":"420684",
                        "parent_area_key":"420600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1904,
                "label":"鄂州市",
                "value":"420700",
                "key":"420700",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1905,
                        "label":"市辖区",
                        "value":"420701",
                        "key":"420701",
                        "parent_area_key":"420700",
                        "children":[

                        ]
                    },
                    {
                        "id":1906,
                        "label":"梁子湖区",
                        "value":"420702",
                        "key":"420702",
                        "parent_area_key":"420700",
                        "children":[

                        ]
                    },
                    {
                        "id":1907,
                        "label":"华容区",
                        "value":"420703",
                        "key":"420703",
                        "parent_area_key":"420700",
                        "children":[

                        ]
                    },
                    {
                        "id":1908,
                        "label":"鄂城区",
                        "value":"420704",
                        "key":"420704",
                        "parent_area_key":"420700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1909,
                "label":"荆门市",
                "value":"420800",
                "key":"420800",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1910,
                        "label":"市辖区",
                        "value":"420801",
                        "key":"420801",
                        "parent_area_key":"420800",
                        "children":[

                        ]
                    },
                    {
                        "id":1911,
                        "label":"东宝区",
                        "value":"420802",
                        "key":"420802",
                        "parent_area_key":"420800",
                        "children":[

                        ]
                    },
                    {
                        "id":1912,
                        "label":"掇刀区",
                        "value":"420804",
                        "key":"420804",
                        "parent_area_key":"420800",
                        "children":[

                        ]
                    },
                    {
                        "id":1913,
                        "label":"京山县",
                        "value":"420821",
                        "key":"420821",
                        "parent_area_key":"420800",
                        "children":[

                        ]
                    },
                    {
                        "id":1914,
                        "label":"沙洋县",
                        "value":"420822",
                        "key":"420822",
                        "parent_area_key":"420800",
                        "children":[

                        ]
                    },
                    {
                        "id":1915,
                        "label":"钟祥市",
                        "value":"420881",
                        "key":"420881",
                        "parent_area_key":"420800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1916,
                "label":"孝感市",
                "value":"420900",
                "key":"420900",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1917,
                        "label":"市辖区",
                        "value":"420901",
                        "key":"420901",
                        "parent_area_key":"420900",
                        "children":[

                        ]
                    },
                    {
                        "id":1918,
                        "label":"孝南区",
                        "value":"420902",
                        "key":"420902",
                        "parent_area_key":"420900",
                        "children":[

                        ]
                    },
                    {
                        "id":1919,
                        "label":"孝昌县",
                        "value":"420921",
                        "key":"420921",
                        "parent_area_key":"420900",
                        "children":[

                        ]
                    },
                    {
                        "id":1920,
                        "label":"大悟县",
                        "value":"420922",
                        "key":"420922",
                        "parent_area_key":"420900",
                        "children":[

                        ]
                    },
                    {
                        "id":1921,
                        "label":"云梦县",
                        "value":"420923",
                        "key":"420923",
                        "parent_area_key":"420900",
                        "children":[

                        ]
                    },
                    {
                        "id":1922,
                        "label":"应城市",
                        "value":"420981",
                        "key":"420981",
                        "parent_area_key":"420900",
                        "children":[

                        ]
                    },
                    {
                        "id":1923,
                        "label":"安陆市",
                        "value":"420982",
                        "key":"420982",
                        "parent_area_key":"420900",
                        "children":[

                        ]
                    },
                    {
                        "id":1924,
                        "label":"汉川市",
                        "value":"420984",
                        "key":"420984",
                        "parent_area_key":"420900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1925,
                "label":"荆州市",
                "value":"421000",
                "key":"421000",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1926,
                        "label":"市辖区",
                        "value":"421001",
                        "key":"421001",
                        "parent_area_key":"421000",
                        "children":[

                        ]
                    },
                    {
                        "id":1927,
                        "label":"沙市区",
                        "value":"421002",
                        "key":"421002",
                        "parent_area_key":"421000",
                        "children":[

                        ]
                    },
                    {
                        "id":1928,
                        "label":"荆州区",
                        "value":"421003",
                        "key":"421003",
                        "parent_area_key":"421000",
                        "children":[

                        ]
                    },
                    {
                        "id":1929,
                        "label":"公安县",
                        "value":"421022",
                        "key":"421022",
                        "parent_area_key":"421000",
                        "children":[

                        ]
                    },
                    {
                        "id":1930,
                        "label":"监利县",
                        "value":"421023",
                        "key":"421023",
                        "parent_area_key":"421000",
                        "children":[

                        ]
                    },
                    {
                        "id":1931,
                        "label":"江陵县",
                        "value":"421024",
                        "key":"421024",
                        "parent_area_key":"421000",
                        "children":[

                        ]
                    },
                    {
                        "id":1932,
                        "label":"石首市",
                        "value":"421081",
                        "key":"421081",
                        "parent_area_key":"421000",
                        "children":[

                        ]
                    },
                    {
                        "id":1933,
                        "label":"洪湖市",
                        "value":"421083",
                        "key":"421083",
                        "parent_area_key":"421000",
                        "children":[

                        ]
                    },
                    {
                        "id":1934,
                        "label":"松滋市",
                        "value":"421087",
                        "key":"421087",
                        "parent_area_key":"421000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1935,
                "label":"黄冈市",
                "value":"421100",
                "key":"421100",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1936,
                        "label":"市辖区",
                        "value":"421101",
                        "key":"421101",
                        "parent_area_key":"421100",
                        "children":[

                        ]
                    },
                    {
                        "id":1937,
                        "label":"黄州区",
                        "value":"421102",
                        "key":"421102",
                        "parent_area_key":"421100",
                        "children":[

                        ]
                    },
                    {
                        "id":1938,
                        "label":"团风县",
                        "value":"421121",
                        "key":"421121",
                        "parent_area_key":"421100",
                        "children":[

                        ]
                    },
                    {
                        "id":1939,
                        "label":"红安县",
                        "value":"421122",
                        "key":"421122",
                        "parent_area_key":"421100",
                        "children":[

                        ]
                    },
                    {
                        "id":1940,
                        "label":"罗田县",
                        "value":"421123",
                        "key":"421123",
                        "parent_area_key":"421100",
                        "children":[

                        ]
                    },
                    {
                        "id":1941,
                        "label":"英山县",
                        "value":"421124",
                        "key":"421124",
                        "parent_area_key":"421100",
                        "children":[

                        ]
                    },
                    {
                        "id":1942,
                        "label":"浠水县",
                        "value":"421125",
                        "key":"421125",
                        "parent_area_key":"421100",
                        "children":[

                        ]
                    },
                    {
                        "id":1943,
                        "label":"蕲春县",
                        "value":"421126",
                        "key":"421126",
                        "parent_area_key":"421100",
                        "children":[

                        ]
                    },
                    {
                        "id":1944,
                        "label":"黄梅县",
                        "value":"421127",
                        "key":"421127",
                        "parent_area_key":"421100",
                        "children":[

                        ]
                    },
                    {
                        "id":1945,
                        "label":"麻城市",
                        "value":"421181",
                        "key":"421181",
                        "parent_area_key":"421100",
                        "children":[

                        ]
                    },
                    {
                        "id":1946,
                        "label":"武穴市",
                        "value":"421182",
                        "key":"421182",
                        "parent_area_key":"421100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1947,
                "label":"咸宁市",
                "value":"421200",
                "key":"421200",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1948,
                        "label":"市辖区",
                        "value":"421201",
                        "key":"421201",
                        "parent_area_key":"421200",
                        "children":[

                        ]
                    },
                    {
                        "id":1949,
                        "label":"咸安区",
                        "value":"421202",
                        "key":"421202",
                        "parent_area_key":"421200",
                        "children":[

                        ]
                    },
                    {
                        "id":1950,
                        "label":"嘉鱼县",
                        "value":"421221",
                        "key":"421221",
                        "parent_area_key":"421200",
                        "children":[

                        ]
                    },
                    {
                        "id":1951,
                        "label":"通城县",
                        "value":"421222",
                        "key":"421222",
                        "parent_area_key":"421200",
                        "children":[

                        ]
                    },
                    {
                        "id":1952,
                        "label":"崇阳县",
                        "value":"421223",
                        "key":"421223",
                        "parent_area_key":"421200",
                        "children":[

                        ]
                    },
                    {
                        "id":1953,
                        "label":"通山县",
                        "value":"421224",
                        "key":"421224",
                        "parent_area_key":"421200",
                        "children":[

                        ]
                    },
                    {
                        "id":1954,
                        "label":"赤壁市",
                        "value":"421281",
                        "key":"421281",
                        "parent_area_key":"421200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1955,
                "label":"随州市",
                "value":"421300",
                "key":"421300",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1956,
                        "label":"市辖区",
                        "value":"421301",
                        "key":"421301",
                        "parent_area_key":"421300",
                        "children":[

                        ]
                    },
                    {
                        "id":1957,
                        "label":"曾都区",
                        "value":"421303",
                        "key":"421303",
                        "parent_area_key":"421300",
                        "children":[

                        ]
                    },
                    {
                        "id":1958,
                        "label":"随县",
                        "value":"421321",
                        "key":"421321",
                        "parent_area_key":"421300",
                        "children":[

                        ]
                    },
                    {
                        "id":1959,
                        "label":"广水市",
                        "value":"421381",
                        "key":"421381",
                        "parent_area_key":"421300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1960,
                "label":"恩施土家族苗族自治州",
                "value":"422800",
                "key":"422800",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1961,
                        "label":"恩施市",
                        "value":"422801",
                        "key":"422801",
                        "parent_area_key":"422800",
                        "children":[

                        ]
                    },
                    {
                        "id":1962,
                        "label":"利川市",
                        "value":"422802",
                        "key":"422802",
                        "parent_area_key":"422800",
                        "children":[

                        ]
                    },
                    {
                        "id":1963,
                        "label":"建始县",
                        "value":"422822",
                        "key":"422822",
                        "parent_area_key":"422800",
                        "children":[

                        ]
                    },
                    {
                        "id":1964,
                        "label":"巴东县",
                        "value":"422823",
                        "key":"422823",
                        "parent_area_key":"422800",
                        "children":[

                        ]
                    },
                    {
                        "id":1965,
                        "label":"宣恩县",
                        "value":"422825",
                        "key":"422825",
                        "parent_area_key":"422800",
                        "children":[

                        ]
                    },
                    {
                        "id":1966,
                        "label":"咸丰县",
                        "value":"422826",
                        "key":"422826",
                        "parent_area_key":"422800",
                        "children":[

                        ]
                    },
                    {
                        "id":1967,
                        "label":"来凤县",
                        "value":"422827",
                        "key":"422827",
                        "parent_area_key":"422800",
                        "children":[

                        ]
                    },
                    {
                        "id":1968,
                        "label":"鹤峰县",
                        "value":"422828",
                        "key":"422828",
                        "parent_area_key":"422800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1969,
                "label":"省直辖县级行政区划",
                "value":"429000",
                "key":"429000",
                "parent_area_key":"420000",
                "children":[
                    {
                        "id":1970,
                        "label":"仙桃市",
                        "value":"429004",
                        "key":"429004",
                        "parent_area_key":"429000",
                        "children":[

                        ]
                    },
                    {
                        "id":1971,
                        "label":"潜江市",
                        "value":"429005",
                        "key":"429005",
                        "parent_area_key":"429000",
                        "children":[

                        ]
                    },
                    {
                        "id":1972,
                        "label":"天门市",
                        "value":"429006",
                        "key":"429006",
                        "parent_area_key":"429000",
                        "children":[

                        ]
                    },
                    {
                        "id":1973,
                        "label":"神农架林区",
                        "value":"429021",
                        "key":"429021",
                        "parent_area_key":"429000",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":1974,
        "label":"湖南省",
        "value":"430000",
        "key":"430000",
        "parent_area_key":"",
        "children":[
            {
                "id":1975,
                "label":"长沙市",
                "value":"430100",
                "key":"430100",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":1976,
                        "label":"市辖区",
                        "value":"430101",
                        "key":"430101",
                        "parent_area_key":"430100",
                        "children":[

                        ]
                    },
                    {
                        "id":1977,
                        "label":"芙蓉区",
                        "value":"430102",
                        "key":"430102",
                        "parent_area_key":"430100",
                        "children":[

                        ]
                    },
                    {
                        "id":1978,
                        "label":"天心区",
                        "value":"430103",
                        "key":"430103",
                        "parent_area_key":"430100",
                        "children":[

                        ]
                    },
                    {
                        "id":1979,
                        "label":"岳麓区",
                        "value":"430104",
                        "key":"430104",
                        "parent_area_key":"430100",
                        "children":[

                        ]
                    },
                    {
                        "id":1980,
                        "label":"开福区",
                        "value":"430105",
                        "key":"430105",
                        "parent_area_key":"430100",
                        "children":[

                        ]
                    },
                    {
                        "id":1981,
                        "label":"雨花区",
                        "value":"430111",
                        "key":"430111",
                        "parent_area_key":"430100",
                        "children":[

                        ]
                    },
                    {
                        "id":1982,
                        "label":"望城区",
                        "value":"430112",
                        "key":"430112",
                        "parent_area_key":"430100",
                        "children":[

                        ]
                    },
                    {
                        "id":1983,
                        "label":"长沙县",
                        "value":"430121",
                        "key":"430121",
                        "parent_area_key":"430100",
                        "children":[

                        ]
                    },
                    {
                        "id":1984,
                        "label":"宁乡县",
                        "value":"430124",
                        "key":"430124",
                        "parent_area_key":"430100",
                        "children":[

                        ]
                    },
                    {
                        "id":1985,
                        "label":"浏阳市",
                        "value":"430181",
                        "key":"430181",
                        "parent_area_key":"430100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1986,
                "label":"株洲市",
                "value":"430200",
                "key":"430200",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":1987,
                        "label":"市辖区",
                        "value":"430201",
                        "key":"430201",
                        "parent_area_key":"430200",
                        "children":[

                        ]
                    },
                    {
                        "id":1988,
                        "label":"荷塘区",
                        "value":"430202",
                        "key":"430202",
                        "parent_area_key":"430200",
                        "children":[

                        ]
                    },
                    {
                        "id":1989,
                        "label":"芦淞区",
                        "value":"430203",
                        "key":"430203",
                        "parent_area_key":"430200",
                        "children":[

                        ]
                    },
                    {
                        "id":1990,
                        "label":"石峰区",
                        "value":"430204",
                        "key":"430204",
                        "parent_area_key":"430200",
                        "children":[

                        ]
                    },
                    {
                        "id":1991,
                        "label":"天元区",
                        "value":"430211",
                        "key":"430211",
                        "parent_area_key":"430200",
                        "children":[

                        ]
                    },
                    {
                        "id":1992,
                        "label":"株洲县",
                        "value":"430221",
                        "key":"430221",
                        "parent_area_key":"430200",
                        "children":[

                        ]
                    },
                    {
                        "id":1993,
                        "label":"攸县",
                        "value":"430223",
                        "key":"430223",
                        "parent_area_key":"430200",
                        "children":[

                        ]
                    },
                    {
                        "id":1994,
                        "label":"茶陵县",
                        "value":"430224",
                        "key":"430224",
                        "parent_area_key":"430200",
                        "children":[

                        ]
                    },
                    {
                        "id":1995,
                        "label":"炎陵县",
                        "value":"430225",
                        "key":"430225",
                        "parent_area_key":"430200",
                        "children":[

                        ]
                    },
                    {
                        "id":1996,
                        "label":"醴陵市",
                        "value":"430281",
                        "key":"430281",
                        "parent_area_key":"430200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":1997,
                "label":"湘潭市",
                "value":"430300",
                "key":"430300",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":1998,
                        "label":"市辖区",
                        "value":"430301",
                        "key":"430301",
                        "parent_area_key":"430300",
                        "children":[

                        ]
                    },
                    {
                        "id":1999,
                        "label":"雨湖区",
                        "value":"430302",
                        "key":"430302",
                        "parent_area_key":"430300",
                        "children":[

                        ]
                    },
                    {
                        "id":2000,
                        "label":"岳塘区",
                        "value":"430304",
                        "key":"430304",
                        "parent_area_key":"430300",
                        "children":[

                        ]
                    },
                    {
                        "id":2001,
                        "label":"湘潭县",
                        "value":"430321",
                        "key":"430321",
                        "parent_area_key":"430300",
                        "children":[

                        ]
                    },
                    {
                        "id":2002,
                        "label":"湘乡市",
                        "value":"430381",
                        "key":"430381",
                        "parent_area_key":"430300",
                        "children":[

                        ]
                    },
                    {
                        "id":2003,
                        "label":"韶山市",
                        "value":"430382",
                        "key":"430382",
                        "parent_area_key":"430300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2004,
                "label":"衡阳市",
                "value":"430400",
                "key":"430400",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":2005,
                        "label":"市辖区",
                        "value":"430401",
                        "key":"430401",
                        "parent_area_key":"430400",
                        "children":[

                        ]
                    },
                    {
                        "id":2006,
                        "label":"珠晖区",
                        "value":"430405",
                        "key":"430405",
                        "parent_area_key":"430400",
                        "children":[

                        ]
                    },
                    {
                        "id":2007,
                        "label":"雁峰区",
                        "value":"430406",
                        "key":"430406",
                        "parent_area_key":"430400",
                        "children":[

                        ]
                    },
                    {
                        "id":2008,
                        "label":"石鼓区",
                        "value":"430407",
                        "key":"430407",
                        "parent_area_key":"430400",
                        "children":[

                        ]
                    },
                    {
                        "id":2009,
                        "label":"蒸湘区",
                        "value":"430408",
                        "key":"430408",
                        "parent_area_key":"430400",
                        "children":[

                        ]
                    },
                    {
                        "id":2010,
                        "label":"南岳区",
                        "value":"430412",
                        "key":"430412",
                        "parent_area_key":"430400",
                        "children":[

                        ]
                    },
                    {
                        "id":2011,
                        "label":"衡阳县",
                        "value":"430421",
                        "key":"430421",
                        "parent_area_key":"430400",
                        "children":[

                        ]
                    },
                    {
                        "id":2012,
                        "label":"衡南县",
                        "value":"430422",
                        "key":"430422",
                        "parent_area_key":"430400",
                        "children":[

                        ]
                    },
                    {
                        "id":2013,
                        "label":"衡山县",
                        "value":"430423",
                        "key":"430423",
                        "parent_area_key":"430400",
                        "children":[

                        ]
                    },
                    {
                        "id":2014,
                        "label":"衡东县",
                        "value":"430424",
                        "key":"430424",
                        "parent_area_key":"430400",
                        "children":[

                        ]
                    },
                    {
                        "id":2015,
                        "label":"祁东县",
                        "value":"430426",
                        "key":"430426",
                        "parent_area_key":"430400",
                        "children":[

                        ]
                    },
                    {
                        "id":2016,
                        "label":"耒阳市",
                        "value":"430481",
                        "key":"430481",
                        "parent_area_key":"430400",
                        "children":[

                        ]
                    },
                    {
                        "id":2017,
                        "label":"常宁市",
                        "value":"430482",
                        "key":"430482",
                        "parent_area_key":"430400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2018,
                "label":"邵阳市",
                "value":"430500",
                "key":"430500",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":2019,
                        "label":"市辖区",
                        "value":"430501",
                        "key":"430501",
                        "parent_area_key":"430500",
                        "children":[

                        ]
                    },
                    {
                        "id":2020,
                        "label":"双清区",
                        "value":"430502",
                        "key":"430502",
                        "parent_area_key":"430500",
                        "children":[

                        ]
                    },
                    {
                        "id":2021,
                        "label":"大祥区",
                        "value":"430503",
                        "key":"430503",
                        "parent_area_key":"430500",
                        "children":[

                        ]
                    },
                    {
                        "id":2022,
                        "label":"北塔区",
                        "value":"430511",
                        "key":"430511",
                        "parent_area_key":"430500",
                        "children":[

                        ]
                    },
                    {
                        "id":2023,
                        "label":"邵东县",
                        "value":"430521",
                        "key":"430521",
                        "parent_area_key":"430500",
                        "children":[

                        ]
                    },
                    {
                        "id":2024,
                        "label":"新邵县",
                        "value":"430522",
                        "key":"430522",
                        "parent_area_key":"430500",
                        "children":[

                        ]
                    },
                    {
                        "id":2025,
                        "label":"邵阳县",
                        "value":"430523",
                        "key":"430523",
                        "parent_area_key":"430500",
                        "children":[

                        ]
                    },
                    {
                        "id":2026,
                        "label":"隆回县",
                        "value":"430524",
                        "key":"430524",
                        "parent_area_key":"430500",
                        "children":[

                        ]
                    },
                    {
                        "id":2027,
                        "label":"洞口县",
                        "value":"430525",
                        "key":"430525",
                        "parent_area_key":"430500",
                        "children":[

                        ]
                    },
                    {
                        "id":2028,
                        "label":"绥宁县",
                        "value":"430527",
                        "key":"430527",
                        "parent_area_key":"430500",
                        "children":[

                        ]
                    },
                    {
                        "id":2029,
                        "label":"新宁县",
                        "value":"430528",
                        "key":"430528",
                        "parent_area_key":"430500",
                        "children":[

                        ]
                    },
                    {
                        "id":2030,
                        "label":"城步苗族自治县",
                        "value":"430529",
                        "key":"430529",
                        "parent_area_key":"430500",
                        "children":[

                        ]
                    },
                    {
                        "id":2031,
                        "label":"武冈市",
                        "value":"430581",
                        "key":"430581",
                        "parent_area_key":"430500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2032,
                "label":"岳阳市",
                "value":"430600",
                "key":"430600",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":2033,
                        "label":"市辖区",
                        "value":"430601",
                        "key":"430601",
                        "parent_area_key":"430600",
                        "children":[

                        ]
                    },
                    {
                        "id":2034,
                        "label":"岳阳楼区",
                        "value":"430602",
                        "key":"430602",
                        "parent_area_key":"430600",
                        "children":[

                        ]
                    },
                    {
                        "id":2035,
                        "label":"云溪区",
                        "value":"430603",
                        "key":"430603",
                        "parent_area_key":"430600",
                        "children":[

                        ]
                    },
                    {
                        "id":2036,
                        "label":"君山区",
                        "value":"430611",
                        "key":"430611",
                        "parent_area_key":"430600",
                        "children":[

                        ]
                    },
                    {
                        "id":2037,
                        "label":"岳阳县",
                        "value":"430621",
                        "key":"430621",
                        "parent_area_key":"430600",
                        "children":[

                        ]
                    },
                    {
                        "id":2038,
                        "label":"华容县",
                        "value":"430623",
                        "key":"430623",
                        "parent_area_key":"430600",
                        "children":[

                        ]
                    },
                    {
                        "id":2039,
                        "label":"湘阴县",
                        "value":"430624",
                        "key":"430624",
                        "parent_area_key":"430600",
                        "children":[

                        ]
                    },
                    {
                        "id":2040,
                        "label":"平江县",
                        "value":"430626",
                        "key":"430626",
                        "parent_area_key":"430600",
                        "children":[

                        ]
                    },
                    {
                        "id":2041,
                        "label":"汨罗市",
                        "value":"430681",
                        "key":"430681",
                        "parent_area_key":"430600",
                        "children":[

                        ]
                    },
                    {
                        "id":2042,
                        "label":"临湘市",
                        "value":"430682",
                        "key":"430682",
                        "parent_area_key":"430600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2043,
                "label":"常德市",
                "value":"430700",
                "key":"430700",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":2044,
                        "label":"市辖区",
                        "value":"430701",
                        "key":"430701",
                        "parent_area_key":"430700",
                        "children":[

                        ]
                    },
                    {
                        "id":2045,
                        "label":"武陵区",
                        "value":"430702",
                        "key":"430702",
                        "parent_area_key":"430700",
                        "children":[

                        ]
                    },
                    {
                        "id":2046,
                        "label":"鼎城区",
                        "value":"430703",
                        "key":"430703",
                        "parent_area_key":"430700",
                        "children":[

                        ]
                    },
                    {
                        "id":2047,
                        "label":"安乡县",
                        "value":"430721",
                        "key":"430721",
                        "parent_area_key":"430700",
                        "children":[

                        ]
                    },
                    {
                        "id":2048,
                        "label":"汉寿县",
                        "value":"430722",
                        "key":"430722",
                        "parent_area_key":"430700",
                        "children":[

                        ]
                    },
                    {
                        "id":2049,
                        "label":"澧县",
                        "value":"430723",
                        "key":"430723",
                        "parent_area_key":"430700",
                        "children":[

                        ]
                    },
                    {
                        "id":2050,
                        "label":"临澧县",
                        "value":"430724",
                        "key":"430724",
                        "parent_area_key":"430700",
                        "children":[

                        ]
                    },
                    {
                        "id":2051,
                        "label":"桃源县",
                        "value":"430725",
                        "key":"430725",
                        "parent_area_key":"430700",
                        "children":[

                        ]
                    },
                    {
                        "id":2052,
                        "label":"石门县",
                        "value":"430726",
                        "key":"430726",
                        "parent_area_key":"430700",
                        "children":[

                        ]
                    },
                    {
                        "id":2053,
                        "label":"津市市",
                        "value":"430781",
                        "key":"430781",
                        "parent_area_key":"430700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2054,
                "label":"张家界市",
                "value":"430800",
                "key":"430800",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":2055,
                        "label":"市辖区",
                        "value":"430801",
                        "key":"430801",
                        "parent_area_key":"430800",
                        "children":[

                        ]
                    },
                    {
                        "id":2056,
                        "label":"永定区",
                        "value":"430802",
                        "key":"430802",
                        "parent_area_key":"430800",
                        "children":[

                        ]
                    },
                    {
                        "id":2057,
                        "label":"武陵源区",
                        "value":"430811",
                        "key":"430811",
                        "parent_area_key":"430800",
                        "children":[

                        ]
                    },
                    {
                        "id":2058,
                        "label":"慈利县",
                        "value":"430821",
                        "key":"430821",
                        "parent_area_key":"430800",
                        "children":[

                        ]
                    },
                    {
                        "id":2059,
                        "label":"桑植县",
                        "value":"430822",
                        "key":"430822",
                        "parent_area_key":"430800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2060,
                "label":"益阳市",
                "value":"430900",
                "key":"430900",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":2061,
                        "label":"市辖区",
                        "value":"430901",
                        "key":"430901",
                        "parent_area_key":"430900",
                        "children":[

                        ]
                    },
                    {
                        "id":2062,
                        "label":"资阳区",
                        "value":"430902",
                        "key":"430902",
                        "parent_area_key":"430900",
                        "children":[

                        ]
                    },
                    {
                        "id":2063,
                        "label":"赫山区",
                        "value":"430903",
                        "key":"430903",
                        "parent_area_key":"430900",
                        "children":[

                        ]
                    },
                    {
                        "id":2064,
                        "label":"南县",
                        "value":"430921",
                        "key":"430921",
                        "parent_area_key":"430900",
                        "children":[

                        ]
                    },
                    {
                        "id":2065,
                        "label":"桃江县",
                        "value":"430922",
                        "key":"430922",
                        "parent_area_key":"430900",
                        "children":[

                        ]
                    },
                    {
                        "id":2066,
                        "label":"安化县",
                        "value":"430923",
                        "key":"430923",
                        "parent_area_key":"430900",
                        "children":[

                        ]
                    },
                    {
                        "id":2067,
                        "label":"沅江市",
                        "value":"430981",
                        "key":"430981",
                        "parent_area_key":"430900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2068,
                "label":"郴州市",
                "value":"431000",
                "key":"431000",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":2069,
                        "label":"市辖区",
                        "value":"431001",
                        "key":"431001",
                        "parent_area_key":"431000",
                        "children":[

                        ]
                    },
                    {
                        "id":2070,
                        "label":"北湖区",
                        "value":"431002",
                        "key":"431002",
                        "parent_area_key":"431000",
                        "children":[

                        ]
                    },
                    {
                        "id":2071,
                        "label":"苏仙区",
                        "value":"431003",
                        "key":"431003",
                        "parent_area_key":"431000",
                        "children":[

                        ]
                    },
                    {
                        "id":2072,
                        "label":"桂阳县",
                        "value":"431021",
                        "key":"431021",
                        "parent_area_key":"431000",
                        "children":[

                        ]
                    },
                    {
                        "id":2073,
                        "label":"宜章县",
                        "value":"431022",
                        "key":"431022",
                        "parent_area_key":"431000",
                        "children":[

                        ]
                    },
                    {
                        "id":2074,
                        "label":"永兴县",
                        "value":"431023",
                        "key":"431023",
                        "parent_area_key":"431000",
                        "children":[

                        ]
                    },
                    {
                        "id":2075,
                        "label":"嘉禾县",
                        "value":"431024",
                        "key":"431024",
                        "parent_area_key":"431000",
                        "children":[

                        ]
                    },
                    {
                        "id":2076,
                        "label":"临武县",
                        "value":"431025",
                        "key":"431025",
                        "parent_area_key":"431000",
                        "children":[

                        ]
                    },
                    {
                        "id":2077,
                        "label":"汝城县",
                        "value":"431026",
                        "key":"431026",
                        "parent_area_key":"431000",
                        "children":[

                        ]
                    },
                    {
                        "id":2078,
                        "label":"桂东县",
                        "value":"431027",
                        "key":"431027",
                        "parent_area_key":"431000",
                        "children":[

                        ]
                    },
                    {
                        "id":2079,
                        "label":"安仁县",
                        "value":"431028",
                        "key":"431028",
                        "parent_area_key":"431000",
                        "children":[

                        ]
                    },
                    {
                        "id":2080,
                        "label":"资兴市",
                        "value":"431081",
                        "key":"431081",
                        "parent_area_key":"431000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2081,
                "label":"永州市",
                "value":"431100",
                "key":"431100",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":2082,
                        "label":"市辖区",
                        "value":"431101",
                        "key":"431101",
                        "parent_area_key":"431100",
                        "children":[

                        ]
                    },
                    {
                        "id":2083,
                        "label":"零陵区",
                        "value":"431102",
                        "key":"431102",
                        "parent_area_key":"431100",
                        "children":[

                        ]
                    },
                    {
                        "id":2084,
                        "label":"冷水滩区",
                        "value":"431103",
                        "key":"431103",
                        "parent_area_key":"431100",
                        "children":[

                        ]
                    },
                    {
                        "id":2085,
                        "label":"祁阳县",
                        "value":"431121",
                        "key":"431121",
                        "parent_area_key":"431100",
                        "children":[

                        ]
                    },
                    {
                        "id":2086,
                        "label":"东安县",
                        "value":"431122",
                        "key":"431122",
                        "parent_area_key":"431100",
                        "children":[

                        ]
                    },
                    {
                        "id":2087,
                        "label":"双牌县",
                        "value":"431123",
                        "key":"431123",
                        "parent_area_key":"431100",
                        "children":[

                        ]
                    },
                    {
                        "id":2088,
                        "label":"道县",
                        "value":"431124",
                        "key":"431124",
                        "parent_area_key":"431100",
                        "children":[

                        ]
                    },
                    {
                        "id":2089,
                        "label":"江永县",
                        "value":"431125",
                        "key":"431125",
                        "parent_area_key":"431100",
                        "children":[

                        ]
                    },
                    {
                        "id":2090,
                        "label":"宁远县",
                        "value":"431126",
                        "key":"431126",
                        "parent_area_key":"431100",
                        "children":[

                        ]
                    },
                    {
                        "id":2091,
                        "label":"蓝山县",
                        "value":"431127",
                        "key":"431127",
                        "parent_area_key":"431100",
                        "children":[

                        ]
                    },
                    {
                        "id":2092,
                        "label":"新田县",
                        "value":"431128",
                        "key":"431128",
                        "parent_area_key":"431100",
                        "children":[

                        ]
                    },
                    {
                        "id":2093,
                        "label":"江华瑶族自治县",
                        "value":"431129",
                        "key":"431129",
                        "parent_area_key":"431100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2094,
                "label":"怀化市",
                "value":"431200",
                "key":"431200",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":2095,
                        "label":"市辖区",
                        "value":"431201",
                        "key":"431201",
                        "parent_area_key":"431200",
                        "children":[

                        ]
                    },
                    {
                        "id":2096,
                        "label":"鹤城区",
                        "value":"431202",
                        "key":"431202",
                        "parent_area_key":"431200",
                        "children":[

                        ]
                    },
                    {
                        "id":2097,
                        "label":"中方县",
                        "value":"431221",
                        "key":"431221",
                        "parent_area_key":"431200",
                        "children":[

                        ]
                    },
                    {
                        "id":2098,
                        "label":"沅陵县",
                        "value":"431222",
                        "key":"431222",
                        "parent_area_key":"431200",
                        "children":[

                        ]
                    },
                    {
                        "id":2099,
                        "label":"辰溪县",
                        "value":"431223",
                        "key":"431223",
                        "parent_area_key":"431200",
                        "children":[

                        ]
                    },
                    {
                        "id":2100,
                        "label":"溆浦县",
                        "value":"431224",
                        "key":"431224",
                        "parent_area_key":"431200",
                        "children":[

                        ]
                    },
                    {
                        "id":2101,
                        "label":"会同县",
                        "value":"431225",
                        "key":"431225",
                        "parent_area_key":"431200",
                        "children":[

                        ]
                    },
                    {
                        "id":2102,
                        "label":"麻阳苗族自治县",
                        "value":"431226",
                        "key":"431226",
                        "parent_area_key":"431200",
                        "children":[

                        ]
                    },
                    {
                        "id":2103,
                        "label":"新晃侗族自治县",
                        "value":"431227",
                        "key":"431227",
                        "parent_area_key":"431200",
                        "children":[

                        ]
                    },
                    {
                        "id":2104,
                        "label":"芷江侗族自治县",
                        "value":"431228",
                        "key":"431228",
                        "parent_area_key":"431200",
                        "children":[

                        ]
                    },
                    {
                        "id":2105,
                        "label":"靖州苗族侗族自治县",
                        "value":"431229",
                        "key":"431229",
                        "parent_area_key":"431200",
                        "children":[

                        ]
                    },
                    {
                        "id":2106,
                        "label":"通道侗族自治县",
                        "value":"431230",
                        "key":"431230",
                        "parent_area_key":"431200",
                        "children":[

                        ]
                    },
                    {
                        "id":2107,
                        "label":"洪江市",
                        "value":"431281",
                        "key":"431281",
                        "parent_area_key":"431200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2108,
                "label":"娄底市",
                "value":"431300",
                "key":"431300",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":2109,
                        "label":"市辖区",
                        "value":"431301",
                        "key":"431301",
                        "parent_area_key":"431300",
                        "children":[

                        ]
                    },
                    {
                        "id":2110,
                        "label":"娄星区",
                        "value":"431302",
                        "key":"431302",
                        "parent_area_key":"431300",
                        "children":[

                        ]
                    },
                    {
                        "id":2111,
                        "label":"双峰县",
                        "value":"431321",
                        "key":"431321",
                        "parent_area_key":"431300",
                        "children":[

                        ]
                    },
                    {
                        "id":2112,
                        "label":"新化县",
                        "value":"431322",
                        "key":"431322",
                        "parent_area_key":"431300",
                        "children":[

                        ]
                    },
                    {
                        "id":2113,
                        "label":"冷水江市",
                        "value":"431381",
                        "key":"431381",
                        "parent_area_key":"431300",
                        "children":[

                        ]
                    },
                    {
                        "id":2114,
                        "label":"涟源市",
                        "value":"431382",
                        "key":"431382",
                        "parent_area_key":"431300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2115,
                "label":"湘西土家族苗族自治州",
                "value":"433100",
                "key":"433100",
                "parent_area_key":"430000",
                "children":[
                    {
                        "id":2116,
                        "label":"吉首市",
                        "value":"433101",
                        "key":"433101",
                        "parent_area_key":"433100",
                        "children":[

                        ]
                    },
                    {
                        "id":2117,
                        "label":"泸溪县",
                        "value":"433122",
                        "key":"433122",
                        "parent_area_key":"433100",
                        "children":[

                        ]
                    },
                    {
                        "id":2118,
                        "label":"凤凰县",
                        "value":"433123",
                        "key":"433123",
                        "parent_area_key":"433100",
                        "children":[

                        ]
                    },
                    {
                        "id":2119,
                        "label":"花垣县",
                        "value":"433124",
                        "key":"433124",
                        "parent_area_key":"433100",
                        "children":[

                        ]
                    },
                    {
                        "id":2120,
                        "label":"保靖县",
                        "value":"433125",
                        "key":"433125",
                        "parent_area_key":"433100",
                        "children":[

                        ]
                    },
                    {
                        "id":2121,
                        "label":"古丈县",
                        "value":"433126",
                        "key":"433126",
                        "parent_area_key":"433100",
                        "children":[

                        ]
                    },
                    {
                        "id":2122,
                        "label":"永顺县",
                        "value":"433127",
                        "key":"433127",
                        "parent_area_key":"433100",
                        "children":[

                        ]
                    },
                    {
                        "id":2123,
                        "label":"龙山县",
                        "value":"433130",
                        "key":"433130",
                        "parent_area_key":"433100",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":2124,
        "label":"广东省",
        "value":"440000",
        "key":"440000",
        "parent_area_key":"",
        "children":[
            {
                "id":2125,
                "label":"广州市",
                "value":"440100",
                "key":"440100",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2126,
                        "label":"市辖区",
                        "value":"440101",
                        "key":"440101",
                        "parent_area_key":"440100",
                        "children":[

                        ]
                    },
                    {
                        "id":2127,
                        "label":"荔湾区",
                        "value":"440103",
                        "key":"440103",
                        "parent_area_key":"440100",
                        "children":[

                        ]
                    },
                    {
                        "id":2128,
                        "label":"越秀区",
                        "value":"440104",
                        "key":"440104",
                        "parent_area_key":"440100",
                        "children":[

                        ]
                    },
                    {
                        "id":2129,
                        "label":"海珠区",
                        "value":"440105",
                        "key":"440105",
                        "parent_area_key":"440100",
                        "children":[

                        ]
                    },
                    {
                        "id":2130,
                        "label":"天河区",
                        "value":"440106",
                        "key":"440106",
                        "parent_area_key":"440100",
                        "children":[

                        ]
                    },
                    {
                        "id":2131,
                        "label":"白云区",
                        "value":"440111",
                        "key":"440111",
                        "parent_area_key":"440100",
                        "children":[

                        ]
                    },
                    {
                        "id":2132,
                        "label":"黄埔区",
                        "value":"440112",
                        "key":"440112",
                        "parent_area_key":"440100",
                        "children":[

                        ]
                    },
                    {
                        "id":2133,
                        "label":"番禺区",
                        "value":"440113",
                        "key":"440113",
                        "parent_area_key":"440100",
                        "children":[

                        ]
                    },
                    {
                        "id":2134,
                        "label":"花都区",
                        "value":"440114",
                        "key":"440114",
                        "parent_area_key":"440100",
                        "children":[

                        ]
                    },
                    {
                        "id":2135,
                        "label":"南沙区",
                        "value":"440115",
                        "key":"440115",
                        "parent_area_key":"440100",
                        "children":[

                        ]
                    },
                    {
                        "id":2136,
                        "label":"从化区",
                        "value":"440117",
                        "key":"440117",
                        "parent_area_key":"440100",
                        "children":[

                        ]
                    },
                    {
                        "id":2137,
                        "label":"增城区",
                        "value":"440118",
                        "key":"440118",
                        "parent_area_key":"440100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2138,
                "label":"韶关市",
                "value":"440200",
                "key":"440200",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2139,
                        "label":"市辖区",
                        "value":"440201",
                        "key":"440201",
                        "parent_area_key":"440200",
                        "children":[

                        ]
                    },
                    {
                        "id":2140,
                        "label":"武江区",
                        "value":"440203",
                        "key":"440203",
                        "parent_area_key":"440200",
                        "children":[

                        ]
                    },
                    {
                        "id":2141,
                        "label":"浈江区",
                        "value":"440204",
                        "key":"440204",
                        "parent_area_key":"440200",
                        "children":[

                        ]
                    },
                    {
                        "id":2142,
                        "label":"曲江区",
                        "value":"440205",
                        "key":"440205",
                        "parent_area_key":"440200",
                        "children":[

                        ]
                    },
                    {
                        "id":2143,
                        "label":"始兴县",
                        "value":"440222",
                        "key":"440222",
                        "parent_area_key":"440200",
                        "children":[

                        ]
                    },
                    {
                        "id":2144,
                        "label":"仁化县",
                        "value":"440224",
                        "key":"440224",
                        "parent_area_key":"440200",
                        "children":[

                        ]
                    },
                    {
                        "id":2145,
                        "label":"翁源县",
                        "value":"440229",
                        "key":"440229",
                        "parent_area_key":"440200",
                        "children":[

                        ]
                    },
                    {
                        "id":2146,
                        "label":"乳源瑶族自治县",
                        "value":"440232",
                        "key":"440232",
                        "parent_area_key":"440200",
                        "children":[

                        ]
                    },
                    {
                        "id":2147,
                        "label":"新丰县",
                        "value":"440233",
                        "key":"440233",
                        "parent_area_key":"440200",
                        "children":[

                        ]
                    },
                    {
                        "id":2148,
                        "label":"乐昌市",
                        "value":"440281",
                        "key":"440281",
                        "parent_area_key":"440200",
                        "children":[

                        ]
                    },
                    {
                        "id":2149,
                        "label":"南雄市",
                        "value":"440282",
                        "key":"440282",
                        "parent_area_key":"440200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2150,
                "label":"深圳市",
                "value":"440300",
                "key":"440300",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2151,
                        "label":"市辖区",
                        "value":"440301",
                        "key":"440301",
                        "parent_area_key":"440300",
                        "children":[

                        ]
                    },
                    {
                        "id":2152,
                        "label":"罗湖区",
                        "value":"440303",
                        "key":"440303",
                        "parent_area_key":"440300",
                        "children":[

                        ]
                    },
                    {
                        "id":2153,
                        "label":"福田区",
                        "value":"440304",
                        "key":"440304",
                        "parent_area_key":"440300",
                        "children":[

                        ]
                    },
                    {
                        "id":2154,
                        "label":"南山区",
                        "value":"440305",
                        "key":"440305",
                        "parent_area_key":"440300",
                        "children":[

                        ]
                    },
                    {
                        "id":2155,
                        "label":"宝安区",
                        "value":"440306",
                        "key":"440306",
                        "parent_area_key":"440300",
                        "children":[

                        ]
                    },
                    {
                        "id":2156,
                        "label":"龙岗区",
                        "value":"440307",
                        "key":"440307",
                        "parent_area_key":"440300",
                        "children":[

                        ]
                    },
                    {
                        "id":2157,
                        "label":"盐田区",
                        "value":"440308",
                        "key":"440308",
                        "parent_area_key":"440300",
                        "children":[

                        ]
                    },
                    {
                        "id":3516,
                        "label":"龙华区",
                        "value":"440309",
                        "key":"440309",
                        "parent_area_key":"440300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2158,
                "label":"珠海市",
                "value":"440400",
                "key":"440400",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2159,
                        "label":"市辖区",
                        "value":"440401",
                        "key":"440401",
                        "parent_area_key":"440400",
                        "children":[

                        ]
                    },
                    {
                        "id":2160,
                        "label":"香洲区",
                        "value":"440402",
                        "key":"440402",
                        "parent_area_key":"440400",
                        "children":[

                        ]
                    },
                    {
                        "id":2161,
                        "label":"斗门区",
                        "value":"440403",
                        "key":"440403",
                        "parent_area_key":"440400",
                        "children":[

                        ]
                    },
                    {
                        "id":2162,
                        "label":"金湾区",
                        "value":"440404",
                        "key":"440404",
                        "parent_area_key":"440400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2163,
                "label":"汕头市",
                "value":"440500",
                "key":"440500",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2164,
                        "label":"市辖区",
                        "value":"440501",
                        "key":"440501",
                        "parent_area_key":"440500",
                        "children":[

                        ]
                    },
                    {
                        "id":2165,
                        "label":"龙湖区",
                        "value":"440507",
                        "key":"440507",
                        "parent_area_key":"440500",
                        "children":[

                        ]
                    },
                    {
                        "id":2166,
                        "label":"金平区",
                        "value":"440511",
                        "key":"440511",
                        "parent_area_key":"440500",
                        "children":[

                        ]
                    },
                    {
                        "id":2167,
                        "label":"濠江区",
                        "value":"440512",
                        "key":"440512",
                        "parent_area_key":"440500",
                        "children":[

                        ]
                    },
                    {
                        "id":2168,
                        "label":"潮阳区",
                        "value":"440513",
                        "key":"440513",
                        "parent_area_key":"440500",
                        "children":[

                        ]
                    },
                    {
                        "id":2169,
                        "label":"潮南区",
                        "value":"440514",
                        "key":"440514",
                        "parent_area_key":"440500",
                        "children":[

                        ]
                    },
                    {
                        "id":2170,
                        "label":"澄海区",
                        "value":"440515",
                        "key":"440515",
                        "parent_area_key":"440500",
                        "children":[

                        ]
                    },
                    {
                        "id":2171,
                        "label":"南澳县",
                        "value":"440523",
                        "key":"440523",
                        "parent_area_key":"440500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2172,
                "label":"佛山市",
                "value":"440600",
                "key":"440600",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2173,
                        "label":"市辖区",
                        "value":"440601",
                        "key":"440601",
                        "parent_area_key":"440600",
                        "children":[

                        ]
                    },
                    {
                        "id":2174,
                        "label":"禅城区",
                        "value":"440604",
                        "key":"440604",
                        "parent_area_key":"440600",
                        "children":[

                        ]
                    },
                    {
                        "id":2175,
                        "label":"南海区",
                        "value":"440605",
                        "key":"440605",
                        "parent_area_key":"440600",
                        "children":[

                        ]
                    },
                    {
                        "id":2176,
                        "label":"顺德区",
                        "value":"440606",
                        "key":"440606",
                        "parent_area_key":"440600",
                        "children":[

                        ]
                    },
                    {
                        "id":2177,
                        "label":"三水区",
                        "value":"440607",
                        "key":"440607",
                        "parent_area_key":"440600",
                        "children":[

                        ]
                    },
                    {
                        "id":2178,
                        "label":"高明区",
                        "value":"440608",
                        "key":"440608",
                        "parent_area_key":"440600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2179,
                "label":"江门市",
                "value":"440700",
                "key":"440700",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2180,
                        "label":"市辖区",
                        "value":"440701",
                        "key":"440701",
                        "parent_area_key":"440700",
                        "children":[

                        ]
                    },
                    {
                        "id":2181,
                        "label":"蓬江区",
                        "value":"440703",
                        "key":"440703",
                        "parent_area_key":"440700",
                        "children":[

                        ]
                    },
                    {
                        "id":2182,
                        "label":"江海区",
                        "value":"440704",
                        "key":"440704",
                        "parent_area_key":"440700",
                        "children":[

                        ]
                    },
                    {
                        "id":2183,
                        "label":"新会区",
                        "value":"440705",
                        "key":"440705",
                        "parent_area_key":"440700",
                        "children":[

                        ]
                    },
                    {
                        "id":2184,
                        "label":"台山市",
                        "value":"440781",
                        "key":"440781",
                        "parent_area_key":"440700",
                        "children":[

                        ]
                    },
                    {
                        "id":2185,
                        "label":"开平市",
                        "value":"440783",
                        "key":"440783",
                        "parent_area_key":"440700",
                        "children":[

                        ]
                    },
                    {
                        "id":2186,
                        "label":"鹤山市",
                        "value":"440784",
                        "key":"440784",
                        "parent_area_key":"440700",
                        "children":[

                        ]
                    },
                    {
                        "id":2187,
                        "label":"恩平市",
                        "value":"440785",
                        "key":"440785",
                        "parent_area_key":"440700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2188,
                "label":"湛江市",
                "value":"440800",
                "key":"440800",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2189,
                        "label":"市辖区",
                        "value":"440801",
                        "key":"440801",
                        "parent_area_key":"440800",
                        "children":[

                        ]
                    },
                    {
                        "id":2190,
                        "label":"赤坎区",
                        "value":"440802",
                        "key":"440802",
                        "parent_area_key":"440800",
                        "children":[

                        ]
                    },
                    {
                        "id":2191,
                        "label":"霞山区",
                        "value":"440803",
                        "key":"440803",
                        "parent_area_key":"440800",
                        "children":[

                        ]
                    },
                    {
                        "id":2192,
                        "label":"坡头区",
                        "value":"440804",
                        "key":"440804",
                        "parent_area_key":"440800",
                        "children":[

                        ]
                    },
                    {
                        "id":2193,
                        "label":"麻章区",
                        "value":"440811",
                        "key":"440811",
                        "parent_area_key":"440800",
                        "children":[

                        ]
                    },
                    {
                        "id":2194,
                        "label":"遂溪县",
                        "value":"440823",
                        "key":"440823",
                        "parent_area_key":"440800",
                        "children":[

                        ]
                    },
                    {
                        "id":2195,
                        "label":"徐闻县",
                        "value":"440825",
                        "key":"440825",
                        "parent_area_key":"440800",
                        "children":[

                        ]
                    },
                    {
                        "id":2196,
                        "label":"廉江市",
                        "value":"440881",
                        "key":"440881",
                        "parent_area_key":"440800",
                        "children":[

                        ]
                    },
                    {
                        "id":2197,
                        "label":"雷州市",
                        "value":"440882",
                        "key":"440882",
                        "parent_area_key":"440800",
                        "children":[

                        ]
                    },
                    {
                        "id":2198,
                        "label":"吴川市",
                        "value":"440883",
                        "key":"440883",
                        "parent_area_key":"440800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2199,
                "label":"茂名市",
                "value":"440900",
                "key":"440900",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2200,
                        "label":"市辖区",
                        "value":"440901",
                        "key":"440901",
                        "parent_area_key":"440900",
                        "children":[

                        ]
                    },
                    {
                        "id":2201,
                        "label":"茂南区",
                        "value":"440902",
                        "key":"440902",
                        "parent_area_key":"440900",
                        "children":[

                        ]
                    },
                    {
                        "id":2202,
                        "label":"电白区",
                        "value":"440904",
                        "key":"440904",
                        "parent_area_key":"440900",
                        "children":[

                        ]
                    },
                    {
                        "id":2203,
                        "label":"高州市",
                        "value":"440981",
                        "key":"440981",
                        "parent_area_key":"440900",
                        "children":[

                        ]
                    },
                    {
                        "id":2204,
                        "label":"化州市",
                        "value":"440982",
                        "key":"440982",
                        "parent_area_key":"440900",
                        "children":[

                        ]
                    },
                    {
                        "id":2205,
                        "label":"信宜市",
                        "value":"440983",
                        "key":"440983",
                        "parent_area_key":"440900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2206,
                "label":"肇庆市",
                "value":"441200",
                "key":"441200",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2207,
                        "label":"市辖区",
                        "value":"441201",
                        "key":"441201",
                        "parent_area_key":"441200",
                        "children":[

                        ]
                    },
                    {
                        "id":2208,
                        "label":"端州区",
                        "value":"441202",
                        "key":"441202",
                        "parent_area_key":"441200",
                        "children":[

                        ]
                    },
                    {
                        "id":2209,
                        "label":"鼎湖区",
                        "value":"441203",
                        "key":"441203",
                        "parent_area_key":"441200",
                        "children":[

                        ]
                    },
                    {
                        "id":2210,
                        "label":"高要区",
                        "value":"441204",
                        "key":"441204",
                        "parent_area_key":"441200",
                        "children":[

                        ]
                    },
                    {
                        "id":2211,
                        "label":"广宁县",
                        "value":"441223",
                        "key":"441223",
                        "parent_area_key":"441200",
                        "children":[

                        ]
                    },
                    {
                        "id":2212,
                        "label":"怀集县",
                        "value":"441224",
                        "key":"441224",
                        "parent_area_key":"441200",
                        "children":[

                        ]
                    },
                    {
                        "id":2213,
                        "label":"封开县",
                        "value":"441225",
                        "key":"441225",
                        "parent_area_key":"441200",
                        "children":[

                        ]
                    },
                    {
                        "id":2214,
                        "label":"德庆县",
                        "value":"441226",
                        "key":"441226",
                        "parent_area_key":"441200",
                        "children":[

                        ]
                    },
                    {
                        "id":2215,
                        "label":"四会市",
                        "value":"441284",
                        "key":"441284",
                        "parent_area_key":"441200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2216,
                "label":"惠州市",
                "value":"441300",
                "key":"441300",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2217,
                        "label":"市辖区",
                        "value":"441301",
                        "key":"441301",
                        "parent_area_key":"441300",
                        "children":[

                        ]
                    },
                    {
                        "id":2218,
                        "label":"惠城区",
                        "value":"441302",
                        "key":"441302",
                        "parent_area_key":"441300",
                        "children":[

                        ]
                    },
                    {
                        "id":2219,
                        "label":"惠阳区",
                        "value":"441303",
                        "key":"441303",
                        "parent_area_key":"441300",
                        "children":[

                        ]
                    },
                    {
                        "id":2220,
                        "label":"博罗县",
                        "value":"441322",
                        "key":"441322",
                        "parent_area_key":"441300",
                        "children":[

                        ]
                    },
                    {
                        "id":2221,
                        "label":"惠东县",
                        "value":"441323",
                        "key":"441323",
                        "parent_area_key":"441300",
                        "children":[

                        ]
                    },
                    {
                        "id":2222,
                        "label":"龙门县",
                        "value":"441324",
                        "key":"441324",
                        "parent_area_key":"441300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2223,
                "label":"梅州市",
                "value":"441400",
                "key":"441400",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2224,
                        "label":"市辖区",
                        "value":"441401",
                        "key":"441401",
                        "parent_area_key":"441400",
                        "children":[

                        ]
                    },
                    {
                        "id":2225,
                        "label":"梅江区",
                        "value":"441402",
                        "key":"441402",
                        "parent_area_key":"441400",
                        "children":[

                        ]
                    },
                    {
                        "id":2226,
                        "label":"梅县区",
                        "value":"441403",
                        "key":"441403",
                        "parent_area_key":"441400",
                        "children":[

                        ]
                    },
                    {
                        "id":2227,
                        "label":"大埔县",
                        "value":"441422",
                        "key":"441422",
                        "parent_area_key":"441400",
                        "children":[

                        ]
                    },
                    {
                        "id":2228,
                        "label":"丰顺县",
                        "value":"441423",
                        "key":"441423",
                        "parent_area_key":"441400",
                        "children":[

                        ]
                    },
                    {
                        "id":2229,
                        "label":"五华县",
                        "value":"441424",
                        "key":"441424",
                        "parent_area_key":"441400",
                        "children":[

                        ]
                    },
                    {
                        "id":2230,
                        "label":"平远县",
                        "value":"441426",
                        "key":"441426",
                        "parent_area_key":"441400",
                        "children":[

                        ]
                    },
                    {
                        "id":2231,
                        "label":"蕉岭县",
                        "value":"441427",
                        "key":"441427",
                        "parent_area_key":"441400",
                        "children":[

                        ]
                    },
                    {
                        "id":2232,
                        "label":"兴宁市",
                        "value":"441481",
                        "key":"441481",
                        "parent_area_key":"441400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2233,
                "label":"汕尾市",
                "value":"441500",
                "key":"441500",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2234,
                        "label":"市辖区",
                        "value":"441501",
                        "key":"441501",
                        "parent_area_key":"441500",
                        "children":[

                        ]
                    },
                    {
                        "id":2235,
                        "label":"城区",
                        "value":"441502",
                        "key":"441502",
                        "parent_area_key":"441500",
                        "children":[

                        ]
                    },
                    {
                        "id":2236,
                        "label":"海丰县",
                        "value":"441521",
                        "key":"441521",
                        "parent_area_key":"441500",
                        "children":[

                        ]
                    },
                    {
                        "id":2237,
                        "label":"陆河县",
                        "value":"441523",
                        "key":"441523",
                        "parent_area_key":"441500",
                        "children":[

                        ]
                    },
                    {
                        "id":2238,
                        "label":"陆丰市",
                        "value":"441581",
                        "key":"441581",
                        "parent_area_key":"441500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2239,
                "label":"河源市",
                "value":"441600",
                "key":"441600",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2240,
                        "label":"市辖区",
                        "value":"441601",
                        "key":"441601",
                        "parent_area_key":"441600",
                        "children":[

                        ]
                    },
                    {
                        "id":2241,
                        "label":"源城区",
                        "value":"441602",
                        "key":"441602",
                        "parent_area_key":"441600",
                        "children":[

                        ]
                    },
                    {
                        "id":2242,
                        "label":"紫金县",
                        "value":"441621",
                        "key":"441621",
                        "parent_area_key":"441600",
                        "children":[

                        ]
                    },
                    {
                        "id":2243,
                        "label":"龙川县",
                        "value":"441622",
                        "key":"441622",
                        "parent_area_key":"441600",
                        "children":[

                        ]
                    },
                    {
                        "id":2244,
                        "label":"连平县",
                        "value":"441623",
                        "key":"441623",
                        "parent_area_key":"441600",
                        "children":[

                        ]
                    },
                    {
                        "id":2245,
                        "label":"和平县",
                        "value":"441624",
                        "key":"441624",
                        "parent_area_key":"441600",
                        "children":[

                        ]
                    },
                    {
                        "id":2246,
                        "label":"东源县",
                        "value":"441625",
                        "key":"441625",
                        "parent_area_key":"441600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2247,
                "label":"阳江市",
                "value":"441700",
                "key":"441700",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2248,
                        "label":"市辖区",
                        "value":"441701",
                        "key":"441701",
                        "parent_area_key":"441700",
                        "children":[

                        ]
                    },
                    {
                        "id":2249,
                        "label":"江城区",
                        "value":"441702",
                        "key":"441702",
                        "parent_area_key":"441700",
                        "children":[

                        ]
                    },
                    {
                        "id":2250,
                        "label":"阳东区",
                        "value":"441704",
                        "key":"441704",
                        "parent_area_key":"441700",
                        "children":[

                        ]
                    },
                    {
                        "id":2251,
                        "label":"阳西县",
                        "value":"441721",
                        "key":"441721",
                        "parent_area_key":"441700",
                        "children":[

                        ]
                    },
                    {
                        "id":2252,
                        "label":"阳春市",
                        "value":"441781",
                        "key":"441781",
                        "parent_area_key":"441700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2253,
                "label":"清远市",
                "value":"441800",
                "key":"441800",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2254,
                        "label":"市辖区",
                        "value":"441801",
                        "key":"441801",
                        "parent_area_key":"441800",
                        "children":[

                        ]
                    },
                    {
                        "id":2255,
                        "label":"清城区",
                        "value":"441802",
                        "key":"441802",
                        "parent_area_key":"441800",
                        "children":[

                        ]
                    },
                    {
                        "id":2256,
                        "label":"清新区",
                        "value":"441803",
                        "key":"441803",
                        "parent_area_key":"441800",
                        "children":[

                        ]
                    },
                    {
                        "id":2257,
                        "label":"佛冈县",
                        "value":"441821",
                        "key":"441821",
                        "parent_area_key":"441800",
                        "children":[

                        ]
                    },
                    {
                        "id":2258,
                        "label":"阳山县",
                        "value":"441823",
                        "key":"441823",
                        "parent_area_key":"441800",
                        "children":[

                        ]
                    },
                    {
                        "id":2259,
                        "label":"连山壮族瑶族自治县",
                        "value":"441825",
                        "key":"441825",
                        "parent_area_key":"441800",
                        "children":[

                        ]
                    },
                    {
                        "id":2260,
                        "label":"连南瑶族自治县",
                        "value":"441826",
                        "key":"441826",
                        "parent_area_key":"441800",
                        "children":[

                        ]
                    },
                    {
                        "id":2261,
                        "label":"英德市",
                        "value":"441881",
                        "key":"441881",
                        "parent_area_key":"441800",
                        "children":[

                        ]
                    },
                    {
                        "id":2262,
                        "label":"连州市",
                        "value":"441882",
                        "key":"441882",
                        "parent_area_key":"441800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2263,
                "label":"东莞市",
                "value":"441900",
                "key":"441900",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":3515,
                        "label":"市辖区",
                        "value":"441901",
                        "key":"441901",
                        "parent_area_key":"441900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2264,
                "label":"中山市",
                "value":"442000",
                "key":"442000",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":3517,
                        "label":"市辖区",
                        "value":"442001",
                        "key":"442001",
                        "parent_area_key":"442000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2265,
                "label":"潮州市",
                "value":"445100",
                "key":"445100",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2266,
                        "label":"市辖区",
                        "value":"445101",
                        "key":"445101",
                        "parent_area_key":"445100",
                        "children":[

                        ]
                    },
                    {
                        "id":2267,
                        "label":"湘桥区",
                        "value":"445102",
                        "key":"445102",
                        "parent_area_key":"445100",
                        "children":[

                        ]
                    },
                    {
                        "id":2268,
                        "label":"潮安区",
                        "value":"445103",
                        "key":"445103",
                        "parent_area_key":"445100",
                        "children":[

                        ]
                    },
                    {
                        "id":2269,
                        "label":"饶平县",
                        "value":"445122",
                        "key":"445122",
                        "parent_area_key":"445100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2270,
                "label":"揭阳市",
                "value":"445200",
                "key":"445200",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2271,
                        "label":"市辖区",
                        "value":"445201",
                        "key":"445201",
                        "parent_area_key":"445200",
                        "children":[

                        ]
                    },
                    {
                        "id":2272,
                        "label":"榕城区",
                        "value":"445202",
                        "key":"445202",
                        "parent_area_key":"445200",
                        "children":[

                        ]
                    },
                    {
                        "id":2273,
                        "label":"揭东区",
                        "value":"445203",
                        "key":"445203",
                        "parent_area_key":"445200",
                        "children":[

                        ]
                    },
                    {
                        "id":2274,
                        "label":"揭西县",
                        "value":"445222",
                        "key":"445222",
                        "parent_area_key":"445200",
                        "children":[

                        ]
                    },
                    {
                        "id":2275,
                        "label":"惠来县",
                        "value":"445224",
                        "key":"445224",
                        "parent_area_key":"445200",
                        "children":[

                        ]
                    },
                    {
                        "id":2276,
                        "label":"普宁市",
                        "value":"445281",
                        "key":"445281",
                        "parent_area_key":"445200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2277,
                "label":"云浮市",
                "value":"445300",
                "key":"445300",
                "parent_area_key":"440000",
                "children":[
                    {
                        "id":2278,
                        "label":"市辖区",
                        "value":"445301",
                        "key":"445301",
                        "parent_area_key":"445300",
                        "children":[

                        ]
                    },
                    {
                        "id":2279,
                        "label":"云城区",
                        "value":"445302",
                        "key":"445302",
                        "parent_area_key":"445300",
                        "children":[

                        ]
                    },
                    {
                        "id":2280,
                        "label":"云安区",
                        "value":"445303",
                        "key":"445303",
                        "parent_area_key":"445300",
                        "children":[

                        ]
                    },
                    {
                        "id":2281,
                        "label":"新兴县",
                        "value":"445321",
                        "key":"445321",
                        "parent_area_key":"445300",
                        "children":[

                        ]
                    },
                    {
                        "id":2282,
                        "label":"郁南县",
                        "value":"445322",
                        "key":"445322",
                        "parent_area_key":"445300",
                        "children":[

                        ]
                    },
                    {
                        "id":2283,
                        "label":"罗定市",
                        "value":"445381",
                        "key":"445381",
                        "parent_area_key":"445300",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":2284,
        "label":"广西壮族自治区",
        "value":"450000",
        "key":"450000",
        "parent_area_key":"",
        "children":[
            {
                "id":2285,
                "label":"南宁市",
                "value":"450100",
                "key":"450100",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2286,
                        "label":"市辖区",
                        "value":"450101",
                        "key":"450101",
                        "parent_area_key":"450100",
                        "children":[

                        ]
                    },
                    {
                        "id":2287,
                        "label":"兴宁区",
                        "value":"450102",
                        "key":"450102",
                        "parent_area_key":"450100",
                        "children":[

                        ]
                    },
                    {
                        "id":2288,
                        "label":"青秀区",
                        "value":"450103",
                        "key":"450103",
                        "parent_area_key":"450100",
                        "children":[

                        ]
                    },
                    {
                        "id":2289,
                        "label":"江南区",
                        "value":"450105",
                        "key":"450105",
                        "parent_area_key":"450100",
                        "children":[

                        ]
                    },
                    {
                        "id":2290,
                        "label":"西乡塘区",
                        "value":"450107",
                        "key":"450107",
                        "parent_area_key":"450100",
                        "children":[

                        ]
                    },
                    {
                        "id":2291,
                        "label":"良庆区",
                        "value":"450108",
                        "key":"450108",
                        "parent_area_key":"450100",
                        "children":[

                        ]
                    },
                    {
                        "id":2292,
                        "label":"邕宁区",
                        "value":"450109",
                        "key":"450109",
                        "parent_area_key":"450100",
                        "children":[

                        ]
                    },
                    {
                        "id":2293,
                        "label":"武鸣区",
                        "value":"450110",
                        "key":"450110",
                        "parent_area_key":"450100",
                        "children":[

                        ]
                    },
                    {
                        "id":2294,
                        "label":"隆安县",
                        "value":"450123",
                        "key":"450123",
                        "parent_area_key":"450100",
                        "children":[

                        ]
                    },
                    {
                        "id":2295,
                        "label":"马山县",
                        "value":"450124",
                        "key":"450124",
                        "parent_area_key":"450100",
                        "children":[

                        ]
                    },
                    {
                        "id":2296,
                        "label":"上林县",
                        "value":"450125",
                        "key":"450125",
                        "parent_area_key":"450100",
                        "children":[

                        ]
                    },
                    {
                        "id":2297,
                        "label":"宾阳县",
                        "value":"450126",
                        "key":"450126",
                        "parent_area_key":"450100",
                        "children":[

                        ]
                    },
                    {
                        "id":2298,
                        "label":"横县",
                        "value":"450127",
                        "key":"450127",
                        "parent_area_key":"450100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2299,
                "label":"柳州市",
                "value":"450200",
                "key":"450200",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2300,
                        "label":"市辖区",
                        "value":"450201",
                        "key":"450201",
                        "parent_area_key":"450200",
                        "children":[

                        ]
                    },
                    {
                        "id":2301,
                        "label":"城中区",
                        "value":"450202",
                        "key":"450202",
                        "parent_area_key":"450200",
                        "children":[

                        ]
                    },
                    {
                        "id":2302,
                        "label":"鱼峰区",
                        "value":"450203",
                        "key":"450203",
                        "parent_area_key":"450200",
                        "children":[

                        ]
                    },
                    {
                        "id":2303,
                        "label":"柳南区",
                        "value":"450204",
                        "key":"450204",
                        "parent_area_key":"450200",
                        "children":[

                        ]
                    },
                    {
                        "id":2304,
                        "label":"柳北区",
                        "value":"450205",
                        "key":"450205",
                        "parent_area_key":"450200",
                        "children":[

                        ]
                    },
                    {
                        "id":2305,
                        "label":"柳江区",
                        "value":"450206",
                        "key":"450206",
                        "parent_area_key":"450200",
                        "children":[

                        ]
                    },
                    {
                        "id":2306,
                        "label":"柳城县",
                        "value":"450222",
                        "key":"450222",
                        "parent_area_key":"450200",
                        "children":[

                        ]
                    },
                    {
                        "id":2307,
                        "label":"鹿寨县",
                        "value":"450223",
                        "key":"450223",
                        "parent_area_key":"450200",
                        "children":[

                        ]
                    },
                    {
                        "id":2308,
                        "label":"融安县",
                        "value":"450224",
                        "key":"450224",
                        "parent_area_key":"450200",
                        "children":[

                        ]
                    },
                    {
                        "id":2309,
                        "label":"融水苗族自治县",
                        "value":"450225",
                        "key":"450225",
                        "parent_area_key":"450200",
                        "children":[

                        ]
                    },
                    {
                        "id":2310,
                        "label":"三江侗族自治县",
                        "value":"450226",
                        "key":"450226",
                        "parent_area_key":"450200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2311,
                "label":"桂林市",
                "value":"450300",
                "key":"450300",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2312,
                        "label":"市辖区",
                        "value":"450301",
                        "key":"450301",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2313,
                        "label":"秀峰区",
                        "value":"450302",
                        "key":"450302",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2314,
                        "label":"叠彩区",
                        "value":"450303",
                        "key":"450303",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2315,
                        "label":"象山区",
                        "value":"450304",
                        "key":"450304",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2316,
                        "label":"七星区",
                        "value":"450305",
                        "key":"450305",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2317,
                        "label":"雁山区",
                        "value":"450311",
                        "key":"450311",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2318,
                        "label":"临桂区",
                        "value":"450312",
                        "key":"450312",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2319,
                        "label":"阳朔县",
                        "value":"450321",
                        "key":"450321",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2320,
                        "label":"灵川县",
                        "value":"450323",
                        "key":"450323",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2321,
                        "label":"全州县",
                        "value":"450324",
                        "key":"450324",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2322,
                        "label":"兴安县",
                        "value":"450325",
                        "key":"450325",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2323,
                        "label":"永福县",
                        "value":"450326",
                        "key":"450326",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2324,
                        "label":"灌阳县",
                        "value":"450327",
                        "key":"450327",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2325,
                        "label":"龙胜各族自治县",
                        "value":"450328",
                        "key":"450328",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2326,
                        "label":"资源县",
                        "value":"450329",
                        "key":"450329",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2327,
                        "label":"平乐县",
                        "value":"450330",
                        "key":"450330",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2328,
                        "label":"荔浦县",
                        "value":"450331",
                        "key":"450331",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    },
                    {
                        "id":2329,
                        "label":"恭城瑶族自治县",
                        "value":"450332",
                        "key":"450332",
                        "parent_area_key":"450300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2330,
                "label":"梧州市",
                "value":"450400",
                "key":"450400",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2331,
                        "label":"市辖区",
                        "value":"450401",
                        "key":"450401",
                        "parent_area_key":"450400",
                        "children":[

                        ]
                    },
                    {
                        "id":2332,
                        "label":"万秀区",
                        "value":"450403",
                        "key":"450403",
                        "parent_area_key":"450400",
                        "children":[

                        ]
                    },
                    {
                        "id":2333,
                        "label":"长洲区",
                        "value":"450405",
                        "key":"450405",
                        "parent_area_key":"450400",
                        "children":[

                        ]
                    },
                    {
                        "id":2334,
                        "label":"龙圩区",
                        "value":"450406",
                        "key":"450406",
                        "parent_area_key":"450400",
                        "children":[

                        ]
                    },
                    {
                        "id":2335,
                        "label":"苍梧县",
                        "value":"450421",
                        "key":"450421",
                        "parent_area_key":"450400",
                        "children":[

                        ]
                    },
                    {
                        "id":2336,
                        "label":"藤县",
                        "value":"450422",
                        "key":"450422",
                        "parent_area_key":"450400",
                        "children":[

                        ]
                    },
                    {
                        "id":2337,
                        "label":"蒙山县",
                        "value":"450423",
                        "key":"450423",
                        "parent_area_key":"450400",
                        "children":[

                        ]
                    },
                    {
                        "id":2338,
                        "label":"岑溪市",
                        "value":"450481",
                        "key":"450481",
                        "parent_area_key":"450400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2339,
                "label":"北海市",
                "value":"450500",
                "key":"450500",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2340,
                        "label":"市辖区",
                        "value":"450501",
                        "key":"450501",
                        "parent_area_key":"450500",
                        "children":[

                        ]
                    },
                    {
                        "id":2341,
                        "label":"海城区",
                        "value":"450502",
                        "key":"450502",
                        "parent_area_key":"450500",
                        "children":[

                        ]
                    },
                    {
                        "id":2342,
                        "label":"银海区",
                        "value":"450503",
                        "key":"450503",
                        "parent_area_key":"450500",
                        "children":[

                        ]
                    },
                    {
                        "id":2343,
                        "label":"铁山港区",
                        "value":"450512",
                        "key":"450512",
                        "parent_area_key":"450500",
                        "children":[

                        ]
                    },
                    {
                        "id":2344,
                        "label":"合浦县",
                        "value":"450521",
                        "key":"450521",
                        "parent_area_key":"450500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2345,
                "label":"防城港市",
                "value":"450600",
                "key":"450600",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2346,
                        "label":"市辖区",
                        "value":"450601",
                        "key":"450601",
                        "parent_area_key":"450600",
                        "children":[

                        ]
                    },
                    {
                        "id":2347,
                        "label":"港口区",
                        "value":"450602",
                        "key":"450602",
                        "parent_area_key":"450600",
                        "children":[

                        ]
                    },
                    {
                        "id":2348,
                        "label":"防城区",
                        "value":"450603",
                        "key":"450603",
                        "parent_area_key":"450600",
                        "children":[

                        ]
                    },
                    {
                        "id":2349,
                        "label":"上思县",
                        "value":"450621",
                        "key":"450621",
                        "parent_area_key":"450600",
                        "children":[

                        ]
                    },
                    {
                        "id":2350,
                        "label":"东兴市",
                        "value":"450681",
                        "key":"450681",
                        "parent_area_key":"450600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2351,
                "label":"钦州市",
                "value":"450700",
                "key":"450700",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2352,
                        "label":"市辖区",
                        "value":"450701",
                        "key":"450701",
                        "parent_area_key":"450700",
                        "children":[

                        ]
                    },
                    {
                        "id":2353,
                        "label":"钦南区",
                        "value":"450702",
                        "key":"450702",
                        "parent_area_key":"450700",
                        "children":[

                        ]
                    },
                    {
                        "id":2354,
                        "label":"钦北区",
                        "value":"450703",
                        "key":"450703",
                        "parent_area_key":"450700",
                        "children":[

                        ]
                    },
                    {
                        "id":2355,
                        "label":"灵山县",
                        "value":"450721",
                        "key":"450721",
                        "parent_area_key":"450700",
                        "children":[

                        ]
                    },
                    {
                        "id":2356,
                        "label":"浦北县",
                        "value":"450722",
                        "key":"450722",
                        "parent_area_key":"450700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2357,
                "label":"贵港市",
                "value":"450800",
                "key":"450800",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2358,
                        "label":"市辖区",
                        "value":"450801",
                        "key":"450801",
                        "parent_area_key":"450800",
                        "children":[

                        ]
                    },
                    {
                        "id":2359,
                        "label":"港北区",
                        "value":"450802",
                        "key":"450802",
                        "parent_area_key":"450800",
                        "children":[

                        ]
                    },
                    {
                        "id":2360,
                        "label":"港南区",
                        "value":"450803",
                        "key":"450803",
                        "parent_area_key":"450800",
                        "children":[

                        ]
                    },
                    {
                        "id":2361,
                        "label":"覃塘区",
                        "value":"450804",
                        "key":"450804",
                        "parent_area_key":"450800",
                        "children":[

                        ]
                    },
                    {
                        "id":2362,
                        "label":"平南县",
                        "value":"450821",
                        "key":"450821",
                        "parent_area_key":"450800",
                        "children":[

                        ]
                    },
                    {
                        "id":2363,
                        "label":"桂平市",
                        "value":"450881",
                        "key":"450881",
                        "parent_area_key":"450800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2364,
                "label":"玉林市",
                "value":"450900",
                "key":"450900",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2365,
                        "label":"市辖区",
                        "value":"450901",
                        "key":"450901",
                        "parent_area_key":"450900",
                        "children":[

                        ]
                    },
                    {
                        "id":2366,
                        "label":"玉州区",
                        "value":"450902",
                        "key":"450902",
                        "parent_area_key":"450900",
                        "children":[

                        ]
                    },
                    {
                        "id":2367,
                        "label":"福绵区",
                        "value":"450903",
                        "key":"450903",
                        "parent_area_key":"450900",
                        "children":[

                        ]
                    },
                    {
                        "id":2368,
                        "label":"容县",
                        "value":"450921",
                        "key":"450921",
                        "parent_area_key":"450900",
                        "children":[

                        ]
                    },
                    {
                        "id":2369,
                        "label":"陆川县",
                        "value":"450922",
                        "key":"450922",
                        "parent_area_key":"450900",
                        "children":[

                        ]
                    },
                    {
                        "id":2370,
                        "label":"博白县",
                        "value":"450923",
                        "key":"450923",
                        "parent_area_key":"450900",
                        "children":[

                        ]
                    },
                    {
                        "id":2371,
                        "label":"兴业县",
                        "value":"450924",
                        "key":"450924",
                        "parent_area_key":"450900",
                        "children":[

                        ]
                    },
                    {
                        "id":2372,
                        "label":"北流市",
                        "value":"450981",
                        "key":"450981",
                        "parent_area_key":"450900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2373,
                "label":"百色市",
                "value":"451000",
                "key":"451000",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2374,
                        "label":"市辖区",
                        "value":"451001",
                        "key":"451001",
                        "parent_area_key":"451000",
                        "children":[

                        ]
                    },
                    {
                        "id":2375,
                        "label":"右江区",
                        "value":"451002",
                        "key":"451002",
                        "parent_area_key":"451000",
                        "children":[

                        ]
                    },
                    {
                        "id":2376,
                        "label":"田阳县",
                        "value":"451021",
                        "key":"451021",
                        "parent_area_key":"451000",
                        "children":[

                        ]
                    },
                    {
                        "id":2377,
                        "label":"田东县",
                        "value":"451022",
                        "key":"451022",
                        "parent_area_key":"451000",
                        "children":[

                        ]
                    },
                    {
                        "id":2378,
                        "label":"平果县",
                        "value":"451023",
                        "key":"451023",
                        "parent_area_key":"451000",
                        "children":[

                        ]
                    },
                    {
                        "id":2379,
                        "label":"德保县",
                        "value":"451024",
                        "key":"451024",
                        "parent_area_key":"451000",
                        "children":[

                        ]
                    },
                    {
                        "id":2380,
                        "label":"那坡县",
                        "value":"451026",
                        "key":"451026",
                        "parent_area_key":"451000",
                        "children":[

                        ]
                    },
                    {
                        "id":2381,
                        "label":"凌云县",
                        "value":"451027",
                        "key":"451027",
                        "parent_area_key":"451000",
                        "children":[

                        ]
                    },
                    {
                        "id":2382,
                        "label":"乐业县",
                        "value":"451028",
                        "key":"451028",
                        "parent_area_key":"451000",
                        "children":[

                        ]
                    },
                    {
                        "id":2383,
                        "label":"田林县",
                        "value":"451029",
                        "key":"451029",
                        "parent_area_key":"451000",
                        "children":[

                        ]
                    },
                    {
                        "id":2384,
                        "label":"西林县",
                        "value":"451030",
                        "key":"451030",
                        "parent_area_key":"451000",
                        "children":[

                        ]
                    },
                    {
                        "id":2385,
                        "label":"隆林各族自治县",
                        "value":"451031",
                        "key":"451031",
                        "parent_area_key":"451000",
                        "children":[

                        ]
                    },
                    {
                        "id":2386,
                        "label":"靖西市",
                        "value":"451081",
                        "key":"451081",
                        "parent_area_key":"451000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2387,
                "label":"贺州市",
                "value":"451100",
                "key":"451100",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2388,
                        "label":"市辖区",
                        "value":"451101",
                        "key":"451101",
                        "parent_area_key":"451100",
                        "children":[

                        ]
                    },
                    {
                        "id":2389,
                        "label":"八步区",
                        "value":"451102",
                        "key":"451102",
                        "parent_area_key":"451100",
                        "children":[

                        ]
                    },
                    {
                        "id":2390,
                        "label":"平桂区",
                        "value":"451103",
                        "key":"451103",
                        "parent_area_key":"451100",
                        "children":[

                        ]
                    },
                    {
                        "id":2391,
                        "label":"昭平县",
                        "value":"451121",
                        "key":"451121",
                        "parent_area_key":"451100",
                        "children":[

                        ]
                    },
                    {
                        "id":2392,
                        "label":"钟山县",
                        "value":"451122",
                        "key":"451122",
                        "parent_area_key":"451100",
                        "children":[

                        ]
                    },
                    {
                        "id":2393,
                        "label":"富川瑶族自治县",
                        "value":"451123",
                        "key":"451123",
                        "parent_area_key":"451100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2394,
                "label":"河池市",
                "value":"451200",
                "key":"451200",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2395,
                        "label":"市辖区",
                        "value":"451201",
                        "key":"451201",
                        "parent_area_key":"451200",
                        "children":[

                        ]
                    },
                    {
                        "id":2396,
                        "label":"金城江区",
                        "value":"451202",
                        "key":"451202",
                        "parent_area_key":"451200",
                        "children":[

                        ]
                    },
                    {
                        "id":2397,
                        "label":"南丹县",
                        "value":"451221",
                        "key":"451221",
                        "parent_area_key":"451200",
                        "children":[

                        ]
                    },
                    {
                        "id":2398,
                        "label":"天峨县",
                        "value":"451222",
                        "key":"451222",
                        "parent_area_key":"451200",
                        "children":[

                        ]
                    },
                    {
                        "id":2399,
                        "label":"凤山县",
                        "value":"451223",
                        "key":"451223",
                        "parent_area_key":"451200",
                        "children":[

                        ]
                    },
                    {
                        "id":2400,
                        "label":"东兰县",
                        "value":"451224",
                        "key":"451224",
                        "parent_area_key":"451200",
                        "children":[

                        ]
                    },
                    {
                        "id":2401,
                        "label":"罗城仫佬族自治县",
                        "value":"451225",
                        "key":"451225",
                        "parent_area_key":"451200",
                        "children":[

                        ]
                    },
                    {
                        "id":2402,
                        "label":"环江毛南族自治县",
                        "value":"451226",
                        "key":"451226",
                        "parent_area_key":"451200",
                        "children":[

                        ]
                    },
                    {
                        "id":2403,
                        "label":"巴马瑶族自治县",
                        "value":"451227",
                        "key":"451227",
                        "parent_area_key":"451200",
                        "children":[

                        ]
                    },
                    {
                        "id":2404,
                        "label":"都安瑶族自治县",
                        "value":"451228",
                        "key":"451228",
                        "parent_area_key":"451200",
                        "children":[

                        ]
                    },
                    {
                        "id":2405,
                        "label":"大化瑶族自治县",
                        "value":"451229",
                        "key":"451229",
                        "parent_area_key":"451200",
                        "children":[

                        ]
                    },
                    {
                        "id":2406,
                        "label":"宜州市",
                        "value":"451281",
                        "key":"451281",
                        "parent_area_key":"451200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2407,
                "label":"来宾市",
                "value":"451300",
                "key":"451300",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2408,
                        "label":"市辖区",
                        "value":"451301",
                        "key":"451301",
                        "parent_area_key":"451300",
                        "children":[

                        ]
                    },
                    {
                        "id":2409,
                        "label":"兴宾区",
                        "value":"451302",
                        "key":"451302",
                        "parent_area_key":"451300",
                        "children":[

                        ]
                    },
                    {
                        "id":2410,
                        "label":"忻城县",
                        "value":"451321",
                        "key":"451321",
                        "parent_area_key":"451300",
                        "children":[

                        ]
                    },
                    {
                        "id":2411,
                        "label":"象州县",
                        "value":"451322",
                        "key":"451322",
                        "parent_area_key":"451300",
                        "children":[

                        ]
                    },
                    {
                        "id":2412,
                        "label":"武宣县",
                        "value":"451323",
                        "key":"451323",
                        "parent_area_key":"451300",
                        "children":[

                        ]
                    },
                    {
                        "id":2413,
                        "label":"金秀瑶族自治县",
                        "value":"451324",
                        "key":"451324",
                        "parent_area_key":"451300",
                        "children":[

                        ]
                    },
                    {
                        "id":2414,
                        "label":"合山市",
                        "value":"451381",
                        "key":"451381",
                        "parent_area_key":"451300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2415,
                "label":"崇左市",
                "value":"451400",
                "key":"451400",
                "parent_area_key":"450000",
                "children":[
                    {
                        "id":2416,
                        "label":"市辖区",
                        "value":"451401",
                        "key":"451401",
                        "parent_area_key":"451400",
                        "children":[

                        ]
                    },
                    {
                        "id":2417,
                        "label":"江州区",
                        "value":"451402",
                        "key":"451402",
                        "parent_area_key":"451400",
                        "children":[

                        ]
                    },
                    {
                        "id":2418,
                        "label":"扶绥县",
                        "value":"451421",
                        "key":"451421",
                        "parent_area_key":"451400",
                        "children":[

                        ]
                    },
                    {
                        "id":2419,
                        "label":"宁明县",
                        "value":"451422",
                        "key":"451422",
                        "parent_area_key":"451400",
                        "children":[

                        ]
                    },
                    {
                        "id":2420,
                        "label":"龙州县",
                        "value":"451423",
                        "key":"451423",
                        "parent_area_key":"451400",
                        "children":[

                        ]
                    },
                    {
                        "id":2421,
                        "label":"大新县",
                        "value":"451424",
                        "key":"451424",
                        "parent_area_key":"451400",
                        "children":[

                        ]
                    },
                    {
                        "id":2422,
                        "label":"天等县",
                        "value":"451425",
                        "key":"451425",
                        "parent_area_key":"451400",
                        "children":[

                        ]
                    },
                    {
                        "id":2423,
                        "label":"凭祥市",
                        "value":"451481",
                        "key":"451481",
                        "parent_area_key":"451400",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":2424,
        "label":"海南省",
        "value":"460000",
        "key":"460000",
        "parent_area_key":"",
        "children":[
            {
                "id":2425,
                "label":"海口市",
                "value":"460100",
                "key":"460100",
                "parent_area_key":"460000",
                "children":[
                    {
                        "id":2426,
                        "label":"市辖区",
                        "value":"460101",
                        "key":"460101",
                        "parent_area_key":"460100",
                        "children":[

                        ]
                    },
                    {
                        "id":2427,
                        "label":"秀英区",
                        "value":"460105",
                        "key":"460105",
                        "parent_area_key":"460100",
                        "children":[

                        ]
                    },
                    {
                        "id":2428,
                        "label":"龙华区",
                        "value":"460106",
                        "key":"460106",
                        "parent_area_key":"460100",
                        "children":[

                        ]
                    },
                    {
                        "id":2429,
                        "label":"琼山区",
                        "value":"460107",
                        "key":"460107",
                        "parent_area_key":"460100",
                        "children":[

                        ]
                    },
                    {
                        "id":2430,
                        "label":"美兰区",
                        "value":"460108",
                        "key":"460108",
                        "parent_area_key":"460100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2431,
                "label":"三亚市",
                "value":"460200",
                "key":"460200",
                "parent_area_key":"460000",
                "children":[
                    {
                        "id":2432,
                        "label":"市辖区",
                        "value":"460201",
                        "key":"460201",
                        "parent_area_key":"460200",
                        "children":[

                        ]
                    },
                    {
                        "id":2433,
                        "label":"海棠区",
                        "value":"460202",
                        "key":"460202",
                        "parent_area_key":"460200",
                        "children":[

                        ]
                    },
                    {
                        "id":2434,
                        "label":"吉阳区",
                        "value":"460203",
                        "key":"460203",
                        "parent_area_key":"460200",
                        "children":[

                        ]
                    },
                    {
                        "id":2435,
                        "label":"天涯区",
                        "value":"460204",
                        "key":"460204",
                        "parent_area_key":"460200",
                        "children":[

                        ]
                    },
                    {
                        "id":2436,
                        "label":"崖州区",
                        "value":"460205",
                        "key":"460205",
                        "parent_area_key":"460200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2437,
                "label":"三沙市",
                "value":"460300",
                "key":"460300",
                "parent_area_key":"460000",
                "children":[

                ]
            },
            {
                "id":2438,
                "label":"儋州市",
                "value":"460400",
                "key":"460400",
                "parent_area_key":"460000",
                "children":[

                ]
            },
            {
                "id":2439,
                "label":"省直辖县级行政区划",
                "value":"469000",
                "key":"469000",
                "parent_area_key":"460000",
                "children":[
                    {
                        "id":2440,
                        "label":"五指山市",
                        "value":"469001",
                        "key":"469001",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2441,
                        "label":"琼海市",
                        "value":"469002",
                        "key":"469002",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2442,
                        "label":"文昌市",
                        "value":"469005",
                        "key":"469005",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2443,
                        "label":"万宁市",
                        "value":"469006",
                        "key":"469006",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2444,
                        "label":"东方市",
                        "value":"469007",
                        "key":"469007",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2445,
                        "label":"定安县",
                        "value":"469021",
                        "key":"469021",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2446,
                        "label":"屯昌县",
                        "value":"469022",
                        "key":"469022",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2447,
                        "label":"澄迈县",
                        "value":"469023",
                        "key":"469023",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2448,
                        "label":"临高县",
                        "value":"469024",
                        "key":"469024",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2449,
                        "label":"白沙黎族自治县",
                        "value":"469025",
                        "key":"469025",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2450,
                        "label":"昌江黎族自治县",
                        "value":"469026",
                        "key":"469026",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2451,
                        "label":"乐东黎族自治县",
                        "value":"469027",
                        "key":"469027",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2452,
                        "label":"陵水黎族自治县",
                        "value":"469028",
                        "key":"469028",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2453,
                        "label":"保亭黎族苗族自治县",
                        "value":"469029",
                        "key":"469029",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    },
                    {
                        "id":2454,
                        "label":"琼中黎族苗族自治县",
                        "value":"469030",
                        "key":"469030",
                        "parent_area_key":"469000",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":2455,
        "label":"重庆市",
        "value":"500000",
        "key":"500000",
        "parent_area_key":"",
        "children":[
            {
                "id":2456,
                "label":"市辖区",
                "value":"500100",
                "key":"500100",
                "parent_area_key":"500000",
                "children":[
                    {
                        "id":2457,
                        "label":"万州区",
                        "value":"500101",
                        "key":"500101",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2458,
                        "label":"涪陵区",
                        "value":"500102",
                        "key":"500102",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2459,
                        "label":"渝中区",
                        "value":"500103",
                        "key":"500103",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2460,
                        "label":"大渡口区",
                        "value":"500104",
                        "key":"500104",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2461,
                        "label":"江北区",
                        "value":"500105",
                        "key":"500105",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2462,
                        "label":"沙坪坝区",
                        "value":"500106",
                        "key":"500106",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2463,
                        "label":"九龙坡区",
                        "value":"500107",
                        "key":"500107",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2464,
                        "label":"南岸区",
                        "value":"500108",
                        "key":"500108",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2465,
                        "label":"北碚区",
                        "value":"500109",
                        "key":"500109",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2466,
                        "label":"綦江区",
                        "value":"500110",
                        "key":"500110",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2467,
                        "label":"大足区",
                        "value":"500111",
                        "key":"500111",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2468,
                        "label":"渝北区",
                        "value":"500112",
                        "key":"500112",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2469,
                        "label":"巴南区",
                        "value":"500113",
                        "key":"500113",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2470,
                        "label":"黔江区",
                        "value":"500114",
                        "key":"500114",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2471,
                        "label":"长寿区",
                        "value":"500115",
                        "key":"500115",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2472,
                        "label":"江津区",
                        "value":"500116",
                        "key":"500116",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2473,
                        "label":"合川区",
                        "value":"500117",
                        "key":"500117",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2474,
                        "label":"永川区",
                        "value":"500118",
                        "key":"500118",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2475,
                        "label":"南川区",
                        "value":"500119",
                        "key":"500119",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2476,
                        "label":"璧山区",
                        "value":"500120",
                        "key":"500120",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2477,
                        "label":"铜梁区",
                        "value":"500151",
                        "key":"500151",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2478,
                        "label":"潼南区",
                        "value":"500152",
                        "key":"500152",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2479,
                        "label":"荣昌区",
                        "value":"500153",
                        "key":"500153",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    },
                    {
                        "id":2480,
                        "label":"开州区",
                        "value":"500154",
                        "key":"500154",
                        "parent_area_key":"500100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2481,
                "label":"县",
                "value":"500200",
                "key":"500200",
                "parent_area_key":"500000",
                "children":[
                    {
                        "id":2482,
                        "label":"梁平县",
                        "value":"500228",
                        "key":"500228",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    },
                    {
                        "id":2483,
                        "label":"城口县",
                        "value":"500229",
                        "key":"500229",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    },
                    {
                        "id":2484,
                        "label":"丰都县",
                        "value":"500230",
                        "key":"500230",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    },
                    {
                        "id":2485,
                        "label":"垫江县",
                        "value":"500231",
                        "key":"500231",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    },
                    {
                        "id":2486,
                        "label":"武隆县",
                        "value":"500232",
                        "key":"500232",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    },
                    {
                        "id":2487,
                        "label":"忠县",
                        "value":"500233",
                        "key":"500233",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    },
                    {
                        "id":2488,
                        "label":"云阳县",
                        "value":"500235",
                        "key":"500235",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    },
                    {
                        "id":2489,
                        "label":"奉节县",
                        "value":"500236",
                        "key":"500236",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    },
                    {
                        "id":2490,
                        "label":"巫山县",
                        "value":"500237",
                        "key":"500237",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    },
                    {
                        "id":2491,
                        "label":"巫溪县",
                        "value":"500238",
                        "key":"500238",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    },
                    {
                        "id":2492,
                        "label":"石柱土家族自治县",
                        "value":"500240",
                        "key":"500240",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    },
                    {
                        "id":2493,
                        "label":"秀山土家族苗族自治县",
                        "value":"500241",
                        "key":"500241",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    },
                    {
                        "id":2494,
                        "label":"酉阳土家族苗族自治县",
                        "value":"500242",
                        "key":"500242",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    },
                    {
                        "id":2495,
                        "label":"彭水苗族土家族自治县",
                        "value":"500243",
                        "key":"500243",
                        "parent_area_key":"500200",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":2496,
        "label":"四川省",
        "value":"510000",
        "key":"510000",
        "parent_area_key":"",
        "children":[
            {
                "id":2497,
                "label":"成都市",
                "value":"510100",
                "key":"510100",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2498,
                        "label":"市辖区",
                        "value":"510101",
                        "key":"510101",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2499,
                        "label":"锦江区",
                        "value":"510104",
                        "key":"510104",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2500,
                        "label":"青羊区",
                        "value":"510105",
                        "key":"510105",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2501,
                        "label":"金牛区",
                        "value":"510106",
                        "key":"510106",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2502,
                        "label":"武侯区",
                        "value":"510107",
                        "key":"510107",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2503,
                        "label":"成华区",
                        "value":"510108",
                        "key":"510108",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2504,
                        "label":"龙泉驿区",
                        "value":"510112",
                        "key":"510112",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2505,
                        "label":"青白江区",
                        "value":"510113",
                        "key":"510113",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2506,
                        "label":"新都区",
                        "value":"510114",
                        "key":"510114",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2507,
                        "label":"温江区",
                        "value":"510115",
                        "key":"510115",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2508,
                        "label":"双流区",
                        "value":"510116",
                        "key":"510116",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2509,
                        "label":"金堂县",
                        "value":"510121",
                        "key":"510121",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2510,
                        "label":"郫县",
                        "value":"510124",
                        "key":"510124",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2511,
                        "label":"大邑县",
                        "value":"510129",
                        "key":"510129",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2512,
                        "label":"蒲江县",
                        "value":"510131",
                        "key":"510131",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2513,
                        "label":"新津县",
                        "value":"510132",
                        "key":"510132",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2514,
                        "label":"都江堰市",
                        "value":"510181",
                        "key":"510181",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2515,
                        "label":"彭州市",
                        "value":"510182",
                        "key":"510182",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2516,
                        "label":"邛崃市",
                        "value":"510183",
                        "key":"510183",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2517,
                        "label":"崇州市",
                        "value":"510184",
                        "key":"510184",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    },
                    {
                        "id":2518,
                        "label":"简阳市",
                        "value":"510185",
                        "key":"510185",
                        "parent_area_key":"510100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2519,
                "label":"自贡市",
                "value":"510300",
                "key":"510300",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2520,
                        "label":"市辖区",
                        "value":"510301",
                        "key":"510301",
                        "parent_area_key":"510300",
                        "children":[

                        ]
                    },
                    {
                        "id":2521,
                        "label":"自流井区",
                        "value":"510302",
                        "key":"510302",
                        "parent_area_key":"510300",
                        "children":[

                        ]
                    },
                    {
                        "id":2522,
                        "label":"贡井区",
                        "value":"510303",
                        "key":"510303",
                        "parent_area_key":"510300",
                        "children":[

                        ]
                    },
                    {
                        "id":2523,
                        "label":"大安区",
                        "value":"510304",
                        "key":"510304",
                        "parent_area_key":"510300",
                        "children":[

                        ]
                    },
                    {
                        "id":2524,
                        "label":"沿滩区",
                        "value":"510311",
                        "key":"510311",
                        "parent_area_key":"510300",
                        "children":[

                        ]
                    },
                    {
                        "id":2525,
                        "label":"荣县",
                        "value":"510321",
                        "key":"510321",
                        "parent_area_key":"510300",
                        "children":[

                        ]
                    },
                    {
                        "id":2526,
                        "label":"富顺县",
                        "value":"510322",
                        "key":"510322",
                        "parent_area_key":"510300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2527,
                "label":"攀枝花市",
                "value":"510400",
                "key":"510400",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2528,
                        "label":"市辖区",
                        "value":"510401",
                        "key":"510401",
                        "parent_area_key":"510400",
                        "children":[

                        ]
                    },
                    {
                        "id":2529,
                        "label":"东区",
                        "value":"510402",
                        "key":"510402",
                        "parent_area_key":"510400",
                        "children":[

                        ]
                    },
                    {
                        "id":2530,
                        "label":"西区",
                        "value":"510403",
                        "key":"510403",
                        "parent_area_key":"510400",
                        "children":[

                        ]
                    },
                    {
                        "id":2531,
                        "label":"仁和区",
                        "value":"510411",
                        "key":"510411",
                        "parent_area_key":"510400",
                        "children":[

                        ]
                    },
                    {
                        "id":2532,
                        "label":"米易县",
                        "value":"510421",
                        "key":"510421",
                        "parent_area_key":"510400",
                        "children":[

                        ]
                    },
                    {
                        "id":2533,
                        "label":"盐边县",
                        "value":"510422",
                        "key":"510422",
                        "parent_area_key":"510400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2534,
                "label":"泸州市",
                "value":"510500",
                "key":"510500",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2535,
                        "label":"市辖区",
                        "value":"510501",
                        "key":"510501",
                        "parent_area_key":"510500",
                        "children":[

                        ]
                    },
                    {
                        "id":2536,
                        "label":"江阳区",
                        "value":"510502",
                        "key":"510502",
                        "parent_area_key":"510500",
                        "children":[

                        ]
                    },
                    {
                        "id":2537,
                        "label":"纳溪区",
                        "value":"510503",
                        "key":"510503",
                        "parent_area_key":"510500",
                        "children":[

                        ]
                    },
                    {
                        "id":2538,
                        "label":"龙马潭区",
                        "value":"510504",
                        "key":"510504",
                        "parent_area_key":"510500",
                        "children":[

                        ]
                    },
                    {
                        "id":2539,
                        "label":"泸县",
                        "value":"510521",
                        "key":"510521",
                        "parent_area_key":"510500",
                        "children":[

                        ]
                    },
                    {
                        "id":2540,
                        "label":"合江县",
                        "value":"510522",
                        "key":"510522",
                        "parent_area_key":"510500",
                        "children":[

                        ]
                    },
                    {
                        "id":2541,
                        "label":"叙永县",
                        "value":"510524",
                        "key":"510524",
                        "parent_area_key":"510500",
                        "children":[

                        ]
                    },
                    {
                        "id":2542,
                        "label":"古蔺县",
                        "value":"510525",
                        "key":"510525",
                        "parent_area_key":"510500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2543,
                "label":"德阳市",
                "value":"510600",
                "key":"510600",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2544,
                        "label":"市辖区",
                        "value":"510601",
                        "key":"510601",
                        "parent_area_key":"510600",
                        "children":[

                        ]
                    },
                    {
                        "id":2545,
                        "label":"旌阳区",
                        "value":"510603",
                        "key":"510603",
                        "parent_area_key":"510600",
                        "children":[

                        ]
                    },
                    {
                        "id":2546,
                        "label":"中江县",
                        "value":"510623",
                        "key":"510623",
                        "parent_area_key":"510600",
                        "children":[

                        ]
                    },
                    {
                        "id":2547,
                        "label":"罗江县",
                        "value":"510626",
                        "key":"510626",
                        "parent_area_key":"510600",
                        "children":[

                        ]
                    },
                    {
                        "id":2548,
                        "label":"广汉市",
                        "value":"510681",
                        "key":"510681",
                        "parent_area_key":"510600",
                        "children":[

                        ]
                    },
                    {
                        "id":2549,
                        "label":"什邡市",
                        "value":"510682",
                        "key":"510682",
                        "parent_area_key":"510600",
                        "children":[

                        ]
                    },
                    {
                        "id":2550,
                        "label":"绵竹市",
                        "value":"510683",
                        "key":"510683",
                        "parent_area_key":"510600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2551,
                "label":"绵阳市",
                "value":"510700",
                "key":"510700",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2552,
                        "label":"市辖区",
                        "value":"510701",
                        "key":"510701",
                        "parent_area_key":"510700",
                        "children":[

                        ]
                    },
                    {
                        "id":2553,
                        "label":"涪城区",
                        "value":"510703",
                        "key":"510703",
                        "parent_area_key":"510700",
                        "children":[

                        ]
                    },
                    {
                        "id":2554,
                        "label":"游仙区",
                        "value":"510704",
                        "key":"510704",
                        "parent_area_key":"510700",
                        "children":[

                        ]
                    },
                    {
                        "id":2555,
                        "label":"安州区",
                        "value":"510705",
                        "key":"510705",
                        "parent_area_key":"510700",
                        "children":[

                        ]
                    },
                    {
                        "id":2556,
                        "label":"三台县",
                        "value":"510722",
                        "key":"510722",
                        "parent_area_key":"510700",
                        "children":[

                        ]
                    },
                    {
                        "id":2557,
                        "label":"盐亭县",
                        "value":"510723",
                        "key":"510723",
                        "parent_area_key":"510700",
                        "children":[

                        ]
                    },
                    {
                        "id":2558,
                        "label":"梓潼县",
                        "value":"510725",
                        "key":"510725",
                        "parent_area_key":"510700",
                        "children":[

                        ]
                    },
                    {
                        "id":2559,
                        "label":"北川羌族自治县",
                        "value":"510726",
                        "key":"510726",
                        "parent_area_key":"510700",
                        "children":[

                        ]
                    },
                    {
                        "id":2560,
                        "label":"平武县",
                        "value":"510727",
                        "key":"510727",
                        "parent_area_key":"510700",
                        "children":[

                        ]
                    },
                    {
                        "id":2561,
                        "label":"江油市",
                        "value":"510781",
                        "key":"510781",
                        "parent_area_key":"510700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2562,
                "label":"广元市",
                "value":"510800",
                "key":"510800",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2563,
                        "label":"市辖区",
                        "value":"510801",
                        "key":"510801",
                        "parent_area_key":"510800",
                        "children":[

                        ]
                    },
                    {
                        "id":2564,
                        "label":"利州区",
                        "value":"510802",
                        "key":"510802",
                        "parent_area_key":"510800",
                        "children":[

                        ]
                    },
                    {
                        "id":2565,
                        "label":"昭化区",
                        "value":"510811",
                        "key":"510811",
                        "parent_area_key":"510800",
                        "children":[

                        ]
                    },
                    {
                        "id":2566,
                        "label":"朝天区",
                        "value":"510812",
                        "key":"510812",
                        "parent_area_key":"510800",
                        "children":[

                        ]
                    },
                    {
                        "id":2567,
                        "label":"旺苍县",
                        "value":"510821",
                        "key":"510821",
                        "parent_area_key":"510800",
                        "children":[

                        ]
                    },
                    {
                        "id":2568,
                        "label":"青川县",
                        "value":"510822",
                        "key":"510822",
                        "parent_area_key":"510800",
                        "children":[

                        ]
                    },
                    {
                        "id":2569,
                        "label":"剑阁县",
                        "value":"510823",
                        "key":"510823",
                        "parent_area_key":"510800",
                        "children":[

                        ]
                    },
                    {
                        "id":2570,
                        "label":"苍溪县",
                        "value":"510824",
                        "key":"510824",
                        "parent_area_key":"510800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2571,
                "label":"遂宁市",
                "value":"510900",
                "key":"510900",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2572,
                        "label":"市辖区",
                        "value":"510901",
                        "key":"510901",
                        "parent_area_key":"510900",
                        "children":[

                        ]
                    },
                    {
                        "id":2573,
                        "label":"船山区",
                        "value":"510903",
                        "key":"510903",
                        "parent_area_key":"510900",
                        "children":[

                        ]
                    },
                    {
                        "id":2574,
                        "label":"安居区",
                        "value":"510904",
                        "key":"510904",
                        "parent_area_key":"510900",
                        "children":[

                        ]
                    },
                    {
                        "id":2575,
                        "label":"蓬溪县",
                        "value":"510921",
                        "key":"510921",
                        "parent_area_key":"510900",
                        "children":[

                        ]
                    },
                    {
                        "id":2576,
                        "label":"射洪县",
                        "value":"510922",
                        "key":"510922",
                        "parent_area_key":"510900",
                        "children":[

                        ]
                    },
                    {
                        "id":2577,
                        "label":"大英县",
                        "value":"510923",
                        "key":"510923",
                        "parent_area_key":"510900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2578,
                "label":"内江市",
                "value":"511000",
                "key":"511000",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2579,
                        "label":"市辖区",
                        "value":"511001",
                        "key":"511001",
                        "parent_area_key":"511000",
                        "children":[

                        ]
                    },
                    {
                        "id":2580,
                        "label":"市中区",
                        "value":"511002",
                        "key":"511002",
                        "parent_area_key":"511000",
                        "children":[

                        ]
                    },
                    {
                        "id":2581,
                        "label":"东兴区",
                        "value":"511011",
                        "key":"511011",
                        "parent_area_key":"511000",
                        "children":[

                        ]
                    },
                    {
                        "id":2582,
                        "label":"威远县",
                        "value":"511024",
                        "key":"511024",
                        "parent_area_key":"511000",
                        "children":[

                        ]
                    },
                    {
                        "id":2583,
                        "label":"资中县",
                        "value":"511025",
                        "key":"511025",
                        "parent_area_key":"511000",
                        "children":[

                        ]
                    },
                    {
                        "id":2584,
                        "label":"隆昌县",
                        "value":"511028",
                        "key":"511028",
                        "parent_area_key":"511000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2585,
                "label":"乐山市",
                "value":"511100",
                "key":"511100",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2586,
                        "label":"市辖区",
                        "value":"511101",
                        "key":"511101",
                        "parent_area_key":"511100",
                        "children":[

                        ]
                    },
                    {
                        "id":2587,
                        "label":"市中区",
                        "value":"511102",
                        "key":"511102",
                        "parent_area_key":"511100",
                        "children":[

                        ]
                    },
                    {
                        "id":2588,
                        "label":"沙湾区",
                        "value":"511111",
                        "key":"511111",
                        "parent_area_key":"511100",
                        "children":[

                        ]
                    },
                    {
                        "id":2589,
                        "label":"五通桥区",
                        "value":"511112",
                        "key":"511112",
                        "parent_area_key":"511100",
                        "children":[

                        ]
                    },
                    {
                        "id":2590,
                        "label":"金口河区",
                        "value":"511113",
                        "key":"511113",
                        "parent_area_key":"511100",
                        "children":[

                        ]
                    },
                    {
                        "id":2591,
                        "label":"犍为县",
                        "value":"511123",
                        "key":"511123",
                        "parent_area_key":"511100",
                        "children":[

                        ]
                    },
                    {
                        "id":2592,
                        "label":"井研县",
                        "value":"511124",
                        "key":"511124",
                        "parent_area_key":"511100",
                        "children":[

                        ]
                    },
                    {
                        "id":2593,
                        "label":"夹江县",
                        "value":"511126",
                        "key":"511126",
                        "parent_area_key":"511100",
                        "children":[

                        ]
                    },
                    {
                        "id":2594,
                        "label":"沐川县",
                        "value":"511129",
                        "key":"511129",
                        "parent_area_key":"511100",
                        "children":[

                        ]
                    },
                    {
                        "id":2595,
                        "label":"峨边彝族自治县",
                        "value":"511132",
                        "key":"511132",
                        "parent_area_key":"511100",
                        "children":[

                        ]
                    },
                    {
                        "id":2596,
                        "label":"马边彝族自治县",
                        "value":"511133",
                        "key":"511133",
                        "parent_area_key":"511100",
                        "children":[

                        ]
                    },
                    {
                        "id":2597,
                        "label":"峨眉山市",
                        "value":"511181",
                        "key":"511181",
                        "parent_area_key":"511100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2598,
                "label":"南充市",
                "value":"511300",
                "key":"511300",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2599,
                        "label":"市辖区",
                        "value":"511301",
                        "key":"511301",
                        "parent_area_key":"511300",
                        "children":[

                        ]
                    },
                    {
                        "id":2600,
                        "label":"顺庆区",
                        "value":"511302",
                        "key":"511302",
                        "parent_area_key":"511300",
                        "children":[

                        ]
                    },
                    {
                        "id":2601,
                        "label":"高坪区",
                        "value":"511303",
                        "key":"511303",
                        "parent_area_key":"511300",
                        "children":[

                        ]
                    },
                    {
                        "id":2602,
                        "label":"嘉陵区",
                        "value":"511304",
                        "key":"511304",
                        "parent_area_key":"511300",
                        "children":[

                        ]
                    },
                    {
                        "id":2603,
                        "label":"南部县",
                        "value":"511321",
                        "key":"511321",
                        "parent_area_key":"511300",
                        "children":[

                        ]
                    },
                    {
                        "id":2604,
                        "label":"营山县",
                        "value":"511322",
                        "key":"511322",
                        "parent_area_key":"511300",
                        "children":[

                        ]
                    },
                    {
                        "id":2605,
                        "label":"蓬安县",
                        "value":"511323",
                        "key":"511323",
                        "parent_area_key":"511300",
                        "children":[

                        ]
                    },
                    {
                        "id":2606,
                        "label":"仪陇县",
                        "value":"511324",
                        "key":"511324",
                        "parent_area_key":"511300",
                        "children":[

                        ]
                    },
                    {
                        "id":2607,
                        "label":"西充县",
                        "value":"511325",
                        "key":"511325",
                        "parent_area_key":"511300",
                        "children":[

                        ]
                    },
                    {
                        "id":2608,
                        "label":"阆中市",
                        "value":"511381",
                        "key":"511381",
                        "parent_area_key":"511300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2609,
                "label":"眉山市",
                "value":"511400",
                "key":"511400",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2610,
                        "label":"市辖区",
                        "value":"511401",
                        "key":"511401",
                        "parent_area_key":"511400",
                        "children":[

                        ]
                    },
                    {
                        "id":2611,
                        "label":"东坡区",
                        "value":"511402",
                        "key":"511402",
                        "parent_area_key":"511400",
                        "children":[

                        ]
                    },
                    {
                        "id":2612,
                        "label":"彭山区",
                        "value":"511403",
                        "key":"511403",
                        "parent_area_key":"511400",
                        "children":[

                        ]
                    },
                    {
                        "id":2613,
                        "label":"仁寿县",
                        "value":"511421",
                        "key":"511421",
                        "parent_area_key":"511400",
                        "children":[

                        ]
                    },
                    {
                        "id":2614,
                        "label":"洪雅县",
                        "value":"511423",
                        "key":"511423",
                        "parent_area_key":"511400",
                        "children":[

                        ]
                    },
                    {
                        "id":2615,
                        "label":"丹棱县",
                        "value":"511424",
                        "key":"511424",
                        "parent_area_key":"511400",
                        "children":[

                        ]
                    },
                    {
                        "id":2616,
                        "label":"青神县",
                        "value":"511425",
                        "key":"511425",
                        "parent_area_key":"511400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2617,
                "label":"宜宾市",
                "value":"511500",
                "key":"511500",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2618,
                        "label":"市辖区",
                        "value":"511501",
                        "key":"511501",
                        "parent_area_key":"511500",
                        "children":[

                        ]
                    },
                    {
                        "id":2619,
                        "label":"翠屏区",
                        "value":"511502",
                        "key":"511502",
                        "parent_area_key":"511500",
                        "children":[

                        ]
                    },
                    {
                        "id":2620,
                        "label":"南溪区",
                        "value":"511503",
                        "key":"511503",
                        "parent_area_key":"511500",
                        "children":[

                        ]
                    },
                    {
                        "id":2621,
                        "label":"宜宾县",
                        "value":"511521",
                        "key":"511521",
                        "parent_area_key":"511500",
                        "children":[

                        ]
                    },
                    {
                        "id":2622,
                        "label":"江安县",
                        "value":"511523",
                        "key":"511523",
                        "parent_area_key":"511500",
                        "children":[

                        ]
                    },
                    {
                        "id":2623,
                        "label":"长宁县",
                        "value":"511524",
                        "key":"511524",
                        "parent_area_key":"511500",
                        "children":[

                        ]
                    },
                    {
                        "id":2624,
                        "label":"高县",
                        "value":"511525",
                        "key":"511525",
                        "parent_area_key":"511500",
                        "children":[

                        ]
                    },
                    {
                        "id":2625,
                        "label":"珙县",
                        "value":"511526",
                        "key":"511526",
                        "parent_area_key":"511500",
                        "children":[

                        ]
                    },
                    {
                        "id":2626,
                        "label":"筠连县",
                        "value":"511527",
                        "key":"511527",
                        "parent_area_key":"511500",
                        "children":[

                        ]
                    },
                    {
                        "id":2627,
                        "label":"兴文县",
                        "value":"511528",
                        "key":"511528",
                        "parent_area_key":"511500",
                        "children":[

                        ]
                    },
                    {
                        "id":2628,
                        "label":"屏山县",
                        "value":"511529",
                        "key":"511529",
                        "parent_area_key":"511500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2629,
                "label":"广安市",
                "value":"511600",
                "key":"511600",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2630,
                        "label":"市辖区",
                        "value":"511601",
                        "key":"511601",
                        "parent_area_key":"511600",
                        "children":[

                        ]
                    },
                    {
                        "id":2631,
                        "label":"广安区",
                        "value":"511602",
                        "key":"511602",
                        "parent_area_key":"511600",
                        "children":[

                        ]
                    },
                    {
                        "id":2632,
                        "label":"前锋区",
                        "value":"511603",
                        "key":"511603",
                        "parent_area_key":"511600",
                        "children":[

                        ]
                    },
                    {
                        "id":2633,
                        "label":"岳池县",
                        "value":"511621",
                        "key":"511621",
                        "parent_area_key":"511600",
                        "children":[

                        ]
                    },
                    {
                        "id":2634,
                        "label":"武胜县",
                        "value":"511622",
                        "key":"511622",
                        "parent_area_key":"511600",
                        "children":[

                        ]
                    },
                    {
                        "id":2635,
                        "label":"邻水县",
                        "value":"511623",
                        "key":"511623",
                        "parent_area_key":"511600",
                        "children":[

                        ]
                    },
                    {
                        "id":2636,
                        "label":"华蓥市",
                        "value":"511681",
                        "key":"511681",
                        "parent_area_key":"511600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2637,
                "label":"达州市",
                "value":"511700",
                "key":"511700",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2638,
                        "label":"市辖区",
                        "value":"511701",
                        "key":"511701",
                        "parent_area_key":"511700",
                        "children":[

                        ]
                    },
                    {
                        "id":2639,
                        "label":"通川区",
                        "value":"511702",
                        "key":"511702",
                        "parent_area_key":"511700",
                        "children":[

                        ]
                    },
                    {
                        "id":2640,
                        "label":"达川区",
                        "value":"511703",
                        "key":"511703",
                        "parent_area_key":"511700",
                        "children":[

                        ]
                    },
                    {
                        "id":2641,
                        "label":"宣汉县",
                        "value":"511722",
                        "key":"511722",
                        "parent_area_key":"511700",
                        "children":[

                        ]
                    },
                    {
                        "id":2642,
                        "label":"开江县",
                        "value":"511723",
                        "key":"511723",
                        "parent_area_key":"511700",
                        "children":[

                        ]
                    },
                    {
                        "id":2643,
                        "label":"大竹县",
                        "value":"511724",
                        "key":"511724",
                        "parent_area_key":"511700",
                        "children":[

                        ]
                    },
                    {
                        "id":2644,
                        "label":"渠县",
                        "value":"511725",
                        "key":"511725",
                        "parent_area_key":"511700",
                        "children":[

                        ]
                    },
                    {
                        "id":2645,
                        "label":"万源市",
                        "value":"511781",
                        "key":"511781",
                        "parent_area_key":"511700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2646,
                "label":"雅安市",
                "value":"511800",
                "key":"511800",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2647,
                        "label":"市辖区",
                        "value":"511801",
                        "key":"511801",
                        "parent_area_key":"511800",
                        "children":[

                        ]
                    },
                    {
                        "id":2648,
                        "label":"雨城区",
                        "value":"511802",
                        "key":"511802",
                        "parent_area_key":"511800",
                        "children":[

                        ]
                    },
                    {
                        "id":2649,
                        "label":"名山区",
                        "value":"511803",
                        "key":"511803",
                        "parent_area_key":"511800",
                        "children":[

                        ]
                    },
                    {
                        "id":2650,
                        "label":"荥经县",
                        "value":"511822",
                        "key":"511822",
                        "parent_area_key":"511800",
                        "children":[

                        ]
                    },
                    {
                        "id":2651,
                        "label":"汉源县",
                        "value":"511823",
                        "key":"511823",
                        "parent_area_key":"511800",
                        "children":[

                        ]
                    },
                    {
                        "id":2652,
                        "label":"石棉县",
                        "value":"511824",
                        "key":"511824",
                        "parent_area_key":"511800",
                        "children":[

                        ]
                    },
                    {
                        "id":2653,
                        "label":"天全县",
                        "value":"511825",
                        "key":"511825",
                        "parent_area_key":"511800",
                        "children":[

                        ]
                    },
                    {
                        "id":2654,
                        "label":"芦山县",
                        "value":"511826",
                        "key":"511826",
                        "parent_area_key":"511800",
                        "children":[

                        ]
                    },
                    {
                        "id":2655,
                        "label":"宝兴县",
                        "value":"511827",
                        "key":"511827",
                        "parent_area_key":"511800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2656,
                "label":"巴中市",
                "value":"511900",
                "key":"511900",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2657,
                        "label":"市辖区",
                        "value":"511901",
                        "key":"511901",
                        "parent_area_key":"511900",
                        "children":[

                        ]
                    },
                    {
                        "id":2658,
                        "label":"巴州区",
                        "value":"511902",
                        "key":"511902",
                        "parent_area_key":"511900",
                        "children":[

                        ]
                    },
                    {
                        "id":2659,
                        "label":"恩阳区",
                        "value":"511903",
                        "key":"511903",
                        "parent_area_key":"511900",
                        "children":[

                        ]
                    },
                    {
                        "id":2660,
                        "label":"通江县",
                        "value":"511921",
                        "key":"511921",
                        "parent_area_key":"511900",
                        "children":[

                        ]
                    },
                    {
                        "id":2661,
                        "label":"南江县",
                        "value":"511922",
                        "key":"511922",
                        "parent_area_key":"511900",
                        "children":[

                        ]
                    },
                    {
                        "id":2662,
                        "label":"平昌县",
                        "value":"511923",
                        "key":"511923",
                        "parent_area_key":"511900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2663,
                "label":"资阳市",
                "value":"512000",
                "key":"512000",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2664,
                        "label":"市辖区",
                        "value":"512001",
                        "key":"512001",
                        "parent_area_key":"512000",
                        "children":[

                        ]
                    },
                    {
                        "id":2665,
                        "label":"雁江区",
                        "value":"512002",
                        "key":"512002",
                        "parent_area_key":"512000",
                        "children":[

                        ]
                    },
                    {
                        "id":2666,
                        "label":"安岳县",
                        "value":"512021",
                        "key":"512021",
                        "parent_area_key":"512000",
                        "children":[

                        ]
                    },
                    {
                        "id":2667,
                        "label":"乐至县",
                        "value":"512022",
                        "key":"512022",
                        "parent_area_key":"512000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2668,
                "label":"阿坝藏族羌族自治州",
                "value":"513200",
                "key":"513200",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2669,
                        "label":"马尔康市",
                        "value":"513201",
                        "key":"513201",
                        "parent_area_key":"513200",
                        "children":[

                        ]
                    },
                    {
                        "id":2670,
                        "label":"汶川县",
                        "value":"513221",
                        "key":"513221",
                        "parent_area_key":"513200",
                        "children":[

                        ]
                    },
                    {
                        "id":2671,
                        "label":"理县",
                        "value":"513222",
                        "key":"513222",
                        "parent_area_key":"513200",
                        "children":[

                        ]
                    },
                    {
                        "id":2672,
                        "label":"茂县",
                        "value":"513223",
                        "key":"513223",
                        "parent_area_key":"513200",
                        "children":[

                        ]
                    },
                    {
                        "id":2673,
                        "label":"松潘县",
                        "value":"513224",
                        "key":"513224",
                        "parent_area_key":"513200",
                        "children":[

                        ]
                    },
                    {
                        "id":2674,
                        "label":"九寨沟县",
                        "value":"513225",
                        "key":"513225",
                        "parent_area_key":"513200",
                        "children":[

                        ]
                    },
                    {
                        "id":2675,
                        "label":"金川县",
                        "value":"513226",
                        "key":"513226",
                        "parent_area_key":"513200",
                        "children":[

                        ]
                    },
                    {
                        "id":2676,
                        "label":"小金县",
                        "value":"513227",
                        "key":"513227",
                        "parent_area_key":"513200",
                        "children":[

                        ]
                    },
                    {
                        "id":2677,
                        "label":"黑水县",
                        "value":"513228",
                        "key":"513228",
                        "parent_area_key":"513200",
                        "children":[

                        ]
                    },
                    {
                        "id":2678,
                        "label":"壤塘县",
                        "value":"513230",
                        "key":"513230",
                        "parent_area_key":"513200",
                        "children":[

                        ]
                    },
                    {
                        "id":2679,
                        "label":"阿坝县",
                        "value":"513231",
                        "key":"513231",
                        "parent_area_key":"513200",
                        "children":[

                        ]
                    },
                    {
                        "id":2680,
                        "label":"若尔盖县",
                        "value":"513232",
                        "key":"513232",
                        "parent_area_key":"513200",
                        "children":[

                        ]
                    },
                    {
                        "id":2681,
                        "label":"红原县",
                        "value":"513233",
                        "key":"513233",
                        "parent_area_key":"513200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2682,
                "label":"甘孜藏族自治州",
                "value":"513300",
                "key":"513300",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2683,
                        "label":"康定市",
                        "value":"513301",
                        "key":"513301",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2684,
                        "label":"泸定县",
                        "value":"513322",
                        "key":"513322",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2685,
                        "label":"丹巴县",
                        "value":"513323",
                        "key":"513323",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2686,
                        "label":"九龙县",
                        "value":"513324",
                        "key":"513324",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2687,
                        "label":"雅江县",
                        "value":"513325",
                        "key":"513325",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2688,
                        "label":"道孚县",
                        "value":"513326",
                        "key":"513326",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2689,
                        "label":"炉霍县",
                        "value":"513327",
                        "key":"513327",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2690,
                        "label":"甘孜县",
                        "value":"513328",
                        "key":"513328",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2691,
                        "label":"新龙县",
                        "value":"513329",
                        "key":"513329",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2692,
                        "label":"德格县",
                        "value":"513330",
                        "key":"513330",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2693,
                        "label":"白玉县",
                        "value":"513331",
                        "key":"513331",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2694,
                        "label":"石渠县",
                        "value":"513332",
                        "key":"513332",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2695,
                        "label":"色达县",
                        "value":"513333",
                        "key":"513333",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2696,
                        "label":"理塘县",
                        "value":"513334",
                        "key":"513334",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2697,
                        "label":"巴塘县",
                        "value":"513335",
                        "key":"513335",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2698,
                        "label":"乡城县",
                        "value":"513336",
                        "key":"513336",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2699,
                        "label":"稻城县",
                        "value":"513337",
                        "key":"513337",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    },
                    {
                        "id":2700,
                        "label":"得荣县",
                        "value":"513338",
                        "key":"513338",
                        "parent_area_key":"513300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2701,
                "label":"凉山彝族自治州",
                "value":"513400",
                "key":"513400",
                "parent_area_key":"510000",
                "children":[
                    {
                        "id":2702,
                        "label":"西昌市",
                        "value":"513401",
                        "key":"513401",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2703,
                        "label":"木里藏族自治县",
                        "value":"513422",
                        "key":"513422",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2704,
                        "label":"盐源县",
                        "value":"513423",
                        "key":"513423",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2705,
                        "label":"德昌县",
                        "value":"513424",
                        "key":"513424",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2706,
                        "label":"会理县",
                        "value":"513425",
                        "key":"513425",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2707,
                        "label":"会东县",
                        "value":"513426",
                        "key":"513426",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2708,
                        "label":"宁南县",
                        "value":"513427",
                        "key":"513427",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2709,
                        "label":"普格县",
                        "value":"513428",
                        "key":"513428",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2710,
                        "label":"布拖县",
                        "value":"513429",
                        "key":"513429",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2711,
                        "label":"金阳县",
                        "value":"513430",
                        "key":"513430",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2712,
                        "label":"昭觉县",
                        "value":"513431",
                        "key":"513431",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2713,
                        "label":"喜德县",
                        "value":"513432",
                        "key":"513432",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2714,
                        "label":"冕宁县",
                        "value":"513433",
                        "key":"513433",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2715,
                        "label":"越西县",
                        "value":"513434",
                        "key":"513434",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2716,
                        "label":"甘洛县",
                        "value":"513435",
                        "key":"513435",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2717,
                        "label":"美姑县",
                        "value":"513436",
                        "key":"513436",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    },
                    {
                        "id":2718,
                        "label":"雷波县",
                        "value":"513437",
                        "key":"513437",
                        "parent_area_key":"513400",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":2719,
        "label":"贵州省",
        "value":"520000",
        "key":"520000",
        "parent_area_key":"",
        "children":[
            {
                "id":2720,
                "label":"贵阳市",
                "value":"520100",
                "key":"520100",
                "parent_area_key":"520000",
                "children":[
                    {
                        "id":2721,
                        "label":"市辖区",
                        "value":"520101",
                        "key":"520101",
                        "parent_area_key":"520100",
                        "children":[

                        ]
                    },
                    {
                        "id":2722,
                        "label":"南明区",
                        "value":"520102",
                        "key":"520102",
                        "parent_area_key":"520100",
                        "children":[

                        ]
                    },
                    {
                        "id":2723,
                        "label":"云岩区",
                        "value":"520103",
                        "key":"520103",
                        "parent_area_key":"520100",
                        "children":[

                        ]
                    },
                    {
                        "id":2724,
                        "label":"花溪区",
                        "value":"520111",
                        "key":"520111",
                        "parent_area_key":"520100",
                        "children":[

                        ]
                    },
                    {
                        "id":2725,
                        "label":"乌当区",
                        "value":"520112",
                        "key":"520112",
                        "parent_area_key":"520100",
                        "children":[

                        ]
                    },
                    {
                        "id":2726,
                        "label":"白云区",
                        "value":"520113",
                        "key":"520113",
                        "parent_area_key":"520100",
                        "children":[

                        ]
                    },
                    {
                        "id":2727,
                        "label":"观山湖区",
                        "value":"520115",
                        "key":"520115",
                        "parent_area_key":"520100",
                        "children":[

                        ]
                    },
                    {
                        "id":2728,
                        "label":"开阳县",
                        "value":"520121",
                        "key":"520121",
                        "parent_area_key":"520100",
                        "children":[

                        ]
                    },
                    {
                        "id":2729,
                        "label":"息烽县",
                        "value":"520122",
                        "key":"520122",
                        "parent_area_key":"520100",
                        "children":[

                        ]
                    },
                    {
                        "id":2730,
                        "label":"修文县",
                        "value":"520123",
                        "key":"520123",
                        "parent_area_key":"520100",
                        "children":[

                        ]
                    },
                    {
                        "id":2731,
                        "label":"清镇市",
                        "value":"520181",
                        "key":"520181",
                        "parent_area_key":"520100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2732,
                "label":"六盘水市",
                "value":"520200",
                "key":"520200",
                "parent_area_key":"520000",
                "children":[
                    {
                        "id":2733,
                        "label":"钟山区",
                        "value":"520201",
                        "key":"520201",
                        "parent_area_key":"520200",
                        "children":[

                        ]
                    },
                    {
                        "id":2734,
                        "label":"六枝特区",
                        "value":"520203",
                        "key":"520203",
                        "parent_area_key":"520200",
                        "children":[

                        ]
                    },
                    {
                        "id":2735,
                        "label":"水城县",
                        "value":"520221",
                        "key":"520221",
                        "parent_area_key":"520200",
                        "children":[

                        ]
                    },
                    {
                        "id":2736,
                        "label":"盘县",
                        "value":"520222",
                        "key":"520222",
                        "parent_area_key":"520200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2737,
                "label":"遵义市",
                "value":"520300",
                "key":"520300",
                "parent_area_key":"520000",
                "children":[
                    {
                        "id":2738,
                        "label":"市辖区",
                        "value":"520301",
                        "key":"520301",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2739,
                        "label":"红花岗区",
                        "value":"520302",
                        "key":"520302",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2740,
                        "label":"汇川区",
                        "value":"520303",
                        "key":"520303",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2741,
                        "label":"播州区",
                        "value":"520304",
                        "key":"520304",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2742,
                        "label":"桐梓县",
                        "value":"520322",
                        "key":"520322",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2743,
                        "label":"绥阳县",
                        "value":"520323",
                        "key":"520323",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2744,
                        "label":"正安县",
                        "value":"520324",
                        "key":"520324",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2745,
                        "label":"道真仡佬族苗族自治县",
                        "value":"520325",
                        "key":"520325",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2746,
                        "label":"务川仡佬族苗族自治县",
                        "value":"520326",
                        "key":"520326",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2747,
                        "label":"凤冈县",
                        "value":"520327",
                        "key":"520327",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2748,
                        "label":"湄潭县",
                        "value":"520328",
                        "key":"520328",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2749,
                        "label":"余庆县",
                        "value":"520329",
                        "key":"520329",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2750,
                        "label":"习水县",
                        "value":"520330",
                        "key":"520330",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2751,
                        "label":"赤水市",
                        "value":"520381",
                        "key":"520381",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    },
                    {
                        "id":2752,
                        "label":"仁怀市",
                        "value":"520382",
                        "key":"520382",
                        "parent_area_key":"520300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2753,
                "label":"安顺市",
                "value":"520400",
                "key":"520400",
                "parent_area_key":"520000",
                "children":[
                    {
                        "id":2754,
                        "label":"市辖区",
                        "value":"520401",
                        "key":"520401",
                        "parent_area_key":"520400",
                        "children":[

                        ]
                    },
                    {
                        "id":2755,
                        "label":"西秀区",
                        "value":"520402",
                        "key":"520402",
                        "parent_area_key":"520400",
                        "children":[

                        ]
                    },
                    {
                        "id":2756,
                        "label":"平坝区",
                        "value":"520403",
                        "key":"520403",
                        "parent_area_key":"520400",
                        "children":[

                        ]
                    },
                    {
                        "id":2757,
                        "label":"普定县",
                        "value":"520422",
                        "key":"520422",
                        "parent_area_key":"520400",
                        "children":[

                        ]
                    },
                    {
                        "id":2758,
                        "label":"镇宁布依族苗族自治县",
                        "value":"520423",
                        "key":"520423",
                        "parent_area_key":"520400",
                        "children":[

                        ]
                    },
                    {
                        "id":2759,
                        "label":"关岭布依族苗族自治县",
                        "value":"520424",
                        "key":"520424",
                        "parent_area_key":"520400",
                        "children":[

                        ]
                    },
                    {
                        "id":2760,
                        "label":"紫云苗族布依族自治县",
                        "value":"520425",
                        "key":"520425",
                        "parent_area_key":"520400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2761,
                "label":"毕节市",
                "value":"520500",
                "key":"520500",
                "parent_area_key":"520000",
                "children":[
                    {
                        "id":2762,
                        "label":"市辖区",
                        "value":"520501",
                        "key":"520501",
                        "parent_area_key":"520500",
                        "children":[

                        ]
                    },
                    {
                        "id":2763,
                        "label":"七星关区",
                        "value":"520502",
                        "key":"520502",
                        "parent_area_key":"520500",
                        "children":[

                        ]
                    },
                    {
                        "id":2764,
                        "label":"大方县",
                        "value":"520521",
                        "key":"520521",
                        "parent_area_key":"520500",
                        "children":[

                        ]
                    },
                    {
                        "id":2765,
                        "label":"黔西县",
                        "value":"520522",
                        "key":"520522",
                        "parent_area_key":"520500",
                        "children":[

                        ]
                    },
                    {
                        "id":2766,
                        "label":"金沙县",
                        "value":"520523",
                        "key":"520523",
                        "parent_area_key":"520500",
                        "children":[

                        ]
                    },
                    {
                        "id":2767,
                        "label":"织金县",
                        "value":"520524",
                        "key":"520524",
                        "parent_area_key":"520500",
                        "children":[

                        ]
                    },
                    {
                        "id":2768,
                        "label":"纳雍县",
                        "value":"520525",
                        "key":"520525",
                        "parent_area_key":"520500",
                        "children":[

                        ]
                    },
                    {
                        "id":2769,
                        "label":"威宁彝族回族苗族自治县",
                        "value":"520526",
                        "key":"520526",
                        "parent_area_key":"520500",
                        "children":[

                        ]
                    },
                    {
                        "id":2770,
                        "label":"赫章县",
                        "value":"520527",
                        "key":"520527",
                        "parent_area_key":"520500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2771,
                "label":"铜仁市",
                "value":"520600",
                "key":"520600",
                "parent_area_key":"520000",
                "children":[
                    {
                        "id":2772,
                        "label":"市辖区",
                        "value":"520601",
                        "key":"520601",
                        "parent_area_key":"520600",
                        "children":[

                        ]
                    },
                    {
                        "id":2773,
                        "label":"碧江区",
                        "value":"520602",
                        "key":"520602",
                        "parent_area_key":"520600",
                        "children":[

                        ]
                    },
                    {
                        "id":2774,
                        "label":"万山区",
                        "value":"520603",
                        "key":"520603",
                        "parent_area_key":"520600",
                        "children":[

                        ]
                    },
                    {
                        "id":2775,
                        "label":"江口县",
                        "value":"520621",
                        "key":"520621",
                        "parent_area_key":"520600",
                        "children":[

                        ]
                    },
                    {
                        "id":2776,
                        "label":"玉屏侗族自治县",
                        "value":"520622",
                        "key":"520622",
                        "parent_area_key":"520600",
                        "children":[

                        ]
                    },
                    {
                        "id":2777,
                        "label":"石阡县",
                        "value":"520623",
                        "key":"520623",
                        "parent_area_key":"520600",
                        "children":[

                        ]
                    },
                    {
                        "id":2778,
                        "label":"思南县",
                        "value":"520624",
                        "key":"520624",
                        "parent_area_key":"520600",
                        "children":[

                        ]
                    },
                    {
                        "id":2779,
                        "label":"印江土家族苗族自治县",
                        "value":"520625",
                        "key":"520625",
                        "parent_area_key":"520600",
                        "children":[

                        ]
                    },
                    {
                        "id":2780,
                        "label":"德江县",
                        "value":"520626",
                        "key":"520626",
                        "parent_area_key":"520600",
                        "children":[

                        ]
                    },
                    {
                        "id":2781,
                        "label":"沿河土家族自治县",
                        "value":"520627",
                        "key":"520627",
                        "parent_area_key":"520600",
                        "children":[

                        ]
                    },
                    {
                        "id":2782,
                        "label":"松桃苗族自治县",
                        "value":"520628",
                        "key":"520628",
                        "parent_area_key":"520600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2783,
                "label":"黔西南布依族苗族自治州",
                "value":"522300",
                "key":"522300",
                "parent_area_key":"520000",
                "children":[
                    {
                        "id":2784,
                        "label":"兴义市",
                        "value":"522301",
                        "key":"522301",
                        "parent_area_key":"522300",
                        "children":[

                        ]
                    },
                    {
                        "id":2785,
                        "label":"兴仁县",
                        "value":"522322",
                        "key":"522322",
                        "parent_area_key":"522300",
                        "children":[

                        ]
                    },
                    {
                        "id":2786,
                        "label":"普安县",
                        "value":"522323",
                        "key":"522323",
                        "parent_area_key":"522300",
                        "children":[

                        ]
                    },
                    {
                        "id":2787,
                        "label":"晴隆县",
                        "value":"522324",
                        "key":"522324",
                        "parent_area_key":"522300",
                        "children":[

                        ]
                    },
                    {
                        "id":2788,
                        "label":"贞丰县",
                        "value":"522325",
                        "key":"522325",
                        "parent_area_key":"522300",
                        "children":[

                        ]
                    },
                    {
                        "id":2789,
                        "label":"望谟县",
                        "value":"522326",
                        "key":"522326",
                        "parent_area_key":"522300",
                        "children":[

                        ]
                    },
                    {
                        "id":2790,
                        "label":"册亨县",
                        "value":"522327",
                        "key":"522327",
                        "parent_area_key":"522300",
                        "children":[

                        ]
                    },
                    {
                        "id":2791,
                        "label":"安龙县",
                        "value":"522328",
                        "key":"522328",
                        "parent_area_key":"522300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2792,
                "label":"黔东南苗族侗族自治州",
                "value":"522600",
                "key":"522600",
                "parent_area_key":"520000",
                "children":[
                    {
                        "id":2793,
                        "label":"凯里市",
                        "value":"522601",
                        "key":"522601",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2794,
                        "label":"黄平县",
                        "value":"522622",
                        "key":"522622",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2795,
                        "label":"施秉县",
                        "value":"522623",
                        "key":"522623",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2796,
                        "label":"三穗县",
                        "value":"522624",
                        "key":"522624",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2797,
                        "label":"镇远县",
                        "value":"522625",
                        "key":"522625",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2798,
                        "label":"岑巩县",
                        "value":"522626",
                        "key":"522626",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2799,
                        "label":"天柱县",
                        "value":"522627",
                        "key":"522627",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2800,
                        "label":"锦屏县",
                        "value":"522628",
                        "key":"522628",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2801,
                        "label":"剑河县",
                        "value":"522629",
                        "key":"522629",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2802,
                        "label":"台江县",
                        "value":"522630",
                        "key":"522630",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2803,
                        "label":"黎平县",
                        "value":"522631",
                        "key":"522631",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2804,
                        "label":"榕江县",
                        "value":"522632",
                        "key":"522632",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2805,
                        "label":"从江县",
                        "value":"522633",
                        "key":"522633",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2806,
                        "label":"雷山县",
                        "value":"522634",
                        "key":"522634",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2807,
                        "label":"麻江县",
                        "value":"522635",
                        "key":"522635",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    },
                    {
                        "id":2808,
                        "label":"丹寨县",
                        "value":"522636",
                        "key":"522636",
                        "parent_area_key":"522600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2809,
                "label":"黔南布依族苗族自治州",
                "value":"522700",
                "key":"522700",
                "parent_area_key":"520000",
                "children":[
                    {
                        "id":2810,
                        "label":"都匀市",
                        "value":"522701",
                        "key":"522701",
                        "parent_area_key":"522700",
                        "children":[

                        ]
                    },
                    {
                        "id":2811,
                        "label":"福泉市",
                        "value":"522702",
                        "key":"522702",
                        "parent_area_key":"522700",
                        "children":[

                        ]
                    },
                    {
                        "id":2812,
                        "label":"荔波县",
                        "value":"522722",
                        "key":"522722",
                        "parent_area_key":"522700",
                        "children":[

                        ]
                    },
                    {
                        "id":2813,
                        "label":"贵定县",
                        "value":"522723",
                        "key":"522723",
                        "parent_area_key":"522700",
                        "children":[

                        ]
                    },
                    {
                        "id":2814,
                        "label":"瓮安县",
                        "value":"522725",
                        "key":"522725",
                        "parent_area_key":"522700",
                        "children":[

                        ]
                    },
                    {
                        "id":2815,
                        "label":"独山县",
                        "value":"522726",
                        "key":"522726",
                        "parent_area_key":"522700",
                        "children":[

                        ]
                    },
                    {
                        "id":2816,
                        "label":"平塘县",
                        "value":"522727",
                        "key":"522727",
                        "parent_area_key":"522700",
                        "children":[

                        ]
                    },
                    {
                        "id":2817,
                        "label":"罗甸县",
                        "value":"522728",
                        "key":"522728",
                        "parent_area_key":"522700",
                        "children":[

                        ]
                    },
                    {
                        "id":2818,
                        "label":"长顺县",
                        "value":"522729",
                        "key":"522729",
                        "parent_area_key":"522700",
                        "children":[

                        ]
                    },
                    {
                        "id":2819,
                        "label":"龙里县",
                        "value":"522730",
                        "key":"522730",
                        "parent_area_key":"522700",
                        "children":[

                        ]
                    },
                    {
                        "id":2820,
                        "label":"惠水县",
                        "value":"522731",
                        "key":"522731",
                        "parent_area_key":"522700",
                        "children":[

                        ]
                    },
                    {
                        "id":2821,
                        "label":"三都水族自治县",
                        "value":"522732",
                        "key":"522732",
                        "parent_area_key":"522700",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":2822,
        "label":"云南省",
        "value":"530000",
        "key":"530000",
        "parent_area_key":"",
        "children":[
            {
                "id":2823,
                "label":"昆明市",
                "value":"530100",
                "key":"530100",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2824,
                        "label":"市辖区",
                        "value":"530101",
                        "key":"530101",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2825,
                        "label":"五华区",
                        "value":"530102",
                        "key":"530102",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2826,
                        "label":"盘龙区",
                        "value":"530103",
                        "key":"530103",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2827,
                        "label":"官渡区",
                        "value":"530111",
                        "key":"530111",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2828,
                        "label":"西山区",
                        "value":"530112",
                        "key":"530112",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2829,
                        "label":"东川区",
                        "value":"530113",
                        "key":"530113",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2830,
                        "label":"呈贡区",
                        "value":"530114",
                        "key":"530114",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2831,
                        "label":"晋宁县",
                        "value":"530122",
                        "key":"530122",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2832,
                        "label":"富民县",
                        "value":"530124",
                        "key":"530124",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2833,
                        "label":"宜良县",
                        "value":"530125",
                        "key":"530125",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2834,
                        "label":"石林彝族自治县",
                        "value":"530126",
                        "key":"530126",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2835,
                        "label":"嵩明县",
                        "value":"530127",
                        "key":"530127",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2836,
                        "label":"禄劝彝族苗族自治县",
                        "value":"530128",
                        "key":"530128",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2837,
                        "label":"寻甸回族彝族自治县",
                        "value":"530129",
                        "key":"530129",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    },
                    {
                        "id":2838,
                        "label":"安宁市",
                        "value":"530181",
                        "key":"530181",
                        "parent_area_key":"530100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2839,
                "label":"曲靖市",
                "value":"530300",
                "key":"530300",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2840,
                        "label":"市辖区",
                        "value":"530301",
                        "key":"530301",
                        "parent_area_key":"530300",
                        "children":[

                        ]
                    },
                    {
                        "id":2841,
                        "label":"麒麟区",
                        "value":"530302",
                        "key":"530302",
                        "parent_area_key":"530300",
                        "children":[

                        ]
                    },
                    {
                        "id":2842,
                        "label":"沾益区",
                        "value":"530303",
                        "key":"530303",
                        "parent_area_key":"530300",
                        "children":[

                        ]
                    },
                    {
                        "id":2843,
                        "label":"马龙县",
                        "value":"530321",
                        "key":"530321",
                        "parent_area_key":"530300",
                        "children":[

                        ]
                    },
                    {
                        "id":2844,
                        "label":"陆良县",
                        "value":"530322",
                        "key":"530322",
                        "parent_area_key":"530300",
                        "children":[

                        ]
                    },
                    {
                        "id":2845,
                        "label":"师宗县",
                        "value":"530323",
                        "key":"530323",
                        "parent_area_key":"530300",
                        "children":[

                        ]
                    },
                    {
                        "id":2846,
                        "label":"罗平县",
                        "value":"530324",
                        "key":"530324",
                        "parent_area_key":"530300",
                        "children":[

                        ]
                    },
                    {
                        "id":2847,
                        "label":"富源县",
                        "value":"530325",
                        "key":"530325",
                        "parent_area_key":"530300",
                        "children":[

                        ]
                    },
                    {
                        "id":2848,
                        "label":"会泽县",
                        "value":"530326",
                        "key":"530326",
                        "parent_area_key":"530300",
                        "children":[

                        ]
                    },
                    {
                        "id":2849,
                        "label":"宣威市",
                        "value":"530381",
                        "key":"530381",
                        "parent_area_key":"530300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2850,
                "label":"玉溪市",
                "value":"530400",
                "key":"530400",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2851,
                        "label":"市辖区",
                        "value":"530401",
                        "key":"530401",
                        "parent_area_key":"530400",
                        "children":[

                        ]
                    },
                    {
                        "id":2852,
                        "label":"红塔区",
                        "value":"530402",
                        "key":"530402",
                        "parent_area_key":"530400",
                        "children":[

                        ]
                    },
                    {
                        "id":2853,
                        "label":"江川区",
                        "value":"530403",
                        "key":"530403",
                        "parent_area_key":"530400",
                        "children":[

                        ]
                    },
                    {
                        "id":2854,
                        "label":"澄江县",
                        "value":"530422",
                        "key":"530422",
                        "parent_area_key":"530400",
                        "children":[

                        ]
                    },
                    {
                        "id":2855,
                        "label":"通海县",
                        "value":"530423",
                        "key":"530423",
                        "parent_area_key":"530400",
                        "children":[

                        ]
                    },
                    {
                        "id":2856,
                        "label":"华宁县",
                        "value":"530424",
                        "key":"530424",
                        "parent_area_key":"530400",
                        "children":[

                        ]
                    },
                    {
                        "id":2857,
                        "label":"易门县",
                        "value":"530425",
                        "key":"530425",
                        "parent_area_key":"530400",
                        "children":[

                        ]
                    },
                    {
                        "id":2858,
                        "label":"峨山彝族自治县",
                        "value":"530426",
                        "key":"530426",
                        "parent_area_key":"530400",
                        "children":[

                        ]
                    },
                    {
                        "id":2859,
                        "label":"新平彝族傣族自治县",
                        "value":"530427",
                        "key":"530427",
                        "parent_area_key":"530400",
                        "children":[

                        ]
                    },
                    {
                        "id":2860,
                        "label":"元江哈尼族彝族傣族自治县",
                        "value":"530428",
                        "key":"530428",
                        "parent_area_key":"530400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2861,
                "label":"保山市",
                "value":"530500",
                "key":"530500",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2862,
                        "label":"市辖区",
                        "value":"530501",
                        "key":"530501",
                        "parent_area_key":"530500",
                        "children":[

                        ]
                    },
                    {
                        "id":2863,
                        "label":"隆阳区",
                        "value":"530502",
                        "key":"530502",
                        "parent_area_key":"530500",
                        "children":[

                        ]
                    },
                    {
                        "id":2864,
                        "label":"施甸县",
                        "value":"530521",
                        "key":"530521",
                        "parent_area_key":"530500",
                        "children":[

                        ]
                    },
                    {
                        "id":2865,
                        "label":"龙陵县",
                        "value":"530523",
                        "key":"530523",
                        "parent_area_key":"530500",
                        "children":[

                        ]
                    },
                    {
                        "id":2866,
                        "label":"昌宁县",
                        "value":"530524",
                        "key":"530524",
                        "parent_area_key":"530500",
                        "children":[

                        ]
                    },
                    {
                        "id":2867,
                        "label":"腾冲市",
                        "value":"530581",
                        "key":"530581",
                        "parent_area_key":"530500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2868,
                "label":"昭通市",
                "value":"530600",
                "key":"530600",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2869,
                        "label":"市辖区",
                        "value":"530601",
                        "key":"530601",
                        "parent_area_key":"530600",
                        "children":[

                        ]
                    },
                    {
                        "id":2870,
                        "label":"昭阳区",
                        "value":"530602",
                        "key":"530602",
                        "parent_area_key":"530600",
                        "children":[

                        ]
                    },
                    {
                        "id":2871,
                        "label":"鲁甸县",
                        "value":"530621",
                        "key":"530621",
                        "parent_area_key":"530600",
                        "children":[

                        ]
                    },
                    {
                        "id":2872,
                        "label":"巧家县",
                        "value":"530622",
                        "key":"530622",
                        "parent_area_key":"530600",
                        "children":[

                        ]
                    },
                    {
                        "id":2873,
                        "label":"盐津县",
                        "value":"530623",
                        "key":"530623",
                        "parent_area_key":"530600",
                        "children":[

                        ]
                    },
                    {
                        "id":2874,
                        "label":"大关县",
                        "value":"530624",
                        "key":"530624",
                        "parent_area_key":"530600",
                        "children":[

                        ]
                    },
                    {
                        "id":2875,
                        "label":"永善县",
                        "value":"530625",
                        "key":"530625",
                        "parent_area_key":"530600",
                        "children":[

                        ]
                    },
                    {
                        "id":2876,
                        "label":"绥江县",
                        "value":"530626",
                        "key":"530626",
                        "parent_area_key":"530600",
                        "children":[

                        ]
                    },
                    {
                        "id":2877,
                        "label":"镇雄县",
                        "value":"530627",
                        "key":"530627",
                        "parent_area_key":"530600",
                        "children":[

                        ]
                    },
                    {
                        "id":2878,
                        "label":"彝良县",
                        "value":"530628",
                        "key":"530628",
                        "parent_area_key":"530600",
                        "children":[

                        ]
                    },
                    {
                        "id":2879,
                        "label":"威信县",
                        "value":"530629",
                        "key":"530629",
                        "parent_area_key":"530600",
                        "children":[

                        ]
                    },
                    {
                        "id":2880,
                        "label":"水富县",
                        "value":"530630",
                        "key":"530630",
                        "parent_area_key":"530600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2881,
                "label":"丽江市",
                "value":"530700",
                "key":"530700",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2882,
                        "label":"市辖区",
                        "value":"530701",
                        "key":"530701",
                        "parent_area_key":"530700",
                        "children":[

                        ]
                    },
                    {
                        "id":2883,
                        "label":"古城区",
                        "value":"530702",
                        "key":"530702",
                        "parent_area_key":"530700",
                        "children":[

                        ]
                    },
                    {
                        "id":2884,
                        "label":"玉龙纳西族自治县",
                        "value":"530721",
                        "key":"530721",
                        "parent_area_key":"530700",
                        "children":[

                        ]
                    },
                    {
                        "id":2885,
                        "label":"永胜县",
                        "value":"530722",
                        "key":"530722",
                        "parent_area_key":"530700",
                        "children":[

                        ]
                    },
                    {
                        "id":2886,
                        "label":"华坪县",
                        "value":"530723",
                        "key":"530723",
                        "parent_area_key":"530700",
                        "children":[

                        ]
                    },
                    {
                        "id":2887,
                        "label":"宁蒗彝族自治县",
                        "value":"530724",
                        "key":"530724",
                        "parent_area_key":"530700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2888,
                "label":"普洱市",
                "value":"530800",
                "key":"530800",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2889,
                        "label":"市辖区",
                        "value":"530801",
                        "key":"530801",
                        "parent_area_key":"530800",
                        "children":[

                        ]
                    },
                    {
                        "id":2890,
                        "label":"思茅区",
                        "value":"530802",
                        "key":"530802",
                        "parent_area_key":"530800",
                        "children":[

                        ]
                    },
                    {
                        "id":2891,
                        "label":"宁洱哈尼族彝族自治县",
                        "value":"530821",
                        "key":"530821",
                        "parent_area_key":"530800",
                        "children":[

                        ]
                    },
                    {
                        "id":2892,
                        "label":"墨江哈尼族自治县",
                        "value":"530822",
                        "key":"530822",
                        "parent_area_key":"530800",
                        "children":[

                        ]
                    },
                    {
                        "id":2893,
                        "label":"景东彝族自治县",
                        "value":"530823",
                        "key":"530823",
                        "parent_area_key":"530800",
                        "children":[

                        ]
                    },
                    {
                        "id":2894,
                        "label":"景谷傣族彝族自治县",
                        "value":"530824",
                        "key":"530824",
                        "parent_area_key":"530800",
                        "children":[

                        ]
                    },
                    {
                        "id":2895,
                        "label":"镇沅彝族哈尼族拉祜族自治县",
                        "value":"530825",
                        "key":"530825",
                        "parent_area_key":"530800",
                        "children":[

                        ]
                    },
                    {
                        "id":2896,
                        "label":"江城哈尼族彝族自治县",
                        "value":"530826",
                        "key":"530826",
                        "parent_area_key":"530800",
                        "children":[

                        ]
                    },
                    {
                        "id":2897,
                        "label":"孟连傣族拉祜族佤族自治县",
                        "value":"530827",
                        "key":"530827",
                        "parent_area_key":"530800",
                        "children":[

                        ]
                    },
                    {
                        "id":2898,
                        "label":"澜沧拉祜族自治县",
                        "value":"530828",
                        "key":"530828",
                        "parent_area_key":"530800",
                        "children":[

                        ]
                    },
                    {
                        "id":2899,
                        "label":"西盟佤族自治县",
                        "value":"530829",
                        "key":"530829",
                        "parent_area_key":"530800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2900,
                "label":"临沧市",
                "value":"530900",
                "key":"530900",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2901,
                        "label":"市辖区",
                        "value":"530901",
                        "key":"530901",
                        "parent_area_key":"530900",
                        "children":[

                        ]
                    },
                    {
                        "id":2902,
                        "label":"临翔区",
                        "value":"530902",
                        "key":"530902",
                        "parent_area_key":"530900",
                        "children":[

                        ]
                    },
                    {
                        "id":2903,
                        "label":"凤庆县",
                        "value":"530921",
                        "key":"530921",
                        "parent_area_key":"530900",
                        "children":[

                        ]
                    },
                    {
                        "id":2904,
                        "label":"云县",
                        "value":"530922",
                        "key":"530922",
                        "parent_area_key":"530900",
                        "children":[

                        ]
                    },
                    {
                        "id":2905,
                        "label":"永德县",
                        "value":"530923",
                        "key":"530923",
                        "parent_area_key":"530900",
                        "children":[

                        ]
                    },
                    {
                        "id":2906,
                        "label":"镇康县",
                        "value":"530924",
                        "key":"530924",
                        "parent_area_key":"530900",
                        "children":[

                        ]
                    },
                    {
                        "id":2907,
                        "label":"双江拉祜族佤族布朗族傣族自治县",
                        "value":"530925",
                        "key":"530925",
                        "parent_area_key":"530900",
                        "children":[

                        ]
                    },
                    {
                        "id":2908,
                        "label":"耿马傣族佤族自治县",
                        "value":"530926",
                        "key":"530926",
                        "parent_area_key":"530900",
                        "children":[

                        ]
                    },
                    {
                        "id":2909,
                        "label":"沧源佤族自治县",
                        "value":"530927",
                        "key":"530927",
                        "parent_area_key":"530900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2910,
                "label":"楚雄彝族自治州",
                "value":"532300",
                "key":"532300",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2911,
                        "label":"楚雄市",
                        "value":"532301",
                        "key":"532301",
                        "parent_area_key":"532300",
                        "children":[

                        ]
                    },
                    {
                        "id":2912,
                        "label":"双柏县",
                        "value":"532322",
                        "key":"532322",
                        "parent_area_key":"532300",
                        "children":[

                        ]
                    },
                    {
                        "id":2913,
                        "label":"牟定县",
                        "value":"532323",
                        "key":"532323",
                        "parent_area_key":"532300",
                        "children":[

                        ]
                    },
                    {
                        "id":2914,
                        "label":"南华县",
                        "value":"532324",
                        "key":"532324",
                        "parent_area_key":"532300",
                        "children":[

                        ]
                    },
                    {
                        "id":2915,
                        "label":"姚安县",
                        "value":"532325",
                        "key":"532325",
                        "parent_area_key":"532300",
                        "children":[

                        ]
                    },
                    {
                        "id":2916,
                        "label":"大姚县",
                        "value":"532326",
                        "key":"532326",
                        "parent_area_key":"532300",
                        "children":[

                        ]
                    },
                    {
                        "id":2917,
                        "label":"永仁县",
                        "value":"532327",
                        "key":"532327",
                        "parent_area_key":"532300",
                        "children":[

                        ]
                    },
                    {
                        "id":2918,
                        "label":"元谋县",
                        "value":"532328",
                        "key":"532328",
                        "parent_area_key":"532300",
                        "children":[

                        ]
                    },
                    {
                        "id":2919,
                        "label":"武定县",
                        "value":"532329",
                        "key":"532329",
                        "parent_area_key":"532300",
                        "children":[

                        ]
                    },
                    {
                        "id":2920,
                        "label":"禄丰县",
                        "value":"532331",
                        "key":"532331",
                        "parent_area_key":"532300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2921,
                "label":"红河哈尼族彝族自治州",
                "value":"532500",
                "key":"532500",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2922,
                        "label":"个旧市",
                        "value":"532501",
                        "key":"532501",
                        "parent_area_key":"532500",
                        "children":[

                        ]
                    },
                    {
                        "id":2923,
                        "label":"开远市",
                        "value":"532502",
                        "key":"532502",
                        "parent_area_key":"532500",
                        "children":[

                        ]
                    },
                    {
                        "id":2924,
                        "label":"蒙自市",
                        "value":"532503",
                        "key":"532503",
                        "parent_area_key":"532500",
                        "children":[

                        ]
                    },
                    {
                        "id":2925,
                        "label":"弥勒市",
                        "value":"532504",
                        "key":"532504",
                        "parent_area_key":"532500",
                        "children":[

                        ]
                    },
                    {
                        "id":2926,
                        "label":"屏边苗族自治县",
                        "value":"532523",
                        "key":"532523",
                        "parent_area_key":"532500",
                        "children":[

                        ]
                    },
                    {
                        "id":2927,
                        "label":"建水县",
                        "value":"532524",
                        "key":"532524",
                        "parent_area_key":"532500",
                        "children":[

                        ]
                    },
                    {
                        "id":2928,
                        "label":"石屏县",
                        "value":"532525",
                        "key":"532525",
                        "parent_area_key":"532500",
                        "children":[

                        ]
                    },
                    {
                        "id":2929,
                        "label":"泸西县",
                        "value":"532527",
                        "key":"532527",
                        "parent_area_key":"532500",
                        "children":[

                        ]
                    },
                    {
                        "id":2930,
                        "label":"元阳县",
                        "value":"532528",
                        "key":"532528",
                        "parent_area_key":"532500",
                        "children":[

                        ]
                    },
                    {
                        "id":2931,
                        "label":"红河县",
                        "value":"532529",
                        "key":"532529",
                        "parent_area_key":"532500",
                        "children":[

                        ]
                    },
                    {
                        "id":2932,
                        "label":"金平苗族瑶族傣族自治县",
                        "value":"532530",
                        "key":"532530",
                        "parent_area_key":"532500",
                        "children":[

                        ]
                    },
                    {
                        "id":2933,
                        "label":"绿春县",
                        "value":"532531",
                        "key":"532531",
                        "parent_area_key":"532500",
                        "children":[

                        ]
                    },
                    {
                        "id":2934,
                        "label":"河口瑶族自治县",
                        "value":"532532",
                        "key":"532532",
                        "parent_area_key":"532500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2935,
                "label":"文山壮族苗族自治州",
                "value":"532600",
                "key":"532600",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2936,
                        "label":"文山市",
                        "value":"532601",
                        "key":"532601",
                        "parent_area_key":"532600",
                        "children":[

                        ]
                    },
                    {
                        "id":2937,
                        "label":"砚山县",
                        "value":"532622",
                        "key":"532622",
                        "parent_area_key":"532600",
                        "children":[

                        ]
                    },
                    {
                        "id":2938,
                        "label":"西畴县",
                        "value":"532623",
                        "key":"532623",
                        "parent_area_key":"532600",
                        "children":[

                        ]
                    },
                    {
                        "id":2939,
                        "label":"麻栗坡县",
                        "value":"532624",
                        "key":"532624",
                        "parent_area_key":"532600",
                        "children":[

                        ]
                    },
                    {
                        "id":2940,
                        "label":"马关县",
                        "value":"532625",
                        "key":"532625",
                        "parent_area_key":"532600",
                        "children":[

                        ]
                    },
                    {
                        "id":2941,
                        "label":"丘北县",
                        "value":"532626",
                        "key":"532626",
                        "parent_area_key":"532600",
                        "children":[

                        ]
                    },
                    {
                        "id":2942,
                        "label":"广南县",
                        "value":"532627",
                        "key":"532627",
                        "parent_area_key":"532600",
                        "children":[

                        ]
                    },
                    {
                        "id":2943,
                        "label":"富宁县",
                        "value":"532628",
                        "key":"532628",
                        "parent_area_key":"532600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2944,
                "label":"西双版纳傣族自治州",
                "value":"532800",
                "key":"532800",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2945,
                        "label":"景洪市",
                        "value":"532801",
                        "key":"532801",
                        "parent_area_key":"532800",
                        "children":[

                        ]
                    },
                    {
                        "id":2946,
                        "label":"勐海县",
                        "value":"532822",
                        "key":"532822",
                        "parent_area_key":"532800",
                        "children":[

                        ]
                    },
                    {
                        "id":2947,
                        "label":"勐腊县",
                        "value":"532823",
                        "key":"532823",
                        "parent_area_key":"532800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2948,
                "label":"大理白族自治州",
                "value":"532900",
                "key":"532900",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2949,
                        "label":"大理市",
                        "value":"532901",
                        "key":"532901",
                        "parent_area_key":"532900",
                        "children":[

                        ]
                    },
                    {
                        "id":2950,
                        "label":"漾濞彝族自治县",
                        "value":"532922",
                        "key":"532922",
                        "parent_area_key":"532900",
                        "children":[

                        ]
                    },
                    {
                        "id":2951,
                        "label":"祥云县",
                        "value":"532923",
                        "key":"532923",
                        "parent_area_key":"532900",
                        "children":[

                        ]
                    },
                    {
                        "id":2952,
                        "label":"宾川县",
                        "value":"532924",
                        "key":"532924",
                        "parent_area_key":"532900",
                        "children":[

                        ]
                    },
                    {
                        "id":2953,
                        "label":"弥渡县",
                        "value":"532925",
                        "key":"532925",
                        "parent_area_key":"532900",
                        "children":[

                        ]
                    },
                    {
                        "id":2954,
                        "label":"南涧彝族自治县",
                        "value":"532926",
                        "key":"532926",
                        "parent_area_key":"532900",
                        "children":[

                        ]
                    },
                    {
                        "id":2955,
                        "label":"巍山彝族回族自治县",
                        "value":"532927",
                        "key":"532927",
                        "parent_area_key":"532900",
                        "children":[

                        ]
                    },
                    {
                        "id":2956,
                        "label":"永平县",
                        "value":"532928",
                        "key":"532928",
                        "parent_area_key":"532900",
                        "children":[

                        ]
                    },
                    {
                        "id":2957,
                        "label":"云龙县",
                        "value":"532929",
                        "key":"532929",
                        "parent_area_key":"532900",
                        "children":[

                        ]
                    },
                    {
                        "id":2958,
                        "label":"洱源县",
                        "value":"532930",
                        "key":"532930",
                        "parent_area_key":"532900",
                        "children":[

                        ]
                    },
                    {
                        "id":2959,
                        "label":"剑川县",
                        "value":"532931",
                        "key":"532931",
                        "parent_area_key":"532900",
                        "children":[

                        ]
                    },
                    {
                        "id":2960,
                        "label":"鹤庆县",
                        "value":"532932",
                        "key":"532932",
                        "parent_area_key":"532900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2961,
                "label":"德宏傣族景颇族自治州",
                "value":"533100",
                "key":"533100",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2962,
                        "label":"瑞丽市",
                        "value":"533102",
                        "key":"533102",
                        "parent_area_key":"533100",
                        "children":[

                        ]
                    },
                    {
                        "id":2963,
                        "label":"芒市",
                        "value":"533103",
                        "key":"533103",
                        "parent_area_key":"533100",
                        "children":[

                        ]
                    },
                    {
                        "id":2964,
                        "label":"梁河县",
                        "value":"533122",
                        "key":"533122",
                        "parent_area_key":"533100",
                        "children":[

                        ]
                    },
                    {
                        "id":2965,
                        "label":"盈江县",
                        "value":"533123",
                        "key":"533123",
                        "parent_area_key":"533100",
                        "children":[

                        ]
                    },
                    {
                        "id":2966,
                        "label":"陇川县",
                        "value":"533124",
                        "key":"533124",
                        "parent_area_key":"533100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2967,
                "label":"怒江傈僳族自治州",
                "value":"533300",
                "key":"533300",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2968,
                        "label":"泸水市",
                        "value":"533301",
                        "key":"533301",
                        "parent_area_key":"533300",
                        "children":[

                        ]
                    },
                    {
                        "id":2969,
                        "label":"福贡县",
                        "value":"533323",
                        "key":"533323",
                        "parent_area_key":"533300",
                        "children":[

                        ]
                    },
                    {
                        "id":2970,
                        "label":"贡山独龙族怒族自治县",
                        "value":"533324",
                        "key":"533324",
                        "parent_area_key":"533300",
                        "children":[

                        ]
                    },
                    {
                        "id":2971,
                        "label":"兰坪白族普米族自治县",
                        "value":"533325",
                        "key":"533325",
                        "parent_area_key":"533300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2972,
                "label":"迪庆藏族自治州",
                "value":"533400",
                "key":"533400",
                "parent_area_key":"530000",
                "children":[
                    {
                        "id":2973,
                        "label":"香格里拉市",
                        "value":"533401",
                        "key":"533401",
                        "parent_area_key":"533400",
                        "children":[

                        ]
                    },
                    {
                        "id":2974,
                        "label":"德钦县",
                        "value":"533422",
                        "key":"533422",
                        "parent_area_key":"533400",
                        "children":[

                        ]
                    },
                    {
                        "id":2975,
                        "label":"维西傈僳族自治县",
                        "value":"533423",
                        "key":"533423",
                        "parent_area_key":"533400",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":2976,
        "label":"西藏自治区",
        "value":"540000",
        "key":"540000",
        "parent_area_key":"",
        "children":[
            {
                "id":2977,
                "label":"拉萨市",
                "value":"540100",
                "key":"540100",
                "parent_area_key":"540000",
                "children":[
                    {
                        "id":2978,
                        "label":"市辖区",
                        "value":"540101",
                        "key":"540101",
                        "parent_area_key":"540100",
                        "children":[

                        ]
                    },
                    {
                        "id":2979,
                        "label":"城关区",
                        "value":"540102",
                        "key":"540102",
                        "parent_area_key":"540100",
                        "children":[

                        ]
                    },
                    {
                        "id":2980,
                        "label":"堆龙德庆区",
                        "value":"540103",
                        "key":"540103",
                        "parent_area_key":"540100",
                        "children":[

                        ]
                    },
                    {
                        "id":2981,
                        "label":"林周县",
                        "value":"540121",
                        "key":"540121",
                        "parent_area_key":"540100",
                        "children":[

                        ]
                    },
                    {
                        "id":2982,
                        "label":"当雄县",
                        "value":"540122",
                        "key":"540122",
                        "parent_area_key":"540100",
                        "children":[

                        ]
                    },
                    {
                        "id":2983,
                        "label":"尼木县",
                        "value":"540123",
                        "key":"540123",
                        "parent_area_key":"540100",
                        "children":[

                        ]
                    },
                    {
                        "id":2984,
                        "label":"曲水县",
                        "value":"540124",
                        "key":"540124",
                        "parent_area_key":"540100",
                        "children":[

                        ]
                    },
                    {
                        "id":2985,
                        "label":"达孜县",
                        "value":"540126",
                        "key":"540126",
                        "parent_area_key":"540100",
                        "children":[

                        ]
                    },
                    {
                        "id":2986,
                        "label":"墨竹工卡县",
                        "value":"540127",
                        "key":"540127",
                        "parent_area_key":"540100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":2987,
                "label":"日喀则市",
                "value":"540200",
                "key":"540200",
                "parent_area_key":"540000",
                "children":[
                    {
                        "id":2988,
                        "label":"桑珠孜区",
                        "value":"540202",
                        "key":"540202",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":2989,
                        "label":"南木林县",
                        "value":"540221",
                        "key":"540221",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":2990,
                        "label":"江孜县",
                        "value":"540222",
                        "key":"540222",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":2991,
                        "label":"定日县",
                        "value":"540223",
                        "key":"540223",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":2992,
                        "label":"萨迦县",
                        "value":"540224",
                        "key":"540224",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":2993,
                        "label":"拉孜县",
                        "value":"540225",
                        "key":"540225",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":2994,
                        "label":"昂仁县",
                        "value":"540226",
                        "key":"540226",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":2995,
                        "label":"谢通门县",
                        "value":"540227",
                        "key":"540227",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":2996,
                        "label":"白朗县",
                        "value":"540228",
                        "key":"540228",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":2997,
                        "label":"仁布县",
                        "value":"540229",
                        "key":"540229",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":2998,
                        "label":"康马县",
                        "value":"540230",
                        "key":"540230",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":2999,
                        "label":"定结县",
                        "value":"540231",
                        "key":"540231",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":3000,
                        "label":"仲巴县",
                        "value":"540232",
                        "key":"540232",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":3001,
                        "label":"亚东县",
                        "value":"540233",
                        "key":"540233",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":3002,
                        "label":"吉隆县",
                        "value":"540234",
                        "key":"540234",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":3003,
                        "label":"聂拉木县",
                        "value":"540235",
                        "key":"540235",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":3004,
                        "label":"萨嘎县",
                        "value":"540236",
                        "key":"540236",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    },
                    {
                        "id":3005,
                        "label":"岗巴县",
                        "value":"540237",
                        "key":"540237",
                        "parent_area_key":"540200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3006,
                "label":"昌都市",
                "value":"540300",
                "key":"540300",
                "parent_area_key":"540000",
                "children":[
                    {
                        "id":3007,
                        "label":"卡若区",
                        "value":"540302",
                        "key":"540302",
                        "parent_area_key":"540300",
                        "children":[

                        ]
                    },
                    {
                        "id":3008,
                        "label":"江达县",
                        "value":"540321",
                        "key":"540321",
                        "parent_area_key":"540300",
                        "children":[

                        ]
                    },
                    {
                        "id":3009,
                        "label":"贡觉县",
                        "value":"540322",
                        "key":"540322",
                        "parent_area_key":"540300",
                        "children":[

                        ]
                    },
                    {
                        "id":3010,
                        "label":"类乌齐县",
                        "value":"540323",
                        "key":"540323",
                        "parent_area_key":"540300",
                        "children":[

                        ]
                    },
                    {
                        "id":3011,
                        "label":"丁青县",
                        "value":"540324",
                        "key":"540324",
                        "parent_area_key":"540300",
                        "children":[

                        ]
                    },
                    {
                        "id":3012,
                        "label":"察雅县",
                        "value":"540325",
                        "key":"540325",
                        "parent_area_key":"540300",
                        "children":[

                        ]
                    },
                    {
                        "id":3013,
                        "label":"八宿县",
                        "value":"540326",
                        "key":"540326",
                        "parent_area_key":"540300",
                        "children":[

                        ]
                    },
                    {
                        "id":3014,
                        "label":"左贡县",
                        "value":"540327",
                        "key":"540327",
                        "parent_area_key":"540300",
                        "children":[

                        ]
                    },
                    {
                        "id":3015,
                        "label":"芒康县",
                        "value":"540328",
                        "key":"540328",
                        "parent_area_key":"540300",
                        "children":[

                        ]
                    },
                    {
                        "id":3016,
                        "label":"洛隆县",
                        "value":"540329",
                        "key":"540329",
                        "parent_area_key":"540300",
                        "children":[

                        ]
                    },
                    {
                        "id":3017,
                        "label":"边坝县",
                        "value":"540330",
                        "key":"540330",
                        "parent_area_key":"540300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3018,
                "label":"林芝市",
                "value":"540400",
                "key":"540400",
                "parent_area_key":"540000",
                "children":[
                    {
                        "id":3019,
                        "label":"巴宜区",
                        "value":"540402",
                        "key":"540402",
                        "parent_area_key":"540400",
                        "children":[

                        ]
                    },
                    {
                        "id":3020,
                        "label":"工布江达县",
                        "value":"540421",
                        "key":"540421",
                        "parent_area_key":"540400",
                        "children":[

                        ]
                    },
                    {
                        "id":3021,
                        "label":"米林县",
                        "value":"540422",
                        "key":"540422",
                        "parent_area_key":"540400",
                        "children":[

                        ]
                    },
                    {
                        "id":3022,
                        "label":"墨脱县",
                        "value":"540423",
                        "key":"540423",
                        "parent_area_key":"540400",
                        "children":[

                        ]
                    },
                    {
                        "id":3023,
                        "label":"波密县",
                        "value":"540424",
                        "key":"540424",
                        "parent_area_key":"540400",
                        "children":[

                        ]
                    },
                    {
                        "id":3024,
                        "label":"察隅县",
                        "value":"540425",
                        "key":"540425",
                        "parent_area_key":"540400",
                        "children":[

                        ]
                    },
                    {
                        "id":3025,
                        "label":"朗县",
                        "value":"540426",
                        "key":"540426",
                        "parent_area_key":"540400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3026,
                "label":"山南市",
                "value":"540500",
                "key":"540500",
                "parent_area_key":"540000",
                "children":[
                    {
                        "id":3027,
                        "label":"市辖区",
                        "value":"540501",
                        "key":"540501",
                        "parent_area_key":"540500",
                        "children":[

                        ]
                    },
                    {
                        "id":3028,
                        "label":"乃东区",
                        "value":"540502",
                        "key":"540502",
                        "parent_area_key":"540500",
                        "children":[

                        ]
                    },
                    {
                        "id":3029,
                        "label":"扎囊县",
                        "value":"540521",
                        "key":"540521",
                        "parent_area_key":"540500",
                        "children":[

                        ]
                    },
                    {
                        "id":3030,
                        "label":"贡嘎县",
                        "value":"540522",
                        "key":"540522",
                        "parent_area_key":"540500",
                        "children":[

                        ]
                    },
                    {
                        "id":3031,
                        "label":"桑日县",
                        "value":"540523",
                        "key":"540523",
                        "parent_area_key":"540500",
                        "children":[

                        ]
                    },
                    {
                        "id":3032,
                        "label":"琼结县",
                        "value":"540524",
                        "key":"540524",
                        "parent_area_key":"540500",
                        "children":[

                        ]
                    },
                    {
                        "id":3033,
                        "label":"曲松县",
                        "value":"540525",
                        "key":"540525",
                        "parent_area_key":"540500",
                        "children":[

                        ]
                    },
                    {
                        "id":3034,
                        "label":"措美县",
                        "value":"540526",
                        "key":"540526",
                        "parent_area_key":"540500",
                        "children":[

                        ]
                    },
                    {
                        "id":3035,
                        "label":"洛扎县",
                        "value":"540527",
                        "key":"540527",
                        "parent_area_key":"540500",
                        "children":[

                        ]
                    },
                    {
                        "id":3036,
                        "label":"加查县",
                        "value":"540528",
                        "key":"540528",
                        "parent_area_key":"540500",
                        "children":[

                        ]
                    },
                    {
                        "id":3037,
                        "label":"隆子县",
                        "value":"540529",
                        "key":"540529",
                        "parent_area_key":"540500",
                        "children":[

                        ]
                    },
                    {
                        "id":3038,
                        "label":"错那县",
                        "value":"540530",
                        "key":"540530",
                        "parent_area_key":"540500",
                        "children":[

                        ]
                    },
                    {
                        "id":3039,
                        "label":"浪卡子县",
                        "value":"540531",
                        "key":"540531",
                        "parent_area_key":"540500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3040,
                "label":"那曲地区",
                "value":"542400",
                "key":"542400",
                "parent_area_key":"540000",
                "children":[
                    {
                        "id":3041,
                        "label":"那曲县",
                        "value":"542421",
                        "key":"542421",
                        "parent_area_key":"542400",
                        "children":[

                        ]
                    },
                    {
                        "id":3042,
                        "label":"嘉黎县",
                        "value":"542422",
                        "key":"542422",
                        "parent_area_key":"542400",
                        "children":[

                        ]
                    },
                    {
                        "id":3043,
                        "label":"比如县",
                        "value":"542423",
                        "key":"542423",
                        "parent_area_key":"542400",
                        "children":[

                        ]
                    },
                    {
                        "id":3044,
                        "label":"聂荣县",
                        "value":"542424",
                        "key":"542424",
                        "parent_area_key":"542400",
                        "children":[

                        ]
                    },
                    {
                        "id":3045,
                        "label":"安多县",
                        "value":"542425",
                        "key":"542425",
                        "parent_area_key":"542400",
                        "children":[

                        ]
                    },
                    {
                        "id":3046,
                        "label":"申扎县",
                        "value":"542426",
                        "key":"542426",
                        "parent_area_key":"542400",
                        "children":[

                        ]
                    },
                    {
                        "id":3047,
                        "label":"索县",
                        "value":"542427",
                        "key":"542427",
                        "parent_area_key":"542400",
                        "children":[

                        ]
                    },
                    {
                        "id":3048,
                        "label":"班戈县",
                        "value":"542428",
                        "key":"542428",
                        "parent_area_key":"542400",
                        "children":[

                        ]
                    },
                    {
                        "id":3049,
                        "label":"巴青县",
                        "value":"542429",
                        "key":"542429",
                        "parent_area_key":"542400",
                        "children":[

                        ]
                    },
                    {
                        "id":3050,
                        "label":"尼玛县",
                        "value":"542430",
                        "key":"542430",
                        "parent_area_key":"542400",
                        "children":[

                        ]
                    },
                    {
                        "id":3051,
                        "label":"双湖县",
                        "value":"542431",
                        "key":"542431",
                        "parent_area_key":"542400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3052,
                "label":"阿里地区",
                "value":"542500",
                "key":"542500",
                "parent_area_key":"540000",
                "children":[
                    {
                        "id":3053,
                        "label":"普兰县",
                        "value":"542521",
                        "key":"542521",
                        "parent_area_key":"542500",
                        "children":[

                        ]
                    },
                    {
                        "id":3054,
                        "label":"札达县",
                        "value":"542522",
                        "key":"542522",
                        "parent_area_key":"542500",
                        "children":[

                        ]
                    },
                    {
                        "id":3055,
                        "label":"噶尔县",
                        "value":"542523",
                        "key":"542523",
                        "parent_area_key":"542500",
                        "children":[

                        ]
                    },
                    {
                        "id":3056,
                        "label":"日土县",
                        "value":"542524",
                        "key":"542524",
                        "parent_area_key":"542500",
                        "children":[

                        ]
                    },
                    {
                        "id":3057,
                        "label":"革吉县",
                        "value":"542525",
                        "key":"542525",
                        "parent_area_key":"542500",
                        "children":[

                        ]
                    },
                    {
                        "id":3058,
                        "label":"改则县",
                        "value":"542526",
                        "key":"542526",
                        "parent_area_key":"542500",
                        "children":[

                        ]
                    },
                    {
                        "id":3059,
                        "label":"措勤县",
                        "value":"542527",
                        "key":"542527",
                        "parent_area_key":"542500",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":3060,
        "label":"陕西省",
        "value":"610000",
        "key":"610000",
        "parent_area_key":"",
        "children":[
            {
                "id":3061,
                "label":"西安市",
                "value":"610100",
                "key":"610100",
                "parent_area_key":"610000",
                "children":[
                    {
                        "id":3062,
                        "label":"市辖区",
                        "value":"610101",
                        "key":"610101",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    },
                    {
                        "id":3063,
                        "label":"新城区",
                        "value":"610102",
                        "key":"610102",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    },
                    {
                        "id":3064,
                        "label":"碑林区",
                        "value":"610103",
                        "key":"610103",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    },
                    {
                        "id":3065,
                        "label":"莲湖区",
                        "value":"610104",
                        "key":"610104",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    },
                    {
                        "id":3066,
                        "label":"灞桥区",
                        "value":"610111",
                        "key":"610111",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    },
                    {
                        "id":3067,
                        "label":"未央区",
                        "value":"610112",
                        "key":"610112",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    },
                    {
                        "id":3068,
                        "label":"雁塔区",
                        "value":"610113",
                        "key":"610113",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    },
                    {
                        "id":3069,
                        "label":"阎良区",
                        "value":"610114",
                        "key":"610114",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    },
                    {
                        "id":3070,
                        "label":"临潼区",
                        "value":"610115",
                        "key":"610115",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    },
                    {
                        "id":3071,
                        "label":"长安区",
                        "value":"610116",
                        "key":"610116",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    },
                    {
                        "id":3072,
                        "label":"高陵区",
                        "value":"610117",
                        "key":"610117",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    },
                    {
                        "id":3073,
                        "label":"蓝田县",
                        "value":"610122",
                        "key":"610122",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    },
                    {
                        "id":3074,
                        "label":"周至县",
                        "value":"610124",
                        "key":"610124",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    },
                    {
                        "id":3075,
                        "label":"户县",
                        "value":"610125",
                        "key":"610125",
                        "parent_area_key":"610100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3076,
                "label":"铜川市",
                "value":"610200",
                "key":"610200",
                "parent_area_key":"610000",
                "children":[
                    {
                        "id":3077,
                        "label":"市辖区",
                        "value":"610201",
                        "key":"610201",
                        "parent_area_key":"610200",
                        "children":[

                        ]
                    },
                    {
                        "id":3078,
                        "label":"王益区",
                        "value":"610202",
                        "key":"610202",
                        "parent_area_key":"610200",
                        "children":[

                        ]
                    },
                    {
                        "id":3079,
                        "label":"印台区",
                        "value":"610203",
                        "key":"610203",
                        "parent_area_key":"610200",
                        "children":[

                        ]
                    },
                    {
                        "id":3080,
                        "label":"耀州区",
                        "value":"610204",
                        "key":"610204",
                        "parent_area_key":"610200",
                        "children":[

                        ]
                    },
                    {
                        "id":3081,
                        "label":"宜君县",
                        "value":"610222",
                        "key":"610222",
                        "parent_area_key":"610200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3082,
                "label":"宝鸡市",
                "value":"610300",
                "key":"610300",
                "parent_area_key":"610000",
                "children":[
                    {
                        "id":3083,
                        "label":"市辖区",
                        "value":"610301",
                        "key":"610301",
                        "parent_area_key":"610300",
                        "children":[

                        ]
                    },
                    {
                        "id":3084,
                        "label":"渭滨区",
                        "value":"610302",
                        "key":"610302",
                        "parent_area_key":"610300",
                        "children":[

                        ]
                    },
                    {
                        "id":3085,
                        "label":"金台区",
                        "value":"610303",
                        "key":"610303",
                        "parent_area_key":"610300",
                        "children":[

                        ]
                    },
                    {
                        "id":3086,
                        "label":"陈仓区",
                        "value":"610304",
                        "key":"610304",
                        "parent_area_key":"610300",
                        "children":[

                        ]
                    },
                    {
                        "id":3087,
                        "label":"凤翔县",
                        "value":"610322",
                        "key":"610322",
                        "parent_area_key":"610300",
                        "children":[

                        ]
                    },
                    {
                        "id":3088,
                        "label":"岐山县",
                        "value":"610323",
                        "key":"610323",
                        "parent_area_key":"610300",
                        "children":[

                        ]
                    },
                    {
                        "id":3089,
                        "label":"扶风县",
                        "value":"610324",
                        "key":"610324",
                        "parent_area_key":"610300",
                        "children":[

                        ]
                    },
                    {
                        "id":3090,
                        "label":"眉县",
                        "value":"610326",
                        "key":"610326",
                        "parent_area_key":"610300",
                        "children":[

                        ]
                    },
                    {
                        "id":3091,
                        "label":"陇县",
                        "value":"610327",
                        "key":"610327",
                        "parent_area_key":"610300",
                        "children":[

                        ]
                    },
                    {
                        "id":3092,
                        "label":"千阳县",
                        "value":"610328",
                        "key":"610328",
                        "parent_area_key":"610300",
                        "children":[

                        ]
                    },
                    {
                        "id":3093,
                        "label":"麟游县",
                        "value":"610329",
                        "key":"610329",
                        "parent_area_key":"610300",
                        "children":[

                        ]
                    },
                    {
                        "id":3094,
                        "label":"凤县",
                        "value":"610330",
                        "key":"610330",
                        "parent_area_key":"610300",
                        "children":[

                        ]
                    },
                    {
                        "id":3095,
                        "label":"太白县",
                        "value":"610331",
                        "key":"610331",
                        "parent_area_key":"610300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3096,
                "label":"咸阳市",
                "value":"610400",
                "key":"610400",
                "parent_area_key":"610000",
                "children":[
                    {
                        "id":3097,
                        "label":"市辖区",
                        "value":"610401",
                        "key":"610401",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3098,
                        "label":"秦都区",
                        "value":"610402",
                        "key":"610402",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3099,
                        "label":"杨陵区",
                        "value":"610403",
                        "key":"610403",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3100,
                        "label":"渭城区",
                        "value":"610404",
                        "key":"610404",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3101,
                        "label":"三原县",
                        "value":"610422",
                        "key":"610422",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3102,
                        "label":"泾阳县",
                        "value":"610423",
                        "key":"610423",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3103,
                        "label":"乾县",
                        "value":"610424",
                        "key":"610424",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3104,
                        "label":"礼泉县",
                        "value":"610425",
                        "key":"610425",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3105,
                        "label":"永寿县",
                        "value":"610426",
                        "key":"610426",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3106,
                        "label":"彬县",
                        "value":"610427",
                        "key":"610427",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3107,
                        "label":"长武县",
                        "value":"610428",
                        "key":"610428",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3108,
                        "label":"旬邑县",
                        "value":"610429",
                        "key":"610429",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3109,
                        "label":"淳化县",
                        "value":"610430",
                        "key":"610430",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3110,
                        "label":"武功县",
                        "value":"610431",
                        "key":"610431",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    },
                    {
                        "id":3111,
                        "label":"兴平市",
                        "value":"610481",
                        "key":"610481",
                        "parent_area_key":"610400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3112,
                "label":"渭南市",
                "value":"610500",
                "key":"610500",
                "parent_area_key":"610000",
                "children":[
                    {
                        "id":3113,
                        "label":"市辖区",
                        "value":"610501",
                        "key":"610501",
                        "parent_area_key":"610500",
                        "children":[

                        ]
                    },
                    {
                        "id":3114,
                        "label":"临渭区",
                        "value":"610502",
                        "key":"610502",
                        "parent_area_key":"610500",
                        "children":[

                        ]
                    },
                    {
                        "id":3115,
                        "label":"华州区",
                        "value":"610503",
                        "key":"610503",
                        "parent_area_key":"610500",
                        "children":[

                        ]
                    },
                    {
                        "id":3116,
                        "label":"潼关县",
                        "value":"610522",
                        "key":"610522",
                        "parent_area_key":"610500",
                        "children":[

                        ]
                    },
                    {
                        "id":3117,
                        "label":"大荔县",
                        "value":"610523",
                        "key":"610523",
                        "parent_area_key":"610500",
                        "children":[

                        ]
                    },
                    {
                        "id":3118,
                        "label":"合阳县",
                        "value":"610524",
                        "key":"610524",
                        "parent_area_key":"610500",
                        "children":[

                        ]
                    },
                    {
                        "id":3119,
                        "label":"澄城县",
                        "value":"610525",
                        "key":"610525",
                        "parent_area_key":"610500",
                        "children":[

                        ]
                    },
                    {
                        "id":3120,
                        "label":"蒲城县",
                        "value":"610526",
                        "key":"610526",
                        "parent_area_key":"610500",
                        "children":[

                        ]
                    },
                    {
                        "id":3121,
                        "label":"白水县",
                        "value":"610527",
                        "key":"610527",
                        "parent_area_key":"610500",
                        "children":[

                        ]
                    },
                    {
                        "id":3122,
                        "label":"富平县",
                        "value":"610528",
                        "key":"610528",
                        "parent_area_key":"610500",
                        "children":[

                        ]
                    },
                    {
                        "id":3123,
                        "label":"韩城市",
                        "value":"610581",
                        "key":"610581",
                        "parent_area_key":"610500",
                        "children":[

                        ]
                    },
                    {
                        "id":3124,
                        "label":"华阴市",
                        "value":"610582",
                        "key":"610582",
                        "parent_area_key":"610500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3125,
                "label":"延安市",
                "value":"610600",
                "key":"610600",
                "parent_area_key":"610000",
                "children":[
                    {
                        "id":3126,
                        "label":"市辖区",
                        "value":"610601",
                        "key":"610601",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    },
                    {
                        "id":3127,
                        "label":"宝塔区",
                        "value":"610602",
                        "key":"610602",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    },
                    {
                        "id":3128,
                        "label":"安塞区",
                        "value":"610603",
                        "key":"610603",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    },
                    {
                        "id":3129,
                        "label":"延长县",
                        "value":"610621",
                        "key":"610621",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    },
                    {
                        "id":3130,
                        "label":"延川县",
                        "value":"610622",
                        "key":"610622",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    },
                    {
                        "id":3131,
                        "label":"子长县",
                        "value":"610623",
                        "key":"610623",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    },
                    {
                        "id":3132,
                        "label":"志丹县",
                        "value":"610625",
                        "key":"610625",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    },
                    {
                        "id":3133,
                        "label":"吴起县",
                        "value":"610626",
                        "key":"610626",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    },
                    {
                        "id":3134,
                        "label":"甘泉县",
                        "value":"610627",
                        "key":"610627",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    },
                    {
                        "id":3135,
                        "label":"富县",
                        "value":"610628",
                        "key":"610628",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    },
                    {
                        "id":3136,
                        "label":"洛川县",
                        "value":"610629",
                        "key":"610629",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    },
                    {
                        "id":3137,
                        "label":"宜川县",
                        "value":"610630",
                        "key":"610630",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    },
                    {
                        "id":3138,
                        "label":"黄龙县",
                        "value":"610631",
                        "key":"610631",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    },
                    {
                        "id":3139,
                        "label":"黄陵县",
                        "value":"610632",
                        "key":"610632",
                        "parent_area_key":"610600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3140,
                "label":"汉中市",
                "value":"610700",
                "key":"610700",
                "parent_area_key":"610000",
                "children":[
                    {
                        "id":3141,
                        "label":"市辖区",
                        "value":"610701",
                        "key":"610701",
                        "parent_area_key":"610700",
                        "children":[

                        ]
                    },
                    {
                        "id":3142,
                        "label":"汉台区",
                        "value":"610702",
                        "key":"610702",
                        "parent_area_key":"610700",
                        "children":[

                        ]
                    },
                    {
                        "id":3143,
                        "label":"南郑县",
                        "value":"610721",
                        "key":"610721",
                        "parent_area_key":"610700",
                        "children":[

                        ]
                    },
                    {
                        "id":3144,
                        "label":"城固县",
                        "value":"610722",
                        "key":"610722",
                        "parent_area_key":"610700",
                        "children":[

                        ]
                    },
                    {
                        "id":3145,
                        "label":"洋县",
                        "value":"610723",
                        "key":"610723",
                        "parent_area_key":"610700",
                        "children":[

                        ]
                    },
                    {
                        "id":3146,
                        "label":"西乡县",
                        "value":"610724",
                        "key":"610724",
                        "parent_area_key":"610700",
                        "children":[

                        ]
                    },
                    {
                        "id":3147,
                        "label":"勉县",
                        "value":"610725",
                        "key":"610725",
                        "parent_area_key":"610700",
                        "children":[

                        ]
                    },
                    {
                        "id":3148,
                        "label":"宁强县",
                        "value":"610726",
                        "key":"610726",
                        "parent_area_key":"610700",
                        "children":[

                        ]
                    },
                    {
                        "id":3149,
                        "label":"略阳县",
                        "value":"610727",
                        "key":"610727",
                        "parent_area_key":"610700",
                        "children":[

                        ]
                    },
                    {
                        "id":3150,
                        "label":"镇巴县",
                        "value":"610728",
                        "key":"610728",
                        "parent_area_key":"610700",
                        "children":[

                        ]
                    },
                    {
                        "id":3151,
                        "label":"留坝县",
                        "value":"610729",
                        "key":"610729",
                        "parent_area_key":"610700",
                        "children":[

                        ]
                    },
                    {
                        "id":3152,
                        "label":"佛坪县",
                        "value":"610730",
                        "key":"610730",
                        "parent_area_key":"610700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3153,
                "label":"榆林市",
                "value":"610800",
                "key":"610800",
                "parent_area_key":"610000",
                "children":[
                    {
                        "id":3154,
                        "label":"市辖区",
                        "value":"610801",
                        "key":"610801",
                        "parent_area_key":"610800",
                        "children":[

                        ]
                    },
                    {
                        "id":3155,
                        "label":"榆阳区",
                        "value":"610802",
                        "key":"610802",
                        "parent_area_key":"610800",
                        "children":[

                        ]
                    },
                    {
                        "id":3156,
                        "label":"横山区",
                        "value":"610803",
                        "key":"610803",
                        "parent_area_key":"610800",
                        "children":[

                        ]
                    },
                    {
                        "id":3157,
                        "label":"神木县",
                        "value":"610821",
                        "key":"610821",
                        "parent_area_key":"610800",
                        "children":[

                        ]
                    },
                    {
                        "id":3158,
                        "label":"府谷县",
                        "value":"610822",
                        "key":"610822",
                        "parent_area_key":"610800",
                        "children":[

                        ]
                    },
                    {
                        "id":3159,
                        "label":"靖边县",
                        "value":"610824",
                        "key":"610824",
                        "parent_area_key":"610800",
                        "children":[

                        ]
                    },
                    {
                        "id":3160,
                        "label":"定边县",
                        "value":"610825",
                        "key":"610825",
                        "parent_area_key":"610800",
                        "children":[

                        ]
                    },
                    {
                        "id":3161,
                        "label":"绥德县",
                        "value":"610826",
                        "key":"610826",
                        "parent_area_key":"610800",
                        "children":[

                        ]
                    },
                    {
                        "id":3162,
                        "label":"米脂县",
                        "value":"610827",
                        "key":"610827",
                        "parent_area_key":"610800",
                        "children":[

                        ]
                    },
                    {
                        "id":3163,
                        "label":"佳县",
                        "value":"610828",
                        "key":"610828",
                        "parent_area_key":"610800",
                        "children":[

                        ]
                    },
                    {
                        "id":3164,
                        "label":"吴堡县",
                        "value":"610829",
                        "key":"610829",
                        "parent_area_key":"610800",
                        "children":[

                        ]
                    },
                    {
                        "id":3165,
                        "label":"清涧县",
                        "value":"610830",
                        "key":"610830",
                        "parent_area_key":"610800",
                        "children":[

                        ]
                    },
                    {
                        "id":3166,
                        "label":"子洲县",
                        "value":"610831",
                        "key":"610831",
                        "parent_area_key":"610800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3167,
                "label":"安康市",
                "value":"610900",
                "key":"610900",
                "parent_area_key":"610000",
                "children":[
                    {
                        "id":3168,
                        "label":"市辖区",
                        "value":"610901",
                        "key":"610901",
                        "parent_area_key":"610900",
                        "children":[

                        ]
                    },
                    {
                        "id":3169,
                        "label":"汉滨区",
                        "value":"610902",
                        "key":"610902",
                        "parent_area_key":"610900",
                        "children":[

                        ]
                    },
                    {
                        "id":3170,
                        "label":"汉阴县",
                        "value":"610921",
                        "key":"610921",
                        "parent_area_key":"610900",
                        "children":[

                        ]
                    },
                    {
                        "id":3171,
                        "label":"石泉县",
                        "value":"610922",
                        "key":"610922",
                        "parent_area_key":"610900",
                        "children":[

                        ]
                    },
                    {
                        "id":3172,
                        "label":"宁陕县",
                        "value":"610923",
                        "key":"610923",
                        "parent_area_key":"610900",
                        "children":[

                        ]
                    },
                    {
                        "id":3173,
                        "label":"紫阳县",
                        "value":"610924",
                        "key":"610924",
                        "parent_area_key":"610900",
                        "children":[

                        ]
                    },
                    {
                        "id":3174,
                        "label":"岚皋县",
                        "value":"610925",
                        "key":"610925",
                        "parent_area_key":"610900",
                        "children":[

                        ]
                    },
                    {
                        "id":3175,
                        "label":"平利县",
                        "value":"610926",
                        "key":"610926",
                        "parent_area_key":"610900",
                        "children":[

                        ]
                    },
                    {
                        "id":3176,
                        "label":"镇坪县",
                        "value":"610927",
                        "key":"610927",
                        "parent_area_key":"610900",
                        "children":[

                        ]
                    },
                    {
                        "id":3177,
                        "label":"旬阳县",
                        "value":"610928",
                        "key":"610928",
                        "parent_area_key":"610900",
                        "children":[

                        ]
                    },
                    {
                        "id":3178,
                        "label":"白河县",
                        "value":"610929",
                        "key":"610929",
                        "parent_area_key":"610900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3179,
                "label":"商洛市",
                "value":"611000",
                "key":"611000",
                "parent_area_key":"610000",
                "children":[
                    {
                        "id":3180,
                        "label":"市辖区",
                        "value":"611001",
                        "key":"611001",
                        "parent_area_key":"611000",
                        "children":[

                        ]
                    },
                    {
                        "id":3181,
                        "label":"商州区",
                        "value":"611002",
                        "key":"611002",
                        "parent_area_key":"611000",
                        "children":[

                        ]
                    },
                    {
                        "id":3182,
                        "label":"洛南县",
                        "value":"611021",
                        "key":"611021",
                        "parent_area_key":"611000",
                        "children":[

                        ]
                    },
                    {
                        "id":3183,
                        "label":"丹凤县",
                        "value":"611022",
                        "key":"611022",
                        "parent_area_key":"611000",
                        "children":[

                        ]
                    },
                    {
                        "id":3184,
                        "label":"商南县",
                        "value":"611023",
                        "key":"611023",
                        "parent_area_key":"611000",
                        "children":[

                        ]
                    },
                    {
                        "id":3185,
                        "label":"山阳县",
                        "value":"611024",
                        "key":"611024",
                        "parent_area_key":"611000",
                        "children":[

                        ]
                    },
                    {
                        "id":3186,
                        "label":"镇安县",
                        "value":"611025",
                        "key":"611025",
                        "parent_area_key":"611000",
                        "children":[

                        ]
                    },
                    {
                        "id":3187,
                        "label":"柞水县",
                        "value":"611026",
                        "key":"611026",
                        "parent_area_key":"611000",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":3188,
        "label":"甘肃省",
        "value":"620000",
        "key":"620000",
        "parent_area_key":"",
        "children":[
            {
                "id":3189,
                "label":"兰州市",
                "value":"620100",
                "key":"620100",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3190,
                        "label":"市辖区",
                        "value":"620101",
                        "key":"620101",
                        "parent_area_key":"620100",
                        "children":[

                        ]
                    },
                    {
                        "id":3191,
                        "label":"城关区",
                        "value":"620102",
                        "key":"620102",
                        "parent_area_key":"620100",
                        "children":[

                        ]
                    },
                    {
                        "id":3192,
                        "label":"七里河区",
                        "value":"620103",
                        "key":"620103",
                        "parent_area_key":"620100",
                        "children":[

                        ]
                    },
                    {
                        "id":3193,
                        "label":"西固区",
                        "value":"620104",
                        "key":"620104",
                        "parent_area_key":"620100",
                        "children":[

                        ]
                    },
                    {
                        "id":3194,
                        "label":"安宁区",
                        "value":"620105",
                        "key":"620105",
                        "parent_area_key":"620100",
                        "children":[

                        ]
                    },
                    {
                        "id":3195,
                        "label":"红古区",
                        "value":"620111",
                        "key":"620111",
                        "parent_area_key":"620100",
                        "children":[

                        ]
                    },
                    {
                        "id":3196,
                        "label":"永登县",
                        "value":"620121",
                        "key":"620121",
                        "parent_area_key":"620100",
                        "children":[

                        ]
                    },
                    {
                        "id":3197,
                        "label":"皋兰县",
                        "value":"620122",
                        "key":"620122",
                        "parent_area_key":"620100",
                        "children":[

                        ]
                    },
                    {
                        "id":3198,
                        "label":"榆中县",
                        "value":"620123",
                        "key":"620123",
                        "parent_area_key":"620100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3199,
                "label":"嘉峪关市",
                "value":"620200",
                "key":"620200",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3200,
                        "label":"市辖区",
                        "value":"620201",
                        "key":"620201",
                        "parent_area_key":"620200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3201,
                "label":"金昌市",
                "value":"620300",
                "key":"620300",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3202,
                        "label":"市辖区",
                        "value":"620301",
                        "key":"620301",
                        "parent_area_key":"620300",
                        "children":[

                        ]
                    },
                    {
                        "id":3203,
                        "label":"金川区",
                        "value":"620302",
                        "key":"620302",
                        "parent_area_key":"620300",
                        "children":[

                        ]
                    },
                    {
                        "id":3204,
                        "label":"永昌县",
                        "value":"620321",
                        "key":"620321",
                        "parent_area_key":"620300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3205,
                "label":"白银市",
                "value":"620400",
                "key":"620400",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3206,
                        "label":"市辖区",
                        "value":"620401",
                        "key":"620401",
                        "parent_area_key":"620400",
                        "children":[

                        ]
                    },
                    {
                        "id":3207,
                        "label":"白银区",
                        "value":"620402",
                        "key":"620402",
                        "parent_area_key":"620400",
                        "children":[

                        ]
                    },
                    {
                        "id":3208,
                        "label":"平川区",
                        "value":"620403",
                        "key":"620403",
                        "parent_area_key":"620400",
                        "children":[

                        ]
                    },
                    {
                        "id":3209,
                        "label":"靖远县",
                        "value":"620421",
                        "key":"620421",
                        "parent_area_key":"620400",
                        "children":[

                        ]
                    },
                    {
                        "id":3210,
                        "label":"会宁县",
                        "value":"620422",
                        "key":"620422",
                        "parent_area_key":"620400",
                        "children":[

                        ]
                    },
                    {
                        "id":3211,
                        "label":"景泰县",
                        "value":"620423",
                        "key":"620423",
                        "parent_area_key":"620400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3212,
                "label":"天水市",
                "value":"620500",
                "key":"620500",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3213,
                        "label":"市辖区",
                        "value":"620501",
                        "key":"620501",
                        "parent_area_key":"620500",
                        "children":[

                        ]
                    },
                    {
                        "id":3214,
                        "label":"秦州区",
                        "value":"620502",
                        "key":"620502",
                        "parent_area_key":"620500",
                        "children":[

                        ]
                    },
                    {
                        "id":3215,
                        "label":"麦积区",
                        "value":"620503",
                        "key":"620503",
                        "parent_area_key":"620500",
                        "children":[

                        ]
                    },
                    {
                        "id":3216,
                        "label":"清水县",
                        "value":"620521",
                        "key":"620521",
                        "parent_area_key":"620500",
                        "children":[

                        ]
                    },
                    {
                        "id":3217,
                        "label":"秦安县",
                        "value":"620522",
                        "key":"620522",
                        "parent_area_key":"620500",
                        "children":[

                        ]
                    },
                    {
                        "id":3218,
                        "label":"甘谷县",
                        "value":"620523",
                        "key":"620523",
                        "parent_area_key":"620500",
                        "children":[

                        ]
                    },
                    {
                        "id":3219,
                        "label":"武山县",
                        "value":"620524",
                        "key":"620524",
                        "parent_area_key":"620500",
                        "children":[

                        ]
                    },
                    {
                        "id":3220,
                        "label":"张家川回族自治县",
                        "value":"620525",
                        "key":"620525",
                        "parent_area_key":"620500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3221,
                "label":"武威市",
                "value":"620600",
                "key":"620600",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3222,
                        "label":"市辖区",
                        "value":"620601",
                        "key":"620601",
                        "parent_area_key":"620600",
                        "children":[

                        ]
                    },
                    {
                        "id":3223,
                        "label":"凉州区",
                        "value":"620602",
                        "key":"620602",
                        "parent_area_key":"620600",
                        "children":[

                        ]
                    },
                    {
                        "id":3224,
                        "label":"民勤县",
                        "value":"620621",
                        "key":"620621",
                        "parent_area_key":"620600",
                        "children":[

                        ]
                    },
                    {
                        "id":3225,
                        "label":"古浪县",
                        "value":"620622",
                        "key":"620622",
                        "parent_area_key":"620600",
                        "children":[

                        ]
                    },
                    {
                        "id":3226,
                        "label":"天祝藏族自治县",
                        "value":"620623",
                        "key":"620623",
                        "parent_area_key":"620600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3227,
                "label":"张掖市",
                "value":"620700",
                "key":"620700",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3228,
                        "label":"市辖区",
                        "value":"620701",
                        "key":"620701",
                        "parent_area_key":"620700",
                        "children":[

                        ]
                    },
                    {
                        "id":3229,
                        "label":"甘州区",
                        "value":"620702",
                        "key":"620702",
                        "parent_area_key":"620700",
                        "children":[

                        ]
                    },
                    {
                        "id":3230,
                        "label":"肃南裕固族自治县",
                        "value":"620721",
                        "key":"620721",
                        "parent_area_key":"620700",
                        "children":[

                        ]
                    },
                    {
                        "id":3231,
                        "label":"民乐县",
                        "value":"620722",
                        "key":"620722",
                        "parent_area_key":"620700",
                        "children":[

                        ]
                    },
                    {
                        "id":3232,
                        "label":"临泽县",
                        "value":"620723",
                        "key":"620723",
                        "parent_area_key":"620700",
                        "children":[

                        ]
                    },
                    {
                        "id":3233,
                        "label":"高台县",
                        "value":"620724",
                        "key":"620724",
                        "parent_area_key":"620700",
                        "children":[

                        ]
                    },
                    {
                        "id":3234,
                        "label":"山丹县",
                        "value":"620725",
                        "key":"620725",
                        "parent_area_key":"620700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3235,
                "label":"平凉市",
                "value":"620800",
                "key":"620800",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3236,
                        "label":"市辖区",
                        "value":"620801",
                        "key":"620801",
                        "parent_area_key":"620800",
                        "children":[

                        ]
                    },
                    {
                        "id":3237,
                        "label":"崆峒区",
                        "value":"620802",
                        "key":"620802",
                        "parent_area_key":"620800",
                        "children":[

                        ]
                    },
                    {
                        "id":3238,
                        "label":"泾川县",
                        "value":"620821",
                        "key":"620821",
                        "parent_area_key":"620800",
                        "children":[

                        ]
                    },
                    {
                        "id":3239,
                        "label":"灵台县",
                        "value":"620822",
                        "key":"620822",
                        "parent_area_key":"620800",
                        "children":[

                        ]
                    },
                    {
                        "id":3240,
                        "label":"崇信县",
                        "value":"620823",
                        "key":"620823",
                        "parent_area_key":"620800",
                        "children":[

                        ]
                    },
                    {
                        "id":3241,
                        "label":"华亭县",
                        "value":"620824",
                        "key":"620824",
                        "parent_area_key":"620800",
                        "children":[

                        ]
                    },
                    {
                        "id":3242,
                        "label":"庄浪县",
                        "value":"620825",
                        "key":"620825",
                        "parent_area_key":"620800",
                        "children":[

                        ]
                    },
                    {
                        "id":3243,
                        "label":"静宁县",
                        "value":"620826",
                        "key":"620826",
                        "parent_area_key":"620800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3244,
                "label":"酒泉市",
                "value":"620900",
                "key":"620900",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3245,
                        "label":"市辖区",
                        "value":"620901",
                        "key":"620901",
                        "parent_area_key":"620900",
                        "children":[

                        ]
                    },
                    {
                        "id":3246,
                        "label":"肃州区",
                        "value":"620902",
                        "key":"620902",
                        "parent_area_key":"620900",
                        "children":[

                        ]
                    },
                    {
                        "id":3247,
                        "label":"金塔县",
                        "value":"620921",
                        "key":"620921",
                        "parent_area_key":"620900",
                        "children":[

                        ]
                    },
                    {
                        "id":3248,
                        "label":"瓜州县",
                        "value":"620922",
                        "key":"620922",
                        "parent_area_key":"620900",
                        "children":[

                        ]
                    },
                    {
                        "id":3249,
                        "label":"肃北蒙古族自治县",
                        "value":"620923",
                        "key":"620923",
                        "parent_area_key":"620900",
                        "children":[

                        ]
                    },
                    {
                        "id":3250,
                        "label":"阿克塞哈萨克族自治县",
                        "value":"620924",
                        "key":"620924",
                        "parent_area_key":"620900",
                        "children":[

                        ]
                    },
                    {
                        "id":3251,
                        "label":"玉门市",
                        "value":"620981",
                        "key":"620981",
                        "parent_area_key":"620900",
                        "children":[

                        ]
                    },
                    {
                        "id":3252,
                        "label":"敦煌市",
                        "value":"620982",
                        "key":"620982",
                        "parent_area_key":"620900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3253,
                "label":"庆阳市",
                "value":"621000",
                "key":"621000",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3254,
                        "label":"市辖区",
                        "value":"621001",
                        "key":"621001",
                        "parent_area_key":"621000",
                        "children":[

                        ]
                    },
                    {
                        "id":3255,
                        "label":"西峰区",
                        "value":"621002",
                        "key":"621002",
                        "parent_area_key":"621000",
                        "children":[

                        ]
                    },
                    {
                        "id":3256,
                        "label":"庆城县",
                        "value":"621021",
                        "key":"621021",
                        "parent_area_key":"621000",
                        "children":[

                        ]
                    },
                    {
                        "id":3257,
                        "label":"环县",
                        "value":"621022",
                        "key":"621022",
                        "parent_area_key":"621000",
                        "children":[

                        ]
                    },
                    {
                        "id":3258,
                        "label":"华池县",
                        "value":"621023",
                        "key":"621023",
                        "parent_area_key":"621000",
                        "children":[

                        ]
                    },
                    {
                        "id":3259,
                        "label":"合水县",
                        "value":"621024",
                        "key":"621024",
                        "parent_area_key":"621000",
                        "children":[

                        ]
                    },
                    {
                        "id":3260,
                        "label":"正宁县",
                        "value":"621025",
                        "key":"621025",
                        "parent_area_key":"621000",
                        "children":[

                        ]
                    },
                    {
                        "id":3261,
                        "label":"宁县",
                        "value":"621026",
                        "key":"621026",
                        "parent_area_key":"621000",
                        "children":[

                        ]
                    },
                    {
                        "id":3262,
                        "label":"镇原县",
                        "value":"621027",
                        "key":"621027",
                        "parent_area_key":"621000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3263,
                "label":"定西市",
                "value":"621100",
                "key":"621100",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3264,
                        "label":"市辖区",
                        "value":"621101",
                        "key":"621101",
                        "parent_area_key":"621100",
                        "children":[

                        ]
                    },
                    {
                        "id":3265,
                        "label":"安定区",
                        "value":"621102",
                        "key":"621102",
                        "parent_area_key":"621100",
                        "children":[

                        ]
                    },
                    {
                        "id":3266,
                        "label":"通渭县",
                        "value":"621121",
                        "key":"621121",
                        "parent_area_key":"621100",
                        "children":[

                        ]
                    },
                    {
                        "id":3267,
                        "label":"陇西县",
                        "value":"621122",
                        "key":"621122",
                        "parent_area_key":"621100",
                        "children":[

                        ]
                    },
                    {
                        "id":3268,
                        "label":"渭源县",
                        "value":"621123",
                        "key":"621123",
                        "parent_area_key":"621100",
                        "children":[

                        ]
                    },
                    {
                        "id":3269,
                        "label":"临洮县",
                        "value":"621124",
                        "key":"621124",
                        "parent_area_key":"621100",
                        "children":[

                        ]
                    },
                    {
                        "id":3270,
                        "label":"漳县",
                        "value":"621125",
                        "key":"621125",
                        "parent_area_key":"621100",
                        "children":[

                        ]
                    },
                    {
                        "id":3271,
                        "label":"岷县",
                        "value":"621126",
                        "key":"621126",
                        "parent_area_key":"621100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3272,
                "label":"陇南市",
                "value":"621200",
                "key":"621200",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3273,
                        "label":"市辖区",
                        "value":"621201",
                        "key":"621201",
                        "parent_area_key":"621200",
                        "children":[

                        ]
                    },
                    {
                        "id":3274,
                        "label":"武都区",
                        "value":"621202",
                        "key":"621202",
                        "parent_area_key":"621200",
                        "children":[

                        ]
                    },
                    {
                        "id":3275,
                        "label":"成县",
                        "value":"621221",
                        "key":"621221",
                        "parent_area_key":"621200",
                        "children":[

                        ]
                    },
                    {
                        "id":3276,
                        "label":"文县",
                        "value":"621222",
                        "key":"621222",
                        "parent_area_key":"621200",
                        "children":[

                        ]
                    },
                    {
                        "id":3277,
                        "label":"宕昌县",
                        "value":"621223",
                        "key":"621223",
                        "parent_area_key":"621200",
                        "children":[

                        ]
                    },
                    {
                        "id":3278,
                        "label":"康县",
                        "value":"621224",
                        "key":"621224",
                        "parent_area_key":"621200",
                        "children":[

                        ]
                    },
                    {
                        "id":3279,
                        "label":"西和县",
                        "value":"621225",
                        "key":"621225",
                        "parent_area_key":"621200",
                        "children":[

                        ]
                    },
                    {
                        "id":3280,
                        "label":"礼县",
                        "value":"621226",
                        "key":"621226",
                        "parent_area_key":"621200",
                        "children":[

                        ]
                    },
                    {
                        "id":3281,
                        "label":"徽县",
                        "value":"621227",
                        "key":"621227",
                        "parent_area_key":"621200",
                        "children":[

                        ]
                    },
                    {
                        "id":3282,
                        "label":"两当县",
                        "value":"621228",
                        "key":"621228",
                        "parent_area_key":"621200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3283,
                "label":"临夏回族自治州",
                "value":"622900",
                "key":"622900",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3284,
                        "label":"临夏市",
                        "value":"622901",
                        "key":"622901",
                        "parent_area_key":"622900",
                        "children":[

                        ]
                    },
                    {
                        "id":3285,
                        "label":"临夏县",
                        "value":"622921",
                        "key":"622921",
                        "parent_area_key":"622900",
                        "children":[

                        ]
                    },
                    {
                        "id":3286,
                        "label":"康乐县",
                        "value":"622922",
                        "key":"622922",
                        "parent_area_key":"622900",
                        "children":[

                        ]
                    },
                    {
                        "id":3287,
                        "label":"永靖县",
                        "value":"622923",
                        "key":"622923",
                        "parent_area_key":"622900",
                        "children":[

                        ]
                    },
                    {
                        "id":3288,
                        "label":"广河县",
                        "value":"622924",
                        "key":"622924",
                        "parent_area_key":"622900",
                        "children":[

                        ]
                    },
                    {
                        "id":3289,
                        "label":"和政县",
                        "value":"622925",
                        "key":"622925",
                        "parent_area_key":"622900",
                        "children":[

                        ]
                    },
                    {
                        "id":3290,
                        "label":"东乡族自治县",
                        "value":"622926",
                        "key":"622926",
                        "parent_area_key":"622900",
                        "children":[

                        ]
                    },
                    {
                        "id":3291,
                        "label":"积石山保安族东乡族撒拉族自治县",
                        "value":"622927",
                        "key":"622927",
                        "parent_area_key":"622900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3292,
                "label":"甘南藏族自治州",
                "value":"623000",
                "key":"623000",
                "parent_area_key":"620000",
                "children":[
                    {
                        "id":3293,
                        "label":"合作市",
                        "value":"623001",
                        "key":"623001",
                        "parent_area_key":"623000",
                        "children":[

                        ]
                    },
                    {
                        "id":3294,
                        "label":"临潭县",
                        "value":"623021",
                        "key":"623021",
                        "parent_area_key":"623000",
                        "children":[

                        ]
                    },
                    {
                        "id":3295,
                        "label":"卓尼县",
                        "value":"623022",
                        "key":"623022",
                        "parent_area_key":"623000",
                        "children":[

                        ]
                    },
                    {
                        "id":3296,
                        "label":"舟曲县",
                        "value":"623023",
                        "key":"623023",
                        "parent_area_key":"623000",
                        "children":[

                        ]
                    },
                    {
                        "id":3297,
                        "label":"迭��县",
                        "value":"623024",
                        "key":"623024",
                        "parent_area_key":"623000",
                        "children":[

                        ]
                    },
                    {
                        "id":3298,
                        "label":"玛曲县",
                        "value":"623025",
                        "key":"623025",
                        "parent_area_key":"623000",
                        "children":[

                        ]
                    },
                    {
                        "id":3299,
                        "label":"碌曲县",
                        "value":"623026",
                        "key":"623026",
                        "parent_area_key":"623000",
                        "children":[

                        ]
                    },
                    {
                        "id":3300,
                        "label":"夏河县",
                        "value":"623027",
                        "key":"623027",
                        "parent_area_key":"623000",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":3301,
        "label":"青海省",
        "value":"630000",
        "key":"630000",
        "parent_area_key":"",
        "children":[
            {
                "id":3302,
                "label":"西宁市",
                "value":"630100",
                "key":"630100",
                "parent_area_key":"630000",
                "children":[
                    {
                        "id":3303,
                        "label":"市辖区",
                        "value":"630101",
                        "key":"630101",
                        "parent_area_key":"630100",
                        "children":[

                        ]
                    },
                    {
                        "id":3304,
                        "label":"城东区",
                        "value":"630102",
                        "key":"630102",
                        "parent_area_key":"630100",
                        "children":[

                        ]
                    },
                    {
                        "id":3305,
                        "label":"城中区",
                        "value":"630103",
                        "key":"630103",
                        "parent_area_key":"630100",
                        "children":[

                        ]
                    },
                    {
                        "id":3306,
                        "label":"城西区",
                        "value":"630104",
                        "key":"630104",
                        "parent_area_key":"630100",
                        "children":[

                        ]
                    },
                    {
                        "id":3307,
                        "label":"城北区",
                        "value":"630105",
                        "key":"630105",
                        "parent_area_key":"630100",
                        "children":[

                        ]
                    },
                    {
                        "id":3308,
                        "label":"大通回族土族自治县",
                        "value":"630121",
                        "key":"630121",
                        "parent_area_key":"630100",
                        "children":[

                        ]
                    },
                    {
                        "id":3309,
                        "label":"湟中县",
                        "value":"630122",
                        "key":"630122",
                        "parent_area_key":"630100",
                        "children":[

                        ]
                    },
                    {
                        "id":3310,
                        "label":"湟源县",
                        "value":"630123",
                        "key":"630123",
                        "parent_area_key":"630100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3311,
                "label":"海东市",
                "value":"630200",
                "key":"630200",
                "parent_area_key":"630000",
                "children":[
                    {
                        "id":3312,
                        "label":"乐都区",
                        "value":"630202",
                        "key":"630202",
                        "parent_area_key":"630200",
                        "children":[

                        ]
                    },
                    {
                        "id":3313,
                        "label":"平安区",
                        "value":"630203",
                        "key":"630203",
                        "parent_area_key":"630200",
                        "children":[

                        ]
                    },
                    {
                        "id":3314,
                        "label":"民和回族土族自治县",
                        "value":"630222",
                        "key":"630222",
                        "parent_area_key":"630200",
                        "children":[

                        ]
                    },
                    {
                        "id":3315,
                        "label":"互助土族自治县",
                        "value":"630223",
                        "key":"630223",
                        "parent_area_key":"630200",
                        "children":[

                        ]
                    },
                    {
                        "id":3316,
                        "label":"化隆回族自治县",
                        "value":"630224",
                        "key":"630224",
                        "parent_area_key":"630200",
                        "children":[

                        ]
                    },
                    {
                        "id":3317,
                        "label":"循化撒拉族自治县",
                        "value":"630225",
                        "key":"630225",
                        "parent_area_key":"630200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3318,
                "label":"海北藏族自治州",
                "value":"632200",
                "key":"632200",
                "parent_area_key":"630000",
                "children":[
                    {
                        "id":3319,
                        "label":"门源回族自治县",
                        "value":"632221",
                        "key":"632221",
                        "parent_area_key":"632200",
                        "children":[

                        ]
                    },
                    {
                        "id":3320,
                        "label":"祁连县",
                        "value":"632222",
                        "key":"632222",
                        "parent_area_key":"632200",
                        "children":[

                        ]
                    },
                    {
                        "id":3321,
                        "label":"海晏县",
                        "value":"632223",
                        "key":"632223",
                        "parent_area_key":"632200",
                        "children":[

                        ]
                    },
                    {
                        "id":3322,
                        "label":"刚察县",
                        "value":"632224",
                        "key":"632224",
                        "parent_area_key":"632200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3323,
                "label":"黄南藏族自治州",
                "value":"632300",
                "key":"632300",
                "parent_area_key":"630000",
                "children":[
                    {
                        "id":3324,
                        "label":"同仁县",
                        "value":"632321",
                        "key":"632321",
                        "parent_area_key":"632300",
                        "children":[

                        ]
                    },
                    {
                        "id":3325,
                        "label":"尖扎县",
                        "value":"632322",
                        "key":"632322",
                        "parent_area_key":"632300",
                        "children":[

                        ]
                    },
                    {
                        "id":3326,
                        "label":"泽库县",
                        "value":"632323",
                        "key":"632323",
                        "parent_area_key":"632300",
                        "children":[

                        ]
                    },
                    {
                        "id":3327,
                        "label":"河南蒙古族自治县",
                        "value":"632324",
                        "key":"632324",
                        "parent_area_key":"632300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3328,
                "label":"海南藏族自治州",
                "value":"632500",
                "key":"632500",
                "parent_area_key":"630000",
                "children":[
                    {
                        "id":3329,
                        "label":"共和县",
                        "value":"632521",
                        "key":"632521",
                        "parent_area_key":"632500",
                        "children":[

                        ]
                    },
                    {
                        "id":3330,
                        "label":"同德县",
                        "value":"632522",
                        "key":"632522",
                        "parent_area_key":"632500",
                        "children":[

                        ]
                    },
                    {
                        "id":3331,
                        "label":"贵德县",
                        "value":"632523",
                        "key":"632523",
                        "parent_area_key":"632500",
                        "children":[

                        ]
                    },
                    {
                        "id":3332,
                        "label":"兴海县",
                        "value":"632524",
                        "key":"632524",
                        "parent_area_key":"632500",
                        "children":[

                        ]
                    },
                    {
                        "id":3333,
                        "label":"贵南县",
                        "value":"632525",
                        "key":"632525",
                        "parent_area_key":"632500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3334,
                "label":"果洛藏族自治州",
                "value":"632600",
                "key":"632600",
                "parent_area_key":"630000",
                "children":[
                    {
                        "id":3335,
                        "label":"玛沁县",
                        "value":"632621",
                        "key":"632621",
                        "parent_area_key":"632600",
                        "children":[

                        ]
                    },
                    {
                        "id":3336,
                        "label":"班玛县",
                        "value":"632622",
                        "key":"632622",
                        "parent_area_key":"632600",
                        "children":[

                        ]
                    },
                    {
                        "id":3337,
                        "label":"甘德县",
                        "value":"632623",
                        "key":"632623",
                        "parent_area_key":"632600",
                        "children":[

                        ]
                    },
                    {
                        "id":3338,
                        "label":"达日县",
                        "value":"632624",
                        "key":"632624",
                        "parent_area_key":"632600",
                        "children":[

                        ]
                    },
                    {
                        "id":3339,
                        "label":"久治县",
                        "value":"632625",
                        "key":"632625",
                        "parent_area_key":"632600",
                        "children":[

                        ]
                    },
                    {
                        "id":3340,
                        "label":"玛多县",
                        "value":"632626",
                        "key":"632626",
                        "parent_area_key":"632600",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3341,
                "label":"玉树藏族自治州",
                "value":"632700",
                "key":"632700",
                "parent_area_key":"630000",
                "children":[
                    {
                        "id":3342,
                        "label":"玉树市",
                        "value":"632701",
                        "key":"632701",
                        "parent_area_key":"632700",
                        "children":[

                        ]
                    },
                    {
                        "id":3343,
                        "label":"杂多县",
                        "value":"632722",
                        "key":"632722",
                        "parent_area_key":"632700",
                        "children":[

                        ]
                    },
                    {
                        "id":3344,
                        "label":"称多县",
                        "value":"632723",
                        "key":"632723",
                        "parent_area_key":"632700",
                        "children":[

                        ]
                    },
                    {
                        "id":3345,
                        "label":"治多县",
                        "value":"632724",
                        "key":"632724",
                        "parent_area_key":"632700",
                        "children":[

                        ]
                    },
                    {
                        "id":3346,
                        "label":"囊谦县",
                        "value":"632725",
                        "key":"632725",
                        "parent_area_key":"632700",
                        "children":[

                        ]
                    },
                    {
                        "id":3347,
                        "label":"曲麻莱县",
                        "value":"632726",
                        "key":"632726",
                        "parent_area_key":"632700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3348,
                "label":"海西蒙古族藏族自治州",
                "value":"632800",
                "key":"632800",
                "parent_area_key":"630000",
                "children":[
                    {
                        "id":3349,
                        "label":"格尔木市",
                        "value":"632801",
                        "key":"632801",
                        "parent_area_key":"632800",
                        "children":[

                        ]
                    },
                    {
                        "id":3350,
                        "label":"德令哈市",
                        "value":"632802",
                        "key":"632802",
                        "parent_area_key":"632800",
                        "children":[

                        ]
                    },
                    {
                        "id":3351,
                        "label":"乌兰县",
                        "value":"632821",
                        "key":"632821",
                        "parent_area_key":"632800",
                        "children":[

                        ]
                    },
                    {
                        "id":3352,
                        "label":"都兰县",
                        "value":"632822",
                        "key":"632822",
                        "parent_area_key":"632800",
                        "children":[

                        ]
                    },
                    {
                        "id":3353,
                        "label":"天峻县",
                        "value":"632823",
                        "key":"632823",
                        "parent_area_key":"632800",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":3354,
        "label":"宁夏回族自治区",
        "value":"640000",
        "key":"640000",
        "parent_area_key":"",
        "children":[
            {
                "id":3355,
                "label":"银川市",
                "value":"640100",
                "key":"640100",
                "parent_area_key":"640000",
                "children":[
                    {
                        "id":3356,
                        "label":"市辖区",
                        "value":"640101",
                        "key":"640101",
                        "parent_area_key":"640100",
                        "children":[

                        ]
                    },
                    {
                        "id":3357,
                        "label":"兴庆区",
                        "value":"640104",
                        "key":"640104",
                        "parent_area_key":"640100",
                        "children":[

                        ]
                    },
                    {
                        "id":3358,
                        "label":"西夏区",
                        "value":"640105",
                        "key":"640105",
                        "parent_area_key":"640100",
                        "children":[

                        ]
                    },
                    {
                        "id":3359,
                        "label":"金凤区",
                        "value":"640106",
                        "key":"640106",
                        "parent_area_key":"640100",
                        "children":[

                        ]
                    },
                    {
                        "id":3360,
                        "label":"永宁县",
                        "value":"640121",
                        "key":"640121",
                        "parent_area_key":"640100",
                        "children":[

                        ]
                    },
                    {
                        "id":3361,
                        "label":"贺兰县",
                        "value":"640122",
                        "key":"640122",
                        "parent_area_key":"640100",
                        "children":[

                        ]
                    },
                    {
                        "id":3362,
                        "label":"灵武市",
                        "value":"640181",
                        "key":"640181",
                        "parent_area_key":"640100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3363,
                "label":"石嘴山市",
                "value":"640200",
                "key":"640200",
                "parent_area_key":"640000",
                "children":[
                    {
                        "id":3364,
                        "label":"市辖区",
                        "value":"640201",
                        "key":"640201",
                        "parent_area_key":"640200",
                        "children":[

                        ]
                    },
                    {
                        "id":3365,
                        "label":"大武口区",
                        "value":"640202",
                        "key":"640202",
                        "parent_area_key":"640200",
                        "children":[

                        ]
                    },
                    {
                        "id":3366,
                        "label":"惠农区",
                        "value":"640205",
                        "key":"640205",
                        "parent_area_key":"640200",
                        "children":[

                        ]
                    },
                    {
                        "id":3367,
                        "label":"平罗县",
                        "value":"640221",
                        "key":"640221",
                        "parent_area_key":"640200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3368,
                "label":"吴忠市",
                "value":"640300",
                "key":"640300",
                "parent_area_key":"640000",
                "children":[
                    {
                        "id":3369,
                        "label":"市辖区",
                        "value":"640301",
                        "key":"640301",
                        "parent_area_key":"640300",
                        "children":[

                        ]
                    },
                    {
                        "id":3370,
                        "label":"利通区",
                        "value":"640302",
                        "key":"640302",
                        "parent_area_key":"640300",
                        "children":[

                        ]
                    },
                    {
                        "id":3371,
                        "label":"红寺堡区",
                        "value":"640303",
                        "key":"640303",
                        "parent_area_key":"640300",
                        "children":[

                        ]
                    },
                    {
                        "id":3372,
                        "label":"盐池县",
                        "value":"640323",
                        "key":"640323",
                        "parent_area_key":"640300",
                        "children":[

                        ]
                    },
                    {
                        "id":3373,
                        "label":"同心县",
                        "value":"640324",
                        "key":"640324",
                        "parent_area_key":"640300",
                        "children":[

                        ]
                    },
                    {
                        "id":3374,
                        "label":"青铜峡市",
                        "value":"640381",
                        "key":"640381",
                        "parent_area_key":"640300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3375,
                "label":"固原市",
                "value":"640400",
                "key":"640400",
                "parent_area_key":"640000",
                "children":[
                    {
                        "id":3376,
                        "label":"市辖区",
                        "value":"640401",
                        "key":"640401",
                        "parent_area_key":"640400",
                        "children":[

                        ]
                    },
                    {
                        "id":3377,
                        "label":"原州区",
                        "value":"640402",
                        "key":"640402",
                        "parent_area_key":"640400",
                        "children":[

                        ]
                    },
                    {
                        "id":3378,
                        "label":"西吉县",
                        "value":"640422",
                        "key":"640422",
                        "parent_area_key":"640400",
                        "children":[

                        ]
                    },
                    {
                        "id":3379,
                        "label":"隆德县",
                        "value":"640423",
                        "key":"640423",
                        "parent_area_key":"640400",
                        "children":[

                        ]
                    },
                    {
                        "id":3380,
                        "label":"泾源县",
                        "value":"640424",
                        "key":"640424",
                        "parent_area_key":"640400",
                        "children":[

                        ]
                    },
                    {
                        "id":3381,
                        "label":"彭阳县",
                        "value":"640425",
                        "key":"640425",
                        "parent_area_key":"640400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3382,
                "label":"中卫市",
                "value":"640500",
                "key":"640500",
                "parent_area_key":"640000",
                "children":[
                    {
                        "id":3383,
                        "label":"市辖区",
                        "value":"640501",
                        "key":"640501",
                        "parent_area_key":"640500",
                        "children":[

                        ]
                    },
                    {
                        "id":3384,
                        "label":"沙坡头区",
                        "value":"640502",
                        "key":"640502",
                        "parent_area_key":"640500",
                        "children":[

                        ]
                    },
                    {
                        "id":3385,
                        "label":"中宁县",
                        "value":"640521",
                        "key":"640521",
                        "parent_area_key":"640500",
                        "children":[

                        ]
                    },
                    {
                        "id":3386,
                        "label":"海原县",
                        "value":"640522",
                        "key":"640522",
                        "parent_area_key":"640500",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":3387,
        "label":"新疆维吾尔自治区",
        "value":"650000",
        "key":"650000",
        "parent_area_key":"",
        "children":[
            {
                "id":3388,
                "label":"乌鲁木齐市",
                "value":"650100",
                "key":"650100",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3389,
                        "label":"市辖区",
                        "value":"650101",
                        "key":"650101",
                        "parent_area_key":"650100",
                        "children":[

                        ]
                    },
                    {
                        "id":3390,
                        "label":"天山区",
                        "value":"650102",
                        "key":"650102",
                        "parent_area_key":"650100",
                        "children":[

                        ]
                    },
                    {
                        "id":3391,
                        "label":"沙依巴克区",
                        "value":"650103",
                        "key":"650103",
                        "parent_area_key":"650100",
                        "children":[

                        ]
                    },
                    {
                        "id":3392,
                        "label":"新市区",
                        "value":"650104",
                        "key":"650104",
                        "parent_area_key":"650100",
                        "children":[

                        ]
                    },
                    {
                        "id":3393,
                        "label":"水磨沟区",
                        "value":"650105",
                        "key":"650105",
                        "parent_area_key":"650100",
                        "children":[

                        ]
                    },
                    {
                        "id":3394,
                        "label":"头屯河区",
                        "value":"650106",
                        "key":"650106",
                        "parent_area_key":"650100",
                        "children":[

                        ]
                    },
                    {
                        "id":3395,
                        "label":"达坂城区",
                        "value":"650107",
                        "key":"650107",
                        "parent_area_key":"650100",
                        "children":[

                        ]
                    },
                    {
                        "id":3396,
                        "label":"米东区",
                        "value":"650109",
                        "key":"650109",
                        "parent_area_key":"650100",
                        "children":[

                        ]
                    },
                    {
                        "id":3397,
                        "label":"乌鲁木齐县",
                        "value":"650121",
                        "key":"650121",
                        "parent_area_key":"650100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3398,
                "label":"克拉玛依市",
                "value":"650200",
                "key":"650200",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3399,
                        "label":"市辖区",
                        "value":"650201",
                        "key":"650201",
                        "parent_area_key":"650200",
                        "children":[

                        ]
                    },
                    {
                        "id":3400,
                        "label":"独山子区",
                        "value":"650202",
                        "key":"650202",
                        "parent_area_key":"650200",
                        "children":[

                        ]
                    },
                    {
                        "id":3401,
                        "label":"克拉玛依区",
                        "value":"650203",
                        "key":"650203",
                        "parent_area_key":"650200",
                        "children":[

                        ]
                    },
                    {
                        "id":3402,
                        "label":"白碱滩区",
                        "value":"650204",
                        "key":"650204",
                        "parent_area_key":"650200",
                        "children":[

                        ]
                    },
                    {
                        "id":3403,
                        "label":"乌尔禾区",
                        "value":"650205",
                        "key":"650205",
                        "parent_area_key":"650200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3404,
                "label":"吐鲁番市",
                "value":"650400",
                "key":"650400",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3405,
                        "label":"高昌区",
                        "value":"650402",
                        "key":"650402",
                        "parent_area_key":"650400",
                        "children":[

                        ]
                    },
                    {
                        "id":3406,
                        "label":"鄯善县",
                        "value":"650421",
                        "key":"650421",
                        "parent_area_key":"650400",
                        "children":[

                        ]
                    },
                    {
                        "id":3407,
                        "label":"托克逊县",
                        "value":"650422",
                        "key":"650422",
                        "parent_area_key":"650400",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3408,
                "label":"哈密市",
                "value":"650500",
                "key":"650500",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3409,
                        "label":"伊州区",
                        "value":"650502",
                        "key":"650502",
                        "parent_area_key":"650500",
                        "children":[

                        ]
                    },
                    {
                        "id":3410,
                        "label":"巴里坤哈萨克自治县",
                        "value":"650521",
                        "key":"650521",
                        "parent_area_key":"650500",
                        "children":[

                        ]
                    },
                    {
                        "id":3411,
                        "label":"伊吾县",
                        "value":"650522",
                        "key":"650522",
                        "parent_area_key":"650500",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3412,
                "label":"昌吉回族自治州",
                "value":"652300",
                "key":"652300",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3413,
                        "label":"昌吉市",
                        "value":"652301",
                        "key":"652301",
                        "parent_area_key":"652300",
                        "children":[

                        ]
                    },
                    {
                        "id":3414,
                        "label":"阜康市",
                        "value":"652302",
                        "key":"652302",
                        "parent_area_key":"652300",
                        "children":[

                        ]
                    },
                    {
                        "id":3415,
                        "label":"呼图壁县",
                        "value":"652323",
                        "key":"652323",
                        "parent_area_key":"652300",
                        "children":[

                        ]
                    },
                    {
                        "id":3416,
                        "label":"玛纳斯县",
                        "value":"652324",
                        "key":"652324",
                        "parent_area_key":"652300",
                        "children":[

                        ]
                    },
                    {
                        "id":3417,
                        "label":"奇台县",
                        "value":"652325",
                        "key":"652325",
                        "parent_area_key":"652300",
                        "children":[

                        ]
                    },
                    {
                        "id":3418,
                        "label":"吉木萨尔县",
                        "value":"652327",
                        "key":"652327",
                        "parent_area_key":"652300",
                        "children":[

                        ]
                    },
                    {
                        "id":3419,
                        "label":"木垒哈萨克自治县",
                        "value":"652328",
                        "key":"652328",
                        "parent_area_key":"652300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3420,
                "label":"博尔塔拉蒙古自治州",
                "value":"652700",
                "key":"652700",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3421,
                        "label":"博乐市",
                        "value":"652701",
                        "key":"652701",
                        "parent_area_key":"652700",
                        "children":[

                        ]
                    },
                    {
                        "id":3422,
                        "label":"阿拉山口市",
                        "value":"652702",
                        "key":"652702",
                        "parent_area_key":"652700",
                        "children":[

                        ]
                    },
                    {
                        "id":3423,
                        "label":"精河县",
                        "value":"652722",
                        "key":"652722",
                        "parent_area_key":"652700",
                        "children":[

                        ]
                    },
                    {
                        "id":3424,
                        "label":"温泉县",
                        "value":"652723",
                        "key":"652723",
                        "parent_area_key":"652700",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3425,
                "label":"巴音郭楞蒙古自治州",
                "value":"652800",
                "key":"652800",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3426,
                        "label":"库尔勒市",
                        "value":"652801",
                        "key":"652801",
                        "parent_area_key":"652800",
                        "children":[

                        ]
                    },
                    {
                        "id":3427,
                        "label":"轮台县",
                        "value":"652822",
                        "key":"652822",
                        "parent_area_key":"652800",
                        "children":[

                        ]
                    },
                    {
                        "id":3428,
                        "label":"尉犁县",
                        "value":"652823",
                        "key":"652823",
                        "parent_area_key":"652800",
                        "children":[

                        ]
                    },
                    {
                        "id":3429,
                        "label":"若羌县",
                        "value":"652824",
                        "key":"652824",
                        "parent_area_key":"652800",
                        "children":[

                        ]
                    },
                    {
                        "id":3430,
                        "label":"且末县",
                        "value":"652825",
                        "key":"652825",
                        "parent_area_key":"652800",
                        "children":[

                        ]
                    },
                    {
                        "id":3431,
                        "label":"焉耆回族自治县",
                        "value":"652826",
                        "key":"652826",
                        "parent_area_key":"652800",
                        "children":[

                        ]
                    },
                    {
                        "id":3432,
                        "label":"和静县",
                        "value":"652827",
                        "key":"652827",
                        "parent_area_key":"652800",
                        "children":[

                        ]
                    },
                    {
                        "id":3433,
                        "label":"和硕县",
                        "value":"652828",
                        "key":"652828",
                        "parent_area_key":"652800",
                        "children":[

                        ]
                    },
                    {
                        "id":3434,
                        "label":"博湖县",
                        "value":"652829",
                        "key":"652829",
                        "parent_area_key":"652800",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3435,
                "label":"阿克苏地区",
                "value":"652900",
                "key":"652900",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3436,
                        "label":"阿克苏市",
                        "value":"652901",
                        "key":"652901",
                        "parent_area_key":"652900",
                        "children":[

                        ]
                    },
                    {
                        "id":3437,
                        "label":"温宿县",
                        "value":"652922",
                        "key":"652922",
                        "parent_area_key":"652900",
                        "children":[

                        ]
                    },
                    {
                        "id":3438,
                        "label":"库车县",
                        "value":"652923",
                        "key":"652923",
                        "parent_area_key":"652900",
                        "children":[

                        ]
                    },
                    {
                        "id":3439,
                        "label":"沙雅县",
                        "value":"652924",
                        "key":"652924",
                        "parent_area_key":"652900",
                        "children":[

                        ]
                    },
                    {
                        "id":3440,
                        "label":"新和县",
                        "value":"652925",
                        "key":"652925",
                        "parent_area_key":"652900",
                        "children":[

                        ]
                    },
                    {
                        "id":3441,
                        "label":"拜城县",
                        "value":"652926",
                        "key":"652926",
                        "parent_area_key":"652900",
                        "children":[

                        ]
                    },
                    {
                        "id":3442,
                        "label":"乌什县",
                        "value":"652927",
                        "key":"652927",
                        "parent_area_key":"652900",
                        "children":[

                        ]
                    },
                    {
                        "id":3443,
                        "label":"阿瓦提县",
                        "value":"652928",
                        "key":"652928",
                        "parent_area_key":"652900",
                        "children":[

                        ]
                    },
                    {
                        "id":3444,
                        "label":"柯坪县",
                        "value":"652929",
                        "key":"652929",
                        "parent_area_key":"652900",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3445,
                "label":"克孜勒苏柯尔克孜自治州",
                "value":"653000",
                "key":"653000",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3446,
                        "label":"阿图什市",
                        "value":"653001",
                        "key":"653001",
                        "parent_area_key":"653000",
                        "children":[

                        ]
                    },
                    {
                        "id":3447,
                        "label":"阿克陶县",
                        "value":"653022",
                        "key":"653022",
                        "parent_area_key":"653000",
                        "children":[

                        ]
                    },
                    {
                        "id":3448,
                        "label":"阿合奇县",
                        "value":"653023",
                        "key":"653023",
                        "parent_area_key":"653000",
                        "children":[

                        ]
                    },
                    {
                        "id":3449,
                        "label":"乌恰县",
                        "value":"653024",
                        "key":"653024",
                        "parent_area_key":"653000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3450,
                "label":"喀什地区",
                "value":"653100",
                "key":"653100",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3451,
                        "label":"喀什市",
                        "value":"653101",
                        "key":"653101",
                        "parent_area_key":"653100",
                        "children":[

                        ]
                    },
                    {
                        "id":3452,
                        "label":"疏附县",
                        "value":"653121",
                        "key":"653121",
                        "parent_area_key":"653100",
                        "children":[

                        ]
                    },
                    {
                        "id":3453,
                        "label":"疏勒县",
                        "value":"653122",
                        "key":"653122",
                        "parent_area_key":"653100",
                        "children":[

                        ]
                    },
                    {
                        "id":3454,
                        "label":"英吉沙县",
                        "value":"653123",
                        "key":"653123",
                        "parent_area_key":"653100",
                        "children":[

                        ]
                    },
                    {
                        "id":3455,
                        "label":"泽普县",
                        "value":"653124",
                        "key":"653124",
                        "parent_area_key":"653100",
                        "children":[

                        ]
                    },
                    {
                        "id":3456,
                        "label":"莎车县",
                        "value":"653125",
                        "key":"653125",
                        "parent_area_key":"653100",
                        "children":[

                        ]
                    },
                    {
                        "id":3457,
                        "label":"叶城县",
                        "value":"653126",
                        "key":"653126",
                        "parent_area_key":"653100",
                        "children":[

                        ]
                    },
                    {
                        "id":3458,
                        "label":"麦盖提县",
                        "value":"653127",
                        "key":"653127",
                        "parent_area_key":"653100",
                        "children":[

                        ]
                    },
                    {
                        "id":3459,
                        "label":"岳普湖县",
                        "value":"653128",
                        "key":"653128",
                        "parent_area_key":"653100",
                        "children":[

                        ]
                    },
                    {
                        "id":3460,
                        "label":"伽师县",
                        "value":"653129",
                        "key":"653129",
                        "parent_area_key":"653100",
                        "children":[

                        ]
                    },
                    {
                        "id":3461,
                        "label":"巴楚县",
                        "value":"653130",
                        "key":"653130",
                        "parent_area_key":"653100",
                        "children":[

                        ]
                    },
                    {
                        "id":3462,
                        "label":"塔什库尔干塔吉克自治县",
                        "value":"653131",
                        "key":"653131",
                        "parent_area_key":"653100",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3463,
                "label":"和田地区",
                "value":"653200",
                "key":"653200",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3464,
                        "label":"和田市",
                        "value":"653201",
                        "key":"653201",
                        "parent_area_key":"653200",
                        "children":[

                        ]
                    },
                    {
                        "id":3465,
                        "label":"和田县",
                        "value":"653221",
                        "key":"653221",
                        "parent_area_key":"653200",
                        "children":[

                        ]
                    },
                    {
                        "id":3466,
                        "label":"墨玉县",
                        "value":"653222",
                        "key":"653222",
                        "parent_area_key":"653200",
                        "children":[

                        ]
                    },
                    {
                        "id":3467,
                        "label":"皮山县",
                        "value":"653223",
                        "key":"653223",
                        "parent_area_key":"653200",
                        "children":[

                        ]
                    },
                    {
                        "id":3468,
                        "label":"洛浦县",
                        "value":"653224",
                        "key":"653224",
                        "parent_area_key":"653200",
                        "children":[

                        ]
                    },
                    {
                        "id":3469,
                        "label":"策勒县",
                        "value":"653225",
                        "key":"653225",
                        "parent_area_key":"653200",
                        "children":[

                        ]
                    },
                    {
                        "id":3470,
                        "label":"于田县",
                        "value":"653226",
                        "key":"653226",
                        "parent_area_key":"653200",
                        "children":[

                        ]
                    },
                    {
                        "id":3471,
                        "label":"民丰县",
                        "value":"653227",
                        "key":"653227",
                        "parent_area_key":"653200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3472,
                "label":"伊犁哈萨克自治州",
                "value":"654000",
                "key":"654000",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3473,
                        "label":"伊宁市",
                        "value":"654002",
                        "key":"654002",
                        "parent_area_key":"654000",
                        "children":[

                        ]
                    },
                    {
                        "id":3474,
                        "label":"奎屯市",
                        "value":"654003",
                        "key":"654003",
                        "parent_area_key":"654000",
                        "children":[

                        ]
                    },
                    {
                        "id":3475,
                        "label":"霍尔果斯市",
                        "value":"654004",
                        "key":"654004",
                        "parent_area_key":"654000",
                        "children":[

                        ]
                    },
                    {
                        "id":3476,
                        "label":"伊宁县",
                        "value":"654021",
                        "key":"654021",
                        "parent_area_key":"654000",
                        "children":[

                        ]
                    },
                    {
                        "id":3477,
                        "label":"察布查尔锡伯自治县",
                        "value":"654022",
                        "key":"654022",
                        "parent_area_key":"654000",
                        "children":[

                        ]
                    },
                    {
                        "id":3478,
                        "label":"霍城县",
                        "value":"654023",
                        "key":"654023",
                        "parent_area_key":"654000",
                        "children":[

                        ]
                    },
                    {
                        "id":3479,
                        "label":"巩留县",
                        "value":"654024",
                        "key":"654024",
                        "parent_area_key":"654000",
                        "children":[

                        ]
                    },
                    {
                        "id":3480,
                        "label":"新源县",
                        "value":"654025",
                        "key":"654025",
                        "parent_area_key":"654000",
                        "children":[

                        ]
                    },
                    {
                        "id":3481,
                        "label":"昭苏县",
                        "value":"654026",
                        "key":"654026",
                        "parent_area_key":"654000",
                        "children":[

                        ]
                    },
                    {
                        "id":3482,
                        "label":"特克斯县",
                        "value":"654027",
                        "key":"654027",
                        "parent_area_key":"654000",
                        "children":[

                        ]
                    },
                    {
                        "id":3483,
                        "label":"尼勒克县",
                        "value":"654028",
                        "key":"654028",
                        "parent_area_key":"654000",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3484,
                "label":"塔城地区",
                "value":"654200",
                "key":"654200",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3485,
                        "label":"塔城市",
                        "value":"654201",
                        "key":"654201",
                        "parent_area_key":"654200",
                        "children":[

                        ]
                    },
                    {
                        "id":3486,
                        "label":"乌苏市",
                        "value":"654202",
                        "key":"654202",
                        "parent_area_key":"654200",
                        "children":[

                        ]
                    },
                    {
                        "id":3487,
                        "label":"额敏县",
                        "value":"654221",
                        "key":"654221",
                        "parent_area_key":"654200",
                        "children":[

                        ]
                    },
                    {
                        "id":3488,
                        "label":"沙湾县",
                        "value":"654223",
                        "key":"654223",
                        "parent_area_key":"654200",
                        "children":[

                        ]
                    },
                    {
                        "id":3489,
                        "label":"托里县",
                        "value":"654224",
                        "key":"654224",
                        "parent_area_key":"654200",
                        "children":[

                        ]
                    },
                    {
                        "id":3490,
                        "label":"裕民县",
                        "value":"654225",
                        "key":"654225",
                        "parent_area_key":"654200",
                        "children":[

                        ]
                    },
                    {
                        "id":3491,
                        "label":"和布克赛尔蒙古自治县",
                        "value":"654226",
                        "key":"654226",
                        "parent_area_key":"654200",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3492,
                "label":"阿勒泰地区",
                "value":"654300",
                "key":"654300",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3493,
                        "label":"阿勒泰市",
                        "value":"654301",
                        "key":"654301",
                        "parent_area_key":"654300",
                        "children":[

                        ]
                    },
                    {
                        "id":3494,
                        "label":"布尔津县",
                        "value":"654321",
                        "key":"654321",
                        "parent_area_key":"654300",
                        "children":[

                        ]
                    },
                    {
                        "id":3495,
                        "label":"富蕴县",
                        "value":"654322",
                        "key":"654322",
                        "parent_area_key":"654300",
                        "children":[

                        ]
                    },
                    {
                        "id":3496,
                        "label":"福海县",
                        "value":"654323",
                        "key":"654323",
                        "parent_area_key":"654300",
                        "children":[

                        ]
                    },
                    {
                        "id":3497,
                        "label":"哈巴河县",
                        "value":"654324",
                        "key":"654324",
                        "parent_area_key":"654300",
                        "children":[

                        ]
                    },
                    {
                        "id":3498,
                        "label":"青河县",
                        "value":"654325",
                        "key":"654325",
                        "parent_area_key":"654300",
                        "children":[

                        ]
                    },
                    {
                        "id":3499,
                        "label":"吉木乃县",
                        "value":"654326",
                        "key":"654326",
                        "parent_area_key":"654300",
                        "children":[

                        ]
                    }
                ]
            },
            {
                "id":3500,
                "label":"自治区直辖县级行政区划",
                "value":"659000",
                "key":"659000",
                "parent_area_key":"650000",
                "children":[
                    {
                        "id":3501,
                        "label":"石河子市",
                        "value":"659001",
                        "key":"659001",
                        "parent_area_key":"659000",
                        "children":[

                        ]
                    },
                    {
                        "id":3502,
                        "label":"阿拉尔市",
                        "value":"659002",
                        "key":"659002",
                        "parent_area_key":"659000",
                        "children":[

                        ]
                    },
                    {
                        "id":3503,
                        "label":"图木舒克市",
                        "value":"659003",
                        "key":"659003",
                        "parent_area_key":"659000",
                        "children":[

                        ]
                    },
                    {
                        "id":3504,
                        "label":"五家渠市",
                        "value":"659004",
                        "key":"659004",
                        "parent_area_key":"659000",
                        "children":[

                        ]
                    },
                    {
                        "id":3505,
                        "label":"铁门关市",
                        "value":"659006",
                        "key":"659006",
                        "parent_area_key":"659000",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":3506,
        "label":"台湾省",
        "value":"710000",
        "key":"710000",
        "parent_area_key":"",
        "children":[
            {
                "id":3509,
                "label":"台湾",
                "value":"710100",
                "key":"710100",
                "parent_area_key":"710000",
                "children":[
                    {
                        "id":3510,
                        "label":"台湾",
                        "value":"710101",
                        "key":"710101",
                        "parent_area_key":"710100",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    },
    {
        "id":3507,
        "label":"香港特别行政区",
        "value":"810000",
        "key":"810000",
        "parent_area_key":"",
        "children":[

        ]
    },
    {
        "id":3508,
        "label":"澳门特别行政区",
        "value":"820000",
        "key":"820000",
        "parent_area_key":"",
        "children":[
            {
                "id":3513,
                "label":"澳门",
                "value":"820100",
                "key":"820100",
                "parent_area_key":"820000",
                "children":[
                    {
                        "id":3514,
                        "label":"澳门",
                        "value":"820101",
                        "key":"820101",
                        "parent_area_key":"820100",
                        "children":[

                        ]
                    }
                ]
            }
        ]
    }
]
export default city
